/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.7.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import { customMutator } from './axios';
import { customFormDataFn } from './customFormDataFn';
export type GetUsers200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetUsers200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetUsers200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetUsers200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetUsers200 = {
  'hydra:member': UserJsonldUserReadCollection[];
  'hydra:search'?: GetUsers200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetUsers200HydraView;
};

export type GetUsersParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
id?: string;
'id[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
search?: string;
};

export type GetTsubscriptions200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetTsubscriptions200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetTsubscriptions200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetTsubscriptions200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetTsubscriptions200 = {
  'hydra:member': TsubscriptionJsonldReadCollectionSubscription[];
  'hydra:search'?: GetTsubscriptions200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetTsubscriptions200HydraView;
};

export type GetTsubscriptionsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GettPropertyViewTypes200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyViewTypes200 = {
  'hydra:member': TpropertyViewTypeJsonldReadCollectionTpropertyViewType[];
  'hydra:search'?: GettPropertyViewTypes200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyViewTypes200HydraView;
};

export type GettPropertyViewTypes200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyViewTypes200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyViewTypes200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyViewTypesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertyViews200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyViews200 = {
  'hydra:member': TpropertyViewJsonldReadCollectionTpropertyView[];
  'hydra:search'?: GettPropertyViews200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyViews200HydraView;
};

export type GettPropertyViews200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyViews200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyViews200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyViewsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertySubTypes200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertySubTypes200 = {
  'hydra:member': TpropertySubTypeJsonldReadCollectionTpropertySubType[];
  'hydra:search'?: GettPropertySubTypes200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertySubTypes200HydraView;
};

export type GettPropertySubTypes200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertySubTypes200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertySubTypes200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertySubTypesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertyStates200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyStates200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyStates200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyStates200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyStates200 = {
  'hydra:member': TpropertyStateJsonldReadCollectionTpropertyState[];
  'hydra:search'?: GettPropertyStates200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyStates200HydraView;
};

export type GettPropertyStatesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertySpecificities200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertySpecificities200 = {
  'hydra:member': TpropertySpecificityJsonldReadCollectionTpropertySpecificity[];
  'hydra:search'?: GettPropertySpecificities200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertySpecificities200HydraView;
};

export type GettPropertySpecificities200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertySpecificities200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertySpecificities200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertySpecificitiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertySituations200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertySituations200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertySituations200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertySituations200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertySituations200 = {
  'hydra:member': TpropertySituationJsonldReadCollectionTpropertySituation[];
  'hydra:search'?: GettPropertySituations200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertySituations200HydraView;
};

export type GettPropertySituationsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertyMandateTypes200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyMandateTypes200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyMandateTypes200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyMandateTypes200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyMandateTypes200 = {
  'hydra:member': TpropertyMandateTypeJsonldReadCollectionTpropertyMandateType[];
  'hydra:search'?: GettPropertyMandateTypes200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyMandateTypes200HydraView;
};

export type GettPropertyMandateTypesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertyFacilities200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyFacilities200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyFacilities200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyFacilities200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyFacilities200 = {
  'hydra:member': TpropertyFacilityJsonldReadCollectionTpropertyFacility[];
  'hydra:search'?: GettPropertyFacilities200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyFacilities200HydraView;
};

export type GettPropertyFacilitiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GettPropertyAvailabilities200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GettPropertyAvailabilities200 = {
  'hydra:member': TpropertyAvailabilityJsonldReadCollectionTpropertyAvailability[];
  'hydra:search'?: GettPropertyAvailabilities200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GettPropertyAvailabilities200HydraView;
};

export type GettPropertyAvailabilities200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GettPropertyAvailabilities200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GettPropertyAvailabilities200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GettPropertyAvailabilitiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GetTpropertiesExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetTpropertiesExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetTpropertiesExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetTpropertiesExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetTpropertiesExcelExportData200 = {
  'hydra:member': TpropertyJsonldReadCollectionTpropertyExcelExport[];
  'hydra:search'?: GetTpropertiesExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetTpropertiesExcelExportData200HydraView;
};

export type GetTpropertiesExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
};

export type GetTproperties200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetTproperties200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetTproperties200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetTproperties200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetTproperties200 = {
  'hydra:member': TpropertyJsonldReadCollectionTpropertyWithoutPrivateData[];
  'hydra:search'?: GetTproperties200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetTproperties200HydraView;
};

export type GetTpropertiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
search?: string;
businessUnit?: string;
'businessUnit[]'?: string[];
user?: string;
'user[]'?: string[];
type?: string;
'type[]'?: string[];
subType?: string;
'subType[]'?: string[];
mandateType?: string;
'mandateType[]'?: string[];
specificities?: string;
'specificities[]'?: string[];
facilities?: string;
'facilities[]'?: string[];
state?: string;
'state[]'?: string[];
views?: string;
'views[]'?: string[];
availability?: string;
'availability[]'?: string[];
viewTypes?: string;
'viewTypes[]'?: string[];
situations?: string;
'situations[]'?: string[];
currency?: string;
'currency[]'?: string[];
pricePeriodicity?: string;
'pricePeriodicity[]'?: string[];
'address.country'?: string;
'address.country[]'?: string[];
'address.city'?: string;
'address.city[]'?: string[];
'address.postcode'?: string;
'project.type'?: string;
'project.type[]'?: string[];
'project.status'?: string;
'project.status[]'?: string[];
'agreementStartAt[before]'?: string;
'agreementStartAt[strictly_before]'?: string;
'agreementStartAt[after]'?: string;
'agreementStartAt[strictly_after]'?: string;
'agreementEndAt[before]'?: string;
'agreementEndAt[strictly_before]'?: string;
'agreementEndAt[after]'?: string;
'agreementEndAt[strictly_after]'?: string;
'commitmentAt[before]'?: string;
'commitmentAt[strictly_before]'?: string;
'commitmentAt[after]'?: string;
'commitmentAt[strictly_after]'?: string;
'contractAt[before]'?: string;
'contractAt[strictly_before]'?: string;
'contractAt[after]'?: string;
'contractAt[strictly_after]'?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
'updatedAt[before]'?: string;
'updatedAt[strictly_before]'?: string;
'updatedAt[after]'?: string;
'updatedAt[strictly_after]'?: string;
'price[between]'?: string;
'price[gt]'?: string;
'price[gte]'?: string;
'price[lt]'?: string;
'price[lte]'?: string;
'numberOfRooms[between]'?: string;
'numberOfRooms[gt]'?: string;
'numberOfRooms[gte]'?: string;
'numberOfRooms[lt]'?: string;
'numberOfRooms[lte]'?: string;
'numberOfBedrooms[between]'?: string;
'numberOfBedrooms[gt]'?: string;
'numberOfBedrooms[gte]'?: string;
'numberOfBedrooms[lt]'?: string;
'numberOfBedrooms[lte]'?: string;
'surfaceAreaInSquareMeters[between]'?: string;
'surfaceAreaInSquareMeters[gt]'?: string;
'surfaceAreaInSquareMeters[gte]'?: string;
'surfaceAreaInSquareMeters[lt]'?: string;
'surfaceAreaInSquareMeters[lte]'?: string;
'landSurfaceAreaInSquareMeters[between]'?: string;
'landSurfaceAreaInSquareMeters[gt]'?: string;
'landSurfaceAreaInSquareMeters[gte]'?: string;
'landSurfaceAreaInSquareMeters[lt]'?: string;
'landSurfaceAreaInSquareMeters[lte]'?: string;
'floor[between]'?: string;
'floor[gt]'?: string;
'floor[gte]'?: string;
'floor[lt]'?: string;
'floor[lte]'?: string;
isGroundFloor?: boolean;
isTopFloor?: boolean;
/**
 * Post code collection
 */
'address.postcode[]'?: string[];
};

export type GetClientProperties200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClientProperties200 = {
  'hydra:member': TpropertyJsonldReadCollectionTpropertyWithoutPrivateData[];
  'hydra:search'?: GetClientProperties200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClientProperties200HydraView;
};

export type GetClientProperties200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClientProperties200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClientProperties200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClientPropertiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetClientProjects200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClientProjects200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClientProjects200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClientProjects200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClientProjects200 = {
  'hydra:member': TprojectJsonldReadCollectionProject[];
  'hydra:search'?: GetClientProjects200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClientProjects200HydraView;
};

export type GetSentInterBUs200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetSentInterBUs200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetSentInterBUs200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetSentInterBUs200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetSentInterBUs200 = {
  'hydra:member': TInterBuJsonldReadCollectionInterbu[];
  'hydra:search'?: GetSentInterBUs200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetSentInterBUs200HydraView;
};

export type GetSentInterBUsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
search?: string;
};

export type GetAssignedInterBUs200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetAssignedInterBUs200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetAssignedInterBUs200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetAssignedInterBUs200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAssignedInterBUs200 = {
  'hydra:member': TInterBuJsonldReadCollectionInterbu[];
  'hydra:search'?: GetAssignedInterBUs200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetAssignedInterBUs200HydraView;
};

export type GetAssignedInterBUsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
search?: string;
};

export type GetBuAdminInterBUs200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetBuAdminInterBUs200 = {
  'hydra:member': TInterBuJsonldReadCollectionInterbu[];
  'hydra:search'?: GetBuAdminInterBUs200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetBuAdminInterBUs200HydraView;
};

export type GetBuAdminInterBUs200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetBuAdminInterBUs200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetBuAdminInterBUs200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetBuAdminInterBUsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
search?: string;
};

export type GetClientInterBUs200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClientInterBUs200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClientInterBUs200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClientInterBUs200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClientInterBUs200 = {
  'hydra:member': TInterBuJsonldReadCollectionInterbu[];
  'hydra:search'?: GetClientInterBUs200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClientInterBUs200HydraView;
};

export type GetClientInterBUsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type PostSocietyMediaBody = {
  file?: Blob;
  isDefault?: boolean;
  order?: number;
  replaceAll?: boolean;
  replaceID?: string;
  skipUpload?: boolean;
  usage?: string;
};

export type GetSocietiesExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetSocietiesExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetSocietiesExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetSocietiesExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetSocietiesExcelExportData200 = {
  'hydra:member': SocietyJsonldReadCollectionSocietyExcelExport[];
  'hydra:search'?: GetSocietiesExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetSocietiesExcelExportData200HydraView;
};

export type GetSocietiesExcelExportDataOrderUpdatedAt = typeof GetSocietiesExcelExportDataOrderUpdatedAt[keyof typeof GetSocietiesExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderCreatedAt = typeof GetSocietiesExcelExportDataOrderCreatedAt[keyof typeof GetSocietiesExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderVatNumber = typeof GetSocietiesExcelExportDataOrderVatNumber[keyof typeof GetSocietiesExcelExportDataOrderVatNumber];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderVatNumber = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderOfficialCode = typeof GetSocietiesExcelExportDataOrderOfficialCode[keyof typeof GetSocietiesExcelExportDataOrderOfficialCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderOfficialCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderOfficialName = typeof GetSocietiesExcelExportDataOrderOfficialName[keyof typeof GetSocietiesExcelExportDataOrderOfficialName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderOfficialName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderName = typeof GetSocietiesExcelExportDataOrderName[keyof typeof GetSocietiesExcelExportDataOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataOrderId = typeof GetSocietiesExcelExportDataOrderId[keyof typeof GetSocietiesExcelExportDataOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesExcelExportDataOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'order[id]'?: GetSocietiesExcelExportDataOrderId;
'order[name]'?: GetSocietiesExcelExportDataOrderName;
'order[officialName]'?: GetSocietiesExcelExportDataOrderOfficialName;
'order[officialCode]'?: GetSocietiesExcelExportDataOrderOfficialCode;
'order[vatNumber]'?: GetSocietiesExcelExportDataOrderVatNumber;
'order[createdAt]'?: GetSocietiesExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetSocietiesExcelExportDataOrderUpdatedAt;
};

export type GetSocieties200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetSocieties200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetSocieties200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetSocieties200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetSocieties200 = {
  'hydra:member': SocietyJsonldReadCollectionSociety[];
  'hydra:search'?: GetSocieties200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetSocieties200HydraView;
};

export type GetSocietiesOrderVatNumber = typeof GetSocietiesOrderVatNumber[keyof typeof GetSocietiesOrderVatNumber];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderVatNumber = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderOfficialCode = typeof GetSocietiesOrderOfficialCode[keyof typeof GetSocietiesOrderOfficialCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderOfficialCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderOfficialName = typeof GetSocietiesOrderOfficialName[keyof typeof GetSocietiesOrderOfficialName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderOfficialName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderId = typeof GetSocietiesOrderId[keyof typeof GetSocietiesOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderUpdatedAt = typeof GetSocietiesOrderUpdatedAt[keyof typeof GetSocietiesOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderCreatedAt = typeof GetSocietiesOrderCreatedAt[keyof typeof GetSocietiesOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderBrand = typeof GetSocietiesOrderBrand[keyof typeof GetSocietiesOrderBrand];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderBrand = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesOrderName = typeof GetSocietiesOrderName[keyof typeof GetSocietiesOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSocietiesOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetSocietiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
internalSource?: string;
'internalSource[]'?: string[];
'contactDetails.contactDetails.zipcode'?: string;
'contactDetails.contactDetails.country'?: string;
'contactDetails.contactDetails.city'?: string;
'status.code'?: string;
'status.code[]'?: string[];
'cluster.cluster.id'?: string;
'cluster.cluster.id[]'?: string[];
'cluster.cluster.type'?: string;
'cluster.cluster.type[]'?: string[];
'cluster.cluster.status.code'?: string;
'cluster.cluster.type.code'?: string;
'cluster.cluster.internalSource'?: string;
'cluster.cluster.internalSource[]'?: string[];
'agency.agency.id'?: string;
'agency.agency.id[]'?: string[];
'agency.agency.name'?: string;
'agency.agency.status.code'?: string;
'agency.agency.internalSource'?: string;
'agency.agency.internalSource[]'?: string[];
'legalRepresentative.collaborator.id'?: string;
'legalRepresentative.collaborator.id[]'?: string[];
'legalRepresentative.collaborator.firstname'?: string;
'legalRepresentative.collaborator.lastname'?: string;
'legalRepresentative.collaborator.status.code'?: string;
search?: string;
'order[name]'?: GetSocietiesOrderName;
'order[brand]'?: GetSocietiesOrderBrand;
'order[createdAt]'?: GetSocietiesOrderCreatedAt;
'order[updatedAt]'?: GetSocietiesOrderUpdatedAt;
'order[id]'?: GetSocietiesOrderId;
'order[officialName]'?: GetSocietiesOrderOfficialName;
'order[officialCode]'?: GetSocietiesOrderOfficialCode;
'order[vatNumber]'?: GetSocietiesOrderVatNumber;
};

export type GetUserSharedDatas200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetUserSharedDatas200 = {
  'hydra:member': SharedDataJsonldReadCollectionSharedData[];
  'hydra:search'?: GetUserSharedDatas200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetUserSharedDatas200HydraView;
};

export type GetUserSharedDatas200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetUserSharedDatas200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetUserSharedDatas200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetUserSharedDatasOrderUpdatedAt = typeof GetUserSharedDatasOrderUpdatedAt[keyof typeof GetUserSharedDatasOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserSharedDatasOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetUserSharedDatasOrderCreatedAt = typeof GetUserSharedDatasOrderCreatedAt[keyof typeof GetUserSharedDatasOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserSharedDatasOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetUserSharedDatasOrderId = typeof GetUserSharedDatasOrderId[keyof typeof GetUserSharedDatasOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserSharedDatasOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetUserSharedDatasDirection = typeof GetUserSharedDatasDirection[keyof typeof GetUserSharedDatasDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserSharedDatasDirection = {
  received: 'received',
  sent: 'sent',
  all: 'all',
} as const;

export type GetUserSharedDatasParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Shared data received or sent by the current user, or both (all), within their interBU perimeter
 */
direction?: GetUserSharedDatasDirection;
id?: string;
'id[]'?: string[];
'from.id'?: string;
'from.id[]'?: string[];
'fromCluster.id'?: string;
'fromCluster.id[]'?: string[];
'fromCluster.name'?: string;
'to.id'?: string;
'to.id[]'?: string[];
'toCluster.id'?: string;
'toCluster.id[]'?: string[];
'toCluster.name'?: string;
'people.id'?: string;
'people.id[]'?: string[];
'people.firstname'?: string;
'people.lastname'?: string;
'project.id'?: string;
'project.id[]'?: string[];
'type.code'?: string;
'type.code[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'interBu.id'?: string;
'interBu.id[]'?: string[];
'interBu.people.id'?: string;
'interBu.people.id[]'?: string[];
'interBu.fromManager.id'?: string;
'interBu.fromManager.id[]'?: string[];
'toManager.id'?: string;
'toManager.id[]'?: string[];
'toCluster.collaborator.collaborator.users.id'?: string;
'toCluster.collaborator.collaborator.users.id[]'?: string[];
'fromCluster.collaborator.collaborator.users.id'?: string;
'fromCluster.collaborator.collaborator.users.id[]'?: string[];
search?: string;
'order[id]'?: GetUserSharedDatasOrderId;
'order[createdAt]'?: GetUserSharedDatasOrderCreatedAt;
'order[updatedAt]'?: GetUserSharedDatasOrderUpdatedAt;
};

export type GetRefLabelGroups200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetRefLabelGroups200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetRefLabelGroups200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetRefLabelGroups200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetRefLabelGroups200 = {
  'hydra:member': RefLabelGroupJsonldReadCollectionRefLabelGroup[];
  'hydra:search'?: GetRefLabelGroups200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetRefLabelGroups200HydraView;
};

export type GetRefLabelGroupsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
group?: string;
label?: string;
search?: string;
};

export type GetLocalesRefLabels200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetLocalesRefLabels200 = {
  'hydra:member': RefLabelJsonldReadCollectionRefLabel[];
  'hydra:search'?: GetLocalesRefLabels200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetLocalesRefLabels200HydraView;
};

export type GetLocalesRefLabels200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetLocalesRefLabels200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetLocalesRefLabels200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetLocalesRefLabelsOrderUpdatedAt = typeof GetLocalesRefLabelsOrderUpdatedAt[keyof typeof GetLocalesRefLabelsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsOrderCreatedAt = typeof GetLocalesRefLabelsOrderCreatedAt[keyof typeof GetLocalesRefLabelsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsOrderRefLabelGroupRelationOrder = typeof GetLocalesRefLabelsOrderRefLabelGroupRelationOrder[keyof typeof GetLocalesRefLabelsOrderRefLabelGroupRelationOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderRefLabelGroupRelationOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsOrderOrder = typeof GetLocalesRefLabelsOrderOrder[keyof typeof GetLocalesRefLabelsOrderOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsOrderCode = typeof GetLocalesRefLabelsOrderCode[keyof typeof GetLocalesRefLabelsOrderCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsOrderLabel = typeof GetLocalesRefLabelsOrderLabel[keyof typeof GetLocalesRefLabelsOrderLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocalesRefLabelsOrderLabel = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetLocalesRefLabelsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Ref Label Group filter
 */
group?: string;
code?: string;
'code[]'?: string[];
value?: string;
label?: string;
'refLabelGroupRelation.refLabelGroup.group'?: string;
search?: string;
'order[label]'?: GetLocalesRefLabelsOrderLabel;
'order[code]'?: GetLocalesRefLabelsOrderCode;
'order[order]'?: GetLocalesRefLabelsOrderOrder;
'order[refLabelGroupRelation.order]'?: GetLocalesRefLabelsOrderRefLabelGroupRelationOrder;
'order[createdAt]'?: GetLocalesRefLabelsOrderCreatedAt;
'order[updatedAt]'?: GetLocalesRefLabelsOrderUpdatedAt;
};

export type GetRefLabelsExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetRefLabelsExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetRefLabelsExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetRefLabelsExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetRefLabelsExcelExportData200 = {
  'hydra:member': RefLabelJsonldReadCollectionRefLabelsExcelExport[];
  'hydra:search'?: GetRefLabelsExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetRefLabelsExcelExportData200HydraView;
};

export type GetRefLabelsExcelExportDataOrderUpdatedAt = typeof GetRefLabelsExcelExportDataOrderUpdatedAt[keyof typeof GetRefLabelsExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataOrderCreatedAt = typeof GetRefLabelsExcelExportDataOrderCreatedAt[keyof typeof GetRefLabelsExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataOrderRefLabelGroupRelationOrder = typeof GetRefLabelsExcelExportDataOrderRefLabelGroupRelationOrder[keyof typeof GetRefLabelsExcelExportDataOrderRefLabelGroupRelationOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderRefLabelGroupRelationOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataOrderOrder = typeof GetRefLabelsExcelExportDataOrderOrder[keyof typeof GetRefLabelsExcelExportDataOrderOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataOrderCode = typeof GetRefLabelsExcelExportDataOrderCode[keyof typeof GetRefLabelsExcelExportDataOrderCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataOrderLabel = typeof GetRefLabelsExcelExportDataOrderLabel[keyof typeof GetRefLabelsExcelExportDataOrderLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsExcelExportDataOrderLabel = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Ref Label Group filter
 */
group?: string;
code?: string;
'code[]'?: string[];
value?: string;
label?: string;
'refLabelGroupRelation.refLabelGroup.group'?: string;
search?: string;
'order[label]'?: GetRefLabelsExcelExportDataOrderLabel;
'order[code]'?: GetRefLabelsExcelExportDataOrderCode;
'order[order]'?: GetRefLabelsExcelExportDataOrderOrder;
'order[refLabelGroupRelation.order]'?: GetRefLabelsExcelExportDataOrderRefLabelGroupRelationOrder;
'order[createdAt]'?: GetRefLabelsExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetRefLabelsExcelExportDataOrderUpdatedAt;
};

export type GetCountriesRefLabels200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetCountriesRefLabels200 = {
  'hydra:member': RefLabelJsonldReadCollectionRefLabel[];
  'hydra:search'?: GetCountriesRefLabels200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetCountriesRefLabels200HydraView;
};

export type GetCountriesRefLabels200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetCountriesRefLabels200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetCountriesRefLabels200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetCountriesRefLabelsOrderUpdatedAt = typeof GetCountriesRefLabelsOrderUpdatedAt[keyof typeof GetCountriesRefLabelsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsOrderCreatedAt = typeof GetCountriesRefLabelsOrderCreatedAt[keyof typeof GetCountriesRefLabelsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsOrderRefLabelGroupRelationOrder = typeof GetCountriesRefLabelsOrderRefLabelGroupRelationOrder[keyof typeof GetCountriesRefLabelsOrderRefLabelGroupRelationOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderRefLabelGroupRelationOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsOrderOrder = typeof GetCountriesRefLabelsOrderOrder[keyof typeof GetCountriesRefLabelsOrderOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsOrderCode = typeof GetCountriesRefLabelsOrderCode[keyof typeof GetCountriesRefLabelsOrderCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsOrderLabel = typeof GetCountriesRefLabelsOrderLabel[keyof typeof GetCountriesRefLabelsOrderLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountriesRefLabelsOrderLabel = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCountriesRefLabelsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Ref Label Group filter
 */
group?: string;
code?: string;
'code[]'?: string[];
value?: string;
label?: string;
'refLabelGroupRelation.refLabelGroup.group'?: string;
search?: string;
'order[label]'?: GetCountriesRefLabelsOrderLabel;
'order[code]'?: GetCountriesRefLabelsOrderCode;
'order[order]'?: GetCountriesRefLabelsOrderOrder;
'order[refLabelGroupRelation.order]'?: GetCountriesRefLabelsOrderRefLabelGroupRelationOrder;
'order[createdAt]'?: GetCountriesRefLabelsOrderCreatedAt;
'order[updatedAt]'?: GetCountriesRefLabelsOrderUpdatedAt;
};

export type GetRefLabels200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetRefLabels200 = {
  'hydra:member': RefLabelJsonldReadCollectionRefLabel[];
  'hydra:search'?: GetRefLabels200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetRefLabels200HydraView;
};

export type GetRefLabels200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetRefLabels200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetRefLabels200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetRefLabelsOrderUpdatedAt = typeof GetRefLabelsOrderUpdatedAt[keyof typeof GetRefLabelsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsOrderCreatedAt = typeof GetRefLabelsOrderCreatedAt[keyof typeof GetRefLabelsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsOrderRefLabelGroupRelationOrder = typeof GetRefLabelsOrderRefLabelGroupRelationOrder[keyof typeof GetRefLabelsOrderRefLabelGroupRelationOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderRefLabelGroupRelationOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsOrderOrder = typeof GetRefLabelsOrderOrder[keyof typeof GetRefLabelsOrderOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsOrderCode = typeof GetRefLabelsOrderCode[keyof typeof GetRefLabelsOrderCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsOrderLabel = typeof GetRefLabelsOrderLabel[keyof typeof GetRefLabelsOrderLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRefLabelsOrderLabel = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetRefLabelsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Ref Label Group filter
 */
group?: string;
code?: string;
'code[]'?: string[];
value?: string;
label?: string;
'refLabelGroupRelation.refLabelGroup.group'?: string;
search?: string;
'order[label]'?: GetRefLabelsOrderLabel;
'order[code]'?: GetRefLabelsOrderCode;
'order[order]'?: GetRefLabelsOrderOrder;
'order[refLabelGroupRelation.order]'?: GetRefLabelsOrderRefLabelGroupRelationOrder;
'order[createdAt]'?: GetRefLabelsOrderCreatedAt;
'order[updatedAt]'?: GetRefLabelsOrderUpdatedAt;
};

export type GetPropertiesSearchExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPropertiesSearchExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPropertiesSearchExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPropertiesSearchExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPropertiesSearchExcelExportData200 = {
  'hydra:member': PropertySearchJsonldReadCollectionPropertySearchExcelExport[];
  'hydra:search'?: GetPropertiesSearchExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPropertiesSearchExcelExportData200HydraView;
};

export type GetPropertiesSearchExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
};

export type GetPropertiesSearch200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPropertiesSearch200 = {
  'hydra:member': PropertySearchJsonldReadCollectionPropertySearch[];
  'hydra:search'?: GetPropertiesSearch200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPropertiesSearch200HydraView;
};

export type GetPropertiesSearch200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPropertiesSearch200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPropertiesSearch200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPropertiesSearchParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
search?: string;
};

export type GetPropertiesOfferOfferExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPropertiesOfferOfferExcelExportData200 = {
  'hydra:member': PropertyOfferJsonldReadCollectionPropertyOfferExcelExport[];
  'hydra:search'?: GetPropertiesOfferOfferExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPropertiesOfferOfferExcelExportData200HydraView;
};

export type GetPropertiesOfferOfferExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPropertiesOfferOfferExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPropertiesOfferOfferExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPropertiesOfferOfferExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
};

export type GetPropertiesOffer200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPropertiesOffer200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPropertiesOffer200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPropertiesOffer200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPropertiesOffer200 = {
  'hydra:member': PropertyOfferJsonldReadCollectionPropertyOffer[];
  'hydra:search'?: GetPropertiesOffer200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPropertiesOffer200HydraView;
};

export type GetPropertiesOfferParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
reference?: string;
'reference[]'?: string[];
search?: string;
/**
 * Property Offer notInternalSource filter
 */
notInternalSource?: string[];
};

export type GetPropertiesExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPropertiesExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPropertiesExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPropertiesExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPropertiesExcelExportData200 = {
  'hydra:member': PropertyJsonldReadCollectionPropertyExcelExport[];
  'hydra:search'?: GetPropertiesExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPropertiesExcelExportData200HydraView;
};

export type GetPropertiesExcelExportDataOrderUpdatedAt = typeof GetPropertiesExcelExportDataOrderUpdatedAt[keyof typeof GetPropertiesExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesExcelExportDataOrderCreatedAt = typeof GetPropertiesExcelExportDataOrderCreatedAt[keyof typeof GetPropertiesExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesExcelExportDataOrderId = typeof GetPropertiesExcelExportDataOrderId[keyof typeof GetPropertiesExcelExportDataOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesExcelExportDataOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'order[id]'?: GetPropertiesExcelExportDataOrderId;
'order[createdAt]'?: GetPropertiesExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetPropertiesExcelExportDataOrderUpdatedAt;
};

export type GetProperties200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetProperties200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetProperties200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetProperties200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetProperties200 = {
  'hydra:member': PropertyJsonldReadCollectionProperty[];
  'hydra:search'?: GetProperties200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetProperties200HydraView;
};

export type GetPropertiesOrderUpdatedAt = typeof GetPropertiesOrderUpdatedAt[keyof typeof GetPropertiesOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesOrderCreatedAt = typeof GetPropertiesOrderCreatedAt[keyof typeof GetPropertiesOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesOrderId = typeof GetPropertiesOrderId[keyof typeof GetPropertiesOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPropertiesOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPropertiesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
name?: string;
areaTotal?: number;
'areaTotal[]'?: number[];
availabilityStatus?: string;
'availabilityStatus[]'?: string[];
'propertyOffer.propertyOffer.id'?: string;
'propertyOffer.propertyOffer.id[]'?: string[];
'propertyOwners.people.id'?: string;
'propertyOwners.people.id[]'?: string[];
search?: string;
'order[id]'?: GetPropertiesOrderId;
'order[createdAt]'?: GetPropertiesOrderCreatedAt;
'order[updatedAt]'?: GetPropertiesOrderUpdatedAt;
};

export type GetProjectsExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetProjectsExcelExportData200 = {
  'hydra:member': ProjectJsonldReadCollectionProjectExcelExport[];
  'hydra:search'?: GetProjectsExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetProjectsExcelExportData200HydraView;
};

export type GetProjectsExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetProjectsExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetProjectsExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetProjectsExcelExportDataOrderUpdatedAt = typeof GetProjectsExcelExportDataOrderUpdatedAt[keyof typeof GetProjectsExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsExcelExportDataOrderCreatedAt = typeof GetProjectsExcelExportDataOrderCreatedAt[keyof typeof GetProjectsExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsExcelExportDataOrderId = typeof GetProjectsExcelExportDataOrderId[keyof typeof GetProjectsExcelExportDataOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsExcelExportDataOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'order[id]'?: GetProjectsExcelExportDataOrderId;
'order[createdAt]'?: GetProjectsExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetProjectsExcelExportDataOrderUpdatedAt;
};

export type GetProjects200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetProjects200 = {
  'hydra:member': ProjectJsonldReadCollectionProject[];
  'hydra:search'?: GetProjects200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetProjects200HydraView;
};

export type GetProjects200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetProjects200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetProjects200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetProjectsOrderUpdatedAt = typeof GetProjectsOrderUpdatedAt[keyof typeof GetProjectsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsOrderCreatedAt = typeof GetProjectsOrderCreatedAt[keyof typeof GetProjectsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsOrderId = typeof GetProjectsOrderId[keyof typeof GetProjectsOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetProjectsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
'agreement.code'?: string;
'agreement.code[]'?: string[];
agreementReference?: string;
'agreementReference[]'?: string[];
id?: string;
'id[]'?: string[];
internalSource?: string;
'internalSource[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'subtype.code'?: string;
'subtype.code[]'?: string[];
'type.code'?: string;
'type.code[]'?: string[];
'collaborator.collaborator.id'?: string;
'collaborator.collaborator.id[]'?: string[];
'collaborator.collaborator.firstname'?: string;
'collaborator.collaborator.lastname'?: string;
'collaborator.collaborator.status.code'?: string;
'collaborator.collaborator.status.code[]'?: string[];
'collaborator.collaborator.internalSource'?: string;
'collaborator.collaborator.internalSource[]'?: string[];
'cluster.cluster.id'?: string;
'cluster.cluster.id[]'?: string[];
'cluster.cluster.status.code'?: string;
'cluster.cluster.status.code[]'?: string[];
'cluster.cluster.type.code'?: string;
'cluster.cluster.type.code[]'?: string[];
'cluster.cluster.name'?: string;
'cluster.cluster.internalSource'?: string;
'cluster.cluster.internalSource[]'?: string[];
'people.people.id'?: string;
'people.people.id[]'?: string[];
'people.people.firstname'?: string;
'people.people.lastname'?: string;
'projectAdvertiser.projectAdvertiser.id'?: string;
'projectAdvertiser.projectAdvertiser.id[]'?: string[];
'projectAdvertiser.projectAdvertiser.name'?: string;
'propertyOffer.propertyOffer.id'?: string;
'propertyOffer.propertyOffer.id[]'?: string[];
'propertyOffer.propertyOffer.status.code'?: string;
'propertyOffer.propertyOffer.status.code[]'?: string[];
'propertyOffer.propertyOffer.type.code'?: string;
'propertyOffer.propertyOffer.type.code[]'?: string[];
'propertyOffer.propertyOffer.subtype.code'?: string;
'propertyOffer.propertyOffer.subtype.code[]'?: string[];
'propertyOffer.propertyOffer.unitPrice.code'?: string;
'propertyOffer.propertyOffer.unitPrice.code[]'?: string[];
'propertyOffer.propertyOffer.pricePeriod'?: string;
'propertyOffer.propertyOffer.pricePeriod[]'?: string[];
'propertyOffer.propertyOffer.currency.code'?: string;
'propertyOffer.propertyOffer.currency.code[]'?: string[];
'propertyOffer.propertyOffer.internalSource'?: string;
'propertyOffer.propertyOffer.internalSource[]'?: string[];
'propertyOffer.propertyOffer.reference'?: string;
'propertyOffer.propertyOffer.group.code'?: string;
'propertyOffer.propertyOffer.group.code[]'?: string[];
'propertyOffer.property.propertyActivities.code'?: string;
'propertyOffer.property.propertyActivities.code[]'?: string[];
'propertyOffer.property.areaUnit.code'?: string;
'propertyOffer.property.areaUnit.code[]'?: string[];
'propertyOffer.property.availabilityStatus.code'?: string;
'propertyOffer.property.availabilityStatus.code[]'?: string[];
'propertyOffer.property.floor'?: number;
'propertyOffer.property.floor[]'?: number[];
'propertyOffer.property.floorName.code'?: string;
'propertyOffer.property.floorName.code[]'?: string[];
'propertyOffer.property.id'?: string;
'propertyOffer.property.id[]'?: string[];
'propertyOffer.property.internalSource'?: string;
'propertyOffer.property.internalSource[]'?: string[];
'propertyOffer.property.name'?: string;
'propertyOffer.property.propertyProximities.refLabel.code'?: string;
'propertyOffer.property.propertyProximities.refLabel.code[]'?: string[];
'propertyOffer.property.propertyOrientations.code'?: string;
'propertyOffer.property.propertyOrientations.code[]'?: string[];
'propertyOffer.property.propertyServices.code'?: string;
'propertyOffer.property.propertyServices.code[]'?: string[];
'propertyOffer.property.status.code'?: string;
'propertyOffer.property.status.code[]'?: string[];
'propertyOffer.property.type.code'?: string;
'propertyOffer.property.type.code[]'?: string[];
'propertyOffer.property.subtype.code'?: string;
'propertyOffer.property.subtype.code[]'?: string[];
'propertyOffer.property.condition.code'?: string;
'propertyOffer.property.condition.code[]'?: string[];
'propertyOffer.property.propertyViewLandscapes.code'?: string;
'propertyOffer.property.propertyViewLandscapes.code[]'?: string[];
'propertyOffer.property.propertyArea.propertyArea.type.code'?: string;
'propertyOffer.property.propertyArea.propertyArea.type.code[]'?: string[];
'propertyOffer.property.propertyArea.propertyArea.unit.code'?: string;
'propertyOffer.property.propertyArea.propertyArea.unit.code[]'?: string[];
'propertyOffer.property.propertyContactDetails.contactDetails.zipcode'?: string;
'propertyOffer.property.propertyContactDetails.contactDetails.country'?: string;
'propertyOffer.property.propertyContactDetails.contactDetails.city'?: string;
'propertySearch.id'?: string;
'propertySearch.id[]'?: string[];
'propertySearch.propertySearch.internalSource'?: string;
'propertySearch.propertySearch.internalSource[]'?: string[];
'propertySearch.propertySearch.status.code'?: string;
'propertySearch.propertySearch.status.code[]'?: string[];
search?: string;
/**
 * Project notInternalSource filter
 */
notInternalSource?: string[];
'agreementFrom[between]'?: string;
'agreementFrom[gt]'?: string;
'agreementFrom[gte]'?: string;
'agreementFrom[lt]'?: string;
'agreementFrom[lte]'?: string;
'agreementFrom[eq]'?: string;
'agreementTo[between]'?: string;
'agreementTo[gt]'?: string;
'agreementTo[gte]'?: string;
'agreementTo[lt]'?: string;
'agreementTo[lte]'?: string;
'agreementTo[eq]'?: string;
'createdAt[between]'?: string;
'createdAt[gt]'?: string;
'createdAt[gte]'?: string;
'createdAt[lt]'?: string;
'createdAt[lte]'?: string;
'createdAt[eq]'?: string;
'updatedAt[between]'?: string;
'updatedAt[gt]'?: string;
'updatedAt[gte]'?: string;
'updatedAt[lt]'?: string;
'updatedAt[lte]'?: string;
'updatedAt[eq]'?: string;
'propertyOffer.property.areaValue[between]'?: string;
'propertyOffer.property.areaValue[gt]'?: string;
'propertyOffer.property.areaValue[gte]'?: string;
'propertyOffer.property.areaValue[lt]'?: string;
'propertyOffer.property.areaValue[lte]'?: string;
'propertyOffer.property.areaValue[eq]'?: string;
'propertyOffer.property.areaTotal[between]'?: string;
'propertyOffer.property.areaTotal[gt]'?: string;
'propertyOffer.property.areaTotal[gte]'?: string;
'propertyOffer.property.areaTotal[lt]'?: string;
'propertyOffer.property.areaTotal[lte]'?: string;
'propertyOffer.property.areaTotal[eq]'?: string;
'propertyOffer.property.nbRooms[between]'?: string;
'propertyOffer.property.nbRooms[gt]'?: string;
'propertyOffer.property.nbRooms[gte]'?: string;
'propertyOffer.property.nbRooms[lt]'?: string;
'propertyOffer.property.nbRooms[lte]'?: string;
'propertyOffer.property.nbRooms[eq]'?: string;
'propertyOffer.property.nbBedrooms[between]'?: string;
'propertyOffer.property.nbBedrooms[gt]'?: string;
'propertyOffer.property.nbBedrooms[gte]'?: string;
'propertyOffer.property.nbBedrooms[lt]'?: string;
'propertyOffer.property.nbBedrooms[lte]'?: string;
'propertyOffer.property.nbBedrooms[eq]'?: string;
'propertyOffer.property.floor[between]'?: string;
'propertyOffer.property.floor[gt]'?: string;
'propertyOffer.property.floor[gte]'?: string;
'propertyOffer.property.floor[lt]'?: string;
'propertyOffer.property.floor[lte]'?: string;
'propertyOffer.property.floor[eq]'?: string;
'propertyOffer.propertyOffer.priceValue[between]'?: string;
'propertyOffer.propertyOffer.priceValue[gt]'?: string;
'propertyOffer.propertyOffer.priceValue[gte]'?: string;
'propertyOffer.propertyOffer.priceValue[lt]'?: string;
'propertyOffer.propertyOffer.priceValue[lte]'?: string;
'propertyOffer.propertyOffer.priceValue[eq]'?: string;
'order[id]'?: GetProjectsOrderId;
'order[createdAt]'?: GetProjectsOrderCreatedAt;
'order[updatedAt]'?: GetProjectsOrderUpdatedAt;
};

export type GetPeopleParams = {
/**
 * Include collaborators in the response
 */
withCollaborators?: boolean;
/**
 * Include projects in the response
 */
withProjects?: boolean;
};

export type GetSimilarPeople200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetSimilarPeople200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetSimilarPeople200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetSimilarPeople200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetSimilarPeople200 = {
  'hydra:member': PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  'hydra:search'?: GetSimilarPeople200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetSimilarPeople200HydraView;
};

export type GetSimilarPeopleParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetPeoplesExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPeoplesExcelExportData200 = {
  'hydra:member': PeopleJsonldReadCollectionPeopleExcelExport[];
  'hydra:search'?: GetPeoplesExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPeoplesExcelExportData200HydraView;
};

export type GetPeoplesExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPeoplesExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPeoplesExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPeoplesExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
};

export type GetPeoples200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPeoples200 = {
  'hydra:member': PeopleJsonldReadCollectionPeople[];
  'hydra:search'?: GetPeoples200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPeoples200HydraView;
};

export type GetPeoples200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPeoples200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPeoples200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPeoplesOrderClusterClusterName = typeof GetPeoplesOrderClusterClusterName[keyof typeof GetPeoplesOrderClusterClusterName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPeoplesOrderClusterClusterName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPeoplesOrderLastname = typeof GetPeoplesOrderLastname[keyof typeof GetPeoplesOrderLastname];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPeoplesOrderLastname = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPeoplesOrderUpdatedAt = typeof GetPeoplesOrderUpdatedAt[keyof typeof GetPeoplesOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPeoplesOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPeoplesOrderCreatedAt = typeof GetPeoplesOrderCreatedAt[keyof typeof GetPeoplesOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPeoplesOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPeoplesOrderStatusCode = typeof GetPeoplesOrderStatusCode[keyof typeof GetPeoplesOrderStatusCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPeoplesOrderStatusCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetPeoplesParams = {
/**
 * Set to true to skip total count (faster). itemsPerPage and page still apply.
 */
partial?: boolean;
/**
 * Include minimal properties in the response
 */
withMinProps?: boolean;
/**
 * Include clusters in the response
 */
withClusters?: boolean;
/**
 * Include minimal clusters in the response
 */
withClustersMinProps?: boolean;
/**
 * Include collaborators in the response
 */
withCollaborators?: boolean;
/**
 * Include projects in the response
 */
withProjects?: boolean;
/**
 * Include spouses in the response
 */
withSpouses?: boolean;
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
birthdate?: string;
'birthdate[]'?: string;
'status.code'?: string;
'status.code[]'?: string[];
'cluster.cluster.id'?: string;
'cluster.cluster.id[]'?: string[];
'cluster.cluster.type.code'?: string;
'cluster.cluster.type.code[]'?: string[];
'collaborator.isDefault'?: boolean;
'collaborator.isDefault[]'?: boolean[];
'collaborator.collaborator.id'?: string;
'collaborator.collaborator.id[]'?: string[];
'project.project.status.code'?: string;
'project.project.status.code[]'?: string[];
'project.project.type.code'?: string;
'project.project.type.code[]'?: string[];
'project.project.subtype.code'?: string;
'project.project.subtype.code[]'?: string[];
'project.project.propertyOffer.property.type.code'?: string;
'project.project.propertyOffer.property.type.code[]'?: string[];
'project.project.propertyOffer.property.subtype.code'?: string;
'project.project.propertyOffer.property.subtype.code[]'?: string[];
'project.project.propertyOffer.property.areaUnit.code'?: string;
'project.project.propertyOffer.property.areaUnit.code[]'?: string[];
'project.project.propertyOffer.propertyOffer.type.code'?: string;
'project.project.propertyOffer.propertyOffer.type.code[]'?: string[];
'project.project.propertyOffer.propertyOffer.subtype.code'?: string;
'project.project.propertyOffer.propertyOffer.subtype.code[]'?: string[];
'project.project.propertyOffer.propertyOffer.reference'?: string;
'project.project.propertyOffer.propertyOffer.reference[]'?: string[];
'project.project.propertyOffer.propertyOffer.currency.code'?: string;
'project.project.propertyOffer.propertyOffer.currency.code[]'?: string[];
'project.project.propertyOffer.propertyOffer.status.code'?: string;
'project.project.propertyOffer.propertyOffer.status.code[]'?: string[];
'project.project.propertySearch.propertySearch.priceCurrency.code'?: string;
'project.project.propertySearch.propertySearch.priceCurrency.code[]'?: string[];
'project.project.propertySearch.propertySearch.status.code'?: string;
'project.project.propertySearch.propertySearch.status.code[]'?: string[];
search?: string;
'project.offer.count[between]'?: string;
'project.offer.count[gt]'?: string;
'project.offer.count[gte]'?: string;
'project.offer.count[lt]'?: string;
'project.offer.count[lte]'?: string;
'project.offer.count[eq]'?: string;
'project.request.count[between]'?: string;
'project.request.count[gt]'?: string;
'project.request.count[gte]'?: string;
'project.request.count[lt]'?: string;
'project.request.count[lte]'?: string;
'project.request.count[eq]'?: string;
'project.project.propertyOffer.property.areaValue[between]'?: string;
'project.project.propertyOffer.property.areaValue[gt]'?: string;
'project.project.propertyOffer.property.areaValue[gte]'?: string;
'project.project.propertyOffer.property.areaValue[lt]'?: string;
'project.project.propertyOffer.property.areaValue[lte]'?: string;
'project.project.propertyOffer.property.areaValue[eq]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[between]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[gt]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[gte]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[lt]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[lte]'?: string;
'project.project.propertyOffer.propertyOffer.priceValue[eq]'?: string;
'project.project.propertySearch.propertySearch.priceMin[between]'?: string;
'project.project.propertySearch.propertySearch.priceMin[gt]'?: string;
'project.project.propertySearch.propertySearch.priceMin[gte]'?: string;
'project.project.propertySearch.propertySearch.priceMin[lt]'?: string;
'project.project.propertySearch.propertySearch.priceMin[lte]'?: string;
'project.project.propertySearch.propertySearch.priceMin[eq]'?: string;
'project.project.propertySearch.propertySearch.priceMax[between]'?: string;
'project.project.propertySearch.propertySearch.priceMax[gt]'?: string;
'project.project.propertySearch.propertySearch.priceMax[gte]'?: string;
'project.project.propertySearch.propertySearch.priceMax[lt]'?: string;
'project.project.propertySearch.propertySearch.priceMax[lte]'?: string;
'project.project.propertySearch.propertySearch.priceMax[eq]'?: string;
'createdAt[between]'?: string;
'createdAt[gt]'?: string;
'createdAt[gte]'?: string;
'createdAt[lt]'?: string;
'createdAt[lte]'?: string;
'createdAt[eq]'?: string;
'order[status.code]'?: GetPeoplesOrderStatusCode;
'order[createdAt]'?: GetPeoplesOrderCreatedAt;
'order[updatedAt]'?: GetPeoplesOrderUpdatedAt;
'order[lastname]'?: GetPeoplesOrderLastname;
'order[cluster.cluster.name]'?: GetPeoplesOrderClusterClusterName;
birthdayInNextDays?: number;
isShared?: boolean;
};

export type ApiMediaFoldersGetCollection200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type ApiMediaFoldersGetCollection200 = {
  'hydra:member': MediaFolderJsonld[];
  'hydra:search'?: ApiMediaFoldersGetCollection200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: ApiMediaFoldersGetCollection200HydraView;
};

export type ApiMediaFoldersGetCollection200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type ApiMediaFoldersGetCollection200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: ApiMediaFoldersGetCollection200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type ApiMediaFoldersGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type ListFolder200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type ListFolder200 = {
  'hydra:member': MediaJsonld[];
  'hydra:search'?: ListFolder200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: ListFolder200HydraView;
};

export type ListFolder200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type ListFolder200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: ListFolder200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type ListFolderParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type ListFile200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type ListFile200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type ListFile200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: ListFile200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type ListFile200 = {
  'hydra:member': MediaJsonld[];
  'hydra:search'?: ListFile200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: ListFile200HydraView;
};

export type ListFileParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GetMarketSegmentByIdParams = {
/**
 * Order by property (e.g., order[id]=asc).
 */
order?: {[key: string]: string};
/**
 * Search filter for direct children.
 */
children_search?: string;
/**
 * Depth for sorting children recursively.
 */
order_depth?: number;
};

export type GetMarketSegments200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetMarketSegments200 = {
  'hydra:member': MarketSegmentJsonldReadCollectionMarketSegment[];
  'hydra:search'?: GetMarketSegments200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetMarketSegments200HydraView;
};

export type GetMarketSegments200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetMarketSegments200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetMarketSegments200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetMarketSegmentsOrderUpdatedAt = typeof GetMarketSegmentsOrderUpdatedAt[keyof typeof GetMarketSegmentsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMarketSegmentsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMarketSegmentsOrderCreatedAt = typeof GetMarketSegmentsOrderCreatedAt[keyof typeof GetMarketSegmentsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMarketSegmentsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMarketSegmentsOrderCode = typeof GetMarketSegmentsOrderCode[keyof typeof GetMarketSegmentsOrderCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMarketSegmentsOrderCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMarketSegmentsOrderLabel = typeof GetMarketSegmentsOrderLabel[keyof typeof GetMarketSegmentsOrderLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMarketSegmentsOrderLabel = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMarketSegmentsOrderId = typeof GetMarketSegmentsOrderId[keyof typeof GetMarketSegmentsOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMarketSegmentsOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetMarketSegmentsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'parent.id'?: string;
'parent.id[]'?: string[];
/**
 * The depth level for sorting children recursively.
 */
order_depth?: number;
search?: string;
'order[id]'?: GetMarketSegmentsOrderId;
'order[label]'?: GetMarketSegmentsOrderLabel;
'order[code]'?: GetMarketSegmentsOrderCode;
'order[createdAt]'?: GetMarketSegmentsOrderCreatedAt;
'order[updatedAt]'?: GetMarketSegmentsOrderUpdatedAt;
};

export type GetSynchroStatus200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetSynchroStatus200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetSynchroStatus200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetSynchroStatus200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetSynchroStatus200 = {
  'hydra:member': MBV4SynchroJsonldReadCollectionSynchroStatus[];
  'hydra:search'?: GetSynchroStatus200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetSynchroStatus200HydraView;
};

export type GetSynchroStatusParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetBarnesStatusUpdated200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetBarnesStatusUpdated200 = {
  'hydra:member': MBV4SynchroJsonldReadCollectionBarnesStatusUpdated[];
  'hydra:search'?: GetBarnesStatusUpdated200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetBarnesStatusUpdated200HydraView;
};

export type GetBarnesStatusUpdated200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetBarnesStatusUpdated200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetBarnesStatusUpdated200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetBarnesStatusUpdatedParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetBarnesStatusDeleted200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetBarnesStatusDeleted200 = {
  'hydra:member': MBV4SynchroJsonldReadCollectionBarnesSttausDeleted[];
  'hydra:search'?: GetBarnesStatusDeleted200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetBarnesStatusDeleted200HydraView;
};

export type GetBarnesStatusDeleted200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetBarnesStatusDeleted200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetBarnesStatusDeleted200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetBarnesStatusDeletedParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type LoginCheckPost200 = {
  /** */
  readonly token: string;
};

export type LoginCheckPostBody = {
  /** */
  email: string;
  /** */
  password: string;
};

export type GetItemActions200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetItemActions200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetItemActions200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetItemActions200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetItemActions200 = {
  'hydra:member': ItemActionJsonldReadCollectionItemAction[];
  'hydra:search'?: GetItemActions200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetItemActions200HydraView;
};

export type GetItemActionsOrderOrder = typeof GetItemActionsOrderOrder[keyof typeof GetItemActionsOrderOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetItemActionsOrderOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetItemActionsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
action?: string;
'action[]'?: string[];
itemName?: string;
'itemName[]'?: string[];
'order[order]'?: GetItemActionsOrderOrder;
};

export type GetInterBuStatsDirection = typeof GetInterBuStatsDirection[keyof typeof GetInterBuStatsDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInterBuStatsDirection = {
  received: 'received',
  sent: 'sent',
  all: 'all',
} as const;

export type GetInterBuStatsParams = {
/**
 * Shares received or sent by the current user, or both (all)
 */
direction: GetInterBuStatsDirection;
'status.code'?: string;
'fromCluster.id'?: string;
'toCluster.id'?: string;
'interBu.fromManager.id'?: string;
'toManager.id'?: string;
search?: string;
};

export type GetInterBuExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetInterBuExcelExportData200 = {
  'hydra:member': InterBuExcelExportRowJsonldReadCollectionInterbuExcelExport[];
  'hydra:search'?: GetInterBuExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetInterBuExcelExportData200HydraView;
};

export type GetInterBuExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetInterBuExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetInterBuExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type PostInterbuFileBody = {
  attachment: Blob;
};

export type PatchInterbuBodyTwo = {
  /** Mandatory when shareddata.status is completed. */
  attachment?: Blob;
  /** JSON string containing patch fields (comment, subject_end, message_end, shareddata.id, shareddata.status). */
  json_data?: string;
};

export type PatchInterbuBodyOneShareddata = {
  id: string;
  status?: string;
};

export type PatchInterbuBodyOne = {
  comment?: string;
  message_end?: string;
  shareddata?: PatchInterbuBodyOneShareddata;
  subject_end?: string;
};

export type GetInterBus200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetInterBus200 = {
  'hydra:member': InterBuJsonldReadCollectionInterbu[];
  'hydra:search'?: GetInterBus200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetInterBus200HydraView;
};

export type GetInterBus200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetInterBus200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetInterBus200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetInterBusParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
search?: string;
};

export type GetHobbyCategories200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetHobbyCategories200 = {
  'hydra:member': HobbyCategoryJsonldReadCollectionHobbyCategory[];
  'hydra:search'?: GetHobbyCategories200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetHobbyCategories200HydraView;
};

export type GetHobbyCategories200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetHobbyCategories200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetHobbyCategories200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetHobbyCategoriesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GetHelpdesks200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetHelpdesks200 = {
  'hydra:member': HelpdeskJsonldReadCollectionHelpdesk[];
  'hydra:search'?: GetHelpdesks200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetHelpdesks200HydraView;
};

export type GetHelpdesks200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetHelpdesks200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetHelpdesks200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetHelpdesksParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetEvents200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetEvents200 = {
  'hydra:member': EventJsonldReadCollectionEvent[];
  'hydra:search'?: GetEvents200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetEvents200HydraView;
};

export type GetEvents200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetEvents200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetEvents200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetEventsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetUserClusters200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetUserClusters200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetUserClusters200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetUserClusters200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetUserClusters200 = {
  'hydra:member': EntityResourceJsonldReadCollectionUserClustersEntityCanSetId[];
  'hydra:search'?: GetUserClusters200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetUserClusters200HydraView;
};

export type GetUserClustersParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetUserClustersNoId200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetUserClustersNoId200 = {
  'hydra:member': EntityResourceJsonldReadCollectionUserClusters[];
  'hydra:search'?: GetUserClustersNoId200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetUserClustersNoId200HydraView;
};

export type GetUserClustersNoId200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetUserClustersNoId200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetUserClustersNoId200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetUserClustersNoIdParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
};

export type GetDirectoryClusterCollaborators200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetDirectoryClusterCollaborators200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetDirectoryClusterCollaborators200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetDirectoryClusterCollaborators200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetDirectoryClusterCollaborators200 = {
  'hydra:member': DirectoryCollaboratorJsonldReadCollectionDirectoryCollaborator[];
  'hydra:search'?: GetDirectoryClusterCollaborators200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetDirectoryClusterCollaborators200HydraView;
};

export type GetDirectoryClusters200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetDirectoryClusters200 = {
  'hydra:member': DirectoryClusterJsonldReadCollectionDirectoryCluster[];
  'hydra:search'?: GetDirectoryClusters200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetDirectoryClusters200HydraView;
};

export type GetDirectoryClusters200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetDirectoryClusters200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetDirectoryClusters200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetDirectoryClustersTypeItem = typeof GetDirectoryClustersTypeItem[keyof typeof GetDirectoryClustersTypeItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDirectoryClustersTypeItem = {
  digital: 'digital',
  physical: 'physical',
  barnes_sas: 'barnes_sas',
  expertise_service: 'expertise_service',
  internal_service: 'internal_service',
  hospitality: 'hospitality',
} as const;

export type GetDirectoryClustersStatusItem = typeof GetDirectoryClustersStatusItem[keyof typeof GetDirectoryClustersStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDirectoryClustersStatusItem = {
  active: 'active',
  archive: 'archive',
  deleted: 'deleted',
  other: 'other',
} as const;

export type GetDirectoryClustersParams = {
/**
 * Agency statuses; ignored for non-admin users, who only see active agencies
 */
'status[]'?: GetDirectoryClustersStatusItem[];
/**
 * Agencies having at least one of these types
 */
'type[]'?: GetDirectoryClustersTypeItem[];
/**
 * Agency name, city, country or area of expertise, or name or function of a published collaborator (case and accent insensitive); its digits: the beginning of the postcode
 */
search?: string;
};

export type PostCollaboratorMediaBody = {
  file?: Blob;
  isDefault?: boolean;
  order?: number;
  replaceAll?: boolean;
  replaceID?: string;
  skipUpload?: boolean;
  usage?: string;
};

export type GetCollaboratorsExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetCollaboratorsExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetCollaboratorsExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetCollaboratorsExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetCollaboratorsExcelExportData200 = {
  'hydra:member': CollaboratorJsonldReadCollectionCollaboratorExcelExport[];
  'hydra:search'?: GetCollaboratorsExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetCollaboratorsExcelExportData200HydraView;
};

export type GetCollaboratorsExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
};

export type GetCollaborators200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetCollaborators200 = {
  'hydra:member': CollaboratorJsonldReadCollectionCollaborator[];
  'hydra:search'?: GetCollaborators200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetCollaborators200HydraView;
};

export type GetCollaborators200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetCollaborators200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetCollaborators200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetCollaboratorsOrderClusterRankRefLabelGroupRelationOrder = typeof GetCollaboratorsOrderClusterRankRefLabelGroupRelationOrder[keyof typeof GetCollaboratorsOrderClusterRankRefLabelGroupRelationOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderClusterRankRefLabelGroupRelationOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsOrderUpdatedAt = typeof GetCollaboratorsOrderUpdatedAt[keyof typeof GetCollaboratorsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsOrderCreatedAt = typeof GetCollaboratorsOrderCreatedAt[keyof typeof GetCollaboratorsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsOrderFullname = typeof GetCollaboratorsOrderFullname[keyof typeof GetCollaboratorsOrderFullname];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderFullname = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsOrderLastname = typeof GetCollaboratorsOrderLastname[keyof typeof GetCollaboratorsOrderLastname];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderLastname = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsOrderId = typeof GetCollaboratorsOrderId[keyof typeof GetCollaboratorsOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollaboratorsOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCollaboratorsParams = {
/**
 * Filter the associated RelCollaboratorCluster by the ID of the linked Cluster.
 */
cluster_id?: string;
/**
 * Include minimal properties in the response
 */
withMinProps?: boolean;
/**
 * Include minimal clusters in the response
 */
withClustersMinProps?: boolean;
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
firstname?: string;
lastname?: string;
fullname?: string;
'status.code'?: string;
'status.code[]'?: string[];
internalSource?: string;
'internalSource[]'?: string[];
'legalRepresentative.agencyOwner.id'?: string;
'legalRepresentative.agencyOwner.id[]'?: string[];
'cluster.isDefault'?: boolean;
'cluster.isDefault[]'?: boolean[];
'cluster.isPublished'?: boolean;
'cluster.isPublished[]'?: boolean[];
'cluster.isPublishedInDirectory'?: boolean;
'cluster.isPublishedInDirectory[]'?: boolean[];
'cluster.status.code'?: string;
'cluster.status.code[]'?: string[];
'cluster.rank.refLabelGroupRelation.refLabel.code'?: string;
'cluster.rank.refLabelGroupRelation.refLabel.code[]'?: string[];
'cluster.cluster.id'?: string;
'cluster.cluster.id[]'?: string[];
'cluster.cluster.internalSource'?: string;
'cluster.cluster.internalSource[]'?: string[];
'cluster.cluster.type'?: string;
'cluster.cluster.type[]'?: string[];
'cluster.cluster.status.code'?: string;
'cluster.cluster.status.code[]'?: string[];
'cluster.cluster.type.code'?: string;
'cluster.cluster.type.code[]'?: string[];
'agency.agency.id'?: string;
'agency.agency.id[]'?: string[];
'agency.agency.internalSource'?: string;
'agency.agency.internalSource[]'?: string[];
'agency.agency.name'?: string;
'agency.agency.status.code'?: string;
'agency.agency.status.code[]'?: string[];
'project.isDefault'?: boolean;
'project.isDefault[]'?: boolean[];
'project.project.id'?: string;
'project.project.id[]'?: string[];
'project.project.internalSource'?: string;
'project.project.internalSource[]'?: string[];
'project.project.status.code'?: string;
'project.project.type.code'?: string;
'project.project.propertyOffer.id'?: string;
'project.project.propertyOffer.id[]'?: string[];
'project.project.propertyOffer.property.id'?: string;
'project.project.propertyOffer.property.id[]'?: string[];
'project.project.propertyOffer.property.internalSource'?: string;
'project.project.propertyOffer.property.internalSource[]'?: string[];
'project.project.propertyOffer.property.status.code'?: string;
'project.project.propertyOffer.property.type.code'?: string;
'project.project.propertyOffer.property.name'?: string;
'project.project.people.id'?: string;
'project.project.people.id[]'?: string[];
'people.isDefault'?: boolean;
'people.isDefault[]'?: boolean[];
'people.people.id'?: string;
'people.people.id[]'?: string[];
'people.people.firstname'?: string;
'people.people.lastname'?: string;
search?: string;
'order[id]'?: GetCollaboratorsOrderId;
'order[lastname]'?: GetCollaboratorsOrderLastname;
'order[fullname]'?: GetCollaboratorsOrderFullname;
'order[createdAt]'?: GetCollaboratorsOrderCreatedAt;
'order[updatedAt]'?: GetCollaboratorsOrderUpdatedAt;
'order[cluster.rank.refLabelGroupRelation.order]'?: GetCollaboratorsOrderClusterRankRefLabelGroupRelationOrder;
/**
 * Collaborator notInternalSource filter
 */
notInternalSource?: string[];
};

export type GetCollaboratorParams = {
/**
 * Include projects in the response
 */
withProjects?: boolean;
/**
 * Include people in the response
 */
withPeople?: boolean;
/**
 * Include legal representatives in the response
 */
withLegalRepresentatives?: boolean;
/**
 * Include clusters in the response
 */
withClusters?: boolean;
/**
 * Include agencies in the response
 */
withAgencies?: boolean;
};

export type PostClusterMediaBody = {
  file?: Blob;
  isDefault?: boolean;
  order?: number;
  replaceAll?: boolean;
  replaceID?: string;
  skipUpload?: boolean;
  usage?: string;
};

export type GetClustersExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClustersExcelExportData200 = {
  'hydra:member': ClusterJsonldReadCollectionClusterExcelExport[];
  'hydra:search'?: GetClustersExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClustersExcelExportData200HydraView;
};

export type GetClustersExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClustersExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClustersExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClustersExcelExportDataOrderUpdatedAt = typeof GetClustersExcelExportDataOrderUpdatedAt[keyof typeof GetClustersExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersExcelExportDataOrderCreatedAt = typeof GetClustersExcelExportDataOrderCreatedAt[keyof typeof GetClustersExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersExcelExportDataOrderName = typeof GetClustersExcelExportDataOrderName[keyof typeof GetClustersExcelExportDataOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersExcelExportDataOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersExcelExportDataOrderId = typeof GetClustersExcelExportDataOrderId[keyof typeof GetClustersExcelExportDataOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersExcelExportDataOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'order[id]'?: GetClustersExcelExportDataOrderId;
'order[name]'?: GetClustersExcelExportDataOrderName;
'order[createdAt]'?: GetClustersExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetClustersExcelExportDataOrderUpdatedAt;
};

export type GetClusters200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClusters200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClusters200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClusters200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClusters200 = {
  'hydra:member': ClusterJsonldReadCollectionCluster[];
  'hydra:search'?: GetClusters200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClusters200HydraView;
};

export type GetClustersOrderUpdatedAt = typeof GetClustersOrderUpdatedAt[keyof typeof GetClustersOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersOrderCreatedAt = typeof GetClustersOrderCreatedAt[keyof typeof GetClustersOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersOrderId = typeof GetClustersOrderId[keyof typeof GetClustersOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersOrderName = typeof GetClustersOrderName[keyof typeof GetClustersOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClustersOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClustersParams = {
/**
 * Include minimal properties in the response
 */
withMinProps?: boolean;
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Latitude (decimal degrees) of the point clusters are sorted by distance from
 */
'near[lat]'?: number;
/**
 * Longitude (decimal degrees) of the point clusters are sorted by distance from
 */
'near[lng]'?: number;
/**
 * Leave out the clusters whose only type is "physical"
 */
notPhysicalOnly?: boolean;
id?: string;
'id[]'?: string[];
name?: string;
'type.code'?: string;
'type.code[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'agencyOwner.agencyOwner.id'?: string;
'agencyOwner.agencyOwner.id[]'?: string[];
'agencyOwner.agencyOwner.name'?: string;
'agencyOwner.agencyOwner.officialName'?: string;
'agencyOwner.agencyOwner.brand'?: string;
'agencyOwner.agencyOwner.officialCode'?: string;
'agencyOwner.agencyOwner.status.code'?: string;
'collaborator.isDefault'?: boolean;
'collaborator.isDefault[]'?: boolean[];
'collaborator.isPublished'?: boolean;
'collaborator.isPublished[]'?: boolean[];
'collaborator.isPublishedInDirectory'?: boolean;
'collaborator.isPublishedInDirectory[]'?: boolean[];
'collaborator.collaborator.id'?: string;
'collaborator.collaborator.id[]'?: string[];
'collaborator.collaborator.firstname'?: string;
'collaborator.collaborator.lastname'?: string;
'collaborator.collaborator.status.code'?: string;
'collaborator.role.code'?: string;
'collaborator.role.code[]'?: string[];
'agency.agency.id'?: string;
'agency.agency.id[]'?: string[];
'agency.agency.name'?: string;
'agency.agency.status.code'?: string;
'project.project.id'?: string;
'project.project.id[]'?: string[];
'project.project.status.code'?: string;
'project.project.type.code'?: string;
'project.project.propertyOffer.id'?: string;
'project.project.propertyOffer.id[]'?: string[];
'project.project.propertyOffer.property.id'?: string;
'project.project.propertyOffer.property.id[]'?: string[];
'project.project.propertyOffer.property.status.code'?: string;
'project.project.propertyOffer.property.type.code'?: string;
'project.project.propertyOffer.property.name'?: string;
'project.project.people.id'?: string;
'project.project.people.id[]'?: string[];
'people.isDefault'?: boolean;
'people.isDefault[]'?: boolean[];
'people.people.id'?: string;
'people.people.id[]'?: string[];
search?: string;
'order[name]'?: GetClustersOrderName;
/**
 * Cluster notInternalSource filter
 */
notInternalSource?: string[];
'order[id]'?: GetClustersOrderId;
'order[createdAt]'?: GetClustersOrderCreatedAt;
'order[updatedAt]'?: GetClustersOrderUpdatedAt;
};

export type GetClusterParams = {
/**
 * Include collaborators in the response
 */
withCollaborators?: boolean;
/**
 * Include collaborators count in the response, true by defaultif withCollaborators is true
 */
nbCollaborators?: boolean;
/**
 * Include projects in the response
 */
withProjects?: boolean;
/**
 * Include projects count in the response, true by default if withProjects is true
 */
nbProjects?: boolean;
/**
 * Include people in the response
 */
withPeople?: boolean;
/**
 * Include people count in the response, true by default if withPeople is true
 */
nbPeople?: boolean;
/**
 * Include agencies in the response
 */
withAgencies?: boolean;
/**
 * Include agencies count in the response, true by default if withAgencies is true
 */
nbAgencies?: boolean;
/**
 * Include agency owners in the response
 */
withAgencyOwners?: boolean;
/**
 * Include agency owners count in the response, true by default if withAgencyOwners is true
 */
nbAgencyOwners?: boolean;
};

export type ApiClientsClientAccessRequestsGetSubresource200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type ApiClientsClientAccessRequestsGetSubresource200 = {
  'hydra:member': ClientAccessRequestJsonldReadCollectionClientAccessRequest[];
  'hydra:search'?: ApiClientsClientAccessRequestsGetSubresource200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: ApiClientsClientAccessRequestsGetSubresource200HydraView;
};

export type ApiClientsClientAccessRequestsGetSubresource200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type ApiClientsClientAccessRequestsGetSubresource200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: ApiClientsClientAccessRequestsGetSubresource200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetPendingClientAccessRequest200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetPendingClientAccessRequest200 = {
  'hydra:member': ClientAccessRequestJsonldReadCollectionClientAccessRequest[];
  'hydra:search'?: GetPendingClientAccessRequest200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetPendingClientAccessRequest200HydraView;
};

export type GetPendingClientAccessRequest200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetPendingClientAccessRequest200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetPendingClientAccessRequest200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAnsweredClientAccessRequest200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetAnsweredClientAccessRequest200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetAnsweredClientAccessRequest200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetAnsweredClientAccessRequest200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAnsweredClientAccessRequest200 = {
  'hydra:member': ClientAccessRequestJsonldReadCollectionClientAccessRequest[];
  'hydra:search'?: GetAnsweredClientAccessRequest200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetAnsweredClientAccessRequest200HydraView;
};

export type GetClients200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetClients200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetClients200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetClients200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetClients200 = {
  'hydra:member': ClientJsonldReadCollectionClient[];
  'hydra:search'?: GetClients200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetClients200HydraView;
};

export type GetClientsOrderUpdatedAt = typeof GetClientsOrderUpdatedAt[keyof typeof GetClientsOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsOrderCreatedAt = typeof GetClientsOrderCreatedAt[keyof typeof GetClientsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsOrderBusinessUnitName = typeof GetClientsOrderBusinessUnitName[keyof typeof GetClientsOrderBusinessUnitName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderBusinessUnitName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsOrderProfileType = typeof GetClientsOrderProfileType[keyof typeof GetClientsOrderProfileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderProfileType = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsOrderLastName = typeof GetClientsOrderLastName[keyof typeof GetClientsOrderLastName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderLastName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsOrderFirstName = typeof GetClientsOrderFirstName[keyof typeof GetClientsOrderFirstName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClientsOrderFirstName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetClientsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
profileType?: string;
'profileType[]'?: string[];
familySituation?: string;
'familySituation[]'?: string[];
nationality?: string;
'nationality[]'?: string[];
businessUnit?: string;
'businessUnit[]'?: string[];
contactOrigin?: string;
'contactOrigin[]'?: string[];
'projects.type'?: string;
'projects.type[]'?: string[];
'projects.status'?: string;
'projects.status[]'?: string[];
'projects.property.type'?: string;
'projects.property.type[]'?: string[];
'projects.property.currency'?: string;
'projects.property.currency[]'?: string[];
'address.country'?: string;
'address.country[]'?: string[];
'address.city'?: string;
'address.city[]'?: string[];
'address.postcode'?: string;
'projects.property.address.country'?: string;
'projects.property.address.country[]'?: string[];
'projects.property.address.city'?: string;
'projects.property.address.city[]'?: string[];
'projects.property.address.postcode'?: string;
'birthdate[before]'?: string;
'birthdate[strictly_before]'?: string;
'birthdate[after]'?: string;
'birthdate[strictly_after]'?: string;
'projects.property.surfaceAreaInSquareMeters[between]'?: string;
'projects.property.surfaceAreaInSquareMeters[gt]'?: string;
'projects.property.surfaceAreaInSquareMeters[gte]'?: string;
'projects.property.surfaceAreaInSquareMeters[lt]'?: string;
'projects.property.surfaceAreaInSquareMeters[lte]'?: string;
'projects.property.price[between]'?: string;
'projects.property.price[gt]'?: string;
'projects.property.price[gte]'?: string;
'projects.property.price[lt]'?: string;
'projects.property.price[lte]'?: string;
languages?: string;
'languages[]'?: string[];
hasChild?: boolean;
'order[firstName]'?: GetClientsOrderFirstName;
'order[lastName]'?: GetClientsOrderLastName;
'order[profileType]'?: GetClientsOrderProfileType;
'order[businessUnit.name]'?: GetClientsOrderBusinessUnitName;
'order[createdAt]'?: GetClientsOrderCreatedAt;
'order[updatedAt]'?: GetClientsOrderUpdatedAt;
or?: string;
'projects[gte]'?: string;
'projects[lte]'?: string;
search?: string;
/**
 * Post code collection
 */
'address.postcode[]'?: string[];
/**
 * Project post code collection
 */
'projects.property.address.postcode[]'?: string[];
};

export type GetCircles200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetCircles200 = {
  'hydra:member': CircleJsonldReadCollectionCircle[];
  'hydra:search'?: GetCircles200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetCircles200HydraView;
};

export type GetCircles200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetCircles200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetCircles200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetCirclesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GetBusinessUnitNames200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetBusinessUnitNames200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetBusinessUnitNames200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetBusinessUnitNames200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetBusinessUnitNames200 = {
  'hydra:member': BusinessUnitJsonldReadCollectionNames[];
  'hydra:search'?: GetBusinessUnitNames200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetBusinessUnitNames200HydraView;
};

export type GetBusinessUnitNamesParams = {
/**
 * Enable or disable pagination
 */
pagination?: boolean;
};

export type GetBrevoNewslettersTop3200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetBrevoNewslettersTop3200 = {
  'hydra:member': BrevoNewsletterJsonld[];
  'hydra:search'?: GetBrevoNewslettersTop3200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetBrevoNewslettersTop3200HydraView;
};

export type GetBrevoNewslettersTop3200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetBrevoNewslettersTop3200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetBrevoNewslettersTop3200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAgencyParams = {
/**
 * Include collaborators in the response
 */
withCollaborators?: boolean;
/**
 * Include clusters in the response
 */
withClusters?: boolean;
/**
 * Include agency owners in the response
 */
withAgencyOwners?: boolean;
};

export type PostAgencyMediaBody = {
  file?: Blob;
  isDefault?: boolean;
  order?: number;
  replaceAll?: boolean;
  replaceID?: string;
  skipUpload?: boolean;
  usage?: string;
};

export type GetAgenciesExcelExportData200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetAgenciesExcelExportData200 = {
  'hydra:member': AgencyJsonldReadCollectionAgencyExcelExport[];
  'hydra:search'?: GetAgenciesExcelExportData200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetAgenciesExcelExportData200HydraView;
};

export type GetAgenciesExcelExportData200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetAgenciesExcelExportData200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetAgenciesExcelExportData200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAgenciesExcelExportDataOrderUpdatedAt = typeof GetAgenciesExcelExportDataOrderUpdatedAt[keyof typeof GetAgenciesExcelExportDataOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesExcelExportDataOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesExcelExportDataOrderCreatedAt = typeof GetAgenciesExcelExportDataOrderCreatedAt[keyof typeof GetAgenciesExcelExportDataOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesExcelExportDataOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesExcelExportDataOrderOfficialName = typeof GetAgenciesExcelExportDataOrderOfficialName[keyof typeof GetAgenciesExcelExportDataOrderOfficialName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesExcelExportDataOrderOfficialName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesExcelExportDataOrderName = typeof GetAgenciesExcelExportDataOrderName[keyof typeof GetAgenciesExcelExportDataOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesExcelExportDataOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesExcelExportDataOrderId = typeof GetAgenciesExcelExportDataOrderId[keyof typeof GetAgenciesExcelExportDataOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesExcelExportDataOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesExcelExportDataParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
'status.code'?: string;
'status.code[]'?: string[];
'order[id]'?: GetAgenciesExcelExportDataOrderId;
'order[name]'?: GetAgenciesExcelExportDataOrderName;
'order[officialName]'?: GetAgenciesExcelExportDataOrderOfficialName;
'order[createdAt]'?: GetAgenciesExcelExportDataOrderCreatedAt;
'order[updatedAt]'?: GetAgenciesExcelExportDataOrderUpdatedAt;
};

export type GetAgencies200HydraView = {
  '@id'?: string;
  '@type'?: string;
  'hydra:first'?: string;
  'hydra:last'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
};

export type GetAgencies200 = {
  'hydra:member': AgencyJsonldReadCollectionAgency[];
  'hydra:search'?: GetAgencies200HydraSearch;
  /** @minimum 0 */
  'hydra:totalItems'?: number;
  'hydra:view'?: GetAgencies200HydraView;
};

export type GetAgencies200HydraSearchHydraMappingItem = {
  '@type'?: string;
  /** @nullable */
  property?: string | null;
  required?: boolean;
  variable?: string;
};

export type GetAgencies200HydraSearch = {
  '@type'?: string;
  'hydra:mapping'?: GetAgencies200HydraSearchHydraMappingItem[];
  'hydra:template'?: string;
  'hydra:variableRepresentation'?: string;
};

export type GetAgenciesOrderOfficialName = typeof GetAgenciesOrderOfficialName[keyof typeof GetAgenciesOrderOfficialName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesOrderOfficialName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesOrderId = typeof GetAgenciesOrderId[keyof typeof GetAgenciesOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesOrderUpdatedAt = typeof GetAgenciesOrderUpdatedAt[keyof typeof GetAgenciesOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesOrderCreatedAt = typeof GetAgenciesOrderCreatedAt[keyof typeof GetAgenciesOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesOrderName = typeof GetAgenciesOrderName[keyof typeof GetAgenciesOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgenciesOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetAgenciesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 */
itemsPerPage?: number;
id?: string;
'id[]'?: string[];
name?: string;
officialName?: string;
'status.code'?: string;
'status.code[]'?: string[];
internalSource?: string;
'internalSource[]'?: string[];
'contactDetails.contactDetails.zipcode'?: string;
'contactDetails.contactDetails.country'?: string;
'contactDetails.contactDetails.city'?: string;
'collaborator.collaborator.id'?: string;
'collaborator.collaborator.id[]'?: string[];
'collaborator.collaborator.firstname'?: string;
'collaborator.collaborator.lastname'?: string;
'collaborator.collaborator.status.code'?: string;
'cluster.cluster.id'?: string;
'cluster.cluster.id[]'?: string[];
'cluster.cluster.internalSource'?: string;
'cluster.cluster.internalSource[]'?: string[];
'cluster.cluster.type'?: string;
'cluster.cluster.type[]'?: string[];
'cluster.cluster.status.code'?: string;
'cluster.cluster.type.code'?: string;
'agencyOwner.agencyOwner.id'?: string;
'agencyOwner.agencyOwner.id[]'?: string[];
'agencyOwner.agencyOwner.name'?: string;
'agencyOwner.agencyOwner.officialName'?: string;
'agencyOwner.agencyOwner.brand'?: string;
'agencyOwner.agencyOwner.officialCode'?: string;
'agencyOwner.agencyOwner.status.code'?: string;
'agencyOwner.agencyOwner.internalSource'?: string;
'agencyOwner.agencyOwner.internalSource[]'?: string[];
search?: string;
'order[name]'?: GetAgenciesOrderName;
'order[createdAt]'?: GetAgenciesOrderCreatedAt;
'order[updatedAt]'?: GetAgenciesOrderUpdatedAt;
/**
 * Agency notInternalSource filter
 */
notInternalSource?: string[];
'order[id]'?: GetAgenciesOrderId;
'order[officialName]'?: GetAgenciesOrderOfficialName;
};

export type DownloadMedia401 = {
  error?: string;
};

export type DownloadMedia400 = {
  error?: string;
};

export type PeoplePostPeopleResponsePeopleClusterItem = { [key: string]: unknown };

export type PeoplePostPeopleResponsePeople = {
  cluster?: PeoplePostPeopleResponsePeopleClusterItem[];
  /** @nullable */
  firstname?: string | null;
  id?: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
};

export interface PeoplePostPeopleResponse {
  id: string;
  message: string;
  people: PeoplePostPeopleResponsePeople;
}

export type InterBuPostInterBuResponsePeopleClusterItem = { [key: string]: unknown };

export type InterBuPostInterBuResponsePeople = {
  cluster?: InterBuPostInterBuResponsePeopleClusterItem[];
  /** @nullable */
  firstname?: string | null;
  id?: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
};

export interface InterBuPostInterBuResponse {
  id: string;
  message: string;
  people: InterBuPostInterBuResponsePeople;
}

export interface InvalidateRefreshTokenResponse {
  code: number;
  message: string;
}

export interface Credentials {
  email: string;
  password: string;
}

export interface Token {
  readonly token: string;
}

export type UserJsonldUserReadItemStatus = RefLabelJsonldUserReadItem | null;

export type UserJsonldUserReadItemSetting = SettingJsonldUserReadItem | null;

export type UserJsonldUserReadItemRolesItem = typeof UserJsonldUserReadItemRolesItem[keyof typeof UserJsonldUserReadItemRolesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldUserReadItemRolesItem = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_COLLABORATOR: 'ROLE_COLLABORATOR',
  ROLE_USER: 'ROLE_USER',
} as const;

export type UserJsonldUserReadItemLocale = typeof UserJsonldUserReadItemLocale[keyof typeof UserJsonldUserReadItemLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldUserReadItemLocale = {
  fr_FR: 'fr_FR',
  en_GB: 'en_GB',
} as const;

export type UserJsonldUserReadItemBusinessUnit = BusinessUnitJsonldUserReadItem | null;

export interface UserJsonldUserReadItem {
  readonly '@context'?: UserJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  businessUnit?: UserJsonldUserReadItemBusinessUnit;
  collaborators?: CollaboratorJsonldUserReadItem[];
  createdAt?: string;
  /** @nullable */
  deactivationComment?: string | null;
  /** @nullable */
  deactivationDate?: string | null;
  email: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  readonly isEmailRandom: boolean;
  /** @nullable */
  lastname?: string | null;
  locale: UserJsonldUserReadItemLocale;
  roles: UserJsonldUserReadItemRolesItem[];
  setting?: UserJsonldUserReadItemSetting;
  status?: UserJsonldUserReadItemStatus;
  updatedAt?: string;
}

export type UserJsonldUserReadItemContextOneOfHydra = typeof UserJsonldUserReadItemContextOneOfHydra[keyof typeof UserJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldUserReadItemContext = string | UserJsonldUserReadItemContextOneOf;

export type UserJsonldUserReadCollectionStatus = RefLabelJsonldUserReadCollection | null;

export type UserJsonldUserReadCollectionRolesItem = typeof UserJsonldUserReadCollectionRolesItem[keyof typeof UserJsonldUserReadCollectionRolesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldUserReadCollectionRolesItem = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_COLLABORATOR: 'ROLE_COLLABORATOR',
  ROLE_USER: 'ROLE_USER',
} as const;

export type UserJsonldUserReadCollectionLocale = typeof UserJsonldUserReadCollectionLocale[keyof typeof UserJsonldUserReadCollectionLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldUserReadCollectionLocale = {
  fr_FR: 'fr_FR',
  en_GB: 'en_GB',
} as const;

export type UserJsonldUserReadCollectionBusinessUnit = BusinessUnitJsonldUserReadCollection | null;

export interface UserJsonldUserReadCollection {
  readonly '@id'?: string;
  readonly '@type'?: string;
  businessUnit?: UserJsonldUserReadCollectionBusinessUnit;
  collaborators?: CollaboratorJsonldUserReadCollection[];
  createdAt?: string;
  /** @nullable */
  deactivationComment?: string | null;
  /** @nullable */
  deactivationDate?: string | null;
  email: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  readonly isEmailRandom: boolean;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale: UserJsonldUserReadCollectionLocale;
  roles: UserJsonldUserReadCollectionRolesItem[];
  status?: UserJsonldUserReadCollectionStatus;
  updatedAt?: string;
}

export interface UserJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: UserJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
}

export type UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadItemTpropertyWithoutPrivateDataContext = string | UserJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export type UserJsonldReadItemInterbuContextOneOfHydra = typeof UserJsonldReadItemInterbuContextOneOfHydra[keyof typeof UserJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadItemInterbuContext = string | UserJsonldReadItemInterbuContextOneOf;

export interface UserJsonldReadItemInterbu {
  readonly '@context'?: UserJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type UserJsonldReadItemHelpdeskItemContextOneOfHydra = typeof UserJsonldReadItemHelpdeskItemContextOneOfHydra[keyof typeof UserJsonldReadItemHelpdeskItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadItemHelpdeskItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadItemHelpdeskItemContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadItemHelpdeskItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadItemHelpdeskItemContext = string | UserJsonldReadItemHelpdeskItemContextOneOf;

export interface UserJsonldReadItemHelpdeskItem {
  readonly '@context'?: UserJsonldReadItemHelpdeskItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type UserJsonldReadItemCollaboratorItemContext = string | UserJsonldReadItemCollaboratorItemContextOneOf;

export interface UserJsonldReadItemCollaboratorItem {
  readonly '@context'?: UserJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type UserJsonldReadItemCollaboratorItemContextOneOfHydra = typeof UserJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof UserJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export interface UserJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: UserJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
}

export type UserJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof UserJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof UserJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadItemClientWithoutPrivateDataContext = string | UserJsonldReadItemClientWithoutPrivateDataContextOneOf;

export interface UserJsonldReadCollectionTpropertyWithoutPrivateData {
  readonly '@context'?: UserJsonldReadCollectionTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
}

export type UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = typeof UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionTpropertyWithoutPrivateDataContext = string | UserJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf;

export type UserJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = typeof UserJsonldReadCollectionTpropertyExcelExportContextOneOfHydra[keyof typeof UserJsonldReadCollectionTpropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionTpropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionTpropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionTpropertyExcelExportContext = string | UserJsonldReadCollectionTpropertyExcelExportContextOneOf;

export interface UserJsonldReadCollectionTpropertyExcelExport {
  readonly '@context'?: UserJsonldReadCollectionTpropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type UserJsonldReadCollectionSharedDataReadItemSharedDataRolesItem = typeof UserJsonldReadCollectionSharedDataReadItemSharedDataRolesItem[keyof typeof UserJsonldReadCollectionSharedDataReadItemSharedDataRolesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionSharedDataReadItemSharedDataRolesItem = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_COLLABORATOR: 'ROLE_COLLABORATOR',
  ROLE_USER: 'ROLE_USER',
} as const;

export interface UserJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: UserJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  email: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  roles: UserJsonldReadCollectionSharedDataReadItemSharedDataRolesItem[];
  updatedAt?: string;
}

export type UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionSharedDataReadItemSharedDataContext = string | UserJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type UserJsonldReadCollectionSharedDataRolesItem = typeof UserJsonldReadCollectionSharedDataRolesItem[keyof typeof UserJsonldReadCollectionSharedDataRolesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionSharedDataRolesItem = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_COLLABORATOR: 'ROLE_COLLABORATOR',
  ROLE_USER: 'ROLE_USER',
} as const;

export type UserJsonldReadCollectionSharedDataContextOneOfHydra = typeof UserJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof UserJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionSharedDataContext = string | UserJsonldReadCollectionSharedDataContextOneOf;

export interface UserJsonldReadCollectionSharedData {
  readonly '@context'?: UserJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  email: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  roles: UserJsonldReadCollectionSharedDataRolesItem[];
  updatedAt?: string;
}

export type UserJsonldReadCollectionProjectContextOneOfHydra = typeof UserJsonldReadCollectionProjectContextOneOfHydra[keyof typeof UserJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionProjectContext = string | UserJsonldReadCollectionProjectContextOneOf;

export interface UserJsonldReadCollectionProject {
  readonly '@context'?: UserJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type UserJsonldReadCollectionInterbuContextOneOfHydra = typeof UserJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof UserJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionInterbuContext = string | UserJsonldReadCollectionInterbuContextOneOf;

export interface UserJsonldReadCollectionInterbu {
  readonly '@context'?: UserJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type UserJsonldReadCollectionHelpdeskContext = string | UserJsonldReadCollectionHelpdeskContextOneOf;

export interface UserJsonldReadCollectionHelpdesk {
  readonly '@context'?: UserJsonldReadCollectionHelpdeskContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type UserJsonldReadCollectionHelpdeskContextOneOfHydra = typeof UserJsonldReadCollectionHelpdeskContextOneOfHydra[keyof typeof UserJsonldReadCollectionHelpdeskContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionHelpdeskContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionHelpdeskContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionHelpdeskContextOneOfHydra;
  [key: string]: unknown;
 };

export interface UserJsonldReadCollectionCollaborator {
  readonly '@context'?: UserJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type UserJsonldReadCollectionCollaboratorContextOneOfHydra = typeof UserJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof UserJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionCollaboratorContext = string | UserJsonldReadCollectionCollaboratorContextOneOf;

export interface UserJsonldReadCollectionClientAccessRequest {
  readonly '@context'?: UserJsonldReadCollectionClientAccessRequestContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
}

export type UserJsonldReadCollectionClientAccessRequestContextOneOfHydra = typeof UserJsonldReadCollectionClientAccessRequestContextOneOfHydra[keyof typeof UserJsonldReadCollectionClientAccessRequestContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionClientAccessRequestContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionClientAccessRequestContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionClientAccessRequestContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionClientAccessRequestContext = string | UserJsonldReadCollectionClientAccessRequestContextOneOf;

export type UserJsonldReadCollectionClientContextOneOfHydra = typeof UserJsonldReadCollectionClientContextOneOfHydra[keyof typeof UserJsonldReadCollectionClientContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldReadCollectionClientContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldReadCollectionClientContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldReadCollectionClientContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldReadCollectionClientContext = string | UserJsonldReadCollectionClientContextOneOf;

export interface UserJsonldReadCollectionClient {
  readonly '@context'?: UserJsonldReadCollectionClientContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type UserJsonldRolesItem = typeof UserJsonldRolesItem[keyof typeof UserJsonldRolesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldRolesItem = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_COLLABORATOR: 'ROLE_COLLABORATOR',
  ROLE_USER: 'ROLE_USER',
} as const;

export type UserJsonldLocale = typeof UserJsonldLocale[keyof typeof UserJsonldLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldLocale = {
  fr_FR: 'fr_FR',
  en_GB: 'en_GB',
} as const;

export type UserJsonldContextOneOfHydra = typeof UserJsonldContextOneOfHydra[keyof typeof UserJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type UserJsonldContextOneOf = {
  '@vocab': string;
  hydra: UserJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type UserJsonldContext = string | UserJsonldContextOneOf;

export interface UserJsonld {
  readonly '@context'?: UserJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  businessUnit?: string | null;
  collaborators?: string[];
  createdAt?: string;
  /** @nullable */
  deactivationComment?: string | null;
  /** @nullable */
  deactivationDate?: string | null;
  /** @nullable */
  readonly defaultCollaborator?: string | null;
  email: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  readonly isEmailRandom: boolean;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale: UserJsonldLocale;
  /** @nullable */
  readonly normalizedEmail?: string | null;
  /** @nullable */
  readonly normalizedFirstname?: string | null;
  /** @nullable */
  readonly normalizedLastname?: string | null;
  password: string;
  roles: UserJsonldRolesItem[];
  /** @nullable */
  setting?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
  readonly userIdentifier?: string;
}

export interface UserPatchUserInput {
  /** @nullable */
  collaborator?: CollaboratorUserDTO[] | null;
  /** @nullable */
  deactivationComment?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  locale?: string | null;
  /** @nullable */
  roles?: string[] | null;
  /** @nullable */
  status?: string | null;
}

export interface UserCreateUserInputJsonld {
  /** @nullable */
  collaborator?: CollaboratorUserDTOJsonld[] | null;
  /** @nullable */
  deactivationComment?: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  locale?: string | null;
  roles?: string[];
  /** @nullable */
  status: string | null;
}

export type TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type TsubscriptionJsonldReadItemClientWithoutPrivateDataContext = string | TsubscriptionJsonldReadItemClientWithoutPrivateDataContextOneOf;

export interface TsubscriptionJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: TsubscriptionJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name?: string;
}

export interface TsubscriptionJsonldReadCollectionSubscription {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name?: string;
}

export interface TsubscriptionJsonld {
  readonly '@context'?: TsubscriptionJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  clients?: string[];
  readonly id: string;
  name?: string;
}

export type TsubscriptionJsonldContextOneOfHydra = typeof TsubscriptionJsonldContextOneOfHydra[keyof typeof TsubscriptionJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TsubscriptionJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TsubscriptionJsonldContextOneOf = {
  '@vocab': string;
  hydra: TsubscriptionJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type TsubscriptionJsonldContext = string | TsubscriptionJsonldContextOneOf;

export type TsubscriptionTranslationsDTOTranslations = {[key: string]: {[key: string]: string}};

export interface TsubscriptionTranslationsDTO {
  translations: TsubscriptionTranslationsDTOTranslations;
}

export interface TsubscriptionPostSubscriptionInputJsonld {
  translations?: MandatoryTranslationsDTOJsonld;
}

export type TsubscriptionPatchSubscriptionInputTranslations = OptionalTranslationsDTO | null;

export interface TsubscriptionPatchSubscriptionInput {
  translations?: TsubscriptionPatchSubscriptionInputTranslations;
}

export interface TranslationsInputDTOJsonld {
  field?: string;
  label?: string;
  locale?: string;
}

export interface TranslationsInputDTO {
  field?: string;
  label?: string;
  locale?: string;
}

export interface TranslationsExtInputDTOJsonldWriteItemMarketSegmentItem {
  field?: string;
  label?: string;
  locale?: string;
}

export interface TranslationsExtInputDTOWriteItemMarketSegmentItem {
  field?: string;
  label?: string;
  locale?: string;
}

export interface TranslationsExtInputDTO {
  field?: string;
  label?: string;
  locale?: string;
}

export interface TpropertyViewTypeJsonldReadCollectionTpropertyViewType {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertyViewJsonldReadCollectionTpropertyView {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertySubTypeJsonldReadCollectionTpropertySubType {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertyStateJsonldReadCollectionTpropertyState {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertySpecificityJsonldReadCollectionTpropertySpecificity {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertySituationJsonldReadCollectionTpropertySituation {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertyMandateTypeJsonldReadCollectionTpropertyMandateType {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertyFacilityJsonldReadCollectionTpropertyFacility {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export interface TpropertyAvailabilityJsonldReadCollectionTpropertyAvailability {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataVisibility = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataVisibility[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataVisibility = {
  NOT_CONFIDENTIAL: 'NOT_CONFIDENTIAL',
  CONFIDENTIAL: 'CONFIDENTIAL',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataType = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataType[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataProjectType = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataProjectType[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataProjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataProjectType = {
  ACQUISITION: 'ACQUISITION',
  LOCATION: 'LOCATION',
  SEASONAL_LOCATION: 'SEASONAL_LOCATION',
  SALE: 'SALE',
  RENTAL: 'RENTAL',
  SEASONAL_RENTAL: 'SEASONAL_RENTAL',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataPricePeriodicity = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataPricePeriodicity[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataPricePeriodicity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataPricePeriodicity = {
  PER_NIGHT: 'PER_NIGHT',
  PER_WEEK: 'PER_WEEK',
  ON_DEMAND: 'ON_DEMAND',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplaySurfaceUnit = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplaySurfaceUnit[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplaySurfaceUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplaySurfaceUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplayLandSurfaceUnit = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplayLandSurfaceUnit[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplayLandSurfaceUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplayLandSurfaceUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataBroadcastedWebsitesItem = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataBroadcastedWebsitesItem[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataBroadcastedWebsitesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataBroadcastedWebsitesItem = {
  BARNES_INTERNATIONAL_REALTY_BRUSSELS: 'BARNES_INTERNATIONAL_REALTY_BRUSSELS',
  BARNES_INTERNATIONAL_REALTY_SWISS: 'BARNES_INTERNATIONAL_REALTY_SWISS',
  BARNES_INTERNATIONAL_REALTY: 'BARNES_INTERNATIONAL_REALTY',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataApproximateCoordinates = (PointJsonldReadItemTpropertyWithoutPrivateData & {
  readonly srid?: number;
  readonly x?: number;
  readonly y?: number;
}) | (null & {
  readonly srid?: number;
  readonly x?: number;
  readonly y?: number;
});

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataAddress = AddressJsonldReadItemTpropertyWithoutPrivateData | null;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type TpropertyJsonldReadItemTpropertyWithoutPrivateDataContext = string | TpropertyJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export interface TpropertyJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  address?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataAddress;
  readonly approximateCoordinates?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataApproximateCoordinates;
  broadcastedWebsites: TpropertyJsonldReadItemTpropertyWithoutPrivateDataBroadcastedWebsitesItem[];
  businessUnit: BusinessUnitJsonldReadItemTpropertyWithoutPrivateData;
  client: ClientJsonldReadItemTpropertyWithoutPrivateData;
  readonly confidentialDataIncluded?: boolean;
  createdAt?: string;
  displayLandSurfaceUnit?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplayLandSurfaceUnit;
  displaySurfaceUnit?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataDisplaySurfaceUnit;
  /** @nullable */
  dpe?: string | null;
  /** @nullable */
  externalReference?: string | null;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  ges?: string | null;
  /** @nullable */
  hasDoubleGlazing?: boolean | null;
  /** @nullable */
  hasElevator?: boolean | null;
  /** @nullable */
  hasFireplace?: boolean | null;
  /** @nullable */
  hasInternet?: boolean | null;
  /** @nullable */
  hasSauna?: boolean | null;
  readonly id: string;
  /** @nullable */
  landSurfaceAreaInSquareMeters?: number | null;
  /** @nullable */
  numberOfBathrooms?: number | null;
  /** @nullable */
  numberOfBedrooms?: number | null;
  /** @nullable */
  numberOfParking?: number | null;
  /** @nullable */
  numberOfRooms?: number | null;
  pictures?: string[];
  pricePeriodicity?: TpropertyJsonldReadItemTpropertyWithoutPrivateDataPricePeriodicity;
  project: TprojectJsonldReadItemTpropertyWithoutPrivateData;
  projectType: TpropertyJsonldReadItemTpropertyWithoutPrivateDataProjectType;
  /** @nullable */
  surfaceAreaInSquareMeters?: number | null;
  type: TpropertyJsonldReadItemTpropertyWithoutPrivateDataType;
  user: UserJsonldReadItemTpropertyWithoutPrivateData;
  visibility: TpropertyJsonldReadItemTpropertyWithoutPrivateDataVisibility;
}

export type TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataType = typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataType[keyof typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplaySurfaceUnit = typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplaySurfaceUnit[keyof typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplaySurfaceUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplaySurfaceUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplayLandSurfaceUnit = typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplayLandSurfaceUnit[keyof typeof TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplayLandSurfaceUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplayLandSurfaceUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataAddress = AddressJsonldReadCollectionTpropertyWithoutPrivateData | null;

export interface TpropertyJsonldReadCollectionTpropertyWithoutPrivateData {
  readonly '@id'?: string;
  readonly '@type'?: string;
  address?: TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataAddress;
  businessUnit: BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateData;
  readonly confidentialDataIncluded?: boolean;
  createdAt?: string;
  displayLandSurfaceUnit?: TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplayLandSurfaceUnit;
  displaySurfaceUnit?: TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataDisplaySurfaceUnit;
  readonly id: string;
  /** @nullable */
  landSurfaceAreaInSquareMeters?: number | null;
  /** @nullable */
  numberOfRooms?: number | null;
  pictures?: string[];
  /** @nullable */
  surfaceAreaInSquareMeters?: number | null;
  type: TpropertyJsonldReadCollectionTpropertyWithoutPrivateDataType;
  user: UserJsonldReadCollectionTpropertyWithoutPrivateData;
}

export type TpropertyJsonldReadCollectionTpropertyExcelExportType = typeof TpropertyJsonldReadCollectionTpropertyExcelExportType[keyof typeof TpropertyJsonldReadCollectionTpropertyExcelExportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyExcelExportType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TpropertyJsonldReadCollectionTpropertyExcelExportDisplaySurfaceUnit = typeof TpropertyJsonldReadCollectionTpropertyExcelExportDisplaySurfaceUnit[keyof typeof TpropertyJsonldReadCollectionTpropertyExcelExportDisplaySurfaceUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyExcelExportDisplaySurfaceUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TpropertyJsonldReadCollectionTpropertyExcelExportCurrency = typeof TpropertyJsonldReadCollectionTpropertyExcelExportCurrency[keyof typeof TpropertyJsonldReadCollectionTpropertyExcelExportCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionTpropertyExcelExportCurrency = {
  EUR: 'EUR',
  USD: 'USD',
  CAD: 'CAD',
  HUF: 'HUF',
  MUR: 'MUR',
  MAD: 'MAD',
  RUB: 'RUB',
  CHF: 'CHF',
  GBP: 'GBP',
} as const;

export type TpropertyJsonldReadCollectionTpropertyExcelExportAddress = AddressJsonldReadCollectionTpropertyExcelExport | null;

export interface TpropertyJsonldReadCollectionTpropertyExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  address?: TpropertyJsonldReadCollectionTpropertyExcelExportAddress;
  businessUnit: BusinessUnitJsonldReadCollectionTpropertyExcelExport;
  client: ClientJsonldReadCollectionTpropertyExcelExport;
  createdAt?: string;
  currency?: TpropertyJsonldReadCollectionTpropertyExcelExportCurrency;
  displaySurfaceUnit?: TpropertyJsonldReadCollectionTpropertyExcelExportDisplaySurfaceUnit;
  /** @nullable */
  floor?: number | null;
  readonly id: string;
  /** @nullable */
  numberOfBedrooms?: number | null;
  /** @nullable */
  price?: number | null;
  project: TprojectJsonldReadCollectionTpropertyExcelExport;
  /** @nullable */
  surfaceAreaInSquareMeters?: number | null;
  type: TpropertyJsonldReadCollectionTpropertyExcelExportType;
  updatedAt?: string;
  user: UserJsonldReadCollectionTpropertyExcelExport;
}

export type TpropertyJsonldReadCollectionProjectType = typeof TpropertyJsonldReadCollectionProjectType[keyof typeof TpropertyJsonldReadCollectionProjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionProjectType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TpropertyJsonldReadCollectionProjectAddress = AddressJsonldReadCollectionProject | null;

export interface TpropertyJsonldReadCollectionProject {
  readonly '@context'?: TpropertyJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  address?: TpropertyJsonldReadCollectionProjectAddress;
  businessUnit: BusinessUnitJsonldReadCollectionProject;
  createdAt?: string;
  readonly id: string;
  type: TpropertyJsonldReadCollectionProjectType;
  updatedAt?: string;
}

export type TpropertyJsonldReadCollectionProjectContextOneOfHydra = typeof TpropertyJsonldReadCollectionProjectContextOneOfHydra[keyof typeof TpropertyJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TpropertyJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: TpropertyJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type TpropertyJsonldReadCollectionProjectContext = string | TpropertyJsonldReadCollectionProjectContextOneOf;

export type TpropertyLogsOutputJsonldContextOneOfHydra = typeof TpropertyLogsOutputJsonldContextOneOfHydra[keyof typeof TpropertyLogsOutputJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyLogsOutputJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TpropertyLogsOutputJsonldContextOneOf = {
  '@vocab': string;
  hydra: TpropertyLogsOutputJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type TpropertyLogsOutputJsonldContext = string | TpropertyLogsOutputJsonldContextOneOf;

export interface TpropertyLogsOutputJsonld {
  readonly '@context'?: TpropertyLogsOutputJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  logs?: LogJsonld[];
}

export type TpropertyWriteItemTpropertyBroadcastedWebsitesItem = typeof TpropertyWriteItemTpropertyBroadcastedWebsitesItem[keyof typeof TpropertyWriteItemTpropertyBroadcastedWebsitesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TpropertyWriteItemTpropertyBroadcastedWebsitesItem = {
  BARNES_INTERNATIONAL_REALTY_BRUSSELS: 'BARNES_INTERNATIONAL_REALTY_BRUSSELS',
  BARNES_INTERNATIONAL_REALTY_SWISS: 'BARNES_INTERNATIONAL_REALTY_SWISS',
  BARNES_INTERNATIONAL_REALTY: 'BARNES_INTERNATIONAL_REALTY',
} as const;

export interface TpropertyWriteItemTproperty {
  broadcastedWebsites: TpropertyWriteItemTpropertyBroadcastedWebsitesItem[];
}

export type TprojectJsonldReadItemTpropertyWithoutPrivateDataStatus = typeof TprojectJsonldReadItemTpropertyWithoutPrivateDataStatus[keyof typeof TprojectJsonldReadItemTpropertyWithoutPrivateDataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadItemTpropertyWithoutPrivateDataStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export interface TprojectJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: TprojectJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status: TprojectJsonldReadItemTpropertyWithoutPrivateDataStatus;
}

export type TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type TprojectJsonldReadItemTpropertyWithoutPrivateDataContext = string | TprojectJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export type TprojectJsonldReadCollectionTpropertyExcelExportType = typeof TprojectJsonldReadCollectionTpropertyExcelExportType[keyof typeof TprojectJsonldReadCollectionTpropertyExcelExportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadCollectionTpropertyExcelExportType = {
  ACQUISITION: 'ACQUISITION',
  LOCATION: 'LOCATION',
  SEASONAL_LOCATION: 'SEASONAL_LOCATION',
  SALE: 'SALE',
  RENTAL: 'RENTAL',
  SEASONAL_RENTAL: 'SEASONAL_RENTAL',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
  PRIVATE_AVIATION: 'PRIVATE_AVIATION',
  CONSTRUCTION: 'CONSTRUCTION',
  ART_ADVISORY: 'ART_ADVISORY',
  YACHTING: 'YACHTING',
} as const;

export type TprojectJsonldReadCollectionTpropertyExcelExportStatus = typeof TprojectJsonldReadCollectionTpropertyExcelExportStatus[keyof typeof TprojectJsonldReadCollectionTpropertyExcelExportStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadCollectionTpropertyExcelExportStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export interface TprojectJsonldReadCollectionTpropertyExcelExport {
  readonly '@context'?: TprojectJsonldReadCollectionTpropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status: TprojectJsonldReadCollectionTpropertyExcelExportStatus;
  type: TprojectJsonldReadCollectionTpropertyExcelExportType;
  updatedAt?: string;
}

export type TprojectJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = typeof TprojectJsonldReadCollectionTpropertyExcelExportContextOneOfHydra[keyof typeof TprojectJsonldReadCollectionTpropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TprojectJsonldReadCollectionTpropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: TprojectJsonldReadCollectionTpropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type TprojectJsonldReadCollectionTpropertyExcelExportContext = string | TprojectJsonldReadCollectionTpropertyExcelExportContextOneOf;

export type TprojectJsonldReadCollectionProjectType = typeof TprojectJsonldReadCollectionProjectType[keyof typeof TprojectJsonldReadCollectionProjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadCollectionProjectType = {
  ACQUISITION: 'ACQUISITION',
  LOCATION: 'LOCATION',
  SEASONAL_LOCATION: 'SEASONAL_LOCATION',
  SALE: 'SALE',
  RENTAL: 'RENTAL',
  SEASONAL_RENTAL: 'SEASONAL_RENTAL',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
  PRIVATE_AVIATION: 'PRIVATE_AVIATION',
  CONSTRUCTION: 'CONSTRUCTION',
  ART_ADVISORY: 'ART_ADVISORY',
  YACHTING: 'YACHTING',
} as const;

export type TprojectJsonldReadCollectionProjectStatus = typeof TprojectJsonldReadCollectionProjectStatus[keyof typeof TprojectJsonldReadCollectionProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TprojectJsonldReadCollectionProjectStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export type TprojectJsonldReadCollectionProjectProperty = TpropertyJsonldReadCollectionProject | null;

export interface TprojectJsonldReadCollectionProject {
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  property?: TprojectJsonldReadCollectionProjectProperty;
  status: TprojectJsonldReadCollectionProjectStatus;
  type: TprojectJsonldReadCollectionProjectType;
  updatedAt?: string;
  user: UserJsonldReadCollectionProject;
}

export interface TimetablesHoursDTOJsonld {
  appointmentOnly?: boolean;
  from?: string;
  to?: string;
}

export interface TimetablesHoursDTO {
  appointmentOnly?: boolean;
  from?: string;
  to?: string;
}

export interface TimetablesDTOJsonld {
  /** @nullable */
  friday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  monday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  saturday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  sunday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  thursday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  tuesday?: TimetablesHoursDTOJsonld[] | null;
  /** @nullable */
  wednesday?: TimetablesHoursDTOJsonld[] | null;
}

export interface TimetablesDTO {
  /** @nullable */
  friday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  monday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  saturday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  sunday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  thursday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  tuesday?: TimetablesHoursDTO[] | null;
  /** @nullable */
  wednesday?: TimetablesHoursDTO[] | null;
}

export type TInterBuJsonldReadItemInterbuUserRole = typeof TInterBuJsonldReadItemInterbuUserRole[keyof typeof TInterBuJsonldReadItemInterbuUserRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuUserRole = {
  DIRECT_DECISION_MAKER: 'DIRECT_DECISION_MAKER',
  INDIRECT_DECISION_MAKER: 'INDIRECT_DECISION_MAKER',
  INTERMEDIATE: 'INTERMEDIATE',
} as const;

export type TInterBuJsonldReadItemInterbuSurfaceAreaUnit = typeof TInterBuJsonldReadItemInterbuSurfaceAreaUnit[keyof typeof TInterBuJsonldReadItemInterbuSurfaceAreaUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuSurfaceAreaUnit = {
  'm²': 'm²',
  'ft²': 'ft²',
  ha: 'ha',
} as const;

export type TInterBuJsonldReadItemInterbuStatus = typeof TInterBuJsonldReadItemInterbuStatus[keyof typeof TInterBuJsonldReadItemInterbuStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuStatus = {
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ABANDONED: 'ABANDONED',
  REFUSED: 'REFUSED',
} as const;

export type TInterBuJsonldReadItemInterbuSpendingLimitCurrency = typeof TInterBuJsonldReadItemInterbuSpendingLimitCurrency[keyof typeof TInterBuJsonldReadItemInterbuSpendingLimitCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuSpendingLimitCurrency = {
  EUR: 'EUR',
  USD: 'USD',
  CAD: 'CAD',
  HUF: 'HUF',
  MUR: 'MUR',
  MAD: 'MAD',
  RUB: 'RUB',
  CHF: 'CHF',
  GBP: 'GBP',
} as const;

export type TInterBuJsonldReadItemInterbuSenderBusinessUnit = BusinessUnitJsonldReadItemInterbu | null;

export type TInterBuJsonldReadItemInterbuRelationType = typeof TInterBuJsonldReadItemInterbuRelationType[keyof typeof TInterBuJsonldReadItemInterbuRelationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuRelationType = {
  COUPLE: 'COUPLE',
  FAMILY: 'FAMILY',
  PROFESSIONAL: 'PROFESSIONAL',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVICE: 'ADVICE',
} as const;

export type TInterBuJsonldReadItemInterbuRecipientUser = UserJsonldReadItemInterbu | null;

export type TInterBuJsonldReadItemInterbuPropertyType = typeof TInterBuJsonldReadItemInterbuPropertyType[keyof typeof TInterBuJsonldReadItemInterbuPropertyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuPropertyType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TInterBuJsonldReadItemInterbuProjectType = typeof TInterBuJsonldReadItemInterbuProjectType[keyof typeof TInterBuJsonldReadItemInterbuProjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuProjectType = {
  ACQUISITION: 'ACQUISITION',
  LOCATION: 'LOCATION',
  SEASONAL_LOCATION: 'SEASONAL_LOCATION',
  SALE: 'SALE',
  RENTAL: 'RENTAL',
  SEASONAL_RENTAL: 'SEASONAL_RENTAL',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
} as const;

export type TInterBuJsonldReadItemInterbuDepartureCountry = typeof TInterBuJsonldReadItemInterbuDepartureCountry[keyof typeof TInterBuJsonldReadItemInterbuDepartureCountry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuDepartureCountry = {
  af: 'af',
  ax: 'ax',
  al: 'al',
  dz: 'dz',
  as: 'as',
  ad: 'ad',
  ao: 'ao',
  ai: 'ai',
  aq: 'aq',
  ag: 'ag',
  ar: 'ar',
  am: 'am',
  aw: 'aw',
  au: 'au',
  at: 'at',
  az: 'az',
  bs: 'bs',
  bh: 'bh',
  bd: 'bd',
  bb: 'bb',
  by: 'by',
  be: 'be',
  bz: 'bz',
  bj: 'bj',
  bm: 'bm',
  bt: 'bt',
  bo: 'bo',
  ba: 'ba',
  bw: 'bw',
  bv: 'bv',
  br: 'br',
  io: 'io',
  vg: 'vg',
  bn: 'bn',
  bg: 'bg',
  bf: 'bf',
  bi: 'bi',
  kh: 'kh',
  cm: 'cm',
  ca: 'ca',
  cv: 'cv',
  bq: 'bq',
  ky: 'ky',
  cf: 'cf',
  td: 'td',
  cl: 'cl',
  cn: 'cn',
  cx: 'cx',
  cc: 'cc',
  co: 'co',
  km: 'km',
  ck: 'ck',
  cr: 'cr',
  ci: 'ci',
  hr: 'hr',
  cu: 'cu',
  cw: 'cw',
  cy: 'cy',
  cz: 'cz',
  cd: 'cd',
  dk: 'dk',
  dj: 'dj',
  dm: 'dm',
  do: 'do',
  ec: 'ec',
  eg: 'eg',
  sv: 'sv',
  gq: 'gq',
  er: 'er',
  ee: 'ee',
  sz: 'sz',
  et: 'et',
  fk: 'fk',
  fo: 'fo',
  fj: 'fj',
  fi: 'fi',
  fr: 'fr',
  gf: 'gf',
  pf: 'pf',
  tf: 'tf',
  ga: 'ga',
  gm: 'gm',
  ge: 'ge',
  de: 'de',
  gh: 'gh',
  gi: 'gi',
  gr: 'gr',
  gl: 'gl',
  gd: 'gd',
  gp: 'gp',
  gu: 'gu',
  gt: 'gt',
  gg: 'gg',
  gn: 'gn',
  gw: 'gw',
  gy: 'gy',
  ht: 'ht',
  hm: 'hm',
  hn: 'hn',
  hk: 'hk',
  hu: 'hu',
  is: 'is',
  in: 'in',
  id: 'id',
  ir: 'ir',
  iq: 'iq',
  ie: 'ie',
  im: 'im',
  il: 'il',
  it: 'it',
  jm: 'jm',
  jp: 'jp',
  je: 'je',
  jo: 'jo',
  kz: 'kz',
  ke: 'ke',
  ki: 'ki',
  xk: 'xk',
  kw: 'kw',
  kg: 'kg',
  la: 'la',
  lv: 'lv',
  lb: 'lb',
  ls: 'ls',
  lr: 'lr',
  ly: 'ly',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mo: 'mo',
  mg: 'mg',
  mw: 'mw',
  my: 'my',
  mv: 'mv',
  ml: 'ml',
  mt: 'mt',
  mh: 'mh',
  mq: 'mq',
  mr: 'mr',
  mu: 'mu',
  yt: 'yt',
  mx: 'mx',
  fm: 'fm',
  md: 'md',
  mc: 'mc',
  mn: 'mn',
  me: 'me',
  ms: 'ms',
  ma: 'ma',
  mz: 'mz',
  mm: 'mm',
  na: 'na',
  nr: 'nr',
  np: 'np',
  nl: 'nl',
  nc: 'nc',
  nz: 'nz',
  ni: 'ni',
  ne: 'ne',
  ng: 'ng',
  nu: 'nu',
  nf: 'nf',
  kp: 'kp',
  mk: 'mk',
  mp: 'mp',
  no: 'no',
  om: 'om',
  pk: 'pk',
  pw: 'pw',
  ps: 'ps',
  pa: 'pa',
  pg: 'pg',
  py: 'py',
  pe: 'pe',
  ph: 'ph',
  pn: 'pn',
  pl: 'pl',
  pt: 'pt',
  pr: 'pr',
  qa: 'qa',
  cg: 'cg',
  re: 're',
  ro: 'ro',
  ru: 'ru',
  rw: 'rw',
  bl: 'bl',
  sh: 'sh',
  kn: 'kn',
  lc: 'lc',
  mf: 'mf',
  pm: 'pm',
  vc: 'vc',
  ws: 'ws',
  sm: 'sm',
  st: 'st',
  sa: 'sa',
  sn: 'sn',
  rs: 'rs',
  sc: 'sc',
  sl: 'sl',
  sg: 'sg',
  sx: 'sx',
  sk: 'sk',
  si: 'si',
  sb: 'sb',
  so: 'so',
  za: 'za',
  gs: 'gs',
  kr: 'kr',
  ss: 'ss',
  es: 'es',
  lk: 'lk',
  sd: 'sd',
  sr: 'sr',
  sj: 'sj',
  se: 'se',
  ch: 'ch',
  sy: 'sy',
  tw: 'tw',
  tj: 'tj',
  tz: 'tz',
  th: 'th',
  tl: 'tl',
  tg: 'tg',
  tk: 'tk',
  to: 'to',
  tt: 'tt',
  tn: 'tn',
  tr: 'tr',
  tm: 'tm',
  tc: 'tc',
  tv: 'tv',
  ug: 'ug',
  ua: 'ua',
  ae: 'ae',
  gb: 'gb',
  us: 'us',
  um: 'um',
  vi: 'vi',
  uy: 'uy',
  uz: 'uz',
  vu: 'vu',
  va: 'va',
  ve: 've',
  vn: 'vn',
  wf: 'wf',
  eh: 'eh',
  ye: 'ye',
  zm: 'zm',
  zw: 'zw',
} as const;

export type TInterBuJsonldReadItemInterbuCountry = typeof TInterBuJsonldReadItemInterbuCountry[keyof typeof TInterBuJsonldReadItemInterbuCountry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuCountry = {
  be: 'be',
  bg: 'bg',
  ca: 'ca',
  es: 'es',
  us: 'us',
  fr: 'fr',
  gr: 'gr',
  hu: 'hu',
  it: 'it',
  lu: 'lu',
  mu: 'mu',
  ma: 'ma',
  mc: 'mc',
  pt: 'pt',
  ru: 'ru',
  bl: 'bl',
  ch: 'ch',
  gb: 'gb',
} as const;

export type TInterBuJsonldReadItemInterbuArrivalCountry = typeof TInterBuJsonldReadItemInterbuArrivalCountry[keyof typeof TInterBuJsonldReadItemInterbuArrivalCountry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuArrivalCountry = {
  af: 'af',
  ax: 'ax',
  al: 'al',
  dz: 'dz',
  as: 'as',
  ad: 'ad',
  ao: 'ao',
  ai: 'ai',
  aq: 'aq',
  ag: 'ag',
  ar: 'ar',
  am: 'am',
  aw: 'aw',
  au: 'au',
  at: 'at',
  az: 'az',
  bs: 'bs',
  bh: 'bh',
  bd: 'bd',
  bb: 'bb',
  by: 'by',
  be: 'be',
  bz: 'bz',
  bj: 'bj',
  bm: 'bm',
  bt: 'bt',
  bo: 'bo',
  ba: 'ba',
  bw: 'bw',
  bv: 'bv',
  br: 'br',
  io: 'io',
  vg: 'vg',
  bn: 'bn',
  bg: 'bg',
  bf: 'bf',
  bi: 'bi',
  kh: 'kh',
  cm: 'cm',
  ca: 'ca',
  cv: 'cv',
  bq: 'bq',
  ky: 'ky',
  cf: 'cf',
  td: 'td',
  cl: 'cl',
  cn: 'cn',
  cx: 'cx',
  cc: 'cc',
  co: 'co',
  km: 'km',
  ck: 'ck',
  cr: 'cr',
  ci: 'ci',
  hr: 'hr',
  cu: 'cu',
  cw: 'cw',
  cy: 'cy',
  cz: 'cz',
  cd: 'cd',
  dk: 'dk',
  dj: 'dj',
  dm: 'dm',
  do: 'do',
  ec: 'ec',
  eg: 'eg',
  sv: 'sv',
  gq: 'gq',
  er: 'er',
  ee: 'ee',
  sz: 'sz',
  et: 'et',
  fk: 'fk',
  fo: 'fo',
  fj: 'fj',
  fi: 'fi',
  fr: 'fr',
  gf: 'gf',
  pf: 'pf',
  tf: 'tf',
  ga: 'ga',
  gm: 'gm',
  ge: 'ge',
  de: 'de',
  gh: 'gh',
  gi: 'gi',
  gr: 'gr',
  gl: 'gl',
  gd: 'gd',
  gp: 'gp',
  gu: 'gu',
  gt: 'gt',
  gg: 'gg',
  gn: 'gn',
  gw: 'gw',
  gy: 'gy',
  ht: 'ht',
  hm: 'hm',
  hn: 'hn',
  hk: 'hk',
  hu: 'hu',
  is: 'is',
  in: 'in',
  id: 'id',
  ir: 'ir',
  iq: 'iq',
  ie: 'ie',
  im: 'im',
  il: 'il',
  it: 'it',
  jm: 'jm',
  jp: 'jp',
  je: 'je',
  jo: 'jo',
  kz: 'kz',
  ke: 'ke',
  ki: 'ki',
  xk: 'xk',
  kw: 'kw',
  kg: 'kg',
  la: 'la',
  lv: 'lv',
  lb: 'lb',
  ls: 'ls',
  lr: 'lr',
  ly: 'ly',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mo: 'mo',
  mg: 'mg',
  mw: 'mw',
  my: 'my',
  mv: 'mv',
  ml: 'ml',
  mt: 'mt',
  mh: 'mh',
  mq: 'mq',
  mr: 'mr',
  mu: 'mu',
  yt: 'yt',
  mx: 'mx',
  fm: 'fm',
  md: 'md',
  mc: 'mc',
  mn: 'mn',
  me: 'me',
  ms: 'ms',
  ma: 'ma',
  mz: 'mz',
  mm: 'mm',
  na: 'na',
  nr: 'nr',
  np: 'np',
  nl: 'nl',
  nc: 'nc',
  nz: 'nz',
  ni: 'ni',
  ne: 'ne',
  ng: 'ng',
  nu: 'nu',
  nf: 'nf',
  kp: 'kp',
  mk: 'mk',
  mp: 'mp',
  no: 'no',
  om: 'om',
  pk: 'pk',
  pw: 'pw',
  ps: 'ps',
  pa: 'pa',
  pg: 'pg',
  py: 'py',
  pe: 'pe',
  ph: 'ph',
  pn: 'pn',
  pl: 'pl',
  pt: 'pt',
  pr: 'pr',
  qa: 'qa',
  cg: 'cg',
  re: 're',
  ro: 'ro',
  ru: 'ru',
  rw: 'rw',
  bl: 'bl',
  sh: 'sh',
  kn: 'kn',
  lc: 'lc',
  mf: 'mf',
  pm: 'pm',
  vc: 'vc',
  ws: 'ws',
  sm: 'sm',
  st: 'st',
  sa: 'sa',
  sn: 'sn',
  rs: 'rs',
  sc: 'sc',
  sl: 'sl',
  sg: 'sg',
  sx: 'sx',
  sk: 'sk',
  si: 'si',
  sb: 'sb',
  so: 'so',
  za: 'za',
  gs: 'gs',
  kr: 'kr',
  ss: 'ss',
  es: 'es',
  lk: 'lk',
  sd: 'sd',
  sr: 'sr',
  sj: 'sj',
  se: 'se',
  ch: 'ch',
  sy: 'sy',
  tw: 'tw',
  tj: 'tj',
  tz: 'tz',
  th: 'th',
  tl: 'tl',
  tg: 'tg',
  tk: 'tk',
  to: 'to',
  tt: 'tt',
  tn: 'tn',
  tr: 'tr',
  tm: 'tm',
  tc: 'tc',
  tv: 'tv',
  ug: 'ug',
  ua: 'ua',
  ae: 'ae',
  gb: 'gb',
  us: 'us',
  um: 'um',
  vi: 'vi',
  uy: 'uy',
  uz: 'uz',
  vu: 'vu',
  va: 'va',
  ve: 've',
  vn: 'vn',
  wf: 'wf',
  eh: 'eh',
  ye: 'ye',
  zm: 'zm',
  zw: 'zw',
} as const;

export type TInterBuJsonldReadItemInterbuActivity = typeof TInterBuJsonldReadItemInterbuActivity[keyof typeof TInterBuJsonldReadItemInterbuActivity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuActivity = {
  PROPERTY: 'PROPERTY',
  PRIVATE_AVIATION: 'PRIVATE_AVIATION',
  CONSTRUCTION: 'CONSTRUCTION',
  ART_ADVISORY: 'ART_ADVISORY',
} as const;

export type TInterBuJsonldReadItemInterbuContextOneOfHydra = typeof TInterBuJsonldReadItemInterbuContextOneOfHydra[keyof typeof TInterBuJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type TInterBuJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: TInterBuJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type TInterBuJsonldReadItemInterbuContext = string | TInterBuJsonldReadItemInterbuContextOneOf;

export interface TInterBuJsonldReadItemInterbu {
  readonly '@context'?: TInterBuJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: TInterBuJsonldReadItemInterbuActivity;
  arrivalCountry?: TInterBuJsonldReadItemInterbuArrivalCountry;
  client: ClientJsonldReadItemInterbu;
  /** @nullable */
  clientComment?: string | null;
  country?: TInterBuJsonldReadItemInterbuCountry;
  createdAt?: string;
  departureCountry?: TInterBuJsonldReadItemInterbuDepartureCountry;
  readonly id: string;
  isClientMailConfidential: boolean;
  isClientPhoneNumberConfidential: boolean;
  progressSteps?: InterBuProgressStepJsonldReadItemInterbu[];
  /** @nullable */
  projectComment?: string | null;
  projectType?: TInterBuJsonldReadItemInterbuProjectType;
  propertyType?: TInterBuJsonldReadItemInterbuPropertyType;
  recipientBusinessUnit: BusinessUnitJsonldReadItemInterbu;
  /** @nullable */
  recipientComment?: string | null;
  recipientUser?: TInterBuJsonldReadItemInterbuRecipientUser;
  relationType: TInterBuJsonldReadItemInterbuRelationType;
  senderBusinessUnit?: TInterBuJsonldReadItemInterbuSenderBusinessUnit;
  senderUser: UserJsonldReadItemInterbu;
  /** @nullable */
  spendingLimit?: number | null;
  spendingLimitCurrency?: TInterBuJsonldReadItemInterbuSpendingLimitCurrency;
  readonly status: TInterBuJsonldReadItemInterbuStatus;
  /** @nullable */
  surfaceArea?: number | null;
  surfaceAreaUnit?: TInterBuJsonldReadItemInterbuSurfaceAreaUnit;
  updatedAt?: string;
  userRole: TInterBuJsonldReadItemInterbuUserRole;
}

export type TInterBuJsonldReadCollectionInterbuStatus = typeof TInterBuJsonldReadCollectionInterbuStatus[keyof typeof TInterBuJsonldReadCollectionInterbuStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadCollectionInterbuStatus = {
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ABANDONED: 'ABANDONED',
  REFUSED: 'REFUSED',
} as const;

export type TInterBuJsonldReadCollectionInterbuSenderBusinessUnit = BusinessUnitJsonldReadCollectionInterbu | null;

export type TInterBuJsonldReadCollectionInterbuRecipientUser = UserJsonldReadCollectionInterbu | null;

export type TInterBuJsonldReadCollectionInterbuPropertyType = typeof TInterBuJsonldReadCollectionInterbuPropertyType[keyof typeof TInterBuJsonldReadCollectionInterbuPropertyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadCollectionInterbuPropertyType = {
  HOUSE: 'HOUSE',
  VILLA: 'VILLA',
  COTTAGE: 'COTTAGE',
  FARM: 'FARM',
  FLAT: 'FLAT',
  LOFT: 'LOFT',
  DUPLEX: 'DUPLEX',
  LAND: 'LAND',
  MANSION: 'MANSION',
  BUILDING: 'BUILDING',
  OFFICE_OR_BUSINESS: 'OFFICE_OR_BUSINESS',
  CASTEL_OR_MANOR: 'CASTEL_OR_MANOR',
  WINE_ESTATE: 'WINE_ESTATE',
  STUD_FARM_AND_EQUESTRIAN_ESTATE: 'STUD_FARM_AND_EQUESTRIAN_ESTATE',
  HUNTING_TERRAIN: 'HUNTING_TERRAIN',
  CELLAR_OR_BOX: 'CELLAR_OR_BOX',
  PARKING: 'PARKING',
  APARTMENT: 'APARTMENT',
} as const;

export type TInterBuJsonldReadCollectionInterbuProjectType = typeof TInterBuJsonldReadCollectionInterbuProjectType[keyof typeof TInterBuJsonldReadCollectionInterbuProjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadCollectionInterbuProjectType = {
  ACQUISITION: 'ACQUISITION',
  LOCATION: 'LOCATION',
  SEASONAL_LOCATION: 'SEASONAL_LOCATION',
  SALE: 'SALE',
  RENTAL: 'RENTAL',
  SEASONAL_RENTAL: 'SEASONAL_RENTAL',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
} as const;

export type TInterBuJsonldReadCollectionInterbuActivity = typeof TInterBuJsonldReadCollectionInterbuActivity[keyof typeof TInterBuJsonldReadCollectionInterbuActivity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TInterBuJsonldReadCollectionInterbuActivity = {
  PROPERTY: 'PROPERTY',
  PRIVATE_AVIATION: 'PRIVATE_AVIATION',
  CONSTRUCTION: 'CONSTRUCTION',
  ART_ADVISORY: 'ART_ADVISORY',
} as const;

export interface TInterBuJsonldReadCollectionInterbu {
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: TInterBuJsonldReadCollectionInterbuActivity;
  client: ClientJsonldReadCollectionInterbu;
  createdAt?: string;
  readonly id: string;
  projectType?: TInterBuJsonldReadCollectionInterbuProjectType;
  propertyType?: TInterBuJsonldReadCollectionInterbuPropertyType;
  recipientBusinessUnit: BusinessUnitJsonldReadCollectionInterbu;
  recipientUser?: TInterBuJsonldReadCollectionInterbuRecipientUser;
  senderBusinessUnit?: TInterBuJsonldReadCollectionInterbuSenderBusinessUnit;
  senderUser: UserJsonldReadCollectionInterbu;
  readonly status: TInterBuJsonldReadCollectionInterbuStatus;
  updatedAt?: string;
}

export interface TInterBuCreateInterBUsInputJsonld {
  activity?: string;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  arrivalCity?: string | null;
  /** @nullable */
  arrivalCountry?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  clientComment?: string | null;
  clientId?: string;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  departureCity?: string | null;
  /** @nullable */
  departureCountry?: string | null;
  /** @nullable */
  departureDate?: string | null;
  isClientMailConfidential?: boolean;
  isClientPhoneNumberConfidential?: boolean;
  /** @nullable */
  projectComment?: string | null;
  /** @nullable */
  projectType?: string | null;
  /** @nullable */
  propertyType?: string | null;
  recipientBusinessUnitsIds?: string[];
  /** @nullable */
  recipientComment?: string | null;
  relationType?: string;
  /** @nullable */
  returnDate?: string | null;
  /** @nullable */
  spendingLimit?: number | null;
  /** @nullable */
  spendingLimitCurrency?: string | null;
  /** @nullable */
  surfaceArea?: number | null;
  /** @nullable */
  surfaceAreaUnit?: string | null;
  userRole?: string;
}

export type SubscriptionJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export type SubscriptionJsonldReadItemProjectContextOneOfHydra = typeof SubscriptionJsonldReadItemProjectContextOneOfHydra[keyof typeof SubscriptionJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SubscriptionJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: SubscriptionJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type SubscriptionJsonldReadItemProjectContext = string | SubscriptionJsonldReadItemProjectContextOneOf;

export interface SubscriptionJsonldReadItemProject {
  readonly '@context'?: SubscriptionJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  subscribeAt?: string | null;
  type?: SubscriptionJsonldReadItemProjectType;
  /** @nullable */
  unsubscribeAt?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type SubscriptionJsonldReadItemPeopleType = RefLabelJsonldReadItemPeople | null;

export interface SubscriptionJsonldReadItemPeople {
  readonly '@context'?: SubscriptionJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  subscribeAt?: string | null;
  type?: SubscriptionJsonldReadItemPeopleType;
  /** @nullable */
  unsubscribeAt?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type SubscriptionJsonldReadItemPeopleContextOneOfHydra = typeof SubscriptionJsonldReadItemPeopleContextOneOfHydra[keyof typeof SubscriptionJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SubscriptionJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: SubscriptionJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type SubscriptionJsonldReadItemPeopleContext = string | SubscriptionJsonldReadItemPeopleContextOneOf;

export type SubscriptionJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type SubscriptionJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof SubscriptionJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof SubscriptionJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SubscriptionJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SubscriptionJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SubscriptionJsonldReadCollectionProjectExcelExportContext = string | SubscriptionJsonldReadCollectionProjectExcelExportContextOneOf;

export interface SubscriptionJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: SubscriptionJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  subscribeAt?: string | null;
  type?: SubscriptionJsonldReadCollectionProjectExcelExportType;
  /** @nullable */
  unsubscribeAt?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type SubscriptionJsonldReadCollectionPeopleExcelExportType = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SubscriptionJsonldReadCollectionPeopleExcelExportContext = string | SubscriptionJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface SubscriptionJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: SubscriptionJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  subscribeAt?: string | null;
  type?: SubscriptionJsonldReadCollectionPeopleExcelExportType;
  /** @nullable */
  unsubscribeAt?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type SocietyMediaJsonldReadItemSocietyItemUsage = RefLabelJsonldReadItemSocietyItem | null;

export interface SocietyMediaJsonldReadItemSocietyItem {
  readonly '@context'?: SocietyMediaJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemSocietyItem;
  /** @nullable */
  order?: number | null;
  society?: SocietyJsonldReadItemSocietyItem;
  usage?: SocietyMediaJsonldReadItemSocietyItemUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type SocietyMediaJsonldReadItemSocietyItemContextOneOfHydra = typeof SocietyMediaJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof SocietyMediaJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadItemSocietyItemContext = string | SocietyMediaJsonldReadItemSocietyItemContextOneOf;

export interface SocietyMediaJsonldReadItemCollaboratorItem {
  readonly '@context'?: SocietyMediaJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type SocietyMediaJsonldReadItemCollaboratorItemContextOneOfHydra = typeof SocietyMediaJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof SocietyMediaJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadItemCollaboratorItemContext = string | SocietyMediaJsonldReadItemCollaboratorItemContextOneOf;

export type SocietyMediaJsonldReadItemClusterItemContextOneOfHydra = typeof SocietyMediaJsonldReadItemClusterItemContextOneOfHydra[keyof typeof SocietyMediaJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadItemClusterItemContext = string | SocietyMediaJsonldReadItemClusterItemContextOneOf;

export interface SocietyMediaJsonldReadItemClusterItem {
  readonly '@context'?: SocietyMediaJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface SocietyMediaJsonldReadItemAgencyItem {
  readonly '@context'?: SocietyMediaJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type SocietyMediaJsonldReadItemAgencyItemContextOneOfHydra = typeof SocietyMediaJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof SocietyMediaJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadItemAgencyItemContext = string | SocietyMediaJsonldReadItemAgencyItemContextOneOf;

export type SocietyMediaJsonldReadCollectionSocietyExcelExportUsage = RefLabelJsonldReadCollectionSocietyExcelExport | null;

export interface SocietyMediaJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: SocietyMediaJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionSocietyExcelExport;
  /** @nullable */
  order?: number | null;
  society?: SocietyJsonldReadCollectionSocietyExcelExport;
  usage?: SocietyMediaJsonldReadCollectionSocietyExcelExportUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadCollectionSocietyExcelExportContext = string | SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOf;

export type SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadCollectionSocietyUsage = RefLabelJsonldReadCollectionSociety | null;

export interface SocietyMediaJsonldReadCollectionSociety {
  readonly '@context'?: SocietyMediaJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionSociety;
  /** @nullable */
  order?: number | null;
  society?: SocietyJsonldReadCollectionSociety;
  usage?: SocietyMediaJsonldReadCollectionSocietyUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type SocietyMediaJsonldReadCollectionSocietyContextOneOfHydra = typeof SocietyMediaJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof SocietyMediaJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadCollectionSocietyContext = string | SocietyMediaJsonldReadCollectionSocietyContextOneOf;

export interface SocietyMediaJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: SocietyMediaJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldReadCollectionAgencyExcelExportContext = string | SocietyMediaJsonldReadCollectionAgencyExcelExportContextOneOf;

export type SocietyMediaJsonldContextOneOfHydra = typeof SocietyMediaJsonldContextOneOfHydra[keyof typeof SocietyMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: SocietyMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyMediaJsonldContext = string | SocietyMediaJsonldContextOneOf;

export interface SocietyMediaJsonld {
  readonly '@context'?: SocietyMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  society?: string;
  /** @nullable */
  usage?: string | null;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type SocietyJsonldReadItemSocietyItemStatus = RefLabelJsonldReadItemSocietyItem | null;

export type SocietyJsonldReadItemSocietyItemLicense = RefLabelJsonldReadItemSocietyItem | null;

export type SocietyJsonldReadItemSocietyItemContextOneOfHydra = typeof SocietyJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof SocietyJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadItemSocietyItemContext = string | SocietyJsonldReadItemSocietyItemContextOneOf;

export interface SocietyJsonldReadItemSocietyItem {
  readonly '@context'?: SocietyJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencySocietyJsonldReadItemSocietyItem[];
  /** @nullable */
  brand?: string | null;
  cluster?: RelAgencyOwnerClusterJsonldReadItemSocietyItem[];
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadItemSocietyItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItem[];
  legals?: RelAgencyOwnerLegalJsonldReadItemSocietyItem[];
  license?: SocietyJsonldReadItemSocietyItemLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadItemSocietyItem[];
  /** @nullable */
  name?: string | null;
  nbAgency?: number;
  nbCluster?: number;
  nbLegalRepresentative?: number;
  nbLegals?: number;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadItemSocietyItemStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export type SocietyJsonldReadItemCollaboratorItemContextOneOfHydra = typeof SocietyJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof SocietyJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadItemCollaboratorItemContext = string | SocietyJsonldReadItemCollaboratorItemContextOneOf;

export interface SocietyJsonldReadItemCollaboratorItem {
  readonly '@context'?: SocietyJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadItemCollaboratorItem[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadItemCollaboratorItemStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export type SocietyJsonldReadItemClusterItemLicense = RefLabelJsonldReadItemClusterItem | null;

export type SocietyJsonldReadItemClusterItemContextOneOfHydra = typeof SocietyJsonldReadItemClusterItemContextOneOfHydra[keyof typeof SocietyJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadItemClusterItemContext = string | SocietyJsonldReadItemClusterItemContextOneOf;

export interface SocietyJsonldReadItemClusterItem {
  readonly '@context'?: SocietyJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadItemClusterItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItem[];
  legals?: RelAgencyOwnerLegalJsonldReadItemClusterItem[];
  license?: SocietyJsonldReadItemClusterItemLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadItemClusterItem[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadItemClusterItemStatus;
  updatedAt?: string;
}

export type SocietyJsonldReadItemAgencyItemStatus = RefLabelJsonldReadItemAgencyItem | null;

export type SocietyJsonldReadItemAgencyItemLicense = RefLabelJsonldReadItemAgencyItem | null;

export interface SocietyJsonldReadItemAgencyItem {
  readonly '@context'?: SocietyJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadItemAgencyItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItem[];
  legals?: RelAgencyOwnerLegalJsonldReadItemAgencyItem[];
  license?: SocietyJsonldReadItemAgencyItemLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadItemAgencyItem[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadItemAgencyItemStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadItemAgencyItemContextOneOfHydra = typeof SocietyJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof SocietyJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadItemAgencyItemContext = string | SocietyJsonldReadItemAgencyItemContextOneOf;

export type SocietyJsonldReadCollectionSocietyExcelExportStatus = RefLabelJsonldReadCollectionSocietyExcelExport | null;

export type SocietyJsonldReadCollectionSocietyExcelExportLicense = RefLabelJsonldReadCollectionSocietyExcelExport | null;

export interface SocietyJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: SocietyJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencySocietyJsonldReadCollectionSocietyExcelExport[];
  /** @nullable */
  brand?: string | null;
  cluster?: RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExport[];
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExport[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExport[];
  legals?: RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExport[];
  license?: SocietyJsonldReadCollectionSocietyExcelExportLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadCollectionSocietyExcelExport[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadCollectionSocietyExcelExportStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof SocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof SocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadCollectionSocietyExcelExportContext = string | SocietyJsonldReadCollectionSocietyExcelExportContextOneOf;

export type SocietyJsonldReadCollectionSocietyStatus = RefLabelJsonldReadCollectionSociety | null;

export type SocietyJsonldReadCollectionSocietyLicense = RefLabelJsonldReadCollectionSociety | null;

export interface SocietyJsonldReadCollectionSociety {
  readonly '@context'?: SocietyJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadCollectionSociety[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  license?: SocietyJsonldReadCollectionSocietyLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadCollectionSociety[];
  /** @nullable */
  name?: string | null;
  nbAgency?: number;
  nbCluster?: number;
  nbLegalRepresentative?: number;
  nbLegals?: number;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadCollectionSocietyStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadCollectionSocietyContextOneOfHydra = typeof SocietyJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof SocietyJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadCollectionSocietyContext = string | SocietyJsonldReadCollectionSocietyContextOneOf;

export type SocietyJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof SocietyJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof SocietyJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadCollectionClusterExcelExportContext = string | SocietyJsonldReadCollectionClusterExcelExportContextOneOf;

export interface SocietyJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: SocietyJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  name?: string | null;
  updatedAt?: string;
}

export type SocietyJsonldReadCollectionAgencyExcelExportStatus = RefLabelJsonldReadCollectionAgencyExcelExport | null;

export type SocietyJsonldReadCollectionAgencyExcelExportLicense = RefLabelJsonldReadCollectionAgencyExcelExport | null;

export interface SocietyJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: SocietyJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExport[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExport[];
  legals?: RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExport[];
  license?: SocietyJsonldReadCollectionAgencyExcelExportLicense;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonldReadCollectionAgencyExcelExport[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status?: SocietyJsonldReadCollectionAgencyExcelExportStatus;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export type SocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof SocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof SocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldReadCollectionAgencyExcelExportContext = string | SocietyJsonldReadCollectionAgencyExcelExportContextOneOf;

export type SocietyJsonldContextOneOfHydra = typeof SocietyJsonldContextOneOfHydra[keyof typeof SocietyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocietyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SocietyJsonldContextOneOf = {
  '@vocab': string;
  hydra: SocietyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type SocietyJsonldContext = string | SocietyJsonldContextOneOf;

export interface SocietyJsonld {
  readonly '@context'?: SocietyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencySocietyJsonld[];
  /** @nullable */
  brand?: string | null;
  cluster?: RelAgencyOwnerClusterJsonld[];
  /** @nullable */
  companyRegistry?: string | null;
  contactDetails?: RelAgencyOwnerContactDetailsJsonld[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonld[];
  legals?: RelAgencyOwnerLegalJsonld[];
  /** @nullable */
  license?: string | null;
  /** @nullable */
  licenseNumber?: string | null;
  media?: SocietyMediaJsonld[];
  /** @nullable */
  name?: string | null;
  nbAgency?: number;
  nbCluster?: number;
  nbLegalRepresentative?: number;
  nbLegals?: number;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
  /** @nullable */
  vatNumber?: string | null;
}

export interface SocietyPostSocietyInputJsonld {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: AgencySocietyDTOJsonld[] | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  cluster?: ClusterSocietyDTOJsonld[] | null;
  /** @nullable */
  companyRegistry?: string | null;
  /** @nullable */
  contactDetails?: ContactDetailsDTOJsonld[] | null;
  /** @nullable */
  legalRepresentative?: LegalRepresentativeDTOJsonld[] | null;
  /** @nullable */
  legals?: LegalsDTOJsonld[] | null;
  /** @nullable */
  license?: string | null;
  /** @nullable */
  licenseNumber?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  officialName: string;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  status: string;
  /** @nullable */
  vatNumber?: string | null;
}

export interface SocietyPatchSocietyInput {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: PatchAgencySocietyDTO[] | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  cluster?: PatchClusterSocietyDTO[] | null;
  /** @nullable */
  companyRegistry?: string | null;
  /** @nullable */
  contactDetails?: PatchContactDetailsDTO[] | null;
  /** @nullable */
  legalRepresentative?: PatchLegalRepresentativeDTO[] | null;
  /** @nullable */
  legals?: PatchLegalsDTO[] | null;
  /** @nullable */
  license?: string | null;
  /** @nullable */
  licenseNumber?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialCode?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  referenceUrl?: string | null;
  /** @nullable */
  registrationCode?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  vatNumber?: string | null;
}

export interface SocietyPatchEntityMediaInput {
  datas?: EntityMediaDTO[];
}

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataToManager = CollaboratorJsonldReadCollectionSharedDataReadItemSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataTo = UserJsonldReadCollectionSharedDataReadItemSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataProject = ProjectJsonldReadCollectionSharedDataReadItemSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataPeople = PeopleJsonldReadCollectionSharedDataReadItemSharedData | null;

/**
 * Side of the author of the last comment, for this share: "sender" (the sending user or a
member of the sending agency), "recipient" (the answering user or a member of the receiving
agency), or null when it cannot be told.
 * @nullable
 */
export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataLastCommentSide = typeof SharedDataJsonldReadCollectionSharedDataReadItemSharedDataLastCommentSide[keyof typeof SharedDataJsonldReadCollectionSharedDataReadItemSharedDataLastCommentSide] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionSharedDataReadItemSharedDataLastCommentSide = {
  sender: 'sender',
  recipient: 'recipient',
} as const;

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataInterBu = InterBuJsonldReadCollectionSharedDataReadItemSharedData | null;

/**
 * SharedData entity for managing shared data between users, collaborators and people.
 */
export interface SharedDataJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  acceptedAt?: string | null;
  /** Comments of the InterBU (ADR 0009, D4), computed for the list only (not persisted). */
  readonly commentCount?: number;
  createdAt?: string;
  /** @nullable */
  deniedAt?: string | null;
  from?: UserJsonldReadCollectionSharedDataReadItemSharedData;
  fromCluster?: ClusterJsonldReadCollectionSharedDataReadItemSharedData;
  readonly id: string;
  interBu?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataInterBu;
  /** @nullable */
  readonly lastCommentAt?: string | null;
  /**
   * Side of the author of the last comment, for this share: "sender" (the sending user or a
member of the sending agency), "recipient" (the answering user or a member of the receiving
agency), or null when it cannot be told.
   * @nullable
   */
  readonly lastCommentSide?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataLastCommentSide;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  messageAnswer?: string | null;
  people?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataPeople;
  project?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataProject;
  /** @nullable */
  revokedAt?: string | null;
  status?: RefLabelJsonldReadCollectionSharedDataReadItemSharedData;
  subject?: string;
  /** @nullable */
  subjectAnswer?: string | null;
  /** @nullable */
  terminatedAt?: string | null;
  to?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataTo;
  toCluster?: ClusterJsonldReadCollectionSharedDataReadItemSharedData;
  toManager?: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataToManager;
  type?: RefLabelJsonldReadCollectionSharedDataReadItemSharedData;
  updatedAt?: string;
}

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContext = string | SharedDataJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type SharedDataJsonldReadCollectionSharedDataToManager = CollaboratorJsonldReadCollectionSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataTo = UserJsonldReadCollectionSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataProject = ProjectJsonldReadCollectionSharedData | null;

export type SharedDataJsonldReadCollectionSharedDataPeople = PeopleJsonldReadCollectionSharedData | null;

/**
 * Side of the author of the last comment, for this share: "sender" (the sending user or a
member of the sending agency), "recipient" (the answering user or a member of the receiving
agency), or null when it cannot be told.
 * @nullable
 */
export type SharedDataJsonldReadCollectionSharedDataLastCommentSide = typeof SharedDataJsonldReadCollectionSharedDataLastCommentSide[keyof typeof SharedDataJsonldReadCollectionSharedDataLastCommentSide] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionSharedDataLastCommentSide = {
  sender: 'sender',
  recipient: 'recipient',
} as const;

export type SharedDataJsonldReadCollectionSharedDataInterBu = InterBuJsonldReadCollectionSharedData | null;

/**
 * SharedData entity for managing shared data between users, collaborators and people.
 */
export interface SharedDataJsonldReadCollectionSharedData {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  acceptedAt?: string | null;
  /** Comments of the InterBU (ADR 0009, D4), computed for the list only (not persisted). */
  readonly commentCount?: number;
  createdAt?: string;
  /** @nullable */
  deniedAt?: string | null;
  from?: UserJsonldReadCollectionSharedData;
  fromCluster?: ClusterJsonldReadCollectionSharedData;
  readonly id: string;
  interBu?: SharedDataJsonldReadCollectionSharedDataInterBu;
  /** @nullable */
  readonly lastCommentAt?: string | null;
  /**
   * Side of the author of the last comment, for this share: "sender" (the sending user or a
member of the sending agency), "recipient" (the answering user or a member of the receiving
agency), or null when it cannot be told.
   * @nullable
   */
  readonly lastCommentSide?: SharedDataJsonldReadCollectionSharedDataLastCommentSide;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  messageAnswer?: string | null;
  people?: SharedDataJsonldReadCollectionSharedDataPeople;
  project?: SharedDataJsonldReadCollectionSharedDataProject;
  /** @nullable */
  revokedAt?: string | null;
  status?: RefLabelJsonldReadCollectionSharedData;
  subject?: string;
  /** @nullable */
  subjectAnswer?: string | null;
  /** @nullable */
  terminatedAt?: string | null;
  to?: SharedDataJsonldReadCollectionSharedDataTo;
  toCluster?: ClusterJsonldReadCollectionSharedData;
  toManager?: SharedDataJsonldReadCollectionSharedDataToManager;
  type?: RefLabelJsonldReadCollectionSharedData;
  updatedAt?: string;
}

export type SharedDataJsonldReadCollectionProjectContextOneOfHydra = typeof SharedDataJsonldReadCollectionProjectContextOneOfHydra[keyof typeof SharedDataJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SharedDataJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: SharedDataJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type SharedDataJsonldReadCollectionProjectContext = string | SharedDataJsonldReadCollectionProjectContextOneOf;

export interface SharedDataJsonldReadCollectionProject {
  readonly '@context'?: SharedDataJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface SharedDataJsonldReadCollectionPeople {
  readonly '@context'?: SharedDataJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type SharedDataJsonldReadCollectionPeopleContextOneOfHydra = typeof SharedDataJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof SharedDataJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SharedDataJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: SharedDataJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type SharedDataJsonldReadCollectionPeopleContext = string | SharedDataJsonldReadCollectionPeopleContextOneOf;

export type SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface SharedDataJsonldReadCollectionInterbu {
  readonly '@context'?: SharedDataJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type SharedDataJsonldReadCollectionInterbuContextOneOfHydra = typeof SharedDataJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof SharedDataJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SharedDataJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: SharedDataJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type SharedDataJsonldReadCollectionInterbuContext = string | SharedDataJsonldReadCollectionInterbuContextOneOf;

/**
 * SharedData entity for managing shared data between users, collaborators and people.
 */
export interface SharedDataPostSharedDataInputJsonldWriteItemSharedData {
  /** @nullable */
  cluster_id?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  people_id?: string | null;
  /** @nullable */
  project_id?: string | null;
  subject: string;
  /** @nullable */
  user_id?: string | null;
}

/**
 * @nullable
 */
export type SharedDataPostReassignSharedDataInputJsonldMode = typeof SharedDataPostReassignSharedDataInputJsonldMode[keyof typeof SharedDataPostReassignSharedDataInputJsonldMode] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataPostReassignSharedDataInputJsonldMode = {
  all: 'all',
  selection: 'selection',
} as const;

/**
 * @nullable
 */
export type SharedDataPostReassignSharedDataInputJsonldFromOrTo = typeof SharedDataPostReassignSharedDataInputJsonldFromOrTo[keyof typeof SharedDataPostReassignSharedDataInputJsonldFromOrTo] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedDataPostReassignSharedDataInputJsonldFromOrTo = {
  from: 'from',
  to: 'to',
} as const;

/**
 * SharedData entity for managing shared data between users, collaborators and people.
 */
export interface SharedDataPostReassignSharedDataInputJsonld {
  /** @nullable */
  fromOrTo: SharedDataPostReassignSharedDataInputJsonldFromOrTo;
  /**
   * @minItems 1
   * @nullable
   */
  mapping: ReassignPeopleMappingInputJsonld[] | null;
  /** @nullable */
  mode: SharedDataPostReassignSharedDataInputJsonldMode;
}

/**
 * SharedData entity for managing shared data between users, collaborators and people.
 */
export interface SharedDataPatchSharedDataInputWriteItemSharedData {
  /** @nullable */
  fromManagerId?: string | null;
  id: string;
  /** @nullable */
  messageAnswer?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  subjectAnswer?: string | null;
  /** @nullable */
  toManagerId?: string | null;
}

export interface SettingsJsonld {
  readonly '@context'?: SettingsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly locales?: readonly string[];
}

export type SettingsJsonldContextOneOfHydra = typeof SettingsJsonldContextOneOfHydra[keyof typeof SettingsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SettingsJsonldContextOneOf = {
  '@vocab': string;
  hydra: SettingsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type SettingsJsonldContext = string | SettingsJsonldContextOneOf;

export interface SettingJsonldUserReadItem {
  readonly '@context'?: SettingJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  locale?: string;
  other?: string[];
  updatedAt?: string;
}

export type SettingJsonldUserReadItemContextOneOfHydra = typeof SettingJsonldUserReadItemContextOneOfHydra[keyof typeof SettingJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SettingJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: SettingJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type SettingJsonldUserReadItemContext = string | SettingJsonldUserReadItemContextOneOf;

export type SettingJsonldReadItemSettingContextOneOfHydra = typeof SettingJsonldReadItemSettingContextOneOfHydra[keyof typeof SettingJsonldReadItemSettingContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingJsonldReadItemSettingContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SettingJsonldReadItemSettingContextOneOf = {
  '@vocab': string;
  hydra: SettingJsonldReadItemSettingContextOneOfHydra;
  [key: string]: unknown;
 };

export type SettingJsonldReadItemSettingContext = string | SettingJsonldReadItemSettingContextOneOf;

export interface SettingJsonldReadItemSetting {
  readonly '@context'?: SettingJsonldReadItemSettingContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  locale?: string;
  other?: string[];
  user?: string;
}

export type SettingJsonldContextOneOfHydra = typeof SettingJsonldContextOneOfHydra[keyof typeof SettingJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type SettingJsonldContextOneOf = {
  '@vocab': string;
  hydra: SettingJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type SettingJsonldContext = string | SettingJsonldContextOneOf;

export interface SettingJsonld {
  readonly '@context'?: SettingJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  locale?: string;
  other?: string[];
  updatedAt?: string;
  user?: string;
}

export interface SettingPostSettingPasswordInputJsonld {
  currentPassword: string;
  /**
   * @minLength 12
   * @pattern ^(.*\d.*)$
   */
  newPassword?: string;
}

export interface SettingPostSettingInputJsonld {
  /**
   * @minLength 2
   * @maxLength 5
   * @nullable
   */
  locale?: string | null;
}

export interface SettingPostSettingInput {
  /**
   * @minLength 2
   * @maxLength 5
   * @nullable
   */
  locale?: string | null;
}

export interface ResetPasswordRequestJsonld {
  readonly '@context'?: ResetPasswordRequestJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly expired?: boolean;
  expiresAt?: string;
  hashedToken?: string;
  readonly id?: number;
  readonly requestedAt?: string;
  user?: string;
}

export type ResetPasswordRequestJsonldContextOneOfHydra = typeof ResetPasswordRequestJsonldContextOneOfHydra[keyof typeof ResetPasswordRequestJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetPasswordRequestJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ResetPasswordRequestJsonldContextOneOf = {
  '@vocab': string;
  hydra: ResetPasswordRequestJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ResetPasswordRequestJsonldContext = string | ResetPasswordRequestJsonldContextOneOf;

export interface ResetPasswordRequestPostResetPasswordRequestDTOJsonld {
  email?: string;
}

export interface ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld {
  password: string;
  token: string;
}

export type RelPropertySearchI18nTextJsonldI18nText = I18nTextJsonld | null;

export type RelPropertySearchI18nTextJsonldContextOneOfHydra = typeof RelPropertySearchI18nTextJsonldContextOneOfHydra[keyof typeof RelPropertySearchI18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertySearchI18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertySearchI18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelPropertySearchI18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertySearchI18nTextJsonldContext = string | RelPropertySearchI18nTextJsonldContextOneOf;

export interface RelPropertySearchI18nTextJsonld {
  readonly '@context'?: RelPropertySearchI18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  i18nText?: RelPropertySearchI18nTextJsonldI18nText;
  readonly id: string;
  /** @nullable */
  propertySearch?: string | null;
  updatedAt?: string;
}

export type RelPropertyPropertyRegulationJsonldReadItemPropertyContext = string | RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOf;

export interface RelPropertyPropertyRegulationJsonldReadItemProperty {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadItemProperty;
}

export type RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RelPropertyPropertyRegulationJsonldReadItemProject {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadItemProject;
}

export type RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyPropertyRegulationJsonldReadItemProjectContext = string | RelPropertyPropertyRegulationJsonldReadItemProjectContextOneOf;

export interface RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadCollectionPropertyExcelExport;
}

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContext = string | RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOf;

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyPropertyRegulationJsonldReadCollectionPropertyContext = string | RelPropertyPropertyRegulationJsonldReadCollectionPropertyContextOneOf;

export interface RelPropertyPropertyRegulationJsonldReadCollectionProperty {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadCollectionProperty;
}

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContext = string | RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOf;

export interface RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadCollectionProjectExcelExport;
}

export interface RelPropertyPropertyRegulationJsonldReadCollectionProject {
  readonly '@context'?: RelPropertyPropertyRegulationJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  propertyRegulation?: PropertyRegulationJsonldReadCollectionProject;
}

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOfHydra = typeof RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyPropertyRegulationJsonldReadCollectionProjectContext = string | RelPropertyPropertyRegulationJsonldReadCollectionProjectContextOneOf;

export type RelPropertyI18nTextJsonldI18nText = I18nTextJsonld | null;

export interface RelPropertyI18nTextJsonld {
  readonly '@context'?: RelPropertyI18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  i18nText?: RelPropertyI18nTextJsonldI18nText;
  readonly id: string;
  /** @nullable */
  property?: string | null;
  updatedAt?: string;
}

export type RelPropertyI18nTextJsonldContextOneOfHydra = typeof RelPropertyI18nTextJsonldContextOneOfHydra[keyof typeof RelPropertyI18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPropertyI18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPropertyI18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelPropertyI18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPropertyI18nTextJsonldContext = string | RelPropertyI18nTextJsonldContextOneOf;

export interface RelPeopleMarketSegmentJsonldReadItemPeople {
  readonly '@context'?: RelPeopleMarketSegmentJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  marketSegment?: MarketSegmentJsonldReadItemPeople;
  people?: PeopleJsonldReadItemPeople;
  updatedAt?: string;
}

export type RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOfHydra = typeof RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOfHydra[keyof typeof RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleMarketSegmentJsonldReadItemPeopleContext = string | RelPeopleMarketSegmentJsonldReadItemPeopleContextOneOf;

export type RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContext = string | RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  marketSegment?: MarketSegmentJsonldReadCollectionPeopleExcelExport;
  people?: PeopleJsonldReadCollectionPeopleExcelExport;
  updatedAt?: string;
}

export type RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleMarketSegmentJsonldContextOneOfHydra = typeof RelPeopleMarketSegmentJsonldContextOneOfHydra[keyof typeof RelPeopleMarketSegmentJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleMarketSegmentJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleMarketSegmentJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleMarketSegmentJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleMarketSegmentJsonldContext = string | RelPeopleMarketSegmentJsonldContextOneOf;

export interface RelPeopleMarketSegmentJsonld {
  readonly '@context'?: RelPeopleMarketSegmentJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  marketSegment?: string;
  people?: string;
  updatedAt?: string;
}

export interface RelPeopleCollaboratorJsonldReadItemProject {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadItemProjectContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadItemProjectContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadItemProjectContext = string | RelPeopleCollaboratorJsonldReadItemProjectContextOneOf;

export type RelPeopleCollaboratorJsonldReadItemPeopleRole = RefLabelJsonldReadItemPeople | null;

export type RelPeopleCollaboratorJsonldReadItemPeopleCollaborator = CollaboratorJsonldReadItemPeople | null;

export interface RelPeopleCollaboratorJsonldReadItemPeople {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelPeopleCollaboratorJsonldReadItemPeopleCollaborator;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelPeopleCollaboratorJsonldReadItemPeopleRole;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadItemPeopleContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadItemPeopleContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadItemPeopleContext = string | RelPeopleCollaboratorJsonldReadItemPeopleContextOneOf;

export type RelPeopleCollaboratorJsonldReadItemCollaboratorItemRole = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelPeopleCollaboratorJsonldReadItemCollaboratorItemPeople = PeopleJsonldReadItemCollaboratorItem | null;

export type RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadItemCollaboratorItemContext = string | RelPeopleCollaboratorJsonldReadItemCollaboratorItemContextOneOf;

export interface RelPeopleCollaboratorJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  people?: RelPeopleCollaboratorJsonldReadItemCollaboratorItemPeople;
  role?: RelPeopleCollaboratorJsonldReadItemCollaboratorItemRole;
  updatedAt?: string;
}

export interface RelPeopleCollaboratorJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContext = string | RelPeopleCollaboratorJsonldReadCollectionProjectExcelExportContextOneOf;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportRole = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportCollaborator = CollaboratorJsonldReadCollectionPeopleExcelExport | null;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContext = string | RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportCollaborator;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExportRole;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadCollectionPeopleRole = RefLabelJsonldReadCollectionPeople | null;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleCollaborator = CollaboratorJsonldReadCollectionPeople | null;

export interface RelPeopleCollaboratorJsonldReadCollectionPeople {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionPeopleCollaborator;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelPeopleCollaboratorJsonldReadCollectionPeopleRole;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadCollectionPeopleContext = string | RelPeopleCollaboratorJsonldReadCollectionPeopleContextOneOf;

export type RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesRole = RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCollaborator = CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export interface RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCollaborator;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesRole;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface RelPeopleCollaboratorJsonld {
  readonly '@context'?: RelPeopleCollaboratorJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  collaborator?: string | null;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  people?: string | null;
  /** @nullable */
  role?: string | null;
  updatedAt?: string;
}

export type RelPeopleCollaboratorJsonldContextOneOfHydra = typeof RelPeopleCollaboratorJsonldContextOneOfHydra[keyof typeof RelPeopleCollaboratorJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelPeopleCollaboratorJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelPeopleCollaboratorJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelPeopleCollaboratorJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelPeopleCollaboratorJsonldContext = string | RelPeopleCollaboratorJsonldContextOneOf;

export type RelMarketSegmentI18nTextJsonldI18nText = I18nTextJsonld | null;

export interface RelMarketSegmentI18nTextJsonld {
  readonly '@context'?: RelMarketSegmentI18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  i18nText?: RelMarketSegmentI18nTextJsonldI18nText;
  readonly id: string;
  /** @nullable */
  marketSegment?: string | null;
  updatedAt?: string;
}

export type RelMarketSegmentI18nTextJsonldContextOneOfHydra = typeof RelMarketSegmentI18nTextJsonldContextOneOfHydra[keyof typeof RelMarketSegmentI18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelMarketSegmentI18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelMarketSegmentI18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelMarketSegmentI18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelMarketSegmentI18nTextJsonldContext = string | RelMarketSegmentI18nTextJsonldContextOneOf;

export type RelCollaboratorContactDetailsJsonldUserReadItemUsage = RefLabelJsonldUserReadItem | null;

export type RelCollaboratorContactDetailsJsonldUserReadItemContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldUserReadItemContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldUserReadItemContext = string | RelCollaboratorContactDetailsJsonldUserReadItemContextOneOf;

export interface RelCollaboratorContactDetailsJsonldUserReadItem {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldUserReadItem;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldUserReadItemUsage;
}

export type RelCollaboratorContactDetailsJsonldUserReadCollectionUsage = RefLabelJsonldUserReadCollection | null;

export interface RelCollaboratorContactDetailsJsonldUserReadCollection {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldUserReadCollection;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldUserReadCollectionUsage;
}

export type RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldUserReadCollectionContext = string | RelCollaboratorContactDetailsJsonldUserReadCollectionContextOneOf;

export type RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemSocietyItemContext = string | RelCollaboratorContactDetailsJsonldReadItemSocietyItemContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadItemSocietyItem {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadItemProjectUsage = RefLabelJsonldReadItemProject | null;

export interface RelCollaboratorContactDetailsJsonldReadItemProject {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemProject;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldReadItemProjectUsage;
}

export type RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemProjectContext = string | RelCollaboratorContactDetailsJsonldReadItemProjectContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadItemPeople {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemPeopleContext = string | RelCollaboratorContactDetailsJsonldReadItemPeopleContextOneOf;

export type RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemUsage = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContext = string | RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemCollaboratorItem;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldReadItemCollaboratorItemUsage;
}

export type RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemClusterItemContext = string | RelCollaboratorContactDetailsJsonldReadItemClusterItemContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadItemClusterItem {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadItemAgencyItemContext = string | RelCollaboratorContactDetailsJsonldReadItemAgencyItemContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadItemAgencyItem {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSharedDataReadItemSharedData;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext = string | RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContext = string | RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionSharedData {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSharedData;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContext = string | RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectUsage = RefLabelJsonldReadCollectionProject | null;

export interface RelCollaboratorContactDetailsJsonldReadCollectionProject {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProject;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldReadCollectionProjectUsage;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionProjectContext = string | RelCollaboratorContactDetailsJsonldReadCollectionProjectContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContext = string | RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionPeople {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionPeopleContext = string | RelCollaboratorContactDetailsJsonldReadCollectionPeopleContextOneOf;

export type RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportUsage = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export interface RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionCollaboratorExcelExport;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportUsage;
}

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContext = string | RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorUsage = RefLabelJsonldReadCollectionCollaborator | null;

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContext = string | RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContextOneOf;

export interface RelCollaboratorContactDetailsJsonldReadCollectionCollaborator {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionCollaborator;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorUsage;
}

export type RelCollaboratorContactDetailsJsonldContextOneOfHydra = typeof RelCollaboratorContactDetailsJsonldContextOneOfHydra[keyof typeof RelCollaboratorContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorContactDetailsJsonldContext = string | RelCollaboratorContactDetailsJsonldContextOneOf;

export interface RelCollaboratorContactDetailsJsonld {
  readonly '@context'?: RelCollaboratorContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: string;
  contactDetails?: ContactDetailsJsonld;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  /** @nullable */
  usage?: string | null;
}

export type RelCollaboratorClusterJsonldUserReadItemStatus = RefLabelJsonldUserReadItem | null;

export type RelCollaboratorClusterJsonldUserReadItemRole = RefLabelJsonldUserReadItem | null;

export type RelCollaboratorClusterJsonldUserReadItemRank = RefLabelJsonldUserReadItem | null;

export type RelCollaboratorClusterJsonldUserReadItemMetadatas = {[key: string]: string};

export type RelCollaboratorClusterJsonldUserReadItemCluster = ClusterJsonldUserReadItem | null;

export interface RelCollaboratorClusterJsonldUserReadItem {
  readonly '@context'?: RelCollaboratorClusterJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelCollaboratorClusterJsonldUserReadItemCluster;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  metadatas?: RelCollaboratorClusterJsonldUserReadItemMetadatas;
  rank?: RelCollaboratorClusterJsonldUserReadItemRank;
  role?: RelCollaboratorClusterJsonldUserReadItemRole;
  status?: RelCollaboratorClusterJsonldUserReadItemStatus;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldUserReadItemContextOneOfHydra = typeof RelCollaboratorClusterJsonldUserReadItemContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldUserReadItemContext = string | RelCollaboratorClusterJsonldUserReadItemContextOneOf;

export type RelCollaboratorClusterJsonldUserReadCollectionStatus = RefLabelJsonldUserReadCollection | null;

export type RelCollaboratorClusterJsonldUserReadCollectionRole = RefLabelJsonldUserReadCollection | null;

export type RelCollaboratorClusterJsonldUserReadCollectionRank = RefLabelJsonldUserReadCollection | null;

export type RelCollaboratorClusterJsonldUserReadCollectionMetadatas = {[key: string]: string};

export type RelCollaboratorClusterJsonldUserReadCollectionCluster = ClusterJsonldUserReadCollection | null;

export type RelCollaboratorClusterJsonldUserReadCollectionContextOneOfHydra = typeof RelCollaboratorClusterJsonldUserReadCollectionContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldUserReadCollectionContext = string | RelCollaboratorClusterJsonldUserReadCollectionContextOneOf;

export interface RelCollaboratorClusterJsonldUserReadCollection {
  readonly '@context'?: RelCollaboratorClusterJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelCollaboratorClusterJsonldUserReadCollectionCluster;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  metadatas?: RelCollaboratorClusterJsonldUserReadCollectionMetadatas;
  rank?: RelCollaboratorClusterJsonldUserReadCollectionRank;
  role?: RelCollaboratorClusterJsonldUserReadCollectionRole;
  status?: RelCollaboratorClusterJsonldUserReadCollectionStatus;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemRole = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemRank = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemMetadatas = {[key: string]: string};

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemCluster = ClusterJsonldReadItemCollaboratorItem | null;

export interface RelCollaboratorClusterJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelCollaboratorClusterJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelCollaboratorClusterJsonldReadItemCollaboratorItemCluster;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  metadatas?: RelCollaboratorClusterJsonldReadItemCollaboratorItemMetadatas;
  rank?: RelCollaboratorClusterJsonldReadItemCollaboratorItemRank;
  role?: RelCollaboratorClusterJsonldReadItemCollaboratorItemRole;
  status?: RelCollaboratorClusterJsonldReadItemCollaboratorItemStatus;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldReadItemCollaboratorItemContext = string | RelCollaboratorClusterJsonldReadItemCollaboratorItemContextOneOf;

export type RelCollaboratorClusterJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export type RelCollaboratorClusterJsonldReadItemClusterItemRole = RefLabelJsonldReadItemClusterItem | null;

export type RelCollaboratorClusterJsonldReadItemClusterItemRank = RefLabelJsonldReadItemClusterItem | null;

export type RelCollaboratorClusterJsonldReadItemClusterItemMetadatas = {[key: string]: string};

export type RelCollaboratorClusterJsonldReadItemClusterItemCollaborator = CollaboratorJsonldReadItemClusterItem | null;

export interface RelCollaboratorClusterJsonldReadItemClusterItem {
  readonly '@context'?: RelCollaboratorClusterJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelCollaboratorClusterJsonldReadItemClusterItemCollaborator;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  metadatas?: RelCollaboratorClusterJsonldReadItemClusterItemMetadatas;
  rank?: RelCollaboratorClusterJsonldReadItemClusterItemRank;
  role?: RelCollaboratorClusterJsonldReadItemClusterItemRole;
  status?: RelCollaboratorClusterJsonldReadItemClusterItemStatus;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldReadItemClusterItemContextOneOfHydra = typeof RelCollaboratorClusterJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldReadItemClusterItemContext = string | RelCollaboratorClusterJsonldReadItemClusterItemContextOneOf;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportRole = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportCluster = ClusterJsonldReadCollectionCollaboratorExcelExport | null;

export interface RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportRole;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContext = string | RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorStatus = RefLabelJsonldReadCollectionCollaborator | null;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorRole = RefLabelJsonldReadCollectionCollaborator | null;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorRank = RefLabelJsonldReadCollectionCollaborator | null;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorMetadatas = {[key: string]: string};

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorCluster = ClusterJsonldReadCollectionCollaborator | null;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOfHydra = typeof RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldReadCollectionCollaboratorContext = string | RelCollaboratorClusterJsonldReadCollectionCollaboratorContextOneOf;

export interface RelCollaboratorClusterJsonldReadCollectionCollaborator {
  readonly '@context'?: RelCollaboratorClusterJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelCollaboratorClusterJsonldReadCollectionCollaboratorCluster;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  metadatas?: RelCollaboratorClusterJsonldReadCollectionCollaboratorMetadatas;
  rank?: RelCollaboratorClusterJsonldReadCollectionCollaboratorRank;
  role?: RelCollaboratorClusterJsonldReadCollectionCollaboratorRole;
  status?: RelCollaboratorClusterJsonldReadCollectionCollaboratorStatus;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldMetadatas = {[key: string]: string};

export interface RelCollaboratorClusterJsonld {
  readonly '@context'?: RelCollaboratorClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  cluster?: string | null;
  /** @nullable */
  collaborator?: string | null;
  /** @nullable */
  commentStatus?: string | null;
  createdAt?: string;
  dateOfEntry?: string;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  function?: string | null;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  readonly manager?: boolean;
  metadatas?: RelCollaboratorClusterJsonldMetadatas;
  /** @nullable */
  rank?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
}

export type RelCollaboratorClusterJsonldContextOneOfHydra = typeof RelCollaboratorClusterJsonldContextOneOfHydra[keyof typeof RelCollaboratorClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorClusterJsonldContext = string | RelCollaboratorClusterJsonldContextOneOf;

export type RelCollaboratorAgencyJsonldUserReadItemContextOneOfHydra = typeof RelCollaboratorAgencyJsonldUserReadItemContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldUserReadItemContext = string | RelCollaboratorAgencyJsonldUserReadItemContextOneOf;

export interface RelCollaboratorAgencyJsonldUserReadItem {
  readonly '@context'?: RelCollaboratorAgencyJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelCollaboratorAgencyJsonldUserReadCollection {
  readonly '@context'?: RelCollaboratorAgencyJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldUserReadCollectionContextOneOfHydra = typeof RelCollaboratorAgencyJsonldUserReadCollectionContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldUserReadCollectionContext = string | RelCollaboratorAgencyJsonldUserReadCollectionContextOneOf;

export type RelCollaboratorAgencyJsonldReadItemSocietyItemRole = RefLabelJsonldReadItemSocietyItem | null;

export interface RelCollaboratorAgencyJsonldReadItemSocietyItem {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelCollaboratorAgencyJsonldReadItemSocietyItemRole;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemSocietyItemContext = string | RelCollaboratorAgencyJsonldReadItemSocietyItemContextOneOf;

export type RelCollaboratorAgencyJsonldReadItemProjectContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemProjectContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemProjectContext = string | RelCollaboratorAgencyJsonldReadItemProjectContextOneOf;

export interface RelCollaboratorAgencyJsonldReadItemProject {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadItemPeopleContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemPeopleContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemPeopleContext = string | RelCollaboratorAgencyJsonldReadItemPeopleContextOneOf;

export interface RelCollaboratorAgencyJsonldReadItemPeople {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadItemCollaboratorItemRole = RefLabelJsonldReadItemCollaboratorItem | null;

export type RelCollaboratorAgencyJsonldReadItemCollaboratorItemAgency = AgencyJsonldReadItemCollaboratorItem | null;

export interface RelCollaboratorAgencyJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelCollaboratorAgencyJsonldReadItemCollaboratorItemAgency;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelCollaboratorAgencyJsonldReadItemCollaboratorItemRole;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemCollaboratorItemContext = string | RelCollaboratorAgencyJsonldReadItemCollaboratorItemContextOneOf;

export type RelCollaboratorAgencyJsonldReadItemClusterItemRole = RefLabelJsonldReadItemClusterItem | null;

export interface RelCollaboratorAgencyJsonldReadItemClusterItem {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelCollaboratorAgencyJsonldReadItemClusterItemRole;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemClusterItemContext = string | RelCollaboratorAgencyJsonldReadItemClusterItemContextOneOf;

export type RelCollaboratorAgencyJsonldReadItemAgencyItemRole = RefLabelJsonldReadItemAgencyItem | null;

export type RelCollaboratorAgencyJsonldReadItemAgencyItemCollaborator = CollaboratorJsonldReadItemAgencyItem | null;

export type RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadItemAgencyItemContext = string | RelCollaboratorAgencyJsonldReadItemAgencyItemContextOneOf;

export interface RelCollaboratorAgencyJsonldReadItemAgencyItem {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelCollaboratorAgencyJsonldReadItemAgencyItemCollaborator;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  role?: RelCollaboratorAgencyJsonldReadItemAgencyItemRole;
  updatedAt?: string;
}

export interface RelCollaboratorAgencyJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContext = string | RelCollaboratorAgencyJsonldReadCollectionProjectExcelExportContextOneOf;

export type RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContext = string | RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadCollectionPeopleContext = string | RelCollaboratorAgencyJsonldReadCollectionPeopleContextOneOf;

export interface RelCollaboratorAgencyJsonldReadCollectionPeople {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export type RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportAgency = AgencyJsonldReadCollectionCollaboratorExcelExport | null;

export type RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContext = string | RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export interface RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExportAgency;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelCollaboratorAgencyJsonld {
  readonly '@context'?: RelCollaboratorAgencyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  collaborator?: string | null;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  role?: string | null;
  updatedAt?: string;
}

export type RelCollaboratorAgencyJsonldContextOneOfHydra = typeof RelCollaboratorAgencyJsonldContextOneOfHydra[keyof typeof RelCollaboratorAgencyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelCollaboratorAgencyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelCollaboratorAgencyJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelCollaboratorAgencyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelCollaboratorAgencyJsonldContext = string | RelCollaboratorAgencyJsonldContextOneOf;

export type RelClusterPeopleJsonldReadItemPeopleCluster = ClusterJsonldReadItemPeople | null;

export interface RelClusterPeopleJsonldReadItemPeople {
  readonly '@context'?: RelClusterPeopleJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelClusterPeopleJsonldReadItemPeopleCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldReadItemPeopleContextOneOfHydra = typeof RelClusterPeopleJsonldReadItemPeopleContextOneOfHydra[keyof typeof RelClusterPeopleJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterPeopleJsonldReadItemPeopleContext = string | RelClusterPeopleJsonldReadItemPeopleContextOneOf;

export type RelClusterPeopleJsonldReadItemClusterItemPeople = PeopleJsonldReadItemClusterItem | null;

export interface RelClusterPeopleJsonldReadItemClusterItem {
  readonly '@context'?: RelClusterPeopleJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  people?: RelClusterPeopleJsonldReadItemClusterItemPeople;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldReadItemClusterItemContextOneOfHydra = typeof RelClusterPeopleJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelClusterPeopleJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterPeopleJsonldReadItemClusterItemContext = string | RelClusterPeopleJsonldReadItemClusterItemContextOneOf;

export type RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterPeopleJsonldReadCollectionPeopleExcelExportContext = string | RelClusterPeopleJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface RelClusterPeopleJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RelClusterPeopleJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldReadCollectionPeopleCluster = ClusterJsonldReadCollectionPeople | null;

export type RelClusterPeopleJsonldReadCollectionPeopleContextOneOfHydra = typeof RelClusterPeopleJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RelClusterPeopleJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterPeopleJsonldReadCollectionPeopleContext = string | RelClusterPeopleJsonldReadCollectionPeopleContextOneOf;

export interface RelClusterPeopleJsonldReadCollectionPeople {
  readonly '@context'?: RelClusterPeopleJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelClusterPeopleJsonldReadCollectionPeopleCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCluster = ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RelClusterPeopleJsonld {
  readonly '@context'?: RelClusterPeopleJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  cluster?: string | null;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  people?: string | null;
  updatedAt?: string;
}

export type RelClusterPeopleJsonldContextOneOfHydra = typeof RelClusterPeopleJsonldContextOneOfHydra[keyof typeof RelClusterPeopleJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterPeopleJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterPeopleJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelClusterPeopleJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterPeopleJsonldContext = string | RelClusterPeopleJsonldContextOneOf;

export type RelClusterI18nTextJsonldI18nText = I18nTextJsonld | null;

export type RelClusterI18nTextJsonldContextOneOfHydra = typeof RelClusterI18nTextJsonldContextOneOfHydra[keyof typeof RelClusterI18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterI18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterI18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelClusterI18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterI18nTextJsonldContext = string | RelClusterI18nTextJsonldContextOneOf;

export interface RelClusterI18nTextJsonld {
  readonly '@context'?: RelClusterI18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  cluster?: string | null;
  createdAt?: string;
  i18nText?: RelClusterI18nTextJsonldI18nText;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldUserReadItemContextOneOfHydra = typeof RelClusterExternalPlatformJsonldUserReadItemContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldUserReadItemContext = string | RelClusterExternalPlatformJsonldUserReadItemContextOneOf;

export interface RelClusterExternalPlatformJsonldUserReadItem {
  readonly '@context'?: RelClusterExternalPlatformJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldUserReadCollectionContextOneOfHydra = typeof RelClusterExternalPlatformJsonldUserReadCollectionContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldUserReadCollectionContext = string | RelClusterExternalPlatformJsonldUserReadCollectionContextOneOf;

export interface RelClusterExternalPlatformJsonldUserReadCollection {
  readonly '@context'?: RelClusterExternalPlatformJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelClusterExternalPlatformJsonldReadItemSocietyItem {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadItemSocietyItemContext = string | RelClusterExternalPlatformJsonldReadItemSocietyItemContextOneOf;

export type RelClusterExternalPlatformJsonldReadItemProjectContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadItemProjectContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadItemProjectContext = string | RelClusterExternalPlatformJsonldReadItemProjectContextOneOf;

export interface RelClusterExternalPlatformJsonldReadItemProject {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelClusterExternalPlatformJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadItemCollaboratorItemContext = string | RelClusterExternalPlatformJsonldReadItemCollaboratorItemContextOneOf;

export type RelClusterExternalPlatformJsonldReadItemClusterItemExternalPlatform = ExternalPlatformJsonldReadItemClusterItem | null;

export type RelClusterExternalPlatformJsonldReadItemClusterItemContext = string | RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOf;

export interface RelClusterExternalPlatformJsonldReadItemClusterItem {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemClusterItemExternalPlatform;
  /** @nullable */
  extId?: string | null;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RelClusterExternalPlatformJsonldReadItemAgencyItem {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadItemAgencyItemContext = string | RelClusterExternalPlatformJsonldReadItemAgencyItemContextOneOf;

export interface RelClusterExternalPlatformJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContext = string | RelClusterExternalPlatformJsonldReadCollectionProjectExcelExportContextOneOf;

export type RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadCollectionProjectContext = string | RelClusterExternalPlatformJsonldReadCollectionProjectContextOneOf;

export interface RelClusterExternalPlatformJsonldReadCollectionProject {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadCollectionCollaboratorContext = string | RelClusterExternalPlatformJsonldReadCollectionCollaboratorContextOneOf;

export interface RelClusterExternalPlatformJsonldReadCollectionCollaborator {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportExternalPlatform = ExternalPlatformJsonldReadCollectionClusterExcelExport | null;

export type RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContext = string | RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOf;

export interface RelClusterExternalPlatformJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionClusterExcelExportExternalPlatform;
  /** @nullable */
  extId?: string | null;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadCollectionClusterExternalPlatform = ExternalPlatformJsonldReadCollectionCluster | null;

export interface RelClusterExternalPlatformJsonldReadCollectionCluster {
  readonly '@context'?: RelClusterExternalPlatformJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionClusterExternalPlatform;
  /** @nullable */
  extId?: string | null;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOfHydra = typeof RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldReadCollectionClusterContext = string | RelClusterExternalPlatformJsonldReadCollectionClusterContextOneOf;

export type RelClusterExternalPlatformJsonldExternalPlatform = ExternalPlatformJsonld | null;

export interface RelClusterExternalPlatformJsonld {
  readonly '@context'?: RelClusterExternalPlatformJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  cluster?: string | null;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldExternalPlatform;
  /** @nullable */
  extId?: string | null;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterExternalPlatformJsonldContextOneOfHydra = typeof RelClusterExternalPlatformJsonldContextOneOfHydra[keyof typeof RelClusterExternalPlatformJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterExternalPlatformJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterExternalPlatformJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelClusterExternalPlatformJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterExternalPlatformJsonldContext = string | RelClusterExternalPlatformJsonldContextOneOf;

export interface RelClusterContactDetailsJsonldReadItemSocietyItem {
  readonly '@context'?: RelClusterContactDetailsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadItemSocietyItemContext = string | RelClusterContactDetailsJsonldReadItemSocietyItemContextOneOf;

export interface RelClusterContactDetailsJsonldReadItemProject {
  readonly '@context'?: RelClusterContactDetailsJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterContactDetailsJsonldReadItemProjectContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadItemProjectContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadItemProjectContext = string | RelClusterContactDetailsJsonldReadItemProjectContextOneOf;

export interface RelClusterContactDetailsJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelClusterContactDetailsJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadItemCollaboratorItemContext = string | RelClusterContactDetailsJsonldReadItemCollaboratorItemContextOneOf;

export type RelClusterContactDetailsJsonldReadItemClusterItemUsage = RefLabelJsonldReadItemClusterItem | null;

export interface RelClusterContactDetailsJsonldReadItemClusterItem {
  readonly '@context'?: RelClusterContactDetailsJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemClusterItem;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelClusterContactDetailsJsonldReadItemClusterItemUsage;
}

export type RelClusterContactDetailsJsonldReadItemClusterItemContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadItemClusterItemContext = string | RelClusterContactDetailsJsonldReadItemClusterItemContextOneOf;

export type RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadItemAgencyItemContext = string | RelClusterContactDetailsJsonldReadItemAgencyItemContextOneOf;

export interface RelClusterContactDetailsJsonldReadItemAgencyItem {
  readonly '@context'?: RelClusterContactDetailsJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelClusterContactDetailsJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContext = string | RelClusterContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf;

export type RelClusterContactDetailsJsonldReadCollectionProjectContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadCollectionProjectContext = string | RelClusterContactDetailsJsonldReadCollectionProjectContextOneOf;

export interface RelClusterContactDetailsJsonldReadCollectionProject {
  readonly '@context'?: RelClusterContactDetailsJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelClusterContactDetailsJsonldReadCollectionClusterExcelExportUsage = RefLabelJsonldReadCollectionClusterExcelExport | null;

export interface RelClusterContactDetailsJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionClusterExcelExport;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelClusterContactDetailsJsonldReadCollectionClusterExcelExportUsage;
}

export type RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContext = string | RelClusterContactDetailsJsonldReadCollectionClusterExcelExportContextOneOf;

export type RelClusterContactDetailsJsonldReadCollectionClusterUsage = RefLabelJsonldReadCollectionCluster | null;

export interface RelClusterContactDetailsJsonldReadCollectionCluster {
  readonly '@context'?: RelClusterContactDetailsJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  usage?: RelClusterContactDetailsJsonldReadCollectionClusterUsage;
}

export type RelClusterContactDetailsJsonldReadCollectionClusterContextOneOfHydra = typeof RelClusterContactDetailsJsonldReadCollectionClusterContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldReadCollectionClusterContext = string | RelClusterContactDetailsJsonldReadCollectionClusterContextOneOf;

export interface RelClusterContactDetailsJsonld {
  readonly '@context'?: RelClusterContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: string;
  contactDetails?: ContactDetailsJsonld;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
  /** @nullable */
  usage?: string | null;
}

export type RelClusterContactDetailsJsonldContextOneOfHydra = typeof RelClusterContactDetailsJsonldContextOneOfHydra[keyof typeof RelClusterContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelClusterContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelClusterContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelClusterContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelClusterContactDetailsJsonldContext = string | RelClusterContactDetailsJsonldContextOneOf;

export type RelAgencySocietyJsonldReadItemSocietyItemAgency = AgencyJsonldReadItemSocietyItem | null;

export type RelAgencySocietyJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencySocietyJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldReadItemSocietyItemContext = string | RelAgencySocietyJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencySocietyJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencySocietyJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelAgencySocietyJsonldReadItemSocietyItemAgency;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldReadItemCollaboratorItemContext = string | RelAgencySocietyJsonldReadItemCollaboratorItemContextOneOf;

export interface RelAgencySocietyJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencySocietyJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadItemAgencyItemAgencyOwner = SocietyJsonldReadItemAgencyItem | null;

export interface RelAgencySocietyJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencySocietyJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencySocietyJsonldReadItemAgencyItemAgencyOwner;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencySocietyJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldReadItemAgencyItemContext = string | RelAgencySocietyJsonldReadItemAgencyItemContextOneOf;

export type RelAgencySocietyJsonldReadCollectionSocietyExcelExportAgency = AgencyJsonldReadCollectionSocietyExcelExport | null;

export interface RelAgencySocietyJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RelAgencySocietyJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelAgencySocietyJsonldReadCollectionSocietyExcelExportAgency;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldReadCollectionSocietyExcelExportContext = string | RelAgencySocietyJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RelAgencySocietyJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContext = string | RelAgencySocietyJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export type RelAgencySocietyJsonldReadCollectionAgencyExcelExportAgencyOwner = SocietyJsonldReadCollectionAgencyExcelExport | null;

export type RelAgencySocietyJsonldReadCollectionAgencyExcelExportContext = string | RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface RelAgencySocietyJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencySocietyJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencySocietyJsonldReadCollectionAgencyExcelExportAgencyOwner;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RelAgencySocietyJsonld {
  readonly '@context'?: RelAgencySocietyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  agencyOwner?: string | null;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencySocietyJsonldContextOneOfHydra = typeof RelAgencySocietyJsonldContextOneOfHydra[keyof typeof RelAgencySocietyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencySocietyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencySocietyJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencySocietyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencySocietyJsonldContext = string | RelAgencySocietyJsonldContextOneOf;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemCollaborator = CollaboratorJsonldReadItemSocietyItem | null;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: RelAgencyOwnerLegalRepresentativeJsonldReadItemSocietyItemCollaborator;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemAgencyOwner = SocietyJsonldReadItemCollaboratorItem | null;

export interface RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemAgencyOwner;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItemContextOneOf;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContextOneOf;

export interface RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadItemAgencyItemContextOneOf;

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldContext = string | RelAgencyOwnerLegalRepresentativeJsonldContextOneOf;

export interface RelAgencyOwnerLegalRepresentativeJsonld {
  readonly '@context'?: RelAgencyOwnerLegalRepresentativeJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  collaborator?: string | null;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalRepresentativeJsonldContextOneOfHydra = typeof RelAgencyOwnerLegalRepresentativeJsonldContextOneOfHydra[keyof typeof RelAgencyOwnerLegalRepresentativeJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalRepresentativeJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalRepresentativeJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalRepresentativeJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadItemSocietyItemAgencyOwnerLegals = AgencyOwnerLegalsJsonldReadItemSocietyItem | null;

export type RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadItemSocietyItemContext = string | RelAgencyOwnerLegalJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyOwnerLegalJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyOwnerLegalJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwnerLegals?: RelAgencyOwnerLegalJsonldReadItemSocietyItemAgencyOwnerLegals;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelAgencyOwnerLegalJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyOwnerLegalJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadItemClusterItemContext = string | RelAgencyOwnerLegalJsonldReadItemClusterItemContextOneOf;

export type RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadItemAgencyItemContext = string | RelAgencyOwnerLegalJsonldReadItemAgencyItemContextOneOf;

export interface RelAgencyOwnerLegalJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyOwnerLegalJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContext = string | RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RelAgencyOwnerLegalJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyOwnerLegalJsonldReadCollectionAgencyExcelExportContextOneOf;

export type RelAgencyOwnerLegalJsonldAgencyOwnerLegals = AgencyOwnerLegalsJsonld | null;

export interface RelAgencyOwnerLegalJsonld {
  readonly '@context'?: RelAgencyOwnerLegalJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agencyOwner?: string | null;
  agencyOwnerLegals?: RelAgencyOwnerLegalJsonldAgencyOwnerLegals;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerLegalJsonldContextOneOfHydra = typeof RelAgencyOwnerLegalJsonldContextOneOfHydra[keyof typeof RelAgencyOwnerLegalJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerLegalJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerLegalJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerLegalJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerLegalJsonldContext = string | RelAgencyOwnerLegalJsonldContextOneOf;

export type RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContext = string | RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemSocietyItem;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContext = string | RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RelAgencyOwnerContactDetailsJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContext = string | RelAgencyOwnerContactDetailsJsonldReadItemClusterItemContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContext = string | RelAgencyOwnerContactDetailsJsonldReadItemAgencyItemContextOneOf;

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContext = string | RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSocietyExcelExport;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContext = string | RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonldReadCollectionSociety {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSociety;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export interface RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyOwnerContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf;

export type RelAgencyOwnerContactDetailsJsonldContextOneOfHydra = typeof RelAgencyOwnerContactDetailsJsonldContextOneOfHydra[keyof typeof RelAgencyOwnerContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerContactDetailsJsonldContext = string | RelAgencyOwnerContactDetailsJsonldContextOneOf;

export interface RelAgencyOwnerContactDetailsJsonld {
  readonly '@context'?: RelAgencyOwnerContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonld;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  society?: string;
  updatedAt?: string;
}

export type RelAgencyOwnerClusterJsonldReadItemSocietyItemCluster = ClusterJsonldReadItemSocietyItem | null;

export type RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerClusterJsonldReadItemSocietyItemContext = string | RelAgencyOwnerClusterJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyOwnerClusterJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyOwnerClusterJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelAgencyOwnerClusterJsonldReadItemSocietyItemCluster;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerClusterJsonldReadItemClusterItemAgencyOwner = SocietyJsonldReadItemClusterItem | null;

export type RelAgencyOwnerClusterJsonldReadItemClusterItemContext = string | RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOf;

export interface RelAgencyOwnerClusterJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyOwnerClusterJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencyOwnerClusterJsonldReadItemClusterItemAgencyOwner;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerClusterJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportCluster = ClusterJsonldReadCollectionSocietyExcelExport | null;

export type RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContext = string | RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelAgencyOwnerClusterJsonldReadCollectionSocietyExcelExportCluster;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportAgencyOwner = SocietyJsonldReadCollectionClusterExcelExport | null;

export type RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContext = string | RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContextOneOf;

export interface RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExportAgencyOwner;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyOwnerClusterJsonldContextOneOfHydra = typeof RelAgencyOwnerClusterJsonldContextOneOfHydra[keyof typeof RelAgencyOwnerClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyOwnerClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyOwnerClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyOwnerClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyOwnerClusterJsonldContext = string | RelAgencyOwnerClusterJsonldContextOneOf;

export interface RelAgencyOwnerClusterJsonld {
  readonly '@context'?: RelAgencyOwnerClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  cluster?: string | null;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyI18nTextJsonldReadItemAgencyItemI18nText = I18nTextJsonldReadItemAgencyItem | null;

export interface RelAgencyI18nTextJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyI18nTextJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  i18nText?: RelAgencyI18nTextJsonldReadItemAgencyItemI18nText;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyI18nTextJsonldReadItemAgencyItemContext = string | RelAgencyI18nTextJsonldReadItemAgencyItemContextOneOf;

export interface RelAgencyI18nTextJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyI18nTextJsonldReadCollectionAgencyExcelExportContextOneOf;

export type RelAgencyI18nTextJsonldI18nText = I18nTextJsonld | null;

export interface RelAgencyI18nTextJsonld {
  readonly '@context'?: RelAgencyI18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agency?: string | null;
  createdAt?: string;
  i18nText?: RelAgencyI18nTextJsonldI18nText;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyI18nTextJsonldContextOneOfHydra = typeof RelAgencyI18nTextJsonldContextOneOfHydra[keyof typeof RelAgencyI18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyI18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyI18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyI18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyI18nTextJsonldContext = string | RelAgencyI18nTextJsonldContextOneOf;

export type RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadItemSocietyItemContext = string | RelAgencyContactDetailsJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyContactDetailsJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadItemCollaboratorItemContext = string | RelAgencyContactDetailsJsonldReadItemCollaboratorItemContextOneOf;

export interface RelAgencyContactDetailsJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelAgencyContactDetailsJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadItemClusterItemContext = string | RelAgencyContactDetailsJsonldReadItemClusterItemContextOneOf;

export interface RelAgencyContactDetailsJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemAgencyItem;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadItemAgencyItemContext = string | RelAgencyContactDetailsJsonldReadItemAgencyItemContextOneOf;

export type RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionAgencyExcelExport;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOfHydra = typeof RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldReadCollectionAgencyContext = string | RelAgencyContactDetailsJsonldReadCollectionAgencyContextOneOf;

export interface RelAgencyContactDetailsJsonldReadCollectionAgency {
  readonly '@context'?: RelAgencyContactDetailsJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionAgency;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export interface RelAgencyContactDetailsJsonld {
  readonly '@context'?: RelAgencyContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: string;
  contactDetails?: ContactDetailsJsonld;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type RelAgencyContactDetailsJsonldContextOneOfHydra = typeof RelAgencyContactDetailsJsonldContextOneOfHydra[keyof typeof RelAgencyContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyContactDetailsJsonldContext = string | RelAgencyContactDetailsJsonldContextOneOf;

export type RelAgencyClusterJsonldReadItemSocietyItemContextOneOfHydra = typeof RelAgencyClusterJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadItemSocietyItemContext = string | RelAgencyClusterJsonldReadItemSocietyItemContextOneOf;

export interface RelAgencyClusterJsonldReadItemSocietyItem {
  readonly '@context'?: RelAgencyClusterJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadItemCollaboratorItemCluster = ClusterJsonldReadItemCollaboratorItem | null;

export interface RelAgencyClusterJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencyClusterJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelAgencyClusterJsonldReadItemCollaboratorItemCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadItemCollaboratorItemContext = string | RelAgencyClusterJsonldReadItemCollaboratorItemContextOneOf;

export type RelAgencyClusterJsonldReadItemClusterItemAgency = AgencyJsonldReadItemClusterItem | null;

export interface RelAgencyClusterJsonldReadItemClusterItem {
  readonly '@context'?: RelAgencyClusterJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelAgencyClusterJsonldReadItemClusterItemAgency;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadItemClusterItemContextOneOfHydra = typeof RelAgencyClusterJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadItemClusterItemContext = string | RelAgencyClusterJsonldReadItemClusterItemContextOneOf;

export type RelAgencyClusterJsonldReadItemAgencyItemCluster = ClusterJsonldReadItemAgencyItem | null;

export type RelAgencyClusterJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyClusterJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadItemAgencyItemContext = string | RelAgencyClusterJsonldReadItemAgencyItemContextOneOf;

export interface RelAgencyClusterJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyClusterJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelAgencyClusterJsonldReadItemAgencyItemCluster;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadCollectionClusterExcelExportAgency = AgencyJsonldReadCollectionClusterExcelExport | null;

export type RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadCollectionClusterExcelExportContext = string | RelAgencyClusterJsonldReadCollectionClusterExcelExportContextOneOf;

export interface RelAgencyClusterJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: RelAgencyClusterJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelAgencyClusterJsonldReadCollectionClusterExcelExportAgency;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadCollectionAgencyExcelExportCluster = ClusterJsonldReadCollectionAgencyExcelExport | null;

export interface RelAgencyClusterJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyClusterJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelAgencyClusterJsonldReadCollectionAgencyExcelExportCluster;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyClusterJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface RelAgencyClusterJsonld {
  readonly '@context'?: RelAgencyClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  cluster?: string | null;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  updatedAt?: string;
}

export type RelAgencyClusterJsonldContextOneOfHydra = typeof RelAgencyClusterJsonldContextOneOfHydra[keyof typeof RelAgencyClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyClusterJsonldContext = string | RelAgencyClusterJsonldContextOneOf;

export type RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldReadItemCollaboratorItemContext = string | RelAgencyActivityJsonldReadItemCollaboratorItemContextOneOf;

export interface RelAgencyActivityJsonldReadItemCollaboratorItem {
  readonly '@context'?: RelAgencyActivityJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyActivityJsonldReadItemAgencyItemCode = typeof RelAgencyActivityJsonldReadItemAgencyItemCode[keyof typeof RelAgencyActivityJsonldReadItemAgencyItemCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadItemAgencyItemCode = {
  'real-estate-sales': 'real-estate-sales',
  'real-estate-rentals': 'real-estate-rentals',
  'real-estate-vacations': 'real-estate-vacations',
  'property-management': 'property-management',
  services: 'services',
  expertise: 'expertise',
  support: 'support',
} as const;

export type RelAgencyActivityJsonldReadItemAgencyItemContextOneOfHydra = typeof RelAgencyActivityJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RelAgencyActivityJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldReadItemAgencyItemContext = string | RelAgencyActivityJsonldReadItemAgencyItemContextOneOf;

export interface RelAgencyActivityJsonldReadItemAgencyItem {
  readonly '@context'?: RelAgencyActivityJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: RelAgencyActivityJsonldReadItemAgencyItemCode;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContext = string | RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export interface RelAgencyActivityJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldReadCollectionAgencyExcelExportCode = typeof RelAgencyActivityJsonldReadCollectionAgencyExcelExportCode[keyof typeof RelAgencyActivityJsonldReadCollectionAgencyExcelExportCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadCollectionAgencyExcelExportCode = {
  'real-estate-sales': 'real-estate-sales',
  'real-estate-rentals': 'real-estate-rentals',
  'real-estate-vacations': 'real-estate-vacations',
  'property-management': 'property-management',
  services: 'services',
  expertise: 'expertise',
  support: 'support',
} as const;

export type RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldReadCollectionAgencyExcelExportContext = string | RelAgencyActivityJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface RelAgencyActivityJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RelAgencyActivityJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: RelAgencyActivityJsonldReadCollectionAgencyExcelExportCode;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RelAgencyActivityJsonldReadCollectionAgency {
  readonly '@context'?: RelAgencyActivityJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyActivityJsonldReadCollectionAgencyContextOneOfHydra = typeof RelAgencyActivityJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof RelAgencyActivityJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldReadCollectionAgencyContext = string | RelAgencyActivityJsonldReadCollectionAgencyContextOneOf;

export type RelAgencyActivityJsonldCode = typeof RelAgencyActivityJsonldCode[keyof typeof RelAgencyActivityJsonldCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldCode = {
  'real-estate-sales': 'real-estate-sales',
  'real-estate-rentals': 'real-estate-rentals',
  'real-estate-vacations': 'real-estate-vacations',
  'property-management': 'property-management',
  services: 'services',
  expertise: 'expertise',
  support: 'support',
} as const;

export interface RelAgencyActivityJsonld {
  readonly '@context'?: RelAgencyActivityJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: RelAgencyActivityJsonldCode;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RelAgencyActivityJsonldContextOneOfHydra = typeof RelAgencyActivityJsonldContextOneOfHydra[keyof typeof RelAgencyActivityJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelAgencyActivityJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RelAgencyActivityJsonldContextOneOf = {
  '@vocab': string;
  hydra: RelAgencyActivityJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RelAgencyActivityJsonldContext = string | RelAgencyActivityJsonldContextOneOf;

export type RefLabelTranslationJsonldUserReadItemContextOneOfHydra = typeof RefLabelTranslationJsonldUserReadItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldUserReadItemContext = string | RefLabelTranslationJsonldUserReadItemContextOneOf;

export interface RefLabelTranslationJsonldUserReadItem {
  readonly '@context'?: RefLabelTranslationJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface RefLabelTranslationJsonldUserReadCollection {
  readonly '@context'?: RefLabelTranslationJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type RefLabelTranslationJsonldUserReadCollectionContextOneOfHydra = typeof RefLabelTranslationJsonldUserReadCollectionContextOneOfHydra[keyof typeof RefLabelTranslationJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldUserReadCollectionContext = string | RefLabelTranslationJsonldUserReadCollectionContextOneOf;

export type RefLabelTranslationJsonldReadItemSocietyItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemSocietyItemContext = string | RefLabelTranslationJsonldReadItemSocietyItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemSocietyItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemRefLabelItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemRefLabelItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemRefLabelItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemRefLabelItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemRefLabelItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemRefLabelItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemRefLabelItemContext = string | RefLabelTranslationJsonldReadItemRefLabelItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemRefLabelItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemRefLabelItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelTranslationJsonldReadItemRefLabelGroupItemContext = string | RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemRefLabelGroupItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemRefLabelGroupItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RefLabelTranslationJsonldReadItemPropertySearch {
  readonly '@context'?: RefLabelTranslationJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemPropertySearchContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemPropertySearchContext = string | RefLabelTranslationJsonldReadItemPropertySearchContextOneOf;

export interface RefLabelTranslationJsonldReadItemPropertyOffer {
  readonly '@context'?: RefLabelTranslationJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemPropertyOfferContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemPropertyOfferContext = string | RefLabelTranslationJsonldReadItemPropertyOfferContextOneOf;

export type RefLabelTranslationJsonldReadItemPropertyContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemPropertyContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemPropertyContext = string | RefLabelTranslationJsonldReadItemPropertyContextOneOf;

export interface RefLabelTranslationJsonldReadItemProperty {
  readonly '@context'?: RefLabelTranslationJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemProjectContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemProjectContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemProjectContext = string | RefLabelTranslationJsonldReadItemProjectContextOneOf;

export interface RefLabelTranslationJsonldReadItemProject {
  readonly '@context'?: RefLabelTranslationJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export interface RefLabelTranslationJsonldReadItemPeople {
  readonly '@context'?: RefLabelTranslationJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemPeopleContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemPeopleContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemPeopleContext = string | RefLabelTranslationJsonldReadItemPeopleContextOneOf;

export type RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemMarketSegmentItemContext = string | RefLabelTranslationJsonldReadItemMarketSegmentItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemMarketSegmentItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export interface RefLabelTranslationJsonldReadItemInterbu {
  readonly '@context'?: RefLabelTranslationJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type RefLabelTranslationJsonldReadItemInterbuContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemInterbuContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemInterbuContext = string | RefLabelTranslationJsonldReadItemInterbuContextOneOf;

export type RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemCollaboratorItemContext = string | RefLabelTranslationJsonldReadItemCollaboratorItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemCollaboratorItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemClusterItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemClusterItemContext = string | RefLabelTranslationJsonldReadItemClusterItemContextOneOf;

export interface RefLabelTranslationJsonldReadItemClusterItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export interface RefLabelTranslationJsonldReadItemAgencyItem {
  readonly '@context'?: RefLabelTranslationJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadItemAgencyItemContextOneOfHydra = typeof RefLabelTranslationJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadItemAgencyItemContext = string | RefLabelTranslationJsonldReadItemAgencyItemContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionSociety {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionSocietyContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionSocietyContext = string | RefLabelTranslationJsonldReadCollectionSocietyContextOneOf;

export type RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContext = string | RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type RefLabelTranslationJsonldReadCollectionSharedDataContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionSharedDataContext = string | RefLabelTranslationJsonldReadCollectionSharedDataContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionSharedData {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface RefLabelTranslationJsonldReadCollectionRefLabel {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionRefLabelContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelTranslationJsonldReadCollectionRefLabelContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionRefLabelContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionRefLabelContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionRefLabelContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionRefLabelContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionRefLabelContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionRefLabelContext = string | RefLabelTranslationJsonldReadCollectionRefLabelContextOneOf;

export type RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContext = string | RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPropertySearchContext = string | RefLabelTranslationJsonldReadCollectionPropertySearchContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionPropertySearch {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContext = string | RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExport {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RefLabelTranslationJsonldReadCollectionPropertyOffer {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPropertyOfferContext = string | RefLabelTranslationJsonldReadCollectionPropertyOfferContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionProperty {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPropertyContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPropertyContext = string | RefLabelTranslationJsonldReadCollectionPropertyContextOneOf;

export type RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionProjectExcelExportContext = string | RefLabelTranslationJsonldReadCollectionProjectExcelExportContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type RefLabelTranslationJsonldReadCollectionProjectContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionProjectContext = string | RefLabelTranslationJsonldReadCollectionProjectContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionProject {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export interface RefLabelTranslationJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPeopleExcelExportContext = string | RefLabelTranslationJsonldReadCollectionPeopleExcelExportContextOneOf;

export type RefLabelTranslationJsonldReadCollectionPeopleContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionPeopleContext = string | RefLabelTranslationJsonldReadCollectionPeopleContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionPeople {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface RefLabelTranslationJsonldReadCollectionMarketSegment {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionMarketSegmentContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionMarketSegmentContext = string | RefLabelTranslationJsonldReadCollectionMarketSegmentContextOneOf;

export type RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type RefLabelTranslationJsonldReadCollectionInterbuContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionInterbuContext = string | RefLabelTranslationJsonldReadCollectionInterbuContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionInterbu {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface RefLabelTranslationJsonldReadCollectionCollaborator {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionCollaboratorContext = string | RefLabelTranslationJsonldReadCollectionCollaboratorContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionCluster {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldReadCollectionClusterContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionClusterContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionClusterContext = string | RefLabelTranslationJsonldReadCollectionClusterContextOneOf;

export type RefLabelTranslationJsonldReadCollectionAgencyContextOneOfHydra = typeof RefLabelTranslationJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof RefLabelTranslationJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldReadCollectionAgencyContext = string | RefLabelTranslationJsonldReadCollectionAgencyContextOneOf;

export interface RefLabelTranslationJsonldReadCollectionAgency {
  readonly '@context'?: RefLabelTranslationJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type RefLabelTranslationJsonldContextOneOfHydra = typeof RefLabelTranslationJsonldContextOneOfHydra[keyof typeof RefLabelTranslationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelTranslationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelTranslationJsonldContextOneOf = {
  '@vocab': string;
  hydra: RefLabelTranslationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelTranslationJsonldContext = string | RefLabelTranslationJsonldContextOneOf;

export interface RefLabelTranslationJsonld {
  readonly '@context'?: RefLabelTranslationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  entity_id?: string | null;
  /** @nullable */
  entityId?: string | null;
  field?: string;
  readonly id?: number;
  readonly label?: string;
  locale?: string;
  /**
   * Get related object
   * @nullable
   */
  object?: string | null;
  /** @nullable */
  rel_entity_id?: string | null;
  /** @nullable */
  relEntityId?: string | null;
}

export interface RefLabelGroupTranslationJsonldReadItemRefLabelItem {
  readonly '@context'?: RefLabelGroupTranslationJsonldReadItemRefLabelItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOfHydra = typeof RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOfHydra[keyof typeof RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupTranslationJsonldReadItemRefLabelItemContext = string | RefLabelGroupTranslationJsonldReadItemRefLabelItemContextOneOf;

export type RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra = typeof RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra[keyof typeof RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContext = string | RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContextOneOf;

export interface RefLabelGroupTranslationJsonldReadItemRefLabelGroupItem {
  readonly '@context'?: RefLabelGroupTranslationJsonldReadItemRefLabelGroupItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOfHydra = typeof RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOfHydra[keyof typeof RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContext = string | RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContextOneOf;

export interface RefLabelGroupTranslationJsonldReadCollectionRefLabelGroup {
  readonly '@context'?: RefLabelGroupTranslationJsonldReadCollectionRefLabelGroupContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type RefLabelGroupTranslationJsonldContext = string | RefLabelGroupTranslationJsonldContextOneOf;

export interface RefLabelGroupTranslationJsonld {
  readonly '@context'?: RefLabelGroupTranslationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  entity_id?: string | null;
  /** @nullable */
  entityId?: string | null;
  field?: string;
  readonly id?: number;
  readonly label?: string;
  locale?: string;
  /**
   * Get related object
   * @nullable
   */
  object?: string | null;
  /** @nullable */
  rel_entity_id?: string | null;
  /** @nullable */
  relEntityId?: string | null;
}

export type RefLabelGroupTranslationJsonldContextOneOfHydra = typeof RefLabelGroupTranslationJsonldContextOneOfHydra[keyof typeof RefLabelGroupTranslationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupTranslationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupTranslationJsonldContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupTranslationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RefLabelGroupRelationDTOJsonld {
  id?: string;
  order?: number;
}

export interface RefLabelGroupRelationDTO {
  id?: string;
  order?: number;
}

export interface RefLabelGroupRelationJsonldUserReadItem {
  readonly '@context'?: RefLabelGroupRelationJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldUserReadItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldUserReadItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldUserReadItemContext = string | RefLabelGroupRelationJsonldUserReadItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemSocietyItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemSocietyItemContext = string | RefLabelGroupRelationJsonldReadItemSocietyItemContextOneOf;

export type RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemRefLabelItemContext = string | RefLabelGroupRelationJsonldReadItemRefLabelItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemRefLabelItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemRefLabelItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  order?: number;
  refLabelGroup?: RefLabelGroupJsonldReadItemRefLabelItem;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContext = string | RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemRefLabelGroupItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemRefLabelGroupItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  order?: number;
  refLabel?: RefLabelJsonldReadItemRefLabelGroupItem;
  updatedAt?: string;
}

export interface RefLabelGroupRelationJsonldReadItemPropertySearch {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemPropertySearchContext = string | RefLabelGroupRelationJsonldReadItemPropertySearchContextOneOf;

export type RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemPropertyOfferContext = string | RefLabelGroupRelationJsonldReadItemPropertyOfferContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemPropertyOffer {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemPropertyContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemPropertyContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemPropertyContext = string | RefLabelGroupRelationJsonldReadItemPropertyContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemProperty {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemPeopleContext = string | RefLabelGroupRelationJsonldReadItemPeopleContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemPeople {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemPeopleContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemPeopleContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export interface RefLabelGroupRelationJsonldReadItemMarketSegmentItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemMarketSegmentItemContext = string | RefLabelGroupRelationJsonldReadItemMarketSegmentItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemInterbu {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemInterbuContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemInterbuContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemInterbuContext = string | RefLabelGroupRelationJsonldReadItemInterbuContextOneOf;

export type RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemCollaboratorItemContext = string | RefLabelGroupRelationJsonldReadItemCollaboratorItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemCollaboratorItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemClusterItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemClusterItemContext = string | RefLabelGroupRelationJsonldReadItemClusterItemContextOneOf;

export interface RefLabelGroupRelationJsonldReadItemClusterItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RefLabelGroupRelationJsonldReadItemAgencyItem {
  readonly '@context'?: RefLabelGroupRelationJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadItemAgencyItemContext = string | RefLabelGroupRelationJsonldReadItemAgencyItemContextOneOf;

export type RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContext = string | RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface RefLabelGroupRelationJsonld {
  readonly '@context'?: RefLabelGroupRelationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  order?: number;
  refLabel?: string;
  refLabelGroup?: string;
  updatedAt?: string;
}

export type RefLabelGroupRelationJsonldContextOneOfHydra = typeof RefLabelGroupRelationJsonldContextOneOfHydra[keyof typeof RefLabelGroupRelationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupRelationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupRelationJsonldContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupRelationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupRelationJsonldContext = string | RefLabelGroupRelationJsonldContextOneOf;

export type RefLabelGroupJsonldReadItemRefLabelItemContextOneOfHydra = typeof RefLabelGroupJsonldReadItemRefLabelItemContextOneOfHydra[keyof typeof RefLabelGroupJsonldReadItemRefLabelItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupJsonldReadItemRefLabelItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupJsonldReadItemRefLabelItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupJsonldReadItemRefLabelItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupJsonldReadItemRefLabelItemContext = string | RefLabelGroupJsonldReadItemRefLabelItemContextOneOf;

export interface RefLabelGroupJsonldReadItemRefLabelItem {
  readonly '@context'?: RefLabelGroupJsonldReadItemRefLabelItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  createdAt?: string;
  group?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelGroupTranslationJsonldReadItemRefLabelItem[];
  updatedAt?: string;
}

export type RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOfHydra = typeof RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOfHydra[keyof typeof RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupJsonldReadItemRefLabelGroupItemContext = string | RefLabelGroupJsonldReadItemRefLabelGroupItemContextOneOf;

export interface RefLabelGroupJsonldReadItemRefLabelGroupItem {
  readonly '@context'?: RefLabelGroupJsonldReadItemRefLabelGroupItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  createdAt?: string;
  group?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemRefLabelGroupItem[];
  translations?: RefLabelGroupTranslationJsonldReadItemRefLabelGroupItem[];
  updatedAt?: string;
}

export interface RefLabelGroupJsonldReadCollectionRefLabelGroup {
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  createdAt?: string;
  group?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelGroupTranslationJsonldReadCollectionRefLabelGroup[];
  updatedAt?: string;
}

export interface RefLabelGroupJsonld {
  readonly '@context'?: RefLabelGroupJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  createdAt?: string;
  group?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  refLabelGroupRelation?: string[];
  translations?: RefLabelGroupTranslationJsonld[];
  updatedAt?: string;
}

export type RefLabelGroupJsonldContextOneOfHydra = typeof RefLabelGroupJsonldContextOneOfHydra[keyof typeof RefLabelGroupJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelGroupJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelGroupJsonldContextOneOf = {
  '@vocab': string;
  hydra: RefLabelGroupJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelGroupJsonldContext = string | RefLabelGroupJsonldContextOneOf;

export interface RefLabelGroupPostRefLabelGroupInputJsonld {
  /** @nullable */
  group?: string | null;
  /** @nullable */
  refLabelGroupRelation?: RefLabelGroupRelationDTOJsonld[] | null;
  /** @nullable */
  translations?: TranslationsInputDTOJsonld[] | null;
}

export interface RefLabelGroupPatchRefLabelGroupInput {
  /** @nullable */
  group?: string | null;
  /** @nullable */
  refLabelGroupRelation?: RefLabelGroupRelationDTO[] | null;
  /** @nullable */
  translations?: TranslationsInputDTO[] | null;
}

export type RefLabelJsonldUserReadItemContextOneOfHydra = typeof RefLabelJsonldUserReadItemContextOneOfHydra[keyof typeof RefLabelJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldUserReadItemContext = string | RefLabelJsonldUserReadItemContextOneOf;

export interface RefLabelJsonldUserReadItem {
  readonly '@context'?: RefLabelJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldUserReadItem[];
  translations?: RefLabelTranslationJsonldUserReadItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldUserReadCollectionContextOneOfHydra = typeof RefLabelJsonldUserReadCollectionContextOneOfHydra[keyof typeof RefLabelJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldUserReadCollectionContext = string | RefLabelJsonldUserReadCollectionContextOneOf;

export interface RefLabelJsonldUserReadCollection {
  readonly '@context'?: RefLabelJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldUserReadCollection[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadItemSocietyItem {
  readonly '@context'?: RefLabelJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemSocietyItem[];
  translations?: RefLabelTranslationJsonldReadItemSocietyItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemSocietyItemContextOneOfHydra = typeof RefLabelJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemSocietyItemContext = string | RefLabelJsonldReadItemSocietyItemContextOneOf;

export type RefLabelJsonldReadItemRefLabelItemContextOneOfHydra = typeof RefLabelJsonldReadItemRefLabelItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemRefLabelItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemRefLabelItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemRefLabelItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemRefLabelItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemRefLabelItemContext = string | RefLabelJsonldReadItemRefLabelItemContextOneOf;

export interface RefLabelJsonldReadItemRefLabelItem {
  readonly '@context'?: RefLabelJsonldReadItemRefLabelItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemRefLabelItem[];
  translations?: RefLabelTranslationJsonldReadItemRefLabelItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadItemRefLabelGroupItem {
  readonly '@context'?: RefLabelJsonldReadItemRefLabelGroupItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadItemRefLabelGroupItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemRefLabelGroupItemContextOneOfHydra = typeof RefLabelJsonldReadItemRefLabelGroupItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemRefLabelGroupItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemRefLabelGroupItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemRefLabelGroupItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemRefLabelGroupItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemRefLabelGroupItemContext = string | RefLabelJsonldReadItemRefLabelGroupItemContextOneOf;

export type RefLabelJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemPropertySearchContext = string | RefLabelJsonldReadItemPropertySearchContextOneOf;

export interface RefLabelJsonldReadItemPropertySearch {
  readonly '@context'?: RefLabelJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemPropertySearch[];
  translations?: RefLabelTranslationJsonldReadItemPropertySearch[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemPropertySearchContextOneOfHydra = typeof RefLabelJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof RefLabelJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemPropertyOfferContextOneOfHydra = typeof RefLabelJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof RefLabelJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemPropertyOfferContext = string | RefLabelJsonldReadItemPropertyOfferContextOneOf;

export interface RefLabelJsonldReadItemPropertyOffer {
  readonly '@context'?: RefLabelJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemPropertyOffer[];
  translations?: RefLabelTranslationJsonldReadItemPropertyOffer[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadItemProperty {
  readonly '@context'?: RefLabelJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemProperty[];
  translations?: RefLabelTranslationJsonldReadItemProperty[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemPropertyContextOneOfHydra = typeof RefLabelJsonldReadItemPropertyContextOneOfHydra[keyof typeof RefLabelJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemPropertyContext = string | RefLabelJsonldReadItemPropertyContextOneOf;

export interface RefLabelJsonldReadItemProject {
  readonly '@context'?: RefLabelJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelTranslationJsonldReadItemProject[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemProjectContextOneOfHydra = typeof RefLabelJsonldReadItemProjectContextOneOfHydra[keyof typeof RefLabelJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemProjectContext = string | RefLabelJsonldReadItemProjectContextOneOf;

export type RefLabelJsonldReadItemPeopleContextOneOfHydra = typeof RefLabelJsonldReadItemPeopleContextOneOfHydra[keyof typeof RefLabelJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemPeopleContext = string | RefLabelJsonldReadItemPeopleContextOneOf;

export interface RefLabelJsonldReadItemPeople {
  readonly '@context'?: RefLabelJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemPeople[];
  translations?: RefLabelTranslationJsonldReadItemPeople[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemMarketSegmentItemContextOneOfHydra = typeof RefLabelJsonldReadItemMarketSegmentItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemMarketSegmentItemContext = string | RefLabelJsonldReadItemMarketSegmentItemContextOneOf;

export interface RefLabelJsonldReadItemMarketSegmentItem {
  readonly '@context'?: RefLabelJsonldReadItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemMarketSegmentItem[];
  translations?: RefLabelTranslationJsonldReadItemMarketSegmentItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadItemInterbu {
  readonly '@context'?: RefLabelJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemInterbu[];
  translations?: RefLabelTranslationJsonldReadItemInterbu[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemInterbuContextOneOfHydra = typeof RefLabelJsonldReadItemInterbuContextOneOfHydra[keyof typeof RefLabelJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemInterbuContext = string | RefLabelJsonldReadItemInterbuContextOneOf;

export type RefLabelJsonldReadItemCollaboratorItemContextOneOfHydra = typeof RefLabelJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemCollaboratorItemContext = string | RefLabelJsonldReadItemCollaboratorItemContextOneOf;

export interface RefLabelJsonldReadItemCollaboratorItem {
  readonly '@context'?: RefLabelJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemCollaboratorItem[];
  translations?: RefLabelTranslationJsonldReadItemCollaboratorItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemClusterItemContextOneOfHydra = typeof RefLabelJsonldReadItemClusterItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemClusterItemContext = string | RefLabelJsonldReadItemClusterItemContextOneOf;

export interface RefLabelJsonldReadItemClusterItem {
  readonly '@context'?: RefLabelJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemClusterItem[];
  translations?: RefLabelTranslationJsonldReadItemClusterItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadItemAgencyItem {
  readonly '@context'?: RefLabelJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadItemAgencyItem[];
  translations?: RefLabelTranslationJsonldReadItemAgencyItem[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadItemAgencyItemContextOneOfHydra = typeof RefLabelJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof RefLabelJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadItemAgencyItemContext = string | RefLabelJsonldReadItemAgencyItemContextOneOf;

export interface RefLabelJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionSocietyExcelExportContext = string | RefLabelJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionSociety {
  readonly '@context'?: RefLabelJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionSociety[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionSocietyContextOneOfHydra = typeof RefLabelJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionSocietyContext = string | RefLabelJsonldReadCollectionSocietyContextOneOf;

export type RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContext = string | RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface RefLabelJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: RefLabelJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  refLabelGroupRelation?: RefLabelGroupRelationJsonldReadCollectionSharedDataReadItemSharedData[];
  translations?: RefLabelTranslationJsonldReadCollectionSharedDataReadItemSharedData[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionSharedDataContextOneOfHydra = typeof RefLabelJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionSharedDataContext = string | RefLabelJsonldReadCollectionSharedDataContextOneOf;

export interface RefLabelJsonldReadCollectionSharedData {
  readonly '@context'?: RefLabelJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionSharedData[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionRefLabelsExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface RefLabelJsonldReadCollectionRefLabel {
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionRefLabel[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPropertySearchExcelExport[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertySearchExcelExportContext = string | RefLabelJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export type RefLabelJsonldReadCollectionPropertySearchContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertySearchContext = string | RefLabelJsonldReadCollectionPropertySearchContextOneOf;

export interface RefLabelJsonldReadCollectionPropertySearch {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPropertySearch[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertyOfferExcelExportContext = string | RefLabelJsonldReadCollectionPropertyOfferExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionPropertyOfferExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertyOfferExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPropertyOfferExcelExport[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionPropertyOffer {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPropertyOffer[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionPropertyOfferContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertyOfferContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertyOfferContext = string | RefLabelJsonldReadCollectionPropertyOfferContextOneOf;

export interface RefLabelJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type RefLabelJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertyExcelExportContext = string | RefLabelJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionProperty {
  readonly '@context'?: RefLabelJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionProperty[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionPropertyContextOneOfHydra = typeof RefLabelJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPropertyContext = string | RefLabelJsonldReadCollectionPropertyContextOneOf;

export type RefLabelJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionProjectExcelExportContext = string | RefLabelJsonldReadCollectionProjectExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelTranslationJsonldReadCollectionProjectExcelExport[];
  updatedAt?: string;
}

export type RefLabelJsonldReadCollectionProjectContextOneOfHydra = typeof RefLabelJsonldReadCollectionProjectContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionProjectContext = string | RefLabelJsonldReadCollectionProjectContextOneOf;

export interface RefLabelJsonldReadCollectionProject {
  readonly '@context'?: RefLabelJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelTranslationJsonldReadCollectionProject[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPeopleExcelExport[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPeopleExcelExportContext = string | RefLabelJsonldReadCollectionPeopleExcelExportContextOneOf;

export type RefLabelJsonldReadCollectionPeopleContextOneOfHydra = typeof RefLabelJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionPeopleContext = string | RefLabelJsonldReadCollectionPeopleContextOneOf;

export interface RefLabelJsonldReadCollectionPeople {
  readonly '@context'?: RefLabelJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionPeople[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionMarketSegment {
  readonly '@context'?: RefLabelJsonldReadCollectionMarketSegmentContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  translations?: RefLabelTranslationJsonldReadCollectionMarketSegment[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionMarketSegmentContextOneOfHydra = typeof RefLabelJsonldReadCollectionMarketSegmentContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionMarketSegmentContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionMarketSegmentContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionMarketSegmentContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionMarketSegmentContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionMarketSegmentContext = string | RefLabelJsonldReadCollectionMarketSegmentContextOneOf;

export type RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionInterbuContextOneOfHydra = typeof RefLabelJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionInterbuContext = string | RefLabelJsonldReadCollectionInterbuContextOneOf;

export interface RefLabelJsonldReadCollectionInterbu {
  readonly '@context'?: RefLabelJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionInterbu[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionCollaboratorExcelExportContext = string | RefLabelJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionCollaborator {
  readonly '@context'?: RefLabelJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionCollaborator[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionCollaboratorContextOneOfHydra = typeof RefLabelJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionCollaboratorContext = string | RefLabelJsonldReadCollectionCollaboratorContextOneOf;

export type RefLabelJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionClusterExcelExportContext = string | RefLabelJsonldReadCollectionClusterExcelExportContextOneOf;

export interface RefLabelJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionClusterContextOneOfHydra = typeof RefLabelJsonldReadCollectionClusterContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionClusterContext = string | RefLabelJsonldReadCollectionClusterContextOneOf;

export interface RefLabelJsonldReadCollectionCluster {
  readonly '@context'?: RefLabelJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionCluster[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: RefLabelJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof RefLabelJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionAgencyExcelExportContext = string | RefLabelJsonldReadCollectionAgencyExcelExportContextOneOf;

export type RefLabelJsonldReadCollectionAgencyContextOneOfHydra = typeof RefLabelJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof RefLabelJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldReadCollectionAgencyContext = string | RefLabelJsonldReadCollectionAgencyContextOneOf;

export interface RefLabelJsonldReadCollectionAgency {
  readonly '@context'?: RefLabelJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  code?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  order?: number | null;
  translations?: RefLabelTranslationJsonldReadCollectionAgency[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type RefLabelJsonldContextOneOfHydra = typeof RefLabelJsonldContextOneOfHydra[keyof typeof RefLabelJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefLabelJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type RefLabelJsonldContextOneOf = {
  '@vocab': string;
  hydra: RefLabelJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type RefLabelJsonldContext = string | RefLabelJsonldContextOneOf;

export interface RefLabelJsonld {
  readonly '@context'?: RefLabelJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  canEdit?: boolean;
  clusterType?: string[];
  code?: string;
  createdAt?: string;
  /** @nullable */
  i18nLabelId?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  /**
   * Get or create i18n_label_id only if there are translations.
   * @nullable
   */
  readonly orCreateI18nLabelId?: string | null;
  /** @nullable */
  order?: number | null;
  peopleLocale?: PeopleLocaleJsonld[];
  refLabelGroupRelation?: string[];
  translations?: RefLabelTranslationJsonld[];
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelPostRefLabelInputJsonld {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  order?: string | null;
  /** @nullable */
  refLabelGroupRelation?: RefLabelGroupRelationDTOJsonld[] | null;
  /** @nullable */
  translations?: TranslationsInputDTOJsonld[] | null;
  /** @nullable */
  value?: string | null;
}

export interface RefLabelPatchRefLabelInput {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  order?: string | null;
  /** @nullable */
  refLabelGroupRelation?: RefLabelGroupRelationDTO[] | null;
  /** @nullable */
  translations?: TranslationsExtInputDTO[] | null;
  /** @nullable */
  value?: string | null;
}

export interface ReassignPeopleMappingInputJsonld {
  /** @nullable */
  clusterId: string | null;
  /** @nullable */
  itemIds?: string[] | null;
  /** @nullable */
  recipientId: string | null;
}

export interface PropertyTagJsonldReadItemPropertySearch {
  readonly '@context'?: PropertyTagJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyTagJsonldReadItemPropertySearchContextOneOfHydra = typeof PropertyTagJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof PropertyTagJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadItemPropertySearchContext = string | PropertyTagJsonldReadItemPropertySearchContextOneOf;

export interface PropertyTagJsonldReadItemProperty {
  readonly '@context'?: PropertyTagJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyTagJsonldReadItemPropertyContextOneOfHydra = typeof PropertyTagJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyTagJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadItemPropertyContext = string | PropertyTagJsonldReadItemPropertyContextOneOf;

export type PropertyTagJsonldReadItemProjectContextOneOfHydra = typeof PropertyTagJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyTagJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadItemProjectContext = string | PropertyTagJsonldReadItemProjectContextOneOf;

export interface PropertyTagJsonldReadItemProject {
  readonly '@context'?: PropertyTagJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionPropertySearchExcelExportContext = string | PropertyTagJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export interface PropertyTagJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: PropertyTagJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface PropertyTagJsonldReadCollectionPropertySearch {
  readonly '@context'?: PropertyTagJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyTagJsonldReadCollectionPropertySearchContextOneOfHydra = typeof PropertyTagJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionPropertySearchContext = string | PropertyTagJsonldReadCollectionPropertySearchContextOneOf;

export type PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionPropertyExcelExportContext = string | PropertyTagJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyTagJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyTagJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export interface PropertyTagJsonldReadCollectionProperty {
  readonly '@context'?: PropertyTagJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyTagJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyTagJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionPropertyContext = string | PropertyTagJsonldReadCollectionPropertyContextOneOf;

export type PropertyTagJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyTagJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionProjectExcelExportContext = string | PropertyTagJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyTagJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyTagJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyTagJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyTagJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyTagJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyTagJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyTagJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyTagJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyTagJsonldReadCollectionProjectContext = string | PropertyTagJsonldReadCollectionProjectContextOneOf;

export interface PropertyTagJsonldReadCollectionProject {
  readonly '@context'?: PropertyTagJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface PropertySearchPropertyAreaJsonldReadItemPropertySearch {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadItemPropertySearch;
  propertySearch?: PropertySearchJsonldReadItemPropertySearch;
}

export type PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadItemPropertySearchContext = string | PropertySearchPropertyAreaJsonldReadItemPropertySearchContextOneOf;

export interface PropertySearchPropertyAreaJsonldReadItemProject {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadItemProject;
}

export type PropertySearchPropertyAreaJsonldReadItemProjectContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadItemProjectContext = string | PropertySearchPropertyAreaJsonldReadItemProjectContextOneOf;

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContext = string | PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export interface PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadCollectionPropertySearchExcelExport;
  propertySearch?: PropertySearchJsonldReadCollectionPropertySearchExcelExport;
}

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContext = string | PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContextOneOf;

export interface PropertySearchPropertyAreaJsonldReadCollectionPropertySearch {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadCollectionPropertySearch;
  propertySearch?: PropertySearchJsonldReadCollectionPropertySearch;
}

export interface PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadCollectionProjectExcelExport;
}

export type PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContext = string | PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf;

export type PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOfHydra = typeof PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchPropertyAreaJsonldReadCollectionProjectContext = string | PropertySearchPropertyAreaJsonldReadCollectionProjectContextOneOf;

export interface PropertySearchPropertyAreaJsonldReadCollectionProject {
  readonly '@context'?: PropertySearchPropertyAreaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyArea?: PropertyAreaJsonldReadCollectionProject;
}

export type PropertySearchJsonldReadItemPropertySearchViewQuality = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchSubtype = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchStatus = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchStanding = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchPriceCurrency = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchFloorName = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchCondition = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchAvailibilityStatus = RefLabelJsonldReadItemPropertySearch | null;

export type PropertySearchJsonldReadItemPropertySearchAreaUnit = RefLabelJsonldReadItemPropertySearch | null;

export interface PropertySearchJsonldReadItemPropertySearch {
  readonly '@context'?: PropertySearchJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadItemPropertySearch[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadItemPropertySearchAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadItemPropertySearchAvailibilityStatus;
  /** @nullable */
  readonly comment?: string | null;
  condition?: PropertySearchJsonldReadItemPropertySearchCondition;
  contactDetails?: ContactDetailsJsonldReadItemPropertySearch[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadItemPropertySearchFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  /** @nullable */
  readonly note?: string | null;
  priceCurrency?: PropertySearchJsonldReadItemPropertySearchPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  projectPropertySearch?: ProjectPropertySearchJsonldReadItemPropertySearch[];
  propertyArea?: PropertySearchPropertyAreaJsonldReadItemPropertySearch[];
  proximities?: RefLabelJsonldReadItemPropertySearch[];
  services?: RefLabelJsonldReadItemPropertySearch[];
  standing?: PropertySearchJsonldReadItemPropertySearchStanding;
  status?: PropertySearchJsonldReadItemPropertySearchStatus;
  subtype?: PropertySearchJsonldReadItemPropertySearchSubtype;
  tag?: PropertyTagJsonldReadItemPropertySearch[];
  types?: RefLabelJsonldReadItemPropertySearch[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadItemPropertySearch[];
  viewQuality?: PropertySearchJsonldReadItemPropertySearchViewQuality;
}

export type PropertySearchJsonldReadItemPropertySearchContextOneOfHydra = typeof PropertySearchJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof PropertySearchJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadItemPropertySearchContext = string | PropertySearchJsonldReadItemPropertySearchContextOneOf;

export type PropertySearchJsonldReadItemProjectViewQuality = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectSubtype = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectStanding = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectPriceCurrency = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectFloorName = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectCondition = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectAvailibilityStatus = RefLabelJsonldReadItemProject | null;

export type PropertySearchJsonldReadItemProjectAreaUnit = RefLabelJsonldReadItemProject | null;

export interface PropertySearchJsonldReadItemProject {
  readonly '@context'?: PropertySearchJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadItemProjectAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadItemProjectAvailibilityStatus;
  condition?: PropertySearchJsonldReadItemProjectCondition;
  contactDetails?: ContactDetailsJsonldReadItemProject[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadItemProjectFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  priceCurrency?: PropertySearchJsonldReadItemProjectPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  propertyArea?: PropertySearchPropertyAreaJsonldReadItemProject[];
  proximities?: RefLabelJsonldReadItemProject[];
  services?: RefLabelJsonldReadItemProject[];
  standing?: PropertySearchJsonldReadItemProjectStanding;
  status?: PropertySearchJsonldReadItemProjectStatus;
  subtype?: PropertySearchJsonldReadItemProjectSubtype;
  tag?: PropertyTagJsonldReadItemProject[];
  types?: RefLabelJsonldReadItemProject[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadItemProject[];
  viewQuality?: PropertySearchJsonldReadItemProjectViewQuality;
}

export type PropertySearchJsonldReadItemProjectContextOneOfHydra = typeof PropertySearchJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertySearchJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadItemProjectContext = string | PropertySearchJsonldReadItemProjectContextOneOf;

export type PropertySearchJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export type PropertySearchJsonldReadItemClusterItemContextOneOfHydra = typeof PropertySearchJsonldReadItemClusterItemContextOneOfHydra[keyof typeof PropertySearchJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadItemClusterItemContext = string | PropertySearchJsonldReadItemClusterItemContextOneOf;

export interface PropertySearchJsonldReadItemClusterItem {
  readonly '@context'?: PropertySearchJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: PropertySearchJsonldReadItemClusterItemStatus;
  updatedAt?: string;
}

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportViewQuality = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportSubtype = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportStatus = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportStanding = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportPriceCurrency = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportFloorName = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportCondition = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportAvailibilityStatus = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportAreaUnit = RefLabelJsonldReadCollectionPropertySearchExcelExport | null;

export interface PropertySearchJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: PropertySearchJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionPropertySearchExcelExport[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadCollectionPropertySearchExcelExportAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadCollectionPropertySearchExcelExportAvailibilityStatus;
  /** @nullable */
  readonly comment?: string | null;
  condition?: PropertySearchJsonldReadCollectionPropertySearchExcelExportCondition;
  contactDetails?: ContactDetailsJsonldReadCollectionPropertySearchExcelExport[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadCollectionPropertySearchExcelExportFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  /** @nullable */
  readonly note?: string | null;
  priceCurrency?: PropertySearchJsonldReadCollectionPropertySearchExcelExportPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  projectPropertySearch?: ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExport[];
  propertyArea?: PropertySearchPropertyAreaJsonldReadCollectionPropertySearchExcelExport[];
  proximities?: RefLabelJsonldReadCollectionPropertySearchExcelExport[];
  services?: RefLabelJsonldReadCollectionPropertySearchExcelExport[];
  standing?: PropertySearchJsonldReadCollectionPropertySearchExcelExportStanding;
  status?: PropertySearchJsonldReadCollectionPropertySearchExcelExportStatus;
  subtype?: PropertySearchJsonldReadCollectionPropertySearchExcelExportSubtype;
  tag?: PropertyTagJsonldReadCollectionPropertySearchExcelExport[];
  types?: RefLabelJsonldReadCollectionPropertySearchExcelExport[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionPropertySearchExcelExport[];
  viewQuality?: PropertySearchJsonldReadCollectionPropertySearchExcelExportViewQuality;
}

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadCollectionPropertySearchExcelExportContext = string | PropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export type PropertySearchJsonldReadCollectionPropertySearchViewQuality = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchSubtype = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchStatus = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchStanding = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchPriceCurrency = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchFloorName = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchCondition = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchAvailibilityStatus = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchAreaUnit = RefLabelJsonldReadCollectionPropertySearch | null;

export type PropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra = typeof PropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof PropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadCollectionPropertySearchContext = string | PropertySearchJsonldReadCollectionPropertySearchContextOneOf;

export interface PropertySearchJsonldReadCollectionPropertySearch {
  readonly '@context'?: PropertySearchJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionPropertySearch[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadCollectionPropertySearchAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadCollectionPropertySearchAvailibilityStatus;
  /** @nullable */
  readonly comment?: string | null;
  condition?: PropertySearchJsonldReadCollectionPropertySearchCondition;
  contactDetails?: ContactDetailsJsonldReadCollectionPropertySearch[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadCollectionPropertySearchFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  /** @nullable */
  readonly note?: string | null;
  priceCurrency?: PropertySearchJsonldReadCollectionPropertySearchPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  projectPropertySearch?: ProjectPropertySearchJsonldReadCollectionPropertySearch[];
  propertyArea?: PropertySearchPropertyAreaJsonldReadCollectionPropertySearch[];
  proximities?: RefLabelJsonldReadCollectionPropertySearch[];
  services?: RefLabelJsonldReadCollectionPropertySearch[];
  standing?: PropertySearchJsonldReadCollectionPropertySearchStanding;
  status?: PropertySearchJsonldReadCollectionPropertySearchStatus;
  subtype?: PropertySearchJsonldReadCollectionPropertySearchSubtype;
  tag?: PropertyTagJsonldReadCollectionPropertySearch[];
  types?: RefLabelJsonldReadCollectionPropertySearch[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionPropertySearch[];
  viewQuality?: PropertySearchJsonldReadCollectionPropertySearchViewQuality;
}

export type PropertySearchJsonldReadCollectionProjectExcelExportViewQuality = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportSubtype = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportStanding = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportPriceCurrency = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportFloorName = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportCondition = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportAvailibilityStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertySearchJsonldReadCollectionProjectExcelExportAreaUnit = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface PropertySearchJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertySearchJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadCollectionProjectExcelExportAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadCollectionProjectExcelExportAvailibilityStatus;
  condition?: PropertySearchJsonldReadCollectionProjectExcelExportCondition;
  contactDetails?: ContactDetailsJsonldReadCollectionProjectExcelExport[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadCollectionProjectExcelExportFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  priceCurrency?: PropertySearchJsonldReadCollectionProjectExcelExportPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  propertyArea?: PropertySearchPropertyAreaJsonldReadCollectionProjectExcelExport[];
  proximities?: RefLabelJsonldReadCollectionProjectExcelExport[];
  services?: RefLabelJsonldReadCollectionProjectExcelExport[];
  standing?: PropertySearchJsonldReadCollectionProjectExcelExportStanding;
  status?: PropertySearchJsonldReadCollectionProjectExcelExportStatus;
  subtype?: PropertySearchJsonldReadCollectionProjectExcelExportSubtype;
  tag?: PropertyTagJsonldReadCollectionProjectExcelExport[];
  types?: RefLabelJsonldReadCollectionProjectExcelExport[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionProjectExcelExport[];
  viewQuality?: PropertySearchJsonldReadCollectionProjectExcelExportViewQuality;
}

export type PropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadCollectionProjectExcelExportContext = string | PropertySearchJsonldReadCollectionProjectExcelExportContextOneOf;

export type PropertySearchJsonldReadCollectionProjectViewQuality = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectSubtype = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectStanding = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectPriceCurrency = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectFloorName = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectCondition = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectAvailibilityStatus = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectAreaUnit = RefLabelJsonldReadCollectionProject | null;

export type PropertySearchJsonldReadCollectionProjectContextOneOfHydra = typeof PropertySearchJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertySearchJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySearchJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertySearchJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertySearchJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertySearchJsonldReadCollectionProjectContext = string | PropertySearchJsonldReadCollectionProjectContextOneOf;

export interface PropertySearchJsonldReadCollectionProject {
  readonly '@context'?: PropertySearchJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  areaMax?: number | null;
  /** @nullable */
  areaMin?: number | null;
  areaUnit?: PropertySearchJsonldReadCollectionProjectAreaUnit;
  availibilityStatus?: PropertySearchJsonldReadCollectionProjectAvailibilityStatus;
  condition?: PropertySearchJsonldReadCollectionProjectCondition;
  contactDetails?: ContactDetailsJsonldReadCollectionProject[];
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  floorMax?: number | null;
  /** @nullable */
  floorMin?: number | null;
  floorName?: PropertySearchJsonldReadCollectionProjectFloorName;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  marginEstimated?: number | null;
  /** @nullable */
  nbBedroomsMax?: number | null;
  /** @nullable */
  nbBedroomsMin?: number | null;
  /** @nullable */
  nbRoomsMax?: number | null;
  /** @nullable */
  nbRoomsMin?: number | null;
  priceCurrency?: PropertySearchJsonldReadCollectionProjectPriceCurrency;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  propertyArea?: PropertySearchPropertyAreaJsonldReadCollectionProject[];
  proximities?: RefLabelJsonldReadCollectionProject[];
  services?: RefLabelJsonldReadCollectionProject[];
  standing?: PropertySearchJsonldReadCollectionProjectStanding;
  status?: PropertySearchJsonldReadCollectionProjectStatus;
  subtype?: PropertySearchJsonldReadCollectionProjectSubtype;
  tag?: PropertyTagJsonldReadCollectionProject[];
  types?: RefLabelJsonldReadCollectionProject[];
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionProject[];
  viewQuality?: PropertySearchJsonldReadCollectionProjectViewQuality;
}

export type PropertyRegulationJsonldReadItemPropertyType = RefLabelJsonldReadItemProperty | null;

export type PropertyRegulationJsonldReadItemPropertyContextOneOfHydra = typeof PropertyRegulationJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadItemPropertyContext = string | PropertyRegulationJsonldReadItemPropertyContextOneOf;

export interface PropertyRegulationJsonldReadItemProperty {
  readonly '@context'?: PropertyRegulationJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadItemPropertyType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export interface PropertyRegulationJsonldReadItemProject {
  readonly '@context'?: PropertyRegulationJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadItemProjectType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadItemProjectContextOneOfHydra = typeof PropertyRegulationJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadItemProjectContext = string | PropertyRegulationJsonldReadItemProjectContextOneOf;

export type PropertyRegulationJsonldReadCollectionPropertyExcelExportType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadCollectionPropertyExcelExportContext = string | PropertyRegulationJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyRegulationJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyRegulationJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadCollectionPropertyExcelExportType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadCollectionPropertyType = RefLabelJsonldReadCollectionProperty | null;

export interface PropertyRegulationJsonldReadCollectionProperty {
  readonly '@context'?: PropertyRegulationJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadCollectionPropertyType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadCollectionPropertyContext = string | PropertyRegulationJsonldReadCollectionPropertyContextOneOf;

export type PropertyRegulationJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface PropertyRegulationJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyRegulationJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadCollectionProjectExcelExportType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadCollectionProjectExcelExportContext = string | PropertyRegulationJsonldReadCollectionProjectExcelExportContextOneOf;

export type PropertyRegulationJsonldReadCollectionProjectType = RefLabelJsonldReadCollectionProject | null;

export interface PropertyRegulationJsonldReadCollectionProject {
  readonly '@context'?: PropertyRegulationJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  graph?: string | null;
  readonly id: string;
  /** @nullable */
  label?: string | null;
  type?: PropertyRegulationJsonldReadCollectionProjectType;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type PropertyRegulationJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyRegulationJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyRegulationJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyRegulationJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyRegulationJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyRegulationJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyRegulationJsonldReadCollectionProjectContext = string | PropertyRegulationJsonldReadCollectionProjectContextOneOf;

export type PropertyProximitiesJsonldReadItemPropertyValueType = RefLabelJsonldReadItemProperty | null;

export type PropertyProximitiesJsonldReadItemPropertyRefLabel = RefLabelJsonldReadItemProperty | null;

export interface PropertyProximitiesJsonldReadItemProperty {
  readonly '@context'?: PropertyProximitiesJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadItemPropertyRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadItemPropertyValueType;
}

export type PropertyProximitiesJsonldReadItemPropertyContextOneOfHydra = typeof PropertyProximitiesJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadItemPropertyContext = string | PropertyProximitiesJsonldReadItemPropertyContextOneOf;

export type PropertyProximitiesJsonldReadItemProjectValueType = RefLabelJsonldReadItemProject | null;

export type PropertyProximitiesJsonldReadItemProjectRefLabel = RefLabelJsonldReadItemProject | null;

export interface PropertyProximitiesJsonldReadItemProject {
  readonly '@context'?: PropertyProximitiesJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadItemProjectRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadItemProjectValueType;
}

export type PropertyProximitiesJsonldReadItemProjectContextOneOfHydra = typeof PropertyProximitiesJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadItemProjectContext = string | PropertyProximitiesJsonldReadItemProjectContextOneOf;

export type PropertyProximitiesJsonldReadCollectionPropertyExcelExportValueType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyProximitiesJsonldReadCollectionPropertyExcelExportRefLabel = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadCollectionPropertyExcelExportContext = string | PropertyProximitiesJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyProximitiesJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyProximitiesJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadCollectionPropertyExcelExportRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadCollectionPropertyExcelExportValueType;
}

export type PropertyProximitiesJsonldReadCollectionPropertyValueType = RefLabelJsonldReadCollectionProperty | null;

export type PropertyProximitiesJsonldReadCollectionPropertyRefLabel = RefLabelJsonldReadCollectionProperty | null;

export interface PropertyProximitiesJsonldReadCollectionProperty {
  readonly '@context'?: PropertyProximitiesJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadCollectionPropertyRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadCollectionPropertyValueType;
}

export type PropertyProximitiesJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyProximitiesJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadCollectionPropertyContext = string | PropertyProximitiesJsonldReadCollectionPropertyContextOneOf;

export type PropertyProximitiesJsonldReadCollectionProjectExcelExportValueType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyProximitiesJsonldReadCollectionProjectExcelExportRefLabel = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface PropertyProximitiesJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyProximitiesJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadCollectionProjectExcelExportRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadCollectionProjectExcelExportValueType;
}

export type PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadCollectionProjectExcelExportContext = string | PropertyProximitiesJsonldReadCollectionProjectExcelExportContextOneOf;

export type PropertyProximitiesJsonldReadCollectionProjectValueType = RefLabelJsonldReadCollectionProject | null;

export type PropertyProximitiesJsonldReadCollectionProjectRefLabel = RefLabelJsonldReadCollectionProject | null;

export type PropertyProximitiesJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyProximitiesJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyProximitiesJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyProximitiesJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyProximitiesJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyProximitiesJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyProximitiesJsonldReadCollectionProjectContext = string | PropertyProximitiesJsonldReadCollectionProjectContextOneOf;

export interface PropertyProximitiesJsonldReadCollectionProject {
  readonly '@context'?: PropertyProximitiesJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PropertyProximitiesJsonldReadCollectionProjectRefLabel;
  /** @nullable */
  value?: string | null;
  valueType?: PropertyProximitiesJsonldReadCollectionProjectValueType;
}

export interface PropertyPropertyAreaJsonldReadItemProperty {
  readonly '@context'?: PropertyPropertyAreaJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadItemProperty;
  propertyArea?: PropertyAreaJsonldReadItemProperty;
}

export type PropertyPropertyAreaJsonldReadItemPropertyContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadItemPropertyContext = string | PropertyPropertyAreaJsonldReadItemPropertyContextOneOf;

export type PropertyPropertyAreaJsonldReadItemProjectContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadItemProjectContext = string | PropertyPropertyAreaJsonldReadItemProjectContextOneOf;

export interface PropertyPropertyAreaJsonldReadItemProject {
  readonly '@context'?: PropertyPropertyAreaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
}

export type PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContext = string | PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyPropertyAreaJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyPropertyAreaJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionPropertyExcelExport;
  propertyArea?: PropertyAreaJsonldReadCollectionPropertyExcelExport;
}

export interface PropertyPropertyAreaJsonldReadCollectionProperty {
  readonly '@context'?: PropertyPropertyAreaJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProperty;
  propertyArea?: PropertyAreaJsonldReadCollectionProperty;
}

export type PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadCollectionPropertyContext = string | PropertyPropertyAreaJsonldReadCollectionPropertyContextOneOf;

export type PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContext = string | PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyPropertyAreaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyPropertyAreaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
}

export interface PropertyPropertyAreaJsonldReadCollectionProject {
  readonly '@context'?: PropertyPropertyAreaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
}

export type PropertyPropertyAreaJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyPropertyAreaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyPropertyAreaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyPropertyAreaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyPropertyAreaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyPropertyAreaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyPropertyAreaJsonldReadCollectionProjectContext = string | PropertyPropertyAreaJsonldReadCollectionProjectContextOneOf;

export type PropertyOwnersJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadItemPropertyContext = string | PropertyOwnersJsonldReadItemPropertyContextOneOf;

export interface PropertyOwnersJsonldReadItemProperty {
  readonly '@context'?: PropertyOwnersJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  readonly id: string;
  people?: PeopleJsonldReadItemProperty;
  /** @nullable */
  sharesPercent?: number | null;
}

export type PropertyOwnersJsonldReadItemPropertyContextOneOfHydra = typeof PropertyOwnersJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadItemProjectContextOneOfHydra = typeof PropertyOwnersJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadItemProjectContext = string | PropertyOwnersJsonldReadItemProjectContextOneOf;

export interface PropertyOwnersJsonldReadItemProject {
  readonly '@context'?: PropertyOwnersJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface PropertyOwnersJsonldReadItemPeople {
  readonly '@context'?: PropertyOwnersJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  readonly id: string;
  property?: PropertyJsonldReadItemPeople;
  /** @nullable */
  sharesPercent?: number | null;
}

export type PropertyOwnersJsonldReadItemPeopleContextOneOfHydra = typeof PropertyOwnersJsonldReadItemPeopleContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadItemPeopleContext = string | PropertyOwnersJsonldReadItemPeopleContextOneOf;

export interface PropertyOwnersJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyOwnersJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  readonly id: string;
  people?: PeopleJsonldReadCollectionPropertyExcelExport;
  /** @nullable */
  sharesPercent?: number | null;
}

export type PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadCollectionPropertyExcelExportContext = string | PropertyOwnersJsonldReadCollectionPropertyExcelExportContextOneOf;

export type PropertyOwnersJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyOwnersJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadCollectionPropertyContext = string | PropertyOwnersJsonldReadCollectionPropertyContextOneOf;

export interface PropertyOwnersJsonldReadCollectionProperty {
  readonly '@context'?: PropertyOwnersJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  readonly id: string;
  people?: PeopleJsonldReadCollectionProperty;
  /** @nullable */
  sharesPercent?: number | null;
}

export type PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadCollectionProjectExcelExportContext = string | PropertyOwnersJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyOwnersJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyOwnersJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface PropertyOwnersJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PropertyOwnersJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  readonly id: string;
  property?: PropertyJsonldReadCollectionPeopleExcelExport;
  /** @nullable */
  sharesPercent?: number | null;
}

export type PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOwnersJsonldReadCollectionPeopleExcelExportContext = string | PropertyOwnersJsonldReadCollectionPeopleExcelExportContextOneOf;

export type PropertyOfferJsonldReadItemPropertyOfferUnitPrice = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferType = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferSubtype = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferStatus = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferPricePeriod = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferGroup = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferCurrency = RefLabelJsonldReadItemPropertyOffer | null;

export type PropertyOfferJsonldReadItemPropertyOfferContext = string | PropertyOfferJsonldReadItemPropertyOfferContextOneOf;

export interface PropertyOfferJsonldReadItemPropertyOffer {
  readonly '@context'?: PropertyOfferJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadItemPropertyOfferCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadItemPropertyOffer[];
  group?: PropertyOfferJsonldReadItemPropertyOfferGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadItemPropertyOfferPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  projectPropertyOffer?: ProjectPropertyOfferJsonldReadItemPropertyOffer[];
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadItemPropertyOfferStatus;
  subtype?: PropertyOfferJsonldReadItemPropertyOfferSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadItemPropertyOfferType;
  unitPrice?: PropertyOfferJsonldReadItemPropertyOfferUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra = typeof PropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof PropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadItemPropertyUnitPrice = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertyType = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertySubtype = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertyStatus = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertyPricePeriod = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertyGroup = RefLabelJsonldReadItemProperty | null;

export type PropertyOfferJsonldReadItemPropertyCurrency = RefLabelJsonldReadItemProperty | null;

export interface PropertyOfferJsonldReadItemProperty {
  readonly '@context'?: PropertyOfferJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadItemPropertyCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadItemProperty[];
  group?: PropertyOfferJsonldReadItemPropertyGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadItemPropertyPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadItemPropertyStatus;
  subtype?: PropertyOfferJsonldReadItemPropertySubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadItemPropertyType;
  unitPrice?: PropertyOfferJsonldReadItemPropertyUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadItemPropertyContextOneOfHydra = typeof PropertyOfferJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyOfferJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadItemPropertyContext = string | PropertyOfferJsonldReadItemPropertyContextOneOf;

export type PropertyOfferJsonldReadItemProjectUnitPrice = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectSubtype = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectPricePeriod = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectGroup = RefLabelJsonldReadItemProject | null;

export type PropertyOfferJsonldReadItemProjectCurrency = RefLabelJsonldReadItemProject | null;

export interface PropertyOfferJsonldReadItemProject {
  readonly '@context'?: PropertyOfferJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadItemProjectCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadItemProject[];
  group?: PropertyOfferJsonldReadItemProjectGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadItemProjectPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadItemProjectStatus;
  subtype?: PropertyOfferJsonldReadItemProjectSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadItemProjectType;
  unitPrice?: PropertyOfferJsonldReadItemProjectUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadItemProjectContextOneOfHydra = typeof PropertyOfferJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyOfferJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadItemProjectContext = string | PropertyOfferJsonldReadItemProjectContextOneOf;

export type PropertyOfferJsonldReadItemCollaboratorItemType = RefLabelJsonldReadItemCollaboratorItem | null;

export type PropertyOfferJsonldReadItemCollaboratorItemSubtype = RefLabelJsonldReadItemCollaboratorItem | null;

export type PropertyOfferJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export interface PropertyOfferJsonldReadItemCollaboratorItem {
  readonly '@context'?: PropertyOfferJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  createdAt?: string;
  readonly id: string;
  status?: PropertyOfferJsonldReadItemCollaboratorItemStatus;
  subtype?: PropertyOfferJsonldReadItemCollaboratorItemSubtype;
  type?: PropertyOfferJsonldReadItemCollaboratorItemType;
  updatedAt?: string;
}

export type PropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra = typeof PropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof PropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadItemCollaboratorItemContext = string | PropertyOfferJsonldReadItemCollaboratorItemContextOneOf;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportUnitPrice = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportType = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportSubtype = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportStatus = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportPricePeriod = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportGroup = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferExcelExportCurrency = RefLabelJsonldReadCollectionPropertyOfferExcelExport | null;

export interface PropertyOfferJsonldReadCollectionPropertyOfferExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadCollectionPropertyOfferExcelExport[];
  group?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  projectPropertyOffer?: ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExport[];
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportStatus;
  subtype?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportType;
  unitPrice?: PropertyOfferJsonldReadCollectionPropertyOfferExcelExportUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadCollectionPropertyOfferUnitPrice = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferType = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferSubtype = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferStatus = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferPricePeriod = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferGroup = RefLabelJsonldReadCollectionPropertyOffer | null;

export type PropertyOfferJsonldReadCollectionPropertyOfferCurrency = RefLabelJsonldReadCollectionPropertyOffer | null;

export interface PropertyOfferJsonldReadCollectionPropertyOffer {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadCollectionPropertyOfferCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadCollectionPropertyOffer[];
  group?: PropertyOfferJsonldReadCollectionPropertyOfferGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadCollectionPropertyOfferPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  projectPropertyOffer?: ProjectPropertyOfferJsonldReadCollectionPropertyOffer[];
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadCollectionPropertyOfferStatus;
  subtype?: PropertyOfferJsonldReadCollectionPropertyOfferSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadCollectionPropertyOfferType;
  unitPrice?: PropertyOfferJsonldReadCollectionPropertyOfferUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadCollectionPropertyExcelExportContext = string | PropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyOfferJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyOfferJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyOfferJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyOfferJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyOfferJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadCollectionPropertyContext = string | PropertyOfferJsonldReadCollectionPropertyContextOneOf;

export interface PropertyOfferJsonldReadCollectionProperty {
  readonly '@context'?: PropertyOfferJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  reference?: string | null;
  updatedAt?: string;
}

export type PropertyOfferJsonldReadCollectionProjectExcelExportUnitPrice = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportSubtype = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportPricePeriod = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportGroup = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportCurrency = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadCollectionProjectExcelExportContext = string | PropertyOfferJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyOfferJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyOfferJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadCollectionProjectExcelExportCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadCollectionProjectExcelExport[];
  group?: PropertyOfferJsonldReadCollectionProjectExcelExportGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadCollectionProjectExcelExportPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadCollectionProjectExcelExportStatus;
  subtype?: PropertyOfferJsonldReadCollectionProjectExcelExportSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadCollectionProjectExcelExportType;
  unitPrice?: PropertyOfferJsonldReadCollectionProjectExcelExportUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type PropertyOfferJsonldReadCollectionProjectUnitPrice = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectType = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectSubtype = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectPricePeriod = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectGroup = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectCurrency = RefLabelJsonldReadCollectionProject | null;

export type PropertyOfferJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyOfferJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyOfferJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyOfferJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyOfferJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyOfferJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyOfferJsonldReadCollectionProjectContext = string | PropertyOfferJsonldReadCollectionProjectContextOneOf;

export interface PropertyOfferJsonldReadCollectionProject {
  readonly '@context'?: PropertyOfferJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  auctionLink?: string | null;
  /** @nullable */
  commissionBuyer?: number | null;
  /** @nullable */
  commissionBuyerRate?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  createdAt?: string;
  currency?: PropertyOfferJsonldReadCollectionProjectCurrency;
  /** @nullable */
  estimationMax?: number | null;
  /** @nullable */
  estimationMin?: number | null;
  feesDetails?: RefLabelJsonldReadCollectionProject[];
  group?: PropertyOfferJsonldReadCollectionProjectGroup;
  readonly id: string;
  /** @nullable */
  inventoryFees?: number | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  priceContribution?: number | null;
  /** @nullable */
  priceDeposit?: number | null;
  /** @nullable */
  priceFees?: number | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceNegotiable?: number | null;
  pricePeriod?: PropertyOfferJsonldReadCollectionProjectPricePeriod;
  /** @nullable */
  priceSeller?: number | null;
  /** @nullable */
  priceSold?: number | null;
  /** @nullable */
  priceValue?: number | null;
  /** @nullable */
  priceVat?: number | null;
  /** @nullable */
  reference?: string | null;
  /** @nullable */
  soldAt?: string | null;
  status?: PropertyOfferJsonldReadCollectionProjectStatus;
  subtype?: PropertyOfferJsonldReadCollectionProjectSubtype;
  /** @nullable */
  tenantAmount?: number | null;
  /** @nullable */
  transfertTax?: number | null;
  type?: PropertyOfferJsonldReadCollectionProjectType;
  unitPrice?: PropertyOfferJsonldReadCollectionProjectUnitPrice;
  updatedAt?: string;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export interface PropertyMediaJsonldReadItemProperty {
  readonly '@context'?: PropertyMediaJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemProperty;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadItemProperty;
}

export type PropertyMediaJsonldReadItemPropertyContextOneOfHydra = typeof PropertyMediaJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyMediaJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadItemPropertyContext = string | PropertyMediaJsonldReadItemPropertyContextOneOf;

export type PropertyMediaJsonldReadItemProjectContextOneOfHydra = typeof PropertyMediaJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyMediaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadItemProjectContext = string | PropertyMediaJsonldReadItemProjectContextOneOf;

export interface PropertyMediaJsonldReadItemProject {
  readonly '@context'?: PropertyMediaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemProject;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadItemProject;
}

export type PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadCollectionPropertyExcelExportContext = string | PropertyMediaJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyMediaJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyMediaJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionPropertyExcelExport;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionPropertyExcelExport;
}

export interface PropertyMediaJsonldReadCollectionProperty {
  readonly '@context'?: PropertyMediaJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionProperty;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProperty;
}

export type PropertyMediaJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyMediaJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyMediaJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadCollectionPropertyContext = string | PropertyMediaJsonldReadCollectionPropertyContextOneOf;

export type PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadCollectionProjectExcelExportContext = string | PropertyMediaJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyMediaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyMediaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionProjectExcelExport;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProjectExcelExport;
}

export type PropertyMediaJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyMediaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyMediaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldReadCollectionProjectContext = string | PropertyMediaJsonldReadCollectionProjectContextOneOf;

export interface PropertyMediaJsonldReadCollectionProject {
  readonly '@context'?: PropertyMediaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionProject;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProject;
}

export interface PropertyMediaJsonld {
  readonly '@context'?: PropertyMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  property?: string;
}

export type PropertyMediaJsonldContextOneOfHydra = typeof PropertyMediaJsonldContextOneOfHydra[keyof typeof PropertyMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: PropertyMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyMediaJsonldContext = string | PropertyMediaJsonldContextOneOf;

export interface PropertyContactDetailsJsonldReadItemProperty {
  readonly '@context'?: PropertyContactDetailsJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemProperty;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadItemProperty;
}

export type PropertyContactDetailsJsonldReadItemPropertyContextOneOfHydra = typeof PropertyContactDetailsJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadItemPropertyContext = string | PropertyContactDetailsJsonldReadItemPropertyContextOneOf;

export interface PropertyContactDetailsJsonldReadItemProject {
  readonly '@context'?: PropertyContactDetailsJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemProject;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadItemProject;
}

export type PropertyContactDetailsJsonldReadItemProjectContextOneOfHydra = typeof PropertyContactDetailsJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadItemProjectContext = string | PropertyContactDetailsJsonldReadItemProjectContextOneOf;

export type PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContext = string | PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PropertyContactDetailsJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyContactDetailsJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionPropertyExcelExport;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadCollectionPropertyExcelExport;
}

export type PropertyContactDetailsJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyContactDetailsJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadCollectionPropertyContext = string | PropertyContactDetailsJsonldReadCollectionPropertyContextOneOf;

export interface PropertyContactDetailsJsonldReadCollectionProperty {
  readonly '@context'?: PropertyContactDetailsJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProperty;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadCollectionProperty;
}

export interface PropertyContactDetailsJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyContactDetailsJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProjectExcelExport;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadCollectionProjectExcelExport;
}

export type PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadCollectionProjectExcelExportContext = string | PropertyContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf;

export type PropertyContactDetailsJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyContactDetailsJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldReadCollectionProjectContext = string | PropertyContactDetailsJsonldReadCollectionProjectContextOneOf;

export interface PropertyContactDetailsJsonldReadCollectionProject {
  readonly '@context'?: PropertyContactDetailsJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProject;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: PropertyJsonldReadCollectionProject;
}

export interface PropertyContactDetailsJsonld {
  readonly '@context'?: PropertyContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonld;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  property?: string;
}

export type PropertyContactDetailsJsonldContextOneOfHydra = typeof PropertyContactDetailsJsonldContextOneOfHydra[keyof typeof PropertyContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: PropertyContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyContactDetailsJsonldContext = string | PropertyContactDetailsJsonldContextOneOf;

export type PropertyAreaJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadItemPropertySearchContext = string | PropertyAreaJsonldReadItemPropertySearchContextOneOf;

export interface PropertyAreaJsonldReadItemPropertySearch {
  readonly '@context'?: PropertyAreaJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadItemPropertySearchContextOneOfHydra = typeof PropertyAreaJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof PropertyAreaJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadItemPropertyUnit = RefLabelJsonldReadItemProperty | null;

export type PropertyAreaJsonldReadItemPropertyType = RefLabelJsonldReadItemProperty | null;

export type PropertyAreaJsonldReadItemPropertyFloorName = RefLabelJsonldReadItemProperty | null;

export type PropertyAreaJsonldReadItemPropertyFloorCoating = RefLabelJsonldReadItemProperty | null;

export interface PropertyAreaJsonldReadItemProperty {
  readonly '@context'?: PropertyAreaJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadItemProperty[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadItemPropertyFloorCoating;
  floorName?: PropertyAreaJsonldReadItemPropertyFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadItemPropertyType;
  unit?: PropertyAreaJsonldReadItemPropertyUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadItemPropertyContextOneOfHydra = typeof PropertyAreaJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyAreaJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadItemPropertyContext = string | PropertyAreaJsonldReadItemPropertyContextOneOf;

export type PropertyAreaJsonldReadItemProjectUnit = RefLabelJsonldReadItemProject | null;

export type PropertyAreaJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export type PropertyAreaJsonldReadItemProjectFloorName = RefLabelJsonldReadItemProject | null;

export type PropertyAreaJsonldReadItemProjectFloorCoating = RefLabelJsonldReadItemProject | null;

export type PropertyAreaJsonldReadItemProjectContextOneOfHydra = typeof PropertyAreaJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyAreaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadItemProjectContext = string | PropertyAreaJsonldReadItemProjectContextOneOf;

export interface PropertyAreaJsonldReadItemProject {
  readonly '@context'?: PropertyAreaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadItemProjectFloorCoating;
  floorName?: PropertyAreaJsonldReadItemProjectFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  property?: PropertyPropertyAreaJsonldReadItemProject[];
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadItemProjectType;
  unit?: PropertyAreaJsonldReadItemProjectUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionPropertySearchExcelExportContext = string | PropertyAreaJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export interface PropertyAreaJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: PropertyAreaJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface PropertyAreaJsonldReadCollectionPropertySearch {
  readonly '@context'?: PropertyAreaJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionPropertySearchContext = string | PropertyAreaJsonldReadCollectionPropertySearchContextOneOf;

export type PropertyAreaJsonldReadCollectionPropertyExcelExportUnit = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyAreaJsonldReadCollectionPropertyExcelExportType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyAreaJsonldReadCollectionPropertyExcelExportFloorName = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyAreaJsonldReadCollectionPropertyExcelExportFloorCoating = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export interface PropertyAreaJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyAreaJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadCollectionPropertyExcelExportFloorCoating;
  floorName?: PropertyAreaJsonldReadCollectionPropertyExcelExportFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadCollectionPropertyExcelExportType;
  unit?: PropertyAreaJsonldReadCollectionPropertyExcelExportUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionPropertyExcelExportContext = string | PropertyAreaJsonldReadCollectionPropertyExcelExportContextOneOf;

export type PropertyAreaJsonldReadCollectionPropertyUnit = RefLabelJsonldReadCollectionProperty | null;

export type PropertyAreaJsonldReadCollectionPropertyType = RefLabelJsonldReadCollectionProperty | null;

export type PropertyAreaJsonldReadCollectionPropertyFloorName = RefLabelJsonldReadCollectionProperty | null;

export type PropertyAreaJsonldReadCollectionPropertyFloorCoating = RefLabelJsonldReadCollectionProperty | null;

export interface PropertyAreaJsonldReadCollectionProperty {
  readonly '@context'?: PropertyAreaJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadCollectionProperty[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadCollectionPropertyFloorCoating;
  floorName?: PropertyAreaJsonldReadCollectionPropertyFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadCollectionPropertyType;
  unit?: PropertyAreaJsonldReadCollectionPropertyUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionPropertyContext = string | PropertyAreaJsonldReadCollectionPropertyContextOneOf;

export type PropertyAreaJsonldReadCollectionProjectExcelExportUnit = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyAreaJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyAreaJsonldReadCollectionProjectExcelExportFloorName = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyAreaJsonldReadCollectionProjectExcelExportFloorCoating = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionProjectExcelExportContext = string | PropertyAreaJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyAreaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyAreaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadCollectionProjectExcelExportFloorCoating;
  floorName?: PropertyAreaJsonldReadCollectionProjectExcelExportFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  property?: PropertyPropertyAreaJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadCollectionProjectExcelExportType;
  unit?: PropertyAreaJsonldReadCollectionProjectExcelExportUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionProjectUnit = RefLabelJsonldReadCollectionProject | null;

export type PropertyAreaJsonldReadCollectionProjectType = RefLabelJsonldReadCollectionProject | null;

export type PropertyAreaJsonldReadCollectionProjectFloorName = RefLabelJsonldReadCollectionProject | null;

export type PropertyAreaJsonldReadCollectionProjectFloorCoating = RefLabelJsonldReadCollectionProject | null;

export interface PropertyAreaJsonldReadCollectionProject {
  readonly '@context'?: PropertyAreaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  areaOrientations?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  ceilingHeight?: number | null;
  createdAt?: string;
  /** @nullable */
  floor?: number | null;
  floorCoating?: PropertyAreaJsonldReadCollectionProjectFloorCoating;
  floorName?: PropertyAreaJsonldReadCollectionProjectFloorName;
  readonly id: string;
  /** @nullable */
  number?: number | null;
  property?: PropertyPropertyAreaJsonldReadCollectionProject[];
  /** @nullable */
  surface?: number | null;
  type?: PropertyAreaJsonldReadCollectionProjectType;
  unit?: PropertyAreaJsonldReadCollectionProjectUnit;
  updatedAt?: string;
}

export type PropertyAreaJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyAreaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyAreaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyAreaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyAreaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyAreaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyAreaJsonldReadCollectionProjectContext = string | PropertyAreaJsonldReadCollectionProjectContextOneOf;

export type PropertyJsonldReadItemPropertyWaterWaste = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyWaterHotNetwork = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyWaterHotMode = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyViewQuality = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyType = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertySubtype = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyStyleName = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyStatus = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyStanding = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyPlotNetFloorUnit = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyPlotLandType = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyHeatingNetwork = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyFloorName = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyConstructionStep = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyCondominiumType = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyCondominiumFeesPeriod = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyCondominiumCurrency = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyCondition = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyAvailabilityStatus = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyAreaUnit = RefLabelJsonldReadItemProperty | null;

export type PropertyJsonldReadItemPropertyContextOneOfHydra = typeof PropertyJsonldReadItemPropertyContextOneOfHydra[keyof typeof PropertyJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadItemPropertyContext = string | PropertyJsonldReadItemPropertyContextOneOf;

export interface PropertyJsonldReadItemProperty {
  readonly '@context'?: PropertyJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadItemProperty[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadItemPropertyAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadItemPropertyAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadItemProperty[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadItemPropertyCondition;
  condominiumCurrency?: PropertyJsonldReadItemPropertyCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadItemPropertyCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadItemPropertyCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadItemPropertyConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadItemProperty[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadItemPropertyFloorName;
  heatingEnergies?: RefLabelJsonldReadItemProperty[];
  heatingModes?: RefLabelJsonldReadItemProperty[];
  heatingNetwork?: PropertyJsonldReadItemPropertyHeatingNetwork;
  readonly id: string;
  isPublic?: boolean;
  isShared?: boolean;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadItemProperty[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadItemProperty[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadItemPropertyPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadItemPropertyPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadItemProperty[];
  propertyOffer?: ProjectPropertyOfferJsonldReadItemProperty[];
  propertyOwners?: PropertyOwnersJsonldReadItemProperty[];
  proximities?: PropertyProximitiesJsonldReadItemProperty[];
  regulations?: RelPropertyPropertyRegulationJsonldReadItemProperty[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadItemProperty[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadItemPropertyStanding;
  status?: PropertyJsonldReadItemPropertyStatus;
  styleName?: PropertyJsonldReadItemPropertyStyleName;
  subtype?: PropertyJsonldReadItemPropertySubtype;
  tag?: PropertyTagJsonldReadItemProperty[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadItemPropertyType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadItemProperty[];
  viewQuality?: PropertyJsonldReadItemPropertyViewQuality;
  waterHotMode?: PropertyJsonldReadItemPropertyWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadItemPropertyWaterHotNetwork;
  waterWaste?: PropertyJsonldReadItemPropertyWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadItemProjectWaterWaste = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectWaterHotNetwork = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectWaterHotMode = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectViewQuality = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectSubtype = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectStyleName = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectStanding = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectPlotNetFloorUnit = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectPlotLandType = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectHeatingNetwork = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectFloorName = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectConstructionStep = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectCondominiumType = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectCondominiumFeesPeriod = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectCondominiumCurrency = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectCondition = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectAvailabilityStatus = RefLabelJsonldReadItemProject | null;

export type PropertyJsonldReadItemProjectAreaUnit = RefLabelJsonldReadItemProject | null;

export interface PropertyJsonldReadItemProject {
  readonly '@context'?: PropertyJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadItemProjectAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadItemProjectAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadItemProjectCondition;
  condominiumCurrency?: PropertyJsonldReadItemProjectCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadItemProjectCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadItemProjectCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadItemProjectConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadItemProject[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadItemProjectFloorName;
  heatingEnergies?: RefLabelJsonldReadItemProject[];
  heatingModes?: RefLabelJsonldReadItemProject[];
  heatingNetwork?: PropertyJsonldReadItemProjectHeatingNetwork;
  readonly id: string;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadItemProject[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadItemProjectPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadItemProjectPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadItemProject[];
  proximities?: PropertyProximitiesJsonldReadItemProject[];
  regulations?: RelPropertyPropertyRegulationJsonldReadItemProject[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadItemProject[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadItemProjectStanding;
  status?: PropertyJsonldReadItemProjectStatus;
  styleName?: PropertyJsonldReadItemProjectStyleName;
  subtype?: PropertyJsonldReadItemProjectSubtype;
  tag?: PropertyTagJsonldReadItemProject[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadItemProjectType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadItemProject[];
  viewQuality?: PropertyJsonldReadItemProjectViewQuality;
  waterHotMode?: PropertyJsonldReadItemProjectWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadItemProjectWaterHotNetwork;
  waterWaste?: PropertyJsonldReadItemProjectWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadItemProjectContextOneOfHydra = typeof PropertyJsonldReadItemProjectContextOneOfHydra[keyof typeof PropertyJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadItemProjectContext = string | PropertyJsonldReadItemProjectContextOneOf;

export type PropertyJsonldReadItemPeopleStatus = RefLabelJsonldReadItemPeople | null;

export type PropertyJsonldReadItemPeopleContextOneOfHydra = typeof PropertyJsonldReadItemPeopleContextOneOfHydra[keyof typeof PropertyJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadItemPeopleContext = string | PropertyJsonldReadItemPeopleContextOneOf;

export interface PropertyJsonldReadItemPeople {
  readonly '@context'?: PropertyJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: PropertyJsonldReadItemPeopleStatus;
  updatedAt?: string;
}

export type PropertyJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export type PropertyJsonldReadItemCollaboratorItemContextOneOfHydra = typeof PropertyJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof PropertyJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadItemCollaboratorItemContext = string | PropertyJsonldReadItemCollaboratorItemContextOneOf;

export interface PropertyJsonldReadItemCollaboratorItem {
  readonly '@context'?: PropertyJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: PropertyJsonldReadItemCollaboratorItemStatus;
  updatedAt?: string;
}

export type PropertyJsonldReadCollectionPropertyExcelExportWaterWaste = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportWaterHotNetwork = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportWaterHotMode = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportViewQuality = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportSubtype = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportStyleName = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportStatus = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportStanding = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportPlotNetFloorUnit = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportPlotLandType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportHeatingNetwork = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportFloorName = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportConstructionStep = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportCondominiumType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportCondominiumFeesPeriod = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportCondominiumCurrency = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportCondition = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportAvailabilityStatus = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PropertyJsonldReadCollectionPropertyExcelExportAreaUnit = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export interface PropertyJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PropertyJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadCollectionPropertyExcelExportAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadCollectionPropertyExcelExportAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadCollectionPropertyExcelExportCondition;
  condominiumCurrency?: PropertyJsonldReadCollectionPropertyExcelExportCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadCollectionPropertyExcelExportCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadCollectionPropertyExcelExportCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadCollectionPropertyExcelExportConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadCollectionPropertyExcelExport[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadCollectionPropertyExcelExportFloorName;
  heatingEnergies?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  heatingModes?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  heatingNetwork?: PropertyJsonldReadCollectionPropertyExcelExportHeatingNetwork;
  readonly id: string;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadCollectionPropertyExcelExportPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadCollectionPropertyExcelExportPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadCollectionPropertyExcelExport[];
  propertyOffer?: ProjectPropertyOfferJsonldReadCollectionPropertyExcelExport[];
  propertyOwners?: PropertyOwnersJsonldReadCollectionPropertyExcelExport[];
  proximities?: PropertyProximitiesJsonldReadCollectionPropertyExcelExport[];
  regulations?: RelPropertyPropertyRegulationJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadCollectionPropertyExcelExportStanding;
  status?: PropertyJsonldReadCollectionPropertyExcelExportStatus;
  styleName?: PropertyJsonldReadCollectionPropertyExcelExportStyleName;
  subtype?: PropertyJsonldReadCollectionPropertyExcelExportSubtype;
  tag?: PropertyTagJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadCollectionPropertyExcelExportType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  viewQuality?: PropertyJsonldReadCollectionPropertyExcelExportViewQuality;
  waterHotMode?: PropertyJsonldReadCollectionPropertyExcelExportWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadCollectionPropertyExcelExportWaterHotNetwork;
  waterWaste?: PropertyJsonldReadCollectionPropertyExcelExportWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PropertyJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PropertyJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadCollectionPropertyExcelExportContext = string | PropertyJsonldReadCollectionPropertyExcelExportContextOneOf;

export type PropertyJsonldReadCollectionPropertyWaterWaste = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyWaterHotNetwork = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyWaterHotMode = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyViewQuality = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyType = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertySubtype = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyStyleName = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyStatus = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyStanding = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyPlotNetFloorUnit = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyPlotLandType = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyHeatingNetwork = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyFloorName = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyConstructionStep = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyCondominiumType = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyCondominiumFeesPeriod = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyCondominiumCurrency = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyCondition = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyAvailabilityStatus = RefLabelJsonldReadCollectionProperty | null;

export type PropertyJsonldReadCollectionPropertyAreaUnit = RefLabelJsonldReadCollectionProperty | null;

export interface PropertyJsonldReadCollectionProperty {
  readonly '@context'?: PropertyJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionProperty[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadCollectionPropertyAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadCollectionPropertyAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadCollectionProperty[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadCollectionPropertyCondition;
  condominiumCurrency?: PropertyJsonldReadCollectionPropertyCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadCollectionPropertyCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadCollectionPropertyCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadCollectionPropertyConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadCollectionProperty[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadCollectionPropertyFloorName;
  heatingEnergies?: RefLabelJsonldReadCollectionProperty[];
  heatingModes?: RefLabelJsonldReadCollectionProperty[];
  heatingNetwork?: PropertyJsonldReadCollectionPropertyHeatingNetwork;
  readonly id: string;
  isPublic?: boolean;
  isShared?: boolean;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadCollectionProperty[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadCollectionProperty[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadCollectionPropertyPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadCollectionPropertyPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadCollectionProperty[];
  propertyOffer?: ProjectPropertyOfferJsonldReadCollectionProperty[];
  propertyOwners?: PropertyOwnersJsonldReadCollectionProperty[];
  proximities?: PropertyProximitiesJsonldReadCollectionProperty[];
  regulations?: RelPropertyPropertyRegulationJsonldReadCollectionProperty[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadCollectionProperty[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadCollectionPropertyStanding;
  status?: PropertyJsonldReadCollectionPropertyStatus;
  styleName?: PropertyJsonldReadCollectionPropertyStyleName;
  subtype?: PropertyJsonldReadCollectionPropertySubtype;
  tag?: PropertyTagJsonldReadCollectionProperty[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadCollectionPropertyType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionProperty[];
  viewQuality?: PropertyJsonldReadCollectionPropertyViewQuality;
  waterHotMode?: PropertyJsonldReadCollectionPropertyWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadCollectionPropertyWaterHotNetwork;
  waterWaste?: PropertyJsonldReadCollectionPropertyWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadCollectionPropertyContextOneOfHydra = typeof PropertyJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PropertyJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadCollectionPropertyContext = string | PropertyJsonldReadCollectionPropertyContextOneOf;

export type PropertyJsonldReadCollectionProjectExcelExportWaterWaste = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportWaterHotNetwork = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportWaterHotMode = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportViewQuality = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportSubtype = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportStyleName = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportStanding = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportPlotNetFloorUnit = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportPlotLandType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportHeatingNetwork = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportFloorName = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportConstructionStep = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportCondominiumType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportCondominiumFeesPeriod = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportCondominiumCurrency = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportCondition = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportAvailabilityStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportAreaUnit = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PropertyJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PropertyJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PropertyJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadCollectionProjectExcelExportContext = string | PropertyJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PropertyJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PropertyJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadCollectionProjectExcelExportAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadCollectionProjectExcelExportAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadCollectionProjectExcelExportCondition;
  condominiumCurrency?: PropertyJsonldReadCollectionProjectExcelExportCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadCollectionProjectExcelExportCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadCollectionProjectExcelExportCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadCollectionProjectExcelExportConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadCollectionProjectExcelExport[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadCollectionProjectExcelExportFloorName;
  heatingEnergies?: RefLabelJsonldReadCollectionProjectExcelExport[];
  heatingModes?: RefLabelJsonldReadCollectionProjectExcelExport[];
  heatingNetwork?: PropertyJsonldReadCollectionProjectExcelExportHeatingNetwork;
  readonly id: string;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadCollectionProjectExcelExportPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadCollectionProjectExcelExportPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadCollectionProjectExcelExport[];
  proximities?: PropertyProximitiesJsonldReadCollectionProjectExcelExport[];
  regulations?: RelPropertyPropertyRegulationJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadCollectionProjectExcelExportStanding;
  status?: PropertyJsonldReadCollectionProjectExcelExportStatus;
  styleName?: PropertyJsonldReadCollectionProjectExcelExportStyleName;
  subtype?: PropertyJsonldReadCollectionProjectExcelExportSubtype;
  tag?: PropertyTagJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadCollectionProjectExcelExportType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionProjectExcelExport[];
  viewQuality?: PropertyJsonldReadCollectionProjectExcelExportViewQuality;
  waterHotMode?: PropertyJsonldReadCollectionProjectExcelExportWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadCollectionProjectExcelExportWaterHotNetwork;
  waterWaste?: PropertyJsonldReadCollectionProjectExcelExportWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadCollectionProjectWaterWaste = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectWaterHotNetwork = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectWaterHotMode = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectViewQuality = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectType = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectSubtype = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectStyleName = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectStanding = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectPlotNetFloorUnit = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectPlotLandType = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectHeatingNetwork = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectFloorName = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectConstructionStep = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectCondominiumType = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectCondominiumFeesPeriod = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectCondominiumCurrency = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectCondition = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectAvailabilityStatus = RefLabelJsonldReadCollectionProject | null;

export type PropertyJsonldReadCollectionProjectAreaUnit = RefLabelJsonldReadCollectionProject | null;

export interface PropertyJsonldReadCollectionProject {
  readonly '@context'?: PropertyJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activities?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  areaTotal?: number | null;
  areaUnit?: PropertyJsonldReadCollectionProjectAreaUnit;
  /** @nullable */
  areaValue?: number | null;
  /** @nullable */
  areaWeighted?: number | null;
  /** @nullable */
  availabilityDate?: string | null;
  availabilityStatus?: PropertyJsonldReadCollectionProjectAvailabilityStatus;
  buildingMaterials?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  buildingUnit?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  codeUpdatedDate?: string | null;
  condition?: PropertyJsonldReadCollectionProjectCondition;
  condominiumCurrency?: PropertyJsonldReadCollectionProjectCondominiumCurrency;
  /** @nullable */
  condominiumFees?: number | null;
  condominiumFeesPeriod?: PropertyJsonldReadCollectionProjectCondominiumFeesPeriod;
  /** @nullable */
  condominiumHeight?: string | null;
  /** @nullable */
  condominiumLenght?: number | null;
  /** @nullable */
  condominiumNbFrontage?: number | null;
  /** @nullable */
  condominiumNbLots?: number | null;
  condominiumType?: PropertyJsonldReadCollectionProjectCondominiumType;
  /** @nullable */
  constructionDate?: string | null;
  constructionStep?: PropertyJsonldReadCollectionProjectConstructionStep;
  /** @nullable */
  constructionYear?: number | null;
  contactDetails?: PropertyContactDetailsJsonldReadCollectionProject[];
  createdAt?: string;
  /** @nullable */
  deliveryDate?: string | null;
  /** @nullable */
  floor?: number | null;
  floorName?: PropertyJsonldReadCollectionProjectFloorName;
  heatingEnergies?: RefLabelJsonldReadCollectionProject[];
  heatingModes?: RefLabelJsonldReadCollectionProject[];
  heatingNetwork?: PropertyJsonldReadCollectionProjectHeatingNetwork;
  readonly id: string;
  /** @nullable */
  landRegister?: string | null;
  /** @nullable */
  license?: string | null;
  media?: PropertyMediaJsonldReadCollectionProject[];
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nameBuilding?: string | null;
  /** @nullable */
  nbBathrooms?: number | null;
  /** @nullable */
  nbBedrooms?: number | null;
  /** @nullable */
  nbFloors?: number | null;
  /** @nullable */
  nbLevels?: number | null;
  /** @nullable */
  nbRooms?: number | null;
  /** @nullable */
  nbSleeps?: number | null;
  orientations?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  parent?: string | null;
  /** @nullable */
  plotHeight?: number | null;
  plotLandType?: PropertyJsonldReadCollectionProjectPlotLandType;
  /** @nullable */
  plotNetFloor?: number | null;
  plotNetFloorUnit?: PropertyJsonldReadCollectionProjectPlotNetFloorUnit;
  /** @nullable */
  plotServiced?: boolean | null;
  /** @nullable */
  plotWidth?: number | null;
  propertyArea?: PropertyPropertyAreaJsonldReadCollectionProject[];
  proximities?: PropertyProximitiesJsonldReadCollectionProject[];
  regulations?: RelPropertyPropertyRegulationJsonldReadCollectionProject[];
  /** @nullable */
  renovationCost?: number | null;
  /** @nullable */
  renovationYear?: number | null;
  services?: RefLabelJsonldReadCollectionProject[];
  /** @nullable */
  shareRating?: number | null;
  /** @nullable */
  stairsNumber?: string | null;
  standing?: PropertyJsonldReadCollectionProjectStanding;
  status?: PropertyJsonldReadCollectionProjectStatus;
  styleName?: PropertyJsonldReadCollectionProjectStyleName;
  subtype?: PropertyJsonldReadCollectionProjectSubtype;
  tag?: PropertyTagJsonldReadCollectionProject[];
  /** @nullable */
  readonly title?: string | null;
  type?: PropertyJsonldReadCollectionProjectType;
  updatedAt?: string;
  viewLandscapes?: RefLabelJsonldReadCollectionProject[];
  viewQuality?: PropertyJsonldReadCollectionProjectViewQuality;
  waterHotMode?: PropertyJsonldReadCollectionProjectWaterHotMode;
  waterHotNetwork?: PropertyJsonldReadCollectionProjectWaterHotNetwork;
  waterWaste?: PropertyJsonldReadCollectionProjectWaterWaste;
  /** @nullable */
  websiteUrl?: string | null;
}

export type PropertyJsonldReadCollectionProjectContextOneOfHydra = typeof PropertyJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PropertyJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadCollectionProjectContext = string | PropertyJsonldReadCollectionProjectContextOneOf;

export interface PropertyJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PropertyJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PropertyJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PropertyJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PropertyJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PropertyJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PropertyJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PropertyJsonldReadCollectionPeopleExcelExportContext = string | PropertyJsonldReadCollectionPeopleExcelExportContextOneOf;

export type ProjectPropertySearchJsonldReadItemPropertySearchContextOneOfHydra = typeof ProjectPropertySearchJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadItemPropertySearchContext = string | ProjectPropertySearchJsonldReadItemPropertySearchContextOneOf;

export interface ProjectPropertySearchJsonldReadItemPropertySearch {
  readonly '@context'?: ProjectPropertySearchJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadItemPropertySearch;
}

export type ProjectPropertySearchJsonldReadItemProjectContextOneOfHydra = typeof ProjectPropertySearchJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadItemProjectContext = string | ProjectPropertySearchJsonldReadItemProjectContextOneOf;

export interface ProjectPropertySearchJsonldReadItemProject {
  readonly '@context'?: ProjectPropertySearchJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertySearch?: PropertySearchJsonldReadItemProject;
}

export interface ProjectPropertySearchJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectPropertySearchJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadItemCollaboratorItemContext = string | ProjectPropertySearchJsonldReadItemCollaboratorItemContextOneOf;

export type ProjectPropertySearchJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectPropertySearchJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadItemClusterItemContext = string | ProjectPropertySearchJsonldReadItemClusterItemContextOneOf;

export interface ProjectPropertySearchJsonldReadItemClusterItem {
  readonly '@context'?: ProjectPropertySearchJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertySearch?: PropertySearchJsonldReadItemClusterItem;
}

export interface ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadCollectionPropertySearchExcelExport;
}

export type ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContext = string | ProjectPropertySearchJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export type ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadCollectionPropertySearchContext = string | ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOf;

export interface ProjectPropertySearchJsonldReadCollectionPropertySearch {
  readonly '@context'?: ProjectPropertySearchJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadCollectionPropertySearch;
}

export type ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra = typeof ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadCollectionProjectExcelExportContext = string | ProjectPropertySearchJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ProjectPropertySearchJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectPropertySearchJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertySearch?: PropertySearchJsonldReadCollectionProjectExcelExport;
}

export interface ProjectPropertySearchJsonldReadCollectionProject {
  readonly '@context'?: ProjectPropertySearchJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertySearch?: PropertySearchJsonldReadCollectionProject;
}

export type ProjectPropertySearchJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectPropertySearchJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectPropertySearchJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertySearchJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertySearchJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertySearchJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertySearchJsonldReadCollectionProjectContext = string | ProjectPropertySearchJsonldReadCollectionProjectContextOneOf;

export interface ProjectPropertyOfferJsonldReadItemPropertyOffer {
  readonly '@context'?: ProjectPropertyOfferJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadItemPropertyOffer;
}

export type ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadItemPropertyOfferContext = string | ProjectPropertyOfferJsonldReadItemPropertyOfferContextOneOf;

export type ProjectPropertyOfferJsonldReadItemPropertyContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadItemPropertyContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadItemPropertyContext = string | ProjectPropertyOfferJsonldReadItemPropertyContextOneOf;

export interface ProjectPropertyOfferJsonldReadItemProperty {
  readonly '@context'?: ProjectPropertyOfferJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadItemProperty;
  propertyOffer?: PropertyOfferJsonldReadItemProperty;
}

export type ProjectPropertyOfferJsonldReadItemProjectContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadItemProjectContext = string | ProjectPropertyOfferJsonldReadItemProjectContextOneOf;

export interface ProjectPropertyOfferJsonldReadItemProject {
  readonly '@context'?: ProjectPropertyOfferJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadItemProject;
  propertyOffer?: PropertyOfferJsonldReadItemProject;
}

export interface ProjectPropertyOfferJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectPropertyOfferJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadItemCollaboratorItem;
  propertyOffer?: PropertyOfferJsonldReadItemCollaboratorItem;
}

export type ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadItemCollaboratorItemContext = string | ProjectPropertyOfferJsonldReadItemCollaboratorItemContextOneOf;

export type ProjectPropertyOfferJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadItemClusterItemContext = string | ProjectPropertyOfferJsonldReadItemClusterItemContextOneOf;

export interface ProjectPropertyOfferJsonldReadItemClusterItem {
  readonly '@context'?: ProjectPropertyOfferJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContext = string | ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContextOneOf;

export interface ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExport {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionPropertyOfferExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadCollectionPropertyOfferExcelExport;
}

export interface ProjectPropertyOfferJsonldReadCollectionPropertyOffer {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadCollectionPropertyOffer;
}

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionPropertyOfferContext = string | ProjectPropertyOfferJsonldReadCollectionPropertyOfferContextOneOf;

export interface ProjectPropertyOfferJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  propertyOffer?: PropertyOfferJsonldReadCollectionPropertyExcelExport;
}

export type ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContext = string | ProjectPropertyOfferJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface ProjectPropertyOfferJsonldReadCollectionProperty {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadCollectionProperty;
  propertyOffer?: PropertyOfferJsonldReadCollectionProperty;
}

export type ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionPropertyContext = string | ProjectPropertyOfferJsonldReadCollectionPropertyContextOneOf;

export type ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContext = string | ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ProjectPropertyOfferJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProjectExcelExport;
  propertyOffer?: PropertyOfferJsonldReadCollectionProjectExcelExport;
}

export type ProjectPropertyOfferJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectPropertyOfferJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectPropertyOfferJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPropertyOfferJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPropertyOfferJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPropertyOfferJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPropertyOfferJsonldReadCollectionProjectContext = string | ProjectPropertyOfferJsonldReadCollectionProjectContextOneOf;

export interface ProjectPropertyOfferJsonldReadCollectionProject {
  readonly '@context'?: ProjectPropertyOfferJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  property?: PropertyJsonldReadCollectionProject;
  propertyOffer?: PropertyOfferJsonldReadCollectionProject;
}

export interface ProjectProjectAdvertiserJsonldReadItemProject {
  readonly '@context'?: ProjectProjectAdvertiserJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  comment?: string | null;
  readonly id: string;
  /** @nullable */
  isCommentHidden?: boolean | null;
  /** @nullable */
  isPictureHidden?: boolean | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  isWatermark?: boolean | null;
  projectAdvertiser?: ProjectAdvertiserJsonldReadItemProject;
}

export type ProjectProjectAdvertiserJsonldReadItemProjectContextOneOfHydra = typeof ProjectProjectAdvertiserJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectProjectAdvertiserJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectProjectAdvertiserJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectProjectAdvertiserJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectProjectAdvertiserJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectProjectAdvertiserJsonldReadItemProjectContext = string | ProjectProjectAdvertiserJsonldReadItemProjectContextOneOf;

export type ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContext = string | ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContextOneOf;

export interface ProjectProjectAdvertiserJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectProjectAdvertiserJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface ProjectProjectAdvertiserJsonldReadItemClusterItem {
  readonly '@context'?: ProjectProjectAdvertiserJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectProjectAdvertiserJsonldReadItemClusterItemContext = string | ProjectProjectAdvertiserJsonldReadItemClusterItemContextOneOf;

export type ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContext = string | ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  comment?: string | null;
  readonly id: string;
  /** @nullable */
  isCommentHidden?: boolean | null;
  /** @nullable */
  isPictureHidden?: boolean | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  isWatermark?: boolean | null;
  projectAdvertiser?: ProjectAdvertiserJsonldReadCollectionProjectExcelExport;
}

export type ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectProjectAdvertiserJsonldReadCollectionProjectContext = string | ProjectProjectAdvertiserJsonldReadCollectionProjectContextOneOf;

export interface ProjectProjectAdvertiserJsonldReadCollectionProject {
  readonly '@context'?: ProjectProjectAdvertiserJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  comment?: string | null;
  readonly id: string;
  /** @nullable */
  isCommentHidden?: boolean | null;
  /** @nullable */
  isPictureHidden?: boolean | null;
  /** @nullable */
  isPriceHidden?: boolean | null;
  /** @nullable */
  isWatermark?: boolean | null;
  projectAdvertiser?: ProjectAdvertiserJsonldReadCollectionProject;
}

export type ProjectPeopleJsonldReadItemProjectRole = RefLabelJsonldReadItemProject | null;

export type ProjectPeopleJsonldReadItemProjectContextOneOfHydra = typeof ProjectPeopleJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadItemProjectContext = string | ProjectPeopleJsonldReadItemProjectContextOneOf;

export interface ProjectPeopleJsonldReadItemProject {
  readonly '@context'?: ProjectPeopleJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  people?: PeopleJsonldReadItemProject;
  role?: ProjectPeopleJsonldReadItemProjectRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadItemPeopleRole = RefLabelJsonldReadItemPeople | null;

export interface ProjectPeopleJsonldReadItemPeople {
  readonly '@context'?: ProjectPeopleJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  project?: ProjectJsonldReadItemPeople;
  role?: ProjectPeopleJsonldReadItemPeopleRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadItemPeopleContextOneOfHydra = typeof ProjectPeopleJsonldReadItemPeopleContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadItemPeopleContext = string | ProjectPeopleJsonldReadItemPeopleContextOneOf;

export type ProjectPeopleJsonldReadItemCollaboratorItemRole = RefLabelJsonldReadItemCollaboratorItem | null;

export interface ProjectPeopleJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectPeopleJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  people?: PeopleJsonldReadItemCollaboratorItem;
  role?: ProjectPeopleJsonldReadItemCollaboratorItemRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectPeopleJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadItemCollaboratorItemContext = string | ProjectPeopleJsonldReadItemCollaboratorItemContextOneOf;

export type ProjectPeopleJsonldReadItemClusterItemRole = RefLabelJsonldReadItemClusterItem | null;

export type ProjectPeopleJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectPeopleJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadItemClusterItemContext = string | ProjectPeopleJsonldReadItemClusterItemContextOneOf;

export interface ProjectPeopleJsonldReadItemClusterItem {
  readonly '@context'?: ProjectPeopleJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  people?: PeopleJsonldReadItemClusterItem;
  role?: ProjectPeopleJsonldReadItemClusterItemRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadCollectionProjectExcelExportRole = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface ProjectPeopleJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectPeopleJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  people?: PeopleJsonldReadCollectionProjectExcelExport;
  role?: ProjectPeopleJsonldReadCollectionProjectExcelExportRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadCollectionProjectExcelExportContext = string | ProjectPeopleJsonldReadCollectionProjectExcelExportContextOneOf;

export type ProjectPeopleJsonldReadCollectionProjectRole = RefLabelJsonldReadCollectionProject | null;

export interface ProjectPeopleJsonldReadCollectionProject {
  readonly '@context'?: ProjectPeopleJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  people?: PeopleJsonldReadCollectionProject;
  role?: ProjectPeopleJsonldReadCollectionProjectRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectPeopleJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadCollectionProjectContext = string | ProjectPeopleJsonldReadCollectionProjectContextOneOf;

export type ProjectPeopleJsonldReadCollectionPeopleExcelExportRole = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface ProjectPeopleJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: ProjectPeopleJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  project?: ProjectJsonldReadCollectionPeopleExcelExport;
  role?: ProjectPeopleJsonldReadCollectionPeopleExcelExportRole;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadCollectionPeopleExcelExportContext = string | ProjectPeopleJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface ProjectPeopleJsonldReadCollectionPeople {
  readonly '@context'?: ProjectPeopleJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  project?: ProjectJsonldReadCollectionPeople;
  updatedAt?: string;
}

export type ProjectPeopleJsonldReadCollectionPeopleContextOneOfHydra = typeof ProjectPeopleJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadCollectionPeopleContext = string | ProjectPeopleJsonldReadCollectionPeopleContextOneOf;

export type ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  project?: ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
  updatedAt?: string;
}

export type ProjectCollaboratorJsonldReadItemProjectRole = RefLabelJsonldReadItemProject | null;

export interface ProjectCollaboratorJsonldReadItemProject {
  readonly '@context'?: ProjectCollaboratorJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: CollaboratorJsonldReadItemProject;
  readonly id: string;
  isDefault?: boolean;
  role?: ProjectCollaboratorJsonldReadItemProjectRole;
}

export type ProjectCollaboratorJsonldReadItemProjectContextOneOfHydra = typeof ProjectCollaboratorJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectCollaboratorJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectCollaboratorJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectCollaboratorJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectCollaboratorJsonldReadItemProjectContext = string | ProjectCollaboratorJsonldReadItemProjectContextOneOf;

export type ProjectCollaboratorJsonldReadItemCollaboratorItemRole = RefLabelJsonldReadItemCollaboratorItem | null;

export type ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectCollaboratorJsonldReadItemCollaboratorItemContext = string | ProjectCollaboratorJsonldReadItemCollaboratorItemContextOneOf;

export interface ProjectCollaboratorJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectCollaboratorJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  isDefault?: boolean;
  project?: ProjectJsonldReadItemCollaboratorItem;
  role?: ProjectCollaboratorJsonldReadItemCollaboratorItemRole;
}

export type ProjectCollaboratorJsonldReadCollectionProjectExcelExportRole = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface ProjectCollaboratorJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectCollaboratorJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: CollaboratorJsonldReadCollectionProjectExcelExport;
  readonly id: string;
  isDefault?: boolean;
  role?: ProjectCollaboratorJsonldReadCollectionProjectExcelExportRole;
}

export type ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectCollaboratorJsonldReadCollectionProjectExcelExportContext = string | ProjectCollaboratorJsonldReadCollectionProjectExcelExportContextOneOf;

export type ProjectCollaboratorJsonldReadCollectionProjectRole = RefLabelJsonldReadCollectionProject | null;

export interface ProjectCollaboratorJsonldReadCollectionProject {
  readonly '@context'?: ProjectCollaboratorJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: CollaboratorJsonldReadCollectionProject;
  readonly id: string;
  isDefault?: boolean;
  role?: ProjectCollaboratorJsonldReadCollectionProjectRole;
}

export type ProjectCollaboratorJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectCollaboratorJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectCollaboratorJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectCollaboratorJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectCollaboratorJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectCollaboratorJsonldReadCollectionProjectContext = string | ProjectCollaboratorJsonldReadCollectionProjectContextOneOf;

export type ProjectCollaboratorJsonldContextOneOfHydra = typeof ProjectCollaboratorJsonldContextOneOfHydra[keyof typeof ProjectCollaboratorJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectCollaboratorJsonldContextOneOf = {
  '@vocab': string;
  hydra: ProjectCollaboratorJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectCollaboratorJsonldContext = string | ProjectCollaboratorJsonldContextOneOf;

export interface ProjectCollaboratorJsonld {
  readonly '@context'?: ProjectCollaboratorJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: string;
  readonly id: string;
  isDefault?: boolean;
  project?: string;
  /** @nullable */
  role?: string | null;
}

export interface ProjectClusterDTOJsonld {
  order?: number;
  project?: string;
}

export interface ProjectClusterJsonldReadItemProject {
  readonly '@context'?: ProjectClusterJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadItemProject;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export type ProjectClusterJsonldReadItemProjectContextOneOfHydra = typeof ProjectClusterJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectClusterJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectClusterJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectClusterJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectClusterJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectClusterJsonldReadItemProjectContext = string | ProjectClusterJsonldReadItemProjectContextOneOf;

export interface ProjectClusterJsonldReadItemClusterItem {
  readonly '@context'?: ProjectClusterJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: ProjectJsonldReadItemClusterItem;
  updatedAt?: string;
}

export type ProjectClusterJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectClusterJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectClusterJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectClusterJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectClusterJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectClusterJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectClusterJsonldReadItemClusterItemContext = string | ProjectClusterJsonldReadItemClusterItemContextOneOf;

export type ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectClusterJsonldReadCollectionProjectExcelExportContext = string | ProjectClusterJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ProjectClusterJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectClusterJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadCollectionProjectExcelExport;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export type ProjectClusterJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectClusterJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectClusterJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectClusterJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectClusterJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectClusterJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectClusterJsonldReadCollectionProjectContext = string | ProjectClusterJsonldReadCollectionProjectContextOneOf;

export interface ProjectClusterJsonldReadCollectionProject {
  readonly '@context'?: ProjectClusterJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadCollectionProject;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export interface ProjectClusterJsonld {
  readonly '@context'?: ProjectClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  order?: number | null;
  project?: string;
  updatedAt?: string;
}

export type ProjectClusterJsonldContextOneOfHydra = typeof ProjectClusterJsonldContextOneOfHydra[keyof typeof ProjectClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: ProjectClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectClusterJsonldContext = string | ProjectClusterJsonldContextOneOf;

export type ProjectAdvertiserJsonldReadItemProjectContextOneOfHydra = typeof ProjectAdvertiserJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectAdvertiserJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectAdvertiserJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectAdvertiserJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectAdvertiserJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectAdvertiserJsonldReadItemProjectContext = string | ProjectAdvertiserJsonldReadItemProjectContextOneOf;

export interface ProjectAdvertiserJsonldReadItemProject {
  readonly '@context'?: ProjectAdvertiserJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  name?: string | null;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export type ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectAdvertiserJsonldReadCollectionProjectExcelExportContext = string | ProjectAdvertiserJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ProjectAdvertiserJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ProjectAdvertiserJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  name?: string | null;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export interface ProjectAdvertiserJsonldReadCollectionProject {
  readonly '@context'?: ProjectAdvertiserJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  name?: string | null;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export type ProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra = typeof ProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectAdvertiserJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectAdvertiserJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectAdvertiserJsonldReadCollectionProjectContext = string | ProjectAdvertiserJsonldReadCollectionProjectContextOneOf;

export interface ProjectJsonldReadItemPropertySearch {
  readonly '@context'?: ProjectJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadItemPropertySearchContextOneOfHydra = typeof ProjectJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof ProjectJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemPropertySearchContext = string | ProjectJsonldReadItemPropertySearchContextOneOf;

export interface ProjectJsonldReadItemPropertyOffer {
  readonly '@context'?: ProjectJsonldReadItemPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadItemPropertyOfferContextOneOfHydra = typeof ProjectJsonldReadItemPropertyOfferContextOneOfHydra[keyof typeof ProjectJsonldReadItemPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemPropertyOfferContext = string | ProjectJsonldReadItemPropertyOfferContextOneOf;

export type ProjectJsonldReadItemPropertyContextOneOfHydra = typeof ProjectJsonldReadItemPropertyContextOneOfHydra[keyof typeof ProjectJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemPropertyContext = string | ProjectJsonldReadItemPropertyContextOneOf;

export interface ProjectJsonldReadItemProperty {
  readonly '@context'?: ProjectJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadItemProjectType = RefLabelJsonldReadItemProject | null;

export type ProjectJsonldReadItemProjectSubtype = RefLabelJsonldReadItemProject | null;

export type ProjectJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type ProjectJsonldReadItemProjectAgreement = RefLabelJsonldReadItemProject | null;

export interface ProjectJsonldReadItemProject {
  readonly '@context'?: ProjectJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agreement?: ProjectJsonldReadItemProjectAgreement;
  /** @nullable */
  agreementFrom?: string | null;
  /** @nullable */
  agreementReference?: string | null;
  /** @nullable */
  agreementTo?: string | null;
  cluster?: ProjectClusterJsonldReadItemProject[];
  collaborator?: ProjectCollaboratorJsonldReadItemProject[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commentInternal?: string | null;
  createdAt?: string;
  readonly id: string;
  isPublic?: boolean;
  isShared?: boolean;
  people?: ProjectPeopleJsonldReadItemProject[];
  projectAdvertiser?: ProjectProjectAdvertiserJsonldReadItemProject[];
  propertyOffer?: ProjectPropertyOfferJsonldReadItemProject[];
  propertySearch?: ProjectPropertySearchJsonldReadItemProject[];
  status?: ProjectJsonldReadItemProjectStatus;
  /** @nullable */
  statusComment?: string | null;
  subtype?: ProjectJsonldReadItemProjectSubtype;
  type?: ProjectJsonldReadItemProjectType;
  updatedAt?: string;
  /** @nullable */
  visitInstructions?: string | null;
  /** @nullable */
  visitKeyNumber?: string | null;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type ProjectJsonldReadItemProjectContextOneOfHydra = typeof ProjectJsonldReadItemProjectContextOneOfHydra[keyof typeof ProjectJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemProjectContext = string | ProjectJsonldReadItemProjectContextOneOf;

export type ProjectJsonldReadItemPeopleType = RefLabelJsonldReadItemPeople | null;

export type ProjectJsonldReadItemPeopleStatus = RefLabelJsonldReadItemPeople | null;

export interface ProjectJsonldReadItemPeople {
  readonly '@context'?: ProjectJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: ProjectJsonldReadItemPeopleStatus;
  type?: ProjectJsonldReadItemPeopleType;
  updatedAt?: string;
}

export type ProjectJsonldReadItemPeopleContextOneOfHydra = typeof ProjectJsonldReadItemPeopleContextOneOfHydra[keyof typeof ProjectJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemPeopleContext = string | ProjectJsonldReadItemPeopleContextOneOf;

export type ProjectJsonldReadItemCollaboratorItemType = RefLabelJsonldReadItemCollaboratorItem | null;

export type ProjectJsonldReadItemCollaboratorItemSubtype = RefLabelJsonldReadItemCollaboratorItem | null;

export type ProjectJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export type ProjectJsonldReadItemCollaboratorItemAgreement = RefLabelJsonldReadItemCollaboratorItem | null;

export interface ProjectJsonldReadItemCollaboratorItem {
  readonly '@context'?: ProjectJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agreement?: ProjectJsonldReadItemCollaboratorItemAgreement;
  /** @nullable */
  agreementFrom?: string | null;
  /** @nullable */
  agreementReference?: string | null;
  /** @nullable */
  agreementTo?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commentInternal?: string | null;
  createdAt?: string;
  readonly id: string;
  people?: ProjectPeopleJsonldReadItemCollaboratorItem[];
  projectAdvertiser?: ProjectProjectAdvertiserJsonldReadItemCollaboratorItem[];
  propertyOffer?: ProjectPropertyOfferJsonldReadItemCollaboratorItem[];
  propertySearch?: ProjectPropertySearchJsonldReadItemCollaboratorItem[];
  status?: ProjectJsonldReadItemCollaboratorItemStatus;
  /** @nullable */
  statusComment?: string | null;
  subtype?: ProjectJsonldReadItemCollaboratorItemSubtype;
  type?: ProjectJsonldReadItemCollaboratorItemType;
  updatedAt?: string;
  /** @nullable */
  visitInstructions?: string | null;
  /** @nullable */
  visitKeyNumber?: string | null;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type ProjectJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ProjectJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ProjectJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemCollaboratorItemContext = string | ProjectJsonldReadItemCollaboratorItemContextOneOf;

export type ProjectJsonldReadItemClusterItemType = RefLabelJsonldReadItemClusterItem | null;

export type ProjectJsonldReadItemClusterItemSubtype = RefLabelJsonldReadItemClusterItem | null;

export type ProjectJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export type ProjectJsonldReadItemClusterItemAgreement = RefLabelJsonldReadItemClusterItem | null;

export interface ProjectJsonldReadItemClusterItem {
  readonly '@context'?: ProjectJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agreement?: ProjectJsonldReadItemClusterItemAgreement;
  /** @nullable */
  agreementFrom?: string | null;
  /** @nullable */
  agreementReference?: string | null;
  /** @nullable */
  agreementTo?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commentInternal?: string | null;
  createdAt?: string;
  readonly id: string;
  people?: ProjectPeopleJsonldReadItemClusterItem[];
  projectAdvertiser?: ProjectProjectAdvertiserJsonldReadItemClusterItem[];
  propertyOffer?: ProjectPropertyOfferJsonldReadItemClusterItem[];
  propertySearch?: ProjectPropertySearchJsonldReadItemClusterItem[];
  status?: ProjectJsonldReadItemClusterItemStatus;
  /** @nullable */
  statusComment?: string | null;
  subtype?: ProjectJsonldReadItemClusterItemSubtype;
  type?: ProjectJsonldReadItemClusterItemType;
  updatedAt?: string;
  /** @nullable */
  visitInstructions?: string | null;
  /** @nullable */
  visitKeyNumber?: string | null;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type ProjectJsonldReadItemClusterItemContextOneOfHydra = typeof ProjectJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ProjectJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadItemClusterItemContext = string | ProjectJsonldReadItemClusterItemContextOneOf;

export type ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionSharedDataReadItemSharedDataContext = string | ProjectJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface ProjectJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: ProjectJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  isShared?: boolean;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionSharedDataContextOneOfHydra = typeof ProjectJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionSharedDataContext = string | ProjectJsonldReadCollectionSharedDataContextOneOf;

export interface ProjectJsonldReadCollectionSharedData {
  readonly '@context'?: ProjectJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  isShared?: boolean;
  updatedAt?: string;
}

export interface ProjectJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: ProjectJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPropertySearchExcelExportContext = string | ProjectJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export type ProjectJsonldReadCollectionPropertySearchContextOneOfHydra = typeof ProjectJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPropertySearchContext = string | ProjectJsonldReadCollectionPropertySearchContextOneOf;

export interface ProjectJsonldReadCollectionPropertySearch {
  readonly '@context'?: ProjectJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface ProjectJsonldReadCollectionPropertyOfferExcelExport {
  readonly '@context'?: ProjectJsonldReadCollectionPropertyOfferExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = typeof ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPropertyOfferExcelExportContext = string | ProjectJsonldReadCollectionPropertyOfferExcelExportContextOneOf;

export type ProjectJsonldReadCollectionPropertyOfferContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPropertyOfferContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPropertyOfferContext = string | ProjectJsonldReadCollectionPropertyOfferContextOneOf;

export interface ProjectJsonldReadCollectionPropertyOffer {
  readonly '@context'?: ProjectJsonldReadCollectionPropertyOfferContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionPropertyOfferContextOneOfHydra = typeof ProjectJsonldReadCollectionPropertyOfferContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPropertyOfferContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPropertyOfferContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPropertyContextOneOfHydra = typeof ProjectJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPropertyContext = string | ProjectJsonldReadCollectionPropertyContextOneOf;

export interface ProjectJsonldReadCollectionProperty {
  readonly '@context'?: ProjectJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionProjectExcelExportType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type ProjectJsonldReadCollectionProjectExcelExportSubtype = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type ProjectJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type ProjectJsonldReadCollectionProjectExcelExportAgreement = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface ProjectJsonldReadCollectionProjectExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  agreement?: ProjectJsonldReadCollectionProjectExcelExportAgreement;
  /** @nullable */
  agreementFrom?: string | null;
  /** @nullable */
  agreementReference?: string | null;
  /** @nullable */
  agreementTo?: string | null;
  cluster?: ProjectClusterJsonldReadCollectionProjectExcelExport[];
  collaborator?: ProjectCollaboratorJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commentInternal?: string | null;
  createdAt?: string;
  readonly id: string;
  people?: ProjectPeopleJsonldReadCollectionProjectExcelExport[];
  projectAdvertiser?: ProjectProjectAdvertiserJsonldReadCollectionProjectExcelExport[];
  propertyOffer?: ProjectPropertyOfferJsonldReadCollectionProjectExcelExport[];
  propertySearch?: ProjectPropertySearchJsonldReadCollectionProjectExcelExport[];
  status?: ProjectJsonldReadCollectionProjectExcelExportStatus;
  /** @nullable */
  statusComment?: string | null;
  subtype?: ProjectJsonldReadCollectionProjectExcelExportSubtype;
  type?: ProjectJsonldReadCollectionProjectExcelExportType;
  updatedAt?: string;
  /** @nullable */
  visitInstructions?: string | null;
  /** @nullable */
  visitKeyNumber?: string | null;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type ProjectJsonldReadCollectionProjectType = RefLabelJsonldReadCollectionProject | null;

export type ProjectJsonldReadCollectionProjectSubtype = RefLabelJsonldReadCollectionProject | null;

export type ProjectJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export type ProjectJsonldReadCollectionProjectAgreement = RefLabelJsonldReadCollectionProject | null;

export interface ProjectJsonldReadCollectionProject {
  readonly '@id'?: string;
  readonly '@type'?: string;
  agreement?: ProjectJsonldReadCollectionProjectAgreement;
  /** @nullable */
  agreementFrom?: string | null;
  /** @nullable */
  agreementReference?: string | null;
  /** @nullable */
  agreementTo?: string | null;
  cluster?: ProjectClusterJsonldReadCollectionProject[];
  collaborator?: ProjectCollaboratorJsonldReadCollectionProject[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commentInternal?: string | null;
  createdAt?: string;
  readonly id: string;
  isPublic?: boolean;
  isShared?: boolean;
  people?: ProjectPeopleJsonldReadCollectionProject[];
  projectAdvertiser?: ProjectProjectAdvertiserJsonldReadCollectionProject[];
  propertyOffer?: ProjectPropertyOfferJsonldReadCollectionProject[];
  propertySearch?: ProjectPropertySearchJsonldReadCollectionProject[];
  sharedData?: SharedDataJsonldReadCollectionProject[];
  status?: ProjectJsonldReadCollectionProjectStatus;
  /** @nullable */
  statusComment?: string | null;
  subtype?: ProjectJsonldReadCollectionProjectSubtype;
  type?: ProjectJsonldReadCollectionProjectType;
  updatedAt?: string;
  /** @nullable */
  visitInstructions?: string | null;
  /** @nullable */
  visitKeyNumber?: string | null;
  /** @nullable */
  readonly wwwbiCanAccessDate?: string | null;
  /** @nullable */
  readonly wwwbiHasAccessDate?: string | null;
}

export type ProjectJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof ProjectJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPeopleExcelExportContext = string | ProjectJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface ProjectJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: ProjectJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionPeopleType = RefLabelJsonldReadCollectionPeople | null;

export type ProjectJsonldReadCollectionPeopleStatus = RefLabelJsonldReadCollectionPeople | null;

export interface ProjectJsonldReadCollectionPeople {
  readonly '@context'?: ProjectJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: ProjectJsonldReadCollectionPeopleStatus;
  type?: ProjectJsonldReadCollectionPeopleType;
  updatedAt?: string;
}

export type ProjectJsonldReadCollectionPeopleContextOneOfHydra = typeof ProjectJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionPeopleContext = string | ProjectJsonldReadCollectionPeopleContextOneOf;

export type ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesType = RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesStatus = RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  status?: ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesStatus;
  type?: ProjectJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesType;
  updatedAt?: string;
}

export type PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type PointJsonldReadItemTpropertyWithoutPrivateDataContext = string | PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export interface PointJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: PointJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadItemProjectContextOneOfHydra = typeof PeopleSpouseJsonldReadItemProjectContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadItemProjectContext = string | PeopleSpouseJsonldReadItemProjectContextOneOf;

export interface PeopleSpouseJsonldReadItemProject {
  readonly '@context'?: PeopleSpouseJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  dst?: PeopleJsonldReadItemProject;
  readonly id: string;
  people?: PeopleJsonldReadItemProject;
  updatedAt?: string;
}

export interface PeopleSpouseJsonldReadItemPeople {
  readonly '@context'?: PeopleSpouseJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  dst?: PeopleJsonldReadItemPeople;
  readonly id: string;
  people?: PeopleJsonldReadItemPeople;
  updatedAt?: string;
}

export type PeopleSpouseJsonldReadItemPeopleContextOneOfHydra = typeof PeopleSpouseJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadItemPeopleContext = string | PeopleSpouseJsonldReadItemPeopleContextOneOf;

export interface PeopleSpouseJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PeopleSpouseJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  dst?: PeopleJsonldReadCollectionProjectExcelExport;
  readonly id: string;
  people?: PeopleJsonldReadCollectionProjectExcelExport;
  updatedAt?: string;
}

export type PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadCollectionProjectExcelExportContext = string | PeopleSpouseJsonldReadCollectionProjectExcelExportContextOneOf;

export type PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadCollectionPeopleExcelExportContext = string | PeopleSpouseJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface PeopleSpouseJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleSpouseJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  dst?: PeopleJsonldReadCollectionPeopleExcelExport;
  readonly id: string;
  people?: PeopleJsonldReadCollectionPeopleExcelExport;
  updatedAt?: string;
}

export type PeopleSpouseJsonldReadCollectionPeopleContextOneOfHydra = typeof PeopleSpouseJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadCollectionPeopleContext = string | PeopleSpouseJsonldReadCollectionPeopleContextOneOf;

export interface PeopleSpouseJsonldReadCollectionPeople {
  readonly '@context'?: PeopleSpouseJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  dst?: PeopleJsonldReadCollectionPeople;
  readonly id: string;
  people?: PeopleJsonldReadCollectionPeople;
  updatedAt?: string;
}

export interface PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  dst?: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
  readonly id: string;
  people?: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
  updatedAt?: string;
}

export type PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export type PeopleMediaJsonldReadItemPropertyContextOneOfHydra = typeof PeopleMediaJsonldReadItemPropertyContextOneOfHydra[keyof typeof PeopleMediaJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadItemPropertyContext = string | PeopleMediaJsonldReadItemPropertyContextOneOf;

export interface PeopleMediaJsonldReadItemProperty {
  readonly '@context'?: PeopleMediaJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type PeopleMediaJsonldReadItemPeopleContextOneOfHydra = typeof PeopleMediaJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleMediaJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadItemPeopleContext = string | PeopleMediaJsonldReadItemPeopleContextOneOf;

export interface PeopleMediaJsonldReadItemPeople {
  readonly '@context'?: PeopleMediaJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemPeople;
  /** @nullable */
  order?: number | null;
  people?: PeopleJsonldReadItemPeople;
}

export interface PeopleMediaJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PeopleMediaJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadCollectionPropertyExcelExportContext = string | PeopleMediaJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PeopleMediaJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleMediaJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionPeopleExcelExport;
  /** @nullable */
  order?: number | null;
  people?: PeopleJsonldReadCollectionPeopleExcelExport;
}

export type PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadCollectionPeopleExcelExportContext = string | PeopleMediaJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface PeopleMediaJsonldReadCollectionPeople {
  readonly '@context'?: PeopleMediaJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionPeople;
  /** @nullable */
  order?: number | null;
  people?: PeopleJsonldReadCollectionPeople;
}

export type PeopleMediaJsonldReadCollectionPeopleContextOneOfHydra = typeof PeopleMediaJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof PeopleMediaJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadCollectionPeopleContext = string | PeopleMediaJsonldReadCollectionPeopleContextOneOf;

export type PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
  /** @nullable */
  order?: number | null;
  people?: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
}

export type PeopleMediaJsonldContextOneOfHydra = typeof PeopleMediaJsonldContextOneOfHydra[keyof typeof PeopleMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: PeopleMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleMediaJsonldContext = string | PeopleMediaJsonldContextOneOf;

export interface PeopleMediaJsonld {
  readonly '@context'?: PeopleMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  people?: string;
}

export interface PeopleLocaleJsonldReadItemProperty {
  readonly '@context'?: PeopleLocaleJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type PeopleLocaleJsonldReadItemPropertyContextOneOfHydra = typeof PeopleLocaleJsonldReadItemPropertyContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadItemPropertyContext = string | PeopleLocaleJsonldReadItemPropertyContextOneOf;

export type PeopleLocaleJsonldReadItemProjectRefLabel = RefLabelJsonldReadItemProject | null;

export interface PeopleLocaleJsonldReadItemProject {
  readonly '@context'?: PeopleLocaleJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  refLabel?: PeopleLocaleJsonldReadItemProjectRefLabel;
  usage?: string;
}

export type PeopleLocaleJsonldReadItemProjectContextOneOfHydra = typeof PeopleLocaleJsonldReadItemProjectContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadItemProjectContext = string | PeopleLocaleJsonldReadItemProjectContextOneOf;

export type PeopleLocaleJsonldReadItemPeopleRefLabel = RefLabelJsonldReadItemPeople | null;

export interface PeopleLocaleJsonldReadItemPeople {
  readonly '@context'?: PeopleLocaleJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  refLabel?: PeopleLocaleJsonldReadItemPeopleRefLabel;
  usage?: string;
}

export type PeopleLocaleJsonldReadItemPeopleContextOneOfHydra = typeof PeopleLocaleJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadItemPeopleContext = string | PeopleLocaleJsonldReadItemPeopleContextOneOf;

export interface PeopleLocaleJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PeopleLocaleJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadCollectionPropertyExcelExportContext = string | PeopleLocaleJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PeopleLocaleJsonldReadCollectionProperty {
  readonly '@context'?: PeopleLocaleJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type PeopleLocaleJsonldReadCollectionPropertyContextOneOfHydra = typeof PeopleLocaleJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadCollectionPropertyContext = string | PeopleLocaleJsonldReadCollectionPropertyContextOneOf;

export type PeopleLocaleJsonldReadCollectionProjectExcelExportRefLabel = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadCollectionProjectExcelExportContext = string | PeopleLocaleJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PeopleLocaleJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PeopleLocaleJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  refLabel?: PeopleLocaleJsonldReadCollectionProjectExcelExportRefLabel;
  usage?: string;
}

export type PeopleLocaleJsonldReadCollectionProjectRefLabel = RefLabelJsonldReadCollectionProject | null;

export interface PeopleLocaleJsonldReadCollectionProject {
  readonly '@context'?: PeopleLocaleJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  refLabel?: PeopleLocaleJsonldReadCollectionProjectRefLabel;
  usage?: string;
}

export type PeopleLocaleJsonldReadCollectionProjectContextOneOfHydra = typeof PeopleLocaleJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadCollectionProjectContext = string | PeopleLocaleJsonldReadCollectionProjectContextOneOf;

export type PeopleLocaleJsonldReadCollectionPeopleExcelExportRefLabel = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface PeopleLocaleJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleLocaleJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  refLabel?: PeopleLocaleJsonldReadCollectionPeopleExcelExportRefLabel;
  usage?: string;
}

export type PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldReadCollectionPeopleExcelExportContext = string | PeopleLocaleJsonldReadCollectionPeopleExcelExportContextOneOf;

export type PeopleLocaleJsonldContextOneOfHydra = typeof PeopleLocaleJsonldContextOneOfHydra[keyof typeof PeopleLocaleJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleLocaleJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleLocaleJsonldContextOneOf = {
  '@vocab': string;
  hydra: PeopleLocaleJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleLocaleJsonldContext = string | PeopleLocaleJsonldContextOneOf;

export interface PeopleLocaleJsonld {
  readonly '@context'?: PeopleLocaleJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  people?: string;
  /** @nullable */
  refLabel?: string | null;
  usage?: string;
}

export interface PeopleCountersJsonldReadItemPeople {
  readonly '@context'?: PeopleCountersJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  project_offer?: number;
  project_request?: number;
}

export type PeopleCountersJsonldReadItemPeopleContextOneOfHydra = typeof PeopleCountersJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleCountersJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleCountersJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleCountersJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleCountersJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleCountersJsonldReadItemPeopleContext = string | PeopleCountersJsonldReadItemPeopleContextOneOf;

export type PeopleCountersJsonldReadCollectionPeopleContextOneOfHydra = typeof PeopleCountersJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof PeopleCountersJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleCountersJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleCountersJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleCountersJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleCountersJsonldReadCollectionPeopleContext = string | PeopleCountersJsonldReadCollectionPeopleContextOneOf;

export interface PeopleCountersJsonldReadCollectionPeople {
  readonly '@context'?: PeopleCountersJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  project_offer?: number;
  project_request?: number;
}

export type PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  project_offer?: number;
  project_request?: number;
}

export type PeopleContactMethodJsonldReadItemPropertyRefLabel = RefLabelJsonldReadItemProperty | null;

export type PeopleContactMethodJsonldReadItemPropertyContextOneOfHydra = typeof PeopleContactMethodJsonldReadItemPropertyContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadItemPropertyContext = string | PeopleContactMethodJsonldReadItemPropertyContextOneOf;

export interface PeopleContactMethodJsonldReadItemProperty {
  readonly '@context'?: PeopleContactMethodJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadItemPropertyRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadItemProjectRefLabel = RefLabelJsonldReadItemProject | null;

export type PeopleContactMethodJsonldReadItemProjectContextOneOfHydra = typeof PeopleContactMethodJsonldReadItemProjectContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadItemProjectContext = string | PeopleContactMethodJsonldReadItemProjectContextOneOf;

export interface PeopleContactMethodJsonldReadItemProject {
  readonly '@context'?: PeopleContactMethodJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadItemProjectRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadItemPeopleRefLabel = RefLabelJsonldReadItemPeople | null;

export interface PeopleContactMethodJsonldReadItemPeople {
  readonly '@context'?: PeopleContactMethodJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadItemPeopleRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadItemPeopleContextOneOfHydra = typeof PeopleContactMethodJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadItemPeopleContext = string | PeopleContactMethodJsonldReadItemPeopleContextOneOf;

export type PeopleContactMethodJsonldReadCollectionPropertyExcelExportRefLabel = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadCollectionPropertyExcelExportContext = string | PeopleContactMethodJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface PeopleContactMethodJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PeopleContactMethodJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadCollectionPropertyExcelExportRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadCollectionProjectExcelExportRefLabel = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface PeopleContactMethodJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PeopleContactMethodJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadCollectionProjectExcelExportRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadCollectionProjectExcelExportContext = string | PeopleContactMethodJsonldReadCollectionProjectExcelExportContextOneOf;

export type PeopleContactMethodJsonldReadCollectionPeopleExcelExportRefLabel = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface PeopleContactMethodJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleContactMethodJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  refLabel?: PeopleContactMethodJsonldReadCollectionPeopleExcelExportRefLabel;
  updatedAt?: string;
}

export type PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactMethodJsonldReadCollectionPeopleExcelExportContext = string | PeopleContactMethodJsonldReadCollectionPeopleExcelExportContextOneOf;

export type PeopleContactDetailsJsonldReadItemPropertyContextOneOfHydra = typeof PeopleContactDetailsJsonldReadItemPropertyContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadItemPropertyContext = string | PeopleContactDetailsJsonldReadItemPropertyContextOneOf;

export interface PeopleContactDetailsJsonldReadItemProperty {
  readonly '@context'?: PeopleContactDetailsJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface PeopleContactDetailsJsonldReadItemProject {
  readonly '@context'?: PeopleContactDetailsJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemProject;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadItemProjectContextOneOfHydra = typeof PeopleContactDetailsJsonldReadItemProjectContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadItemProjectContext = string | PeopleContactDetailsJsonldReadItemProjectContextOneOf;

export interface PeopleContactDetailsJsonldReadItemPeople {
  readonly '@context'?: PeopleContactDetailsJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadItemPeople;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadItemPeopleContextOneOfHydra = typeof PeopleContactDetailsJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadItemPeopleContext = string | PeopleContactDetailsJsonldReadItemPeopleContextOneOf;

export type PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext = string | PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSharedDataReadItemSharedData;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionSharedDataContext = string | PeopleContactDetailsJsonldReadCollectionSharedDataContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionSharedData {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionSharedData;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface PeopleContactDetailsJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContext = string | PeopleContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf;

export type PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionProjectExcelExportContext = string | PeopleContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProjectExcelExport;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionProjectContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionProjectContext = string | PeopleContactDetailsJsonldReadCollectionProjectContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionProject {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionProject;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContext = string | PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionPeopleExcelExport;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export interface PeopleContactDetailsJsonldReadCollectionPeople {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionPeople;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionPeopleContext = string | PeopleContactDetailsJsonldReadCollectionPeopleContextOneOf;

export interface PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export type PeopleContactDetailsJsonldContextOneOfHydra = typeof PeopleContactDetailsJsonldContextOneOfHydra[keyof typeof PeopleContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: PeopleContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleContactDetailsJsonldContext = string | PeopleContactDetailsJsonldContextOneOf;

export interface PeopleContactDetailsJsonld {
  readonly '@context'?: PeopleContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: ContactDetailsJsonld;
  createdAt?: string;
  readonly id: string;
  isDefault?: boolean;
  order?: number;
  people?: string;
  updatedAt?: string;
}

export interface PeopleClusterDTOJsonld {
  cluster?: string;
  id?: string;
  people?: string;
}

export type PeopleJsonldReadItemPropertyTitle = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyStatus = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyMaritalStatus = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyMaritalContractStatus = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyCustomerType = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyCurrency = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyActivity = RefLabelJsonldReadItemProperty | null;

export type PeopleJsonldReadItemPropertyContextOneOfHydra = typeof PeopleJsonldReadItemPropertyContextOneOfHydra[keyof typeof PeopleJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemPropertyContext = string | PeopleJsonldReadItemPropertyContextOneOf;

export interface PeopleJsonldReadItemProperty {
  readonly '@context'?: PeopleJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadItemPropertyActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadItemProperty[];
  contactMethod?: PeopleContactMethodJsonldReadItemProperty[];
  createdAt?: string;
  currency?: PeopleJsonldReadItemPropertyCurrency;
  customerType?: PeopleJsonldReadItemPropertyCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadItemProperty[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadItemProperty[];
  maritalContractStatus?: PeopleJsonldReadItemPropertyMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadItemPropertyMaritalStatus;
  media?: PeopleMediaJsonldReadItemProperty[];
  readonly nationality?: readonly PeopleLocaleJsonldReadItemProperty[];
  /** @nullable */
  ranking?: number | null;
  status?: PeopleJsonldReadItemPropertyStatus;
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadItemPropertyTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadItemProjectTitle = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectMaritalStatus = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectMaritalContractStatus = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectCustomerType = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectCurrency = RefLabelJsonldReadItemProject | null;

export type PeopleJsonldReadItemProjectActivity = RefLabelJsonldReadItemProject | null;

export interface PeopleJsonldReadItemProject {
  readonly '@context'?: PeopleJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadItemProjectActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  collaborator?: RelPeopleCollaboratorJsonldReadItemProject[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadItemProject[];
  contactMethod?: PeopleContactMethodJsonldReadItemProject[];
  createdAt?: string;
  currency?: PeopleJsonldReadItemProjectCurrency;
  customerType?: PeopleJsonldReadItemProjectCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadItemProject[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadItemProject[];
  maritalContractStatus?: PeopleJsonldReadItemProjectMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadItemProjectMaritalStatus;
  readonly nationality?: readonly PeopleLocaleJsonldReadItemProject[];
  propertyOwners?: PropertyOwnersJsonldReadItemProject[];
  /** @nullable */
  ranking?: number | null;
  spouse?: PeopleSpouseJsonldReadItemProject[];
  status?: PeopleJsonldReadItemProjectStatus;
  subscription?: SubscriptionJsonldReadItemProject[];
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadItemProjectTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadItemProjectContextOneOfHydra = typeof PeopleJsonldReadItemProjectContextOneOfHydra[keyof typeof PeopleJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemProjectContext = string | PeopleJsonldReadItemProjectContextOneOf;

export type PeopleJsonldReadItemPeopleTitle = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleStatus = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleMaritalStatus = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleMaritalContractStatus = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleCustomerType = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleCurrency = RefLabelJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleCounters = PeopleCountersJsonldReadItemPeople | null;

export type PeopleJsonldReadItemPeopleActivity = RefLabelJsonldReadItemPeople | null;

export interface PeopleJsonldReadItemPeople {
  readonly '@context'?: PeopleJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadItemPeopleActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  cluster?: RelClusterPeopleJsonldReadItemPeople[];
  collaborator?: RelPeopleCollaboratorJsonldReadItemPeople[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadItemPeople[];
  contactMethod?: PeopleContactMethodJsonldReadItemPeople[];
  readonly counters?: PeopleJsonldReadItemPeopleCounters;
  createdAt?: string;
  currency?: PeopleJsonldReadItemPeopleCurrency;
  customerType?: PeopleJsonldReadItemPeopleCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadItemPeople[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isShared?: boolean;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadItemPeople[];
  maritalContractStatus?: PeopleJsonldReadItemPeopleMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadItemPeopleMaritalStatus;
  marketSegments?: RelPeopleMarketSegmentJsonldReadItemPeople[];
  media?: PeopleMediaJsonldReadItemPeople[];
  readonly nationality?: readonly PeopleLocaleJsonldReadItemPeople[];
  project?: ProjectPeopleJsonldReadItemPeople[];
  propertyOwners?: PropertyOwnersJsonldReadItemPeople[];
  /** @nullable */
  ranking?: number | null;
  spouse?: PeopleSpouseJsonldReadItemPeople[];
  status?: PeopleJsonldReadItemPeopleStatus;
  subscription?: SubscriptionJsonldReadItemPeople[];
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadItemPeopleTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadItemPeopleContextOneOfHydra = typeof PeopleJsonldReadItemPeopleContextOneOfHydra[keyof typeof PeopleJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemPeopleContext = string | PeopleJsonldReadItemPeopleContextOneOf;

export type PeopleJsonldReadItemInterbuContextOneOfHydra = typeof PeopleJsonldReadItemInterbuContextOneOfHydra[keyof typeof PeopleJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemInterbuContext = string | PeopleJsonldReadItemInterbuContextOneOf;

export interface PeopleJsonldReadItemInterbu {
  readonly '@context'?: PeopleJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleJsonldReadItemCollaboratorItemTitle = RefLabelJsonldReadItemCollaboratorItem | null;

export type PeopleJsonldReadItemCollaboratorItemCustomerType = RefLabelJsonldReadItemCollaboratorItem | null;

export interface PeopleJsonldReadItemCollaboratorItem {
  readonly '@context'?: PeopleJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  createdAt?: string;
  customerType?: PeopleJsonldReadItemCollaboratorItemCustomerType;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  title?: PeopleJsonldReadItemCollaboratorItemTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadItemCollaboratorItemContextOneOfHydra = typeof PeopleJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof PeopleJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemCollaboratorItemContext = string | PeopleJsonldReadItemCollaboratorItemContextOneOf;

export type PeopleJsonldReadItemClusterItemTitle = RefLabelJsonldReadItemClusterItem | null;

export type PeopleJsonldReadItemClusterItemCustomerType = RefLabelJsonldReadItemClusterItem | null;

export type PeopleJsonldReadItemClusterItemContextOneOfHydra = typeof PeopleJsonldReadItemClusterItemContextOneOfHydra[keyof typeof PeopleJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadItemClusterItemContext = string | PeopleJsonldReadItemClusterItemContextOneOf;

export interface PeopleJsonldReadItemClusterItem {
  readonly '@context'?: PeopleJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  createdAt?: string;
  customerType?: PeopleJsonldReadItemClusterItemCustomerType;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  title?: PeopleJsonldReadItemClusterItemTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionSharedDataReadItemSharedDataContext = string | PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface PeopleJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: PeopleJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionSharedDataReadItemSharedData[];
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionSharedDataContextOneOfHydra = typeof PeopleJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionSharedDataContext = string | PeopleJsonldReadCollectionSharedDataContextOneOf;

export interface PeopleJsonldReadCollectionSharedData {
  readonly '@context'?: PeopleJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionSharedData[];
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionPropertyExcelExportTitle = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportStatus = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportMaritalStatus = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportMaritalContractStatus = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportCustomerType = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportCurrency = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type PeopleJsonldReadCollectionPropertyExcelExportActivity = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export interface PeopleJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: PeopleJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadCollectionPropertyExcelExportActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionPropertyExcelExport[];
  contactMethod?: PeopleContactMethodJsonldReadCollectionPropertyExcelExport[];
  createdAt?: string;
  currency?: PeopleJsonldReadCollectionPropertyExcelExportCurrency;
  customerType?: PeopleJsonldReadCollectionPropertyExcelExportCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadCollectionPropertyExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadCollectionPropertyExcelExport[];
  maritalContractStatus?: PeopleJsonldReadCollectionPropertyExcelExportMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadCollectionPropertyExcelExportMaritalStatus;
  media?: PeopleMediaJsonldReadCollectionPropertyExcelExport[];
  readonly nationality?: readonly PeopleLocaleJsonldReadCollectionPropertyExcelExport[];
  /** @nullable */
  ranking?: number | null;
  status?: PeopleJsonldReadCollectionPropertyExcelExportStatus;
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadCollectionPropertyExcelExportTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof PeopleJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionPropertyExcelExportContext = string | PeopleJsonldReadCollectionPropertyExcelExportContextOneOf;

export type PeopleJsonldReadCollectionPropertyTitle = RefLabelJsonldReadCollectionProperty | null;

export type PeopleJsonldReadCollectionPropertyCustomerType = RefLabelJsonldReadCollectionProperty | null;

export type PeopleJsonldReadCollectionPropertyContextOneOfHydra = typeof PeopleJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionPropertyContext = string | PeopleJsonldReadCollectionPropertyContextOneOf;

export interface PeopleJsonldReadCollectionProperty {
  readonly '@context'?: PeopleJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  createdAt?: string;
  customerType?: PeopleJsonldReadCollectionPropertyCustomerType;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadCollectionProperty[];
  readonly nationality?: readonly PeopleLocaleJsonldReadCollectionProperty[];
  title?: PeopleJsonldReadCollectionPropertyTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionProjectExcelExportTitle = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportMaritalStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportMaritalContractStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportCustomerType = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportCurrency = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type PeopleJsonldReadCollectionProjectExcelExportActivity = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface PeopleJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: PeopleJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadCollectionProjectExcelExportActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionProjectExcelExport[];
  contactMethod?: PeopleContactMethodJsonldReadCollectionProjectExcelExport[];
  createdAt?: string;
  currency?: PeopleJsonldReadCollectionProjectExcelExportCurrency;
  customerType?: PeopleJsonldReadCollectionProjectExcelExportCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadCollectionProjectExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadCollectionProjectExcelExport[];
  maritalContractStatus?: PeopleJsonldReadCollectionProjectExcelExportMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadCollectionProjectExcelExportMaritalStatus;
  readonly nationality?: readonly PeopleLocaleJsonldReadCollectionProjectExcelExport[];
  propertyOwners?: PropertyOwnersJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  ranking?: number | null;
  spouse?: PeopleSpouseJsonldReadCollectionProjectExcelExport[];
  status?: PeopleJsonldReadCollectionProjectExcelExportStatus;
  subscription?: SubscriptionJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadCollectionProjectExcelExportTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof PeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionProjectExcelExportContext = string | PeopleJsonldReadCollectionProjectExcelExportContextOneOf;

export type PeopleJsonldReadCollectionProjectTitle = RefLabelJsonldReadCollectionProject | null;

export type PeopleJsonldReadCollectionProjectCustomerType = RefLabelJsonldReadCollectionProject | null;

export type PeopleJsonldReadCollectionProjectCurrency = RefLabelJsonldReadCollectionProject | null;

export interface PeopleJsonldReadCollectionProject {
  readonly '@context'?: PeopleJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionProject[];
  createdAt?: string;
  currency?: PeopleJsonldReadCollectionProjectCurrency;
  customerType?: PeopleJsonldReadCollectionProjectCustomerType;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadCollectionProject[];
  readonly nationality?: readonly PeopleLocaleJsonldReadCollectionProject[];
  title?: PeopleJsonldReadCollectionProjectTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionProjectContextOneOfHydra = typeof PeopleJsonldReadCollectionProjectContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionProjectContext = string | PeopleJsonldReadCollectionProjectContextOneOf;

export type PeopleJsonldReadCollectionPeopleExcelExportTitle = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportStatus = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportMaritalStatus = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportMaritalContractStatus = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportCustomerType = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportCurrency = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type PeopleJsonldReadCollectionPeopleExcelExportActivity = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface PeopleJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: PeopleJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  activity?: PeopleJsonldReadCollectionPeopleExcelExportActivity;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  /** @nullable */
  childCount?: number | null;
  cluster?: RelClusterPeopleJsonldReadCollectionPeopleExcelExport[];
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  contactDetails?: PeopleContactDetailsJsonldReadCollectionPeopleExcelExport[];
  contactMethod?: PeopleContactMethodJsonldReadCollectionPeopleExcelExport[];
  currency?: PeopleJsonldReadCollectionPeopleExcelExportCurrency;
  customerType?: PeopleJsonldReadCollectionPeopleExcelExportCustomerType;
  /** @nullable */
  firstname?: string | null;
  hobbies?: RefLabelJsonldReadCollectionPeopleExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  locale?: PeopleLocaleJsonldReadCollectionPeopleExcelExport[];
  maritalContractStatus?: PeopleJsonldReadCollectionPeopleExcelExportMaritalContractStatus;
  maritalStatus?: PeopleJsonldReadCollectionPeopleExcelExportMaritalStatus;
  marketSegments?: RelPeopleMarketSegmentJsonldReadCollectionPeopleExcelExport[];
  media?: PeopleMediaJsonldReadCollectionPeopleExcelExport[];
  readonly nationality?: readonly PeopleLocaleJsonldReadCollectionPeopleExcelExport[];
  project?: ProjectPeopleJsonldReadCollectionPeopleExcelExport[];
  propertyOwners?: PropertyOwnersJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  ranking?: number | null;
  spouse?: PeopleSpouseJsonldReadCollectionPeopleExcelExport[];
  status?: PeopleJsonldReadCollectionPeopleExcelExportStatus;
  subscription?: SubscriptionJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  taxcode?: string | null;
  title?: PeopleJsonldReadCollectionPeopleExcelExportTitle;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof PeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionPeopleExcelExportContext = string | PeopleJsonldReadCollectionPeopleExcelExportContextOneOf;

export type PeopleJsonldReadCollectionPeopleCounters = PeopleCountersJsonldReadCollectionPeople | null;

export interface PeopleJsonldReadCollectionPeople {
  readonly '@context'?: PeopleJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  cluster?: RelClusterPeopleJsonldReadCollectionPeople[];
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionPeople[];
  contactDetails?: PeopleContactDetailsJsonldReadCollectionPeople[];
  readonly counters?: PeopleJsonldReadCollectionPeopleCounters;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
  media?: PeopleMediaJsonldReadCollectionPeople[];
  project?: ProjectPeopleJsonldReadCollectionPeople[];
  sharedData?: SharedDataJsonldReadCollectionPeople[];
  spouse?: PeopleSpouseJsonldReadCollectionPeople[];
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionPeopleContextOneOfHydra = typeof PeopleJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionPeopleContext = string | PeopleJsonldReadCollectionPeopleContextOneOf;

export type PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCounters = PeopleCountersJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export interface PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  cluster?: RelClusterPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  collaborator?: RelPeopleCollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  contactDetails?: PeopleContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  readonly counters?: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesCounters;
  createdAt?: string;
  /** @nullable */
  firstname?: string | null;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  lastname?: string | null;
  media?: PeopleMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  project?: ProjectPeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  sharedData?: SharedDataJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  spouse?: PeopleSpouseJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | PeopleJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface PeopleJsonldReadCollectionInterbu {
  readonly '@context'?: PeopleJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type PeopleJsonldReadCollectionInterbuContextOneOfHydra = typeof PeopleJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof PeopleJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeopleJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type PeopleJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: PeopleJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type PeopleJsonldReadCollectionInterbuContext = string | PeopleJsonldReadCollectionInterbuContextOneOf;

/**
 * @nullable
 */
export type PeoplePostReassignPeopleInputJsonldMode = typeof PeoplePostReassignPeopleInputJsonldMode[keyof typeof PeoplePostReassignPeopleInputJsonldMode] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeoplePostReassignPeopleInputJsonldMode = {
  all: 'all',
  selection: 'selection',
} as const;

export interface PeoplePostReassignPeopleInputJsonld {
  /**
   * @minItems 1
   * @nullable
   */
  mapping: ReassignPeopleMappingInputJsonld[] | null;
  /** @nullable */
  mode: PeoplePostReassignPeopleInputJsonldMode;
}

export type PeoplePostPeopleInputJsonldChildCount = string | null | number | null;

export interface PeoplePostPeopleInputJsonld {
  /** @nullable */
  activity?: string | null;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  childCount?: PeoplePostPeopleInputJsonldChildCount;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  /**
   * @minItems 1
   * @maxItems 1
   * @nullable
   */
  contactDetails: ContactDetailsDTOJsonld[] | null;
  /** @nullable */
  contactMethod?: string[] | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  customerType?: string | null;
  /** @nullable */
  fid_cluster?: string | null;
  firstname: string;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  lastname: string;
  /** @minItems 1 */
  locale: string[];
  /** @nullable */
  maritalContractStatus?: string | null;
  /** @nullable */
  maritalStatus?: string | null;
  /** @nullable */
  marketSegments?: string[] | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  ranking?: number | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  subscription?: string[] | null;
  /** @nullable */
  taxcode?: string | null;
  title: string;
}

export type PeoplePatchPeopleInputRanking = string | null | number | null;

export type PeoplePatchPeopleInputChildCount = string | null | number | null;

export interface PeoplePatchPeopleInput {
  /** @nullable */
  activity?: string | null;
  /** @nullable */
  birthdate?: string | null;
  /** @nullable */
  birthplace?: string | null;
  childCount?: PeoplePatchPeopleInputChildCount;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  companyVatNumber?: string | null;
  /**
   * @maxItems 1
   * @nullable
   */
  contactDetails?: PatchContactDetailsDTO[] | null;
  /** @nullable */
  contactMethod?: string[] | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  customerType?: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  locale?: string[] | null;
  /** @nullable */
  maritalContractStatus?: string | null;
  /** @nullable */
  maritalStatus?: string | null;
  /** @nullable */
  marketSegments?: string[] | null;
  /** @nullable */
  nationality?: string | null;
  ranking?: PeoplePatchPeopleInputRanking;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  subscription?: string[] | null;
  /** @nullable */
  taxcode?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface PatchProjectClusterDTO {
  /** @nullable */
  order?: number | null;
  /** @nullable */
  project?: string | null;
}

export interface PatchPeopleClusterDTO {
  /** @nullable */
  cluster?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  people?: string | null;
}

export interface PatchLegalsDTO {
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  agencyOwnerLegals?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface PatchLegalRepresentativeDTO {
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  collaborator?: string | null;
  /** @nullable */
  id?: string | null;
}

export type PatchContactDetailsDTOTimetables = TimetablesDTO | null;

export type PatchContactDetailsDTOMobileNoWhatsapp = string | null | boolean | null;

export type PatchContactDetailsDTOMobile2NoWhatsapp = string | null | boolean | null;

export interface PatchContactDetailsDTO {
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: string | null;
  /** @nullable */
  canton?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  emailValidity?: string | null;
  /** @nullable */
  fax?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  isDefault?: string | null;
  /** @nullable */
  latitude?: string | null;
  /** @nullable */
  longitude?: string | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: PatchContactDetailsDTOMobile2NoWhatsapp;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: PatchContactDetailsDTOMobileNoWhatsapp;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: string | null;
  /** @nullable */
  neighborhoodLongitude?: string | null;
  /** @nullable */
  order?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicLatitude?: string | null;
  /** @nullable */
  publicLongitude?: string | null;
  /** @nullable */
  radius?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: PatchContactDetailsDTOTimetables;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export interface PatchCollaboratorPeopleDTO {
  /** @nullable */
  collaborator?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  people?: string | null;
  /** @nullable */
  role?: string | null;
}

/**
 * @nullable
 */
export type PatchCollaboratorClusterDTOMetadatas = {[key: string]: string} | null;

export type PatchCollaboratorClusterDTODateOfLeaving = string | null | string | null;

export type PatchCollaboratorClusterDTODateOfEntry = string | null | string | null;

export interface PatchCollaboratorClusterDTO {
  /** @nullable */
  cluster_id?: string | null;
  collaborator?: string;
  /** @nullable */
  commentStatus?: string | null;
  dateOfEntry?: PatchCollaboratorClusterDTODateOfEntry;
  dateOfLeaving?: PatchCollaboratorClusterDTODateOfLeaving;
  /** @nullable */
  function?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  isPublishedInDirectory?: boolean | null;
  /** @nullable */
  metadatas?: PatchCollaboratorClusterDTOMetadatas;
  /** @nullable */
  rank?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface PatchCollaboratorAgencyDTO {
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  collaborator?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  role?: string | null;
}

export interface PatchClusterSocietyDTO {
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  cluster?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface PatchAgencySocietyDTO {
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  agencyOwner?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface PatchAgencyClusterDTO {
  /** @nullable */
  agency?: string | null;
  /** @nullable */
  cluster?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  isDefault?: boolean | null;
}

export interface OptionalTranslationsDTO {
  /** @nullable */
  en_GB?: string | null;
  /** @nullable */
  fr_FR?: string | null;
}

export interface MediaFolderJsonld {
  readonly '@id'?: string;
  readonly '@type'?: string;
  fileCount?: number;
  folderCount?: number;
  folders?: string[];
  id?: string;
  name?: string;
  path?: string;
}

export type MediaJsonldReadItemSocietyItemContextOneOfHydra = typeof MediaJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof MediaJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemSocietyItemContext = string | MediaJsonldReadItemSocietyItemContextOneOf;

export interface MediaJsonldReadItemSocietyItem {
  readonly '@context'?: MediaJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export interface MediaJsonldReadItemProperty {
  readonly '@context'?: MediaJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadItemPropertyContextOneOfHydra = typeof MediaJsonldReadItemPropertyContextOneOfHydra[keyof typeof MediaJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemPropertyContext = string | MediaJsonldReadItemPropertyContextOneOf;

export type MediaJsonldReadItemProjectContextOneOfHydra = typeof MediaJsonldReadItemProjectContextOneOfHydra[keyof typeof MediaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemProjectContext = string | MediaJsonldReadItemProjectContextOneOf;

export interface MediaJsonldReadItemProject {
  readonly '@context'?: MediaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadItemPeopleContextOneOfHydra = typeof MediaJsonldReadItemPeopleContextOneOfHydra[keyof typeof MediaJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemPeopleContext = string | MediaJsonldReadItemPeopleContextOneOf;

export interface MediaJsonldReadItemPeople {
  readonly '@context'?: MediaJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export interface MediaJsonldReadItemCollaboratorItem {
  readonly '@context'?: MediaJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadItemCollaboratorItemContextOneOfHydra = typeof MediaJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof MediaJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemCollaboratorItemContext = string | MediaJsonldReadItemCollaboratorItemContextOneOf;

export interface MediaJsonldReadItemClusterItem {
  readonly '@context'?: MediaJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadItemClusterItemContextOneOfHydra = typeof MediaJsonldReadItemClusterItemContextOneOfHydra[keyof typeof MediaJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemClusterItemContext = string | MediaJsonldReadItemClusterItemContextOneOf;

export type MediaJsonldReadItemAgencyItemContextOneOfHydra = typeof MediaJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof MediaJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadItemAgencyItemContext = string | MediaJsonldReadItemAgencyItemContextOneOf;

export interface MediaJsonldReadItemAgencyItem {
  readonly '@context'?: MediaJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof MediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof MediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionSocietyExcelExportContext = string | MediaJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface MediaJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: MediaJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface MediaJsonldReadCollectionSociety {
  readonly '@context'?: MediaJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionSocietyContextOneOfHydra = typeof MediaJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof MediaJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionSocietyContext = string | MediaJsonldReadCollectionSocietyContextOneOf;

export type MediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof MediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof MediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionPropertyExcelExportContext = string | MediaJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface MediaJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: MediaJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionPropertyContextOneOfHydra = typeof MediaJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof MediaJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionPropertyContext = string | MediaJsonldReadCollectionPropertyContextOneOf;

export interface MediaJsonldReadCollectionProperty {
  readonly '@context'?: MediaJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export interface MediaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: MediaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof MediaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof MediaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionProjectExcelExportContext = string | MediaJsonldReadCollectionProjectExcelExportContextOneOf;

export interface MediaJsonldReadCollectionProject {
  readonly '@context'?: MediaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionProjectContextOneOfHydra = typeof MediaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof MediaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionProjectContext = string | MediaJsonldReadCollectionProjectContextOneOf;

export interface MediaJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: MediaJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof MediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof MediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionPeopleExcelExportContext = string | MediaJsonldReadCollectionPeopleExcelExportContextOneOf;

export type MediaJsonldReadCollectionPeopleContextOneOfHydra = typeof MediaJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof MediaJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionPeopleContext = string | MediaJsonldReadCollectionPeopleContextOneOf;

export interface MediaJsonldReadCollectionPeople {
  readonly '@context'?: MediaJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: MediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export interface MediaJsonldReadCollectionCollaborator {
  readonly '@context'?: MediaJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionCollaboratorContextOneOfHydra = typeof MediaJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof MediaJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionCollaboratorContext = string | MediaJsonldReadCollectionCollaboratorContextOneOf;

export type MediaJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof MediaJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof MediaJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionClusterExcelExportContext = string | MediaJsonldReadCollectionClusterExcelExportContextOneOf;

export interface MediaJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: MediaJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface MediaJsonldReadCollectionCluster {
  readonly '@context'?: MediaJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionClusterContextOneOfHydra = typeof MediaJsonldReadCollectionClusterContextOneOfHydra[keyof typeof MediaJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionClusterContext = string | MediaJsonldReadCollectionClusterContextOneOf;

export type MediaJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldReadCollectionAgencyContext = string | MediaJsonldReadCollectionAgencyContextOneOf;

export interface MediaJsonldReadCollectionAgency {
  readonly '@context'?: MediaJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export type MediaJsonldReadCollectionAgencyContextOneOfHydra = typeof MediaJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof MediaJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldContextOneOfHydra = typeof MediaJsonldContextOneOfHydra[keyof typeof MediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: MediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type MediaJsonldContext = string | MediaJsonldContextOneOf;

export interface MediaJsonld {
  readonly '@context'?: MediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  author?: string | null;
  clusterMedias?: ClusterMediaJsonld[];
  readonly clusters?: readonly ClusterMediaJsonld[];
  collaboratorMedias?: CollaboratorMediaJsonld[];
  readonly collaborators?: readonly CollaboratorMediaJsonld[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  copyright?: string | null;
  createdAt?: string;
  /** @nullable */
  height?: number | null;
  readonly id: string;
  /** @nullable */
  isCdn?: boolean | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isPanorama?: boolean | null;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  isWatermarked?: boolean | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  order?: number | null;
  path?: string;
  people?: PeopleMediaJsonld[];
  readonly property?: readonly PropertyMediaJsonld[];
  /** @nullable */
  size?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  width?: number | null;
}

export interface MarketSegmentTranslationJsonldReadItemMarketSegmentItem {
  readonly '@context'?: MarketSegmentTranslationJsonldReadItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra = typeof MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra[keyof typeof MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentTranslationJsonldReadItemMarketSegmentItemContext = string | MarketSegmentTranslationJsonldReadItemMarketSegmentItemContextOneOf;

export interface MarketSegmentTranslationJsonldReadCollectionMarketSegment {
  readonly '@context'?: MarketSegmentTranslationJsonldReadCollectionMarketSegmentContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra = typeof MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra[keyof typeof MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentTranslationJsonldReadCollectionMarketSegmentContext = string | MarketSegmentTranslationJsonldReadCollectionMarketSegmentContextOneOf;

export type MarketSegmentTranslationJsonldContextOneOfHydra = typeof MarketSegmentTranslationJsonldContextOneOfHydra[keyof typeof MarketSegmentTranslationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentTranslationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentTranslationJsonldContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentTranslationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentTranslationJsonldContext = string | MarketSegmentTranslationJsonldContextOneOf;

export interface MarketSegmentTranslationJsonld {
  readonly '@context'?: MarketSegmentTranslationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  entity_id?: string | null;
  /** @nullable */
  entityId?: string | null;
  field?: string;
  readonly id?: number;
  readonly label?: string;
  locale?: string;
  /**
   * Get related object
   * @nullable
   */
  object?: string | null;
  /** @nullable */
  rel_entity_id?: string | null;
  /** @nullable */
  relEntityId?: string | null;
}

export type MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOfHydra = typeof MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOfHydra[keyof typeof MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldWriteItemMarketSegmentItemContext = string | MarketSegmentJsonldWriteItemMarketSegmentItemContextOneOf;

export interface MarketSegmentJsonldWriteItemMarketSegmentItem {
  readonly '@context'?: MarketSegmentJsonldWriteItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface MarketSegmentJsonldReadItemPeople {
  readonly '@context'?: MarketSegmentJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type MarketSegmentJsonldReadItemPeopleContextOneOfHydra = typeof MarketSegmentJsonldReadItemPeopleContextOneOfHydra[keyof typeof MarketSegmentJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldReadItemPeopleContext = string | MarketSegmentJsonldReadItemPeopleContextOneOf;

export type MarketSegmentJsonldReadItemMarketSegmentItemParent = MarketSegmentJsonldReadItemMarketSegmentItem | null;

export type MarketSegmentJsonldReadItemMarketSegmentItemCountry = RefLabelJsonldReadItemMarketSegmentItem | null;

export type MarketSegmentJsonldReadItemMarketSegmentItemContextOneOfHydra = typeof MarketSegmentJsonldReadItemMarketSegmentItemContextOneOfHydra[keyof typeof MarketSegmentJsonldReadItemMarketSegmentItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldReadItemMarketSegmentItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldReadItemMarketSegmentItemContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldReadItemMarketSegmentItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldReadItemMarketSegmentItemContext = string | MarketSegmentJsonldReadItemMarketSegmentItemContextOneOf;

export interface MarketSegmentJsonldReadItemMarketSegmentItem {
  readonly '@context'?: MarketSegmentJsonldReadItemMarketSegmentItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  children?: MarketSegmentJsonldReadItemMarketSegmentItem[];
  code?: string;
  country?: MarketSegmentJsonldReadItemMarketSegmentItemCountry;
  createdAt?: string;
  /** @nullable */
  dateBeginAt?: string | null;
  /** @nullable */
  dateEndAt?: string | null;
  hasChildren?: boolean;
  hasDateLimit?: boolean;
  hasTimeLimit?: boolean;
  readonly id: string;
  label?: string;
  parent?: MarketSegmentJsonldReadItemMarketSegmentItemParent;
  /** @nullable */
  timeBeginAt?: string | null;
  /** @nullable */
  timeEndAt?: string | null;
  translations?: MarketSegmentTranslationJsonldReadItemMarketSegmentItem[];
  updatedAt?: string;
}

export type MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldReadCollectionPeopleExcelExportContext = string | MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOf;

export interface MarketSegmentJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: MarketSegmentJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  updatedAt?: string;
}

export type MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldReadCollectionMarketSegmentParent = MarketSegmentJsonldReadCollectionMarketSegment | null;

export type MarketSegmentJsonldReadCollectionMarketSegmentCountry = RefLabelJsonldReadCollectionMarketSegment | null;

export type MarketSegmentJsonldReadCollectionMarketSegmentContextOneOfHydra = typeof MarketSegmentJsonldReadCollectionMarketSegmentContextOneOfHydra[keyof typeof MarketSegmentJsonldReadCollectionMarketSegmentContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldReadCollectionMarketSegmentContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldReadCollectionMarketSegmentContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldReadCollectionMarketSegmentContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldReadCollectionMarketSegmentContext = string | MarketSegmentJsonldReadCollectionMarketSegmentContextOneOf;

export interface MarketSegmentJsonldReadCollectionMarketSegment {
  readonly '@context'?: MarketSegmentJsonldReadCollectionMarketSegmentContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  children?: MarketSegmentJsonldReadCollectionMarketSegment[];
  code?: string;
  country?: MarketSegmentJsonldReadCollectionMarketSegmentCountry;
  createdAt?: string;
  /** @nullable */
  dateBeginAt?: string | null;
  /** @nullable */
  dateEndAt?: string | null;
  hasChildren?: boolean;
  hasDateLimit?: boolean;
  hasTimeLimit?: boolean;
  readonly id: string;
  label?: string;
  parent?: MarketSegmentJsonldReadCollectionMarketSegmentParent;
  /** @nullable */
  timeBeginAt?: string | null;
  /** @nullable */
  timeEndAt?: string | null;
  translations?: MarketSegmentTranslationJsonldReadCollectionMarketSegment[];
  updatedAt?: string;
}

export interface MarketSegmentJsonld {
  readonly '@context'?: MarketSegmentJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  children?: string[];
  code?: string;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  dateBeginAt?: string | null;
  /** @nullable */
  dateEndAt?: string | null;
  hasChildren?: boolean;
  hasDateLimit?: boolean;
  hasTimeLimit?: boolean;
  i18nText?: RelMarketSegmentI18nTextJsonld[];
  readonly id: string;
  label?: string;
  readonly lft?: number;
  readonly lvl?: number;
  /** @nullable */
  parent?: string | null;
  readonly people?: readonly RelPeopleMarketSegmentJsonld[];
  readonly rgt?: number;
  /** @nullable */
  root?: string | null;
  /** @nullable */
  timeBeginAt?: string | null;
  /** @nullable */
  timeEndAt?: string | null;
  translations?: MarketSegmentTranslationJsonld[];
  updatedAt?: string;
}

export type MarketSegmentJsonldContextOneOfHydra = typeof MarketSegmentJsonldContextOneOfHydra[keyof typeof MarketSegmentJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketSegmentJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MarketSegmentJsonldContextOneOf = {
  '@vocab': string;
  hydra: MarketSegmentJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type MarketSegmentJsonldContext = string | MarketSegmentJsonldContextOneOf;

export interface MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem {
  code: string;
  /** @nullable */
  countryId?: string | null;
  /** @nullable */
  dateBeginAt?: string | null;
  /** @nullable */
  dateEndAt?: string | null;
  /** @nullable */
  hasChildren?: boolean | null;
  /** @nullable */
  hasDateLimit?: boolean | null;
  /** @nullable */
  hasTimeLimit?: boolean | null;
  /** @nullable */
  parentId?: string | null;
  /** @nullable */
  timeBeginAt?: string | null;
  /** @nullable */
  timeEndAt?: string | null;
  translations: TranslationsExtInputDTOJsonldWriteItemMarketSegmentItem[];
}

export interface MarketSegmentPostApplyMarketSegmentInputJsonld {
  /**
   * @minItems 1
   * @nullable
   */
  emails: string[] | null;
  /** @nullable */
  segmentId: string | null;
}

export interface MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  countryId?: string | null;
  /** @nullable */
  dateBeginAt?: string | null;
  /** @nullable */
  dateEndAt?: string | null;
  /** @nullable */
  hasChildren?: boolean | null;
  /** @nullable */
  hasDateLimit?: boolean | null;
  /** @nullable */
  hasTimeLimit?: boolean | null;
  /** @nullable */
  parentId?: string | null;
  /** @nullable */
  timeBeginAt?: string | null;
  /** @nullable */
  timeEndAt?: string | null;
  /** @nullable */
  translations?: TranslationsExtInputDTOWriteItemMarketSegmentItem[] | null;
}

export interface MandatoryTranslationsDTOJsonld {
  en_GB: string;
  fr_FR: string;
}

export interface MBV4SynchroJsonldReadCollectionSynchroStatus {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  endAt?: string | null;
  readonly id?: number;
  /** @nullable */
  last_log_message?: string | null;
  startAt?: string;
  /** @nullable */
  status?: string | null;
}

export interface MBV4SynchroJsonldReadCollectionBarnesSttausDeleted {
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  datasUpdatedAt?: string;
  entity?: string;
  entityId?: string;
  readonly id?: number;
  status?: string;
  updatedAt?: string;
}

export interface MBV4SynchroJsonldReadCollectionBarnesStatusUpdated {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  barnesId?: string | null;
  createdAt?: string;
  datasUpdatedAt?: string;
  /** @nullable */
  entity?: string | null;
  entityCreatedAt?: string;
  entityUpdatedAt?: string;
  readonly id?: number;
  status?: string;
  updatedAt?: string;
}

export interface MBV4SynchroJsonld {
  readonly '@context'?: MBV4SynchroJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export type MBV4SynchroJsonldContextOneOfHydra = typeof MBV4SynchroJsonldContextOneOfHydra[keyof typeof MBV4SynchroJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MBV4SynchroJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type MBV4SynchroJsonldContextOneOf = {
  '@vocab': string;
  hydra: MBV4SynchroJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type MBV4SynchroJsonldContext = string | MBV4SynchroJsonldContextOneOf;

export interface MBV4SynchroSynchroLogDTOJsonld {
  log_id?: number;
}

export interface MBV4SynchroPostMbv4SynchroInputJsonld { [key: string]: unknown }

export interface MBV4SynchroPostMbv4ImportInputJsonld {
  /** @nullable */
  force?: boolean | null;
  /** @nullable */
  withReset?: boolean | null;
}

export type LogJsonldContextOneOfHydra = typeof LogJsonldContextOneOfHydra[keyof typeof LogJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type LogJsonldContextOneOf = {
  '@vocab': string;
  hydra: LogJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type LogJsonldContext = string | LogJsonldContextOneOf;

export interface LogJsonld {
  readonly '@context'?: LogJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  action?: string | null;
  /** @nullable */
  field?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  loggedAt?: string | null;
  newValue?: unknown;
  oldValue?: unknown;
  /** @nullable */
  userFirstname?: string | null;
  /** @nullable */
  userLastname?: string | null;
}

export interface LegalsDTOJsonld {
  agencyOwner?: string;
  agencyOwnerLegals?: string;
  id?: string;
}

export interface LegalRepresentativeDTOJsonld {
  agencyOwner?: string;
  collaborator?: string;
  id?: string;
}

export interface ItemActionJsonldReadCollectionItemAction {
  readonly '@id'?: string;
  readonly '@type'?: string;
  action?: string;
  createdAt?: string;
  readonly id: string;
  itemId?: string;
  itemName?: string;
  order?: number;
  updatedAt?: string;
}

export interface ItemActionPostItemActionsInputJsonld {
  /** @nullable */
  action?: string | null;
  /**
   * Array of item UUIDs. Their position defines the `order` value.
   * @nullable
   */
  itemIds: string[] | null;
  /** @nullable */
  itemName?: string | null;
}

export interface ItemActionPostItemActionsInput {
  /** @nullable */
  action?: string | null;
  /**
   * Array of item UUIDs. Their position defines the `order` value.
   * @nullable
   */
  itemIds: string[] | null;
  /** @nullable */
  itemName?: string | null;
}

export type InterbuCommentJsonldReadItemInterbuContextOneOfHydra = typeof InterbuCommentJsonldReadItemInterbuContextOneOfHydra[keyof typeof InterbuCommentJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterbuCommentJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterbuCommentJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterbuCommentJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterbuCommentJsonldReadItemInterbuContext = string | InterbuCommentJsonldReadItemInterbuContextOneOf;

export interface InterbuCommentJsonldReadItemInterbu {
  readonly '@context'?: InterbuCommentJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  comment?: CommentJsonldReadItemInterbu;
  createdAt?: string;
  readonly id: string;
  interBu?: InterBuJsonldReadItemInterbu;
  updatedAt?: string;
}

export interface InterbuCommentJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  comment?: CommentJsonldReadCollectionSharedDataReadItemSharedData;
  createdAt?: string;
  readonly id: string;
  interBu?: InterBuJsonldReadCollectionSharedDataReadItemSharedData;
  updatedAt?: string;
}

export type InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContext = string | InterbuCommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface InterbuCommentJsonldReadCollectionSharedData {
  readonly '@context'?: InterbuCommentJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  comment?: CommentJsonldReadCollectionSharedData;
  createdAt?: string;
  readonly id: string;
  interBu?: InterBuJsonldReadCollectionSharedData;
  updatedAt?: string;
}

export type InterbuCommentJsonldReadCollectionSharedDataContextOneOfHydra = typeof InterbuCommentJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof InterbuCommentJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterbuCommentJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterbuCommentJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: InterbuCommentJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterbuCommentJsonldReadCollectionSharedDataContext = string | InterbuCommentJsonldReadCollectionSharedDataContextOneOf;

export type InterbuCommentJsonldReadCollectionInterbuContextOneOfHydra = typeof InterbuCommentJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof InterbuCommentJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterbuCommentJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterbuCommentJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterbuCommentJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterbuCommentJsonldReadCollectionInterbuContext = string | InterbuCommentJsonldReadCollectionInterbuContextOneOf;

export interface InterbuCommentJsonldReadCollectionInterbu {
  readonly '@context'?: InterbuCommentJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  comment?: CommentJsonldReadCollectionInterbu;
  createdAt?: string;
  readonly id: string;
  interBu?: InterBuJsonldReadCollectionInterbu;
  updatedAt?: string;
}

export type InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOfHydra = typeof InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOfHydra[keyof typeof InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOf = {
  '@vocab': string;
  hydra: InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuStatsOptionJsonldReadItemInterbuStatsContext = string | InterBuStatsOptionJsonldReadItemInterbuStatsContextOneOf;

export interface InterBuStatsOptionJsonldReadItemInterbuStats {
  readonly '@context'?: InterBuStatsOptionJsonldReadItemInterbuStatsContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  id?: string;
  label?: string;
}

export interface InterBuStatsCountJsonldReadItemInterbuStats {
  readonly '@context'?: InterBuStatsCountJsonldReadItemInterbuStatsContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  count?: number;
}

export type InterBuStatsCountJsonldReadItemInterbuStatsContextOneOfHydra = typeof InterBuStatsCountJsonldReadItemInterbuStatsContextOneOfHydra[keyof typeof InterBuStatsCountJsonldReadItemInterbuStatsContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuStatsCountJsonldReadItemInterbuStatsContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuStatsCountJsonldReadItemInterbuStatsContextOneOf = {
  '@vocab': string;
  hydra: InterBuStatsCountJsonldReadItemInterbuStatsContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuStatsCountJsonldReadItemInterbuStatsContext = string | InterBuStatsCountJsonldReadItemInterbuStatsContextOneOf;

export type InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOfHydra = typeof InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOfHydra[keyof typeof InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOf = {
  '@vocab': string;
  hydra: InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuStatsAgencyJsonldReadItemInterbuStatsContext = string | InterBuStatsAgencyJsonldReadItemInterbuStatsContextOneOf;

export interface InterBuStatsAgencyJsonldReadItemInterbuStats {
  readonly '@context'?: InterBuStatsAgencyJsonldReadItemInterbuStatsContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  count?: number;
  id?: string;
  name?: string;
}

export type InterBuStatsJsonldReadItemInterbuStatsContextOneOfHydra = typeof InterBuStatsJsonldReadItemInterbuStatsContextOneOfHydra[keyof typeof InterBuStatsJsonldReadItemInterbuStatsContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuStatsJsonldReadItemInterbuStatsContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuStatsJsonldReadItemInterbuStatsContextOneOf = {
  '@vocab': string;
  hydra: InterBuStatsJsonldReadItemInterbuStatsContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuStatsJsonldReadItemInterbuStatsContext = string | InterBuStatsJsonldReadItemInterbuStatsContextOneOf;

/**
 * Indicators of the interBU list for one direction (ADR 0009, D2): counts by status, most active
partner agencies, and the options of the agency and manager filters. Computed on the same
perimeter and filters as GET /api/shared-datas?direction=…, with grouped queries.
 */
export interface InterBuStatsJsonldReadItemInterbuStats {
  readonly '@context'?: InterBuStatsJsonldReadItemInterbuStatsContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOptions?: InterBuStatsOptionJsonldReadItemInterbuStats[];
  managerOptions?: InterBuStatsOptionJsonldReadItemInterbuStats[];
  statusCounts?: InterBuStatsCountJsonldReadItemInterbuStats[];
  topAgencies?: InterBuStatsAgencyJsonldReadItemInterbuStats[];
  total?: number;
}

export type InterBuProgressStepUploadedFileJsonldReadItemInterbuContext = string | InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOf;

export interface InterBuProgressStepUploadedFileJsonldReadItemInterbu {
  readonly '@context'?: InterBuProgressStepUploadedFileJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  fileUrl?: string | null;
  readonly id: string;
  updatedAt?: string;
}

export type InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOfHydra = typeof InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOfHydra[keyof typeof InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuProgressStepUploadedFileJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuProgressStepJsonldReadItemInterbuRecipientUser = UserJsonldReadItemInterbu | null;

export type InterBuProgressStepJsonldReadItemInterbuRecipientBusinessUnit = BusinessUnitJsonldReadItemInterbu | null;

export type InterBuProgressStepJsonldReadItemInterbuProgressStep = typeof InterBuProgressStepJsonldReadItemInterbuProgressStep[keyof typeof InterBuProgressStepJsonldReadItemInterbuProgressStep];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuProgressStepJsonldReadItemInterbuProgressStep = {
  SENT_TO_BU: 'SENT_TO_BU',
  ASSIGNED_TO_USER: 'ASSIGNED_TO_USER',
  CONTACTED: 'CONTACTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ABANDONED: 'ABANDONED',
  REFUSED: 'REFUSED',
} as const;

export type InterBuProgressStepJsonldReadItemInterbuMotivation = typeof InterBuProgressStepJsonldReadItemInterbuMotivation[keyof typeof InterBuProgressStepJsonldReadItemInterbuMotivation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuProgressStepJsonldReadItemInterbuMotivation = {
  ALREADY_KNOWN_CLIENT_OR_PROJECT: 'ALREADY_KNOWN_CLIENT_OR_PROJECT',
  IMPOSSIBLE_PROJECT: 'IMPOSSIBLE_PROJECT',
  NOT_IN_SCOPE: 'NOT_IN_SCOPE',
  OTHER: 'OTHER',
  NOTICE_OF_VALUE: 'NOTICE_OF_VALUE',
  PROJECT_CANCELLED: 'PROJECT_CANCELLED',
  PROJECT_COMPLETED_OUTSIDE_BARNES: 'PROJECT_COMPLETED_OUTSIDE_BARNES',
  CLIENT_NOT_RESPONSIVE: 'CLIENT_NOT_RESPONSIVE',
  LACK_OF_FUNDING: 'LACK_OF_FUNDING',
} as const;

export interface InterBuProgressStepJsonldReadItemInterbu {
  readonly '@context'?: InterBuProgressStepJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  readonly id: string;
  motivation?: InterBuProgressStepJsonldReadItemInterbuMotivation;
  progressStep: InterBuProgressStepJsonldReadItemInterbuProgressStep;
  recipientBusinessUnit?: InterBuProgressStepJsonldReadItemInterbuRecipientBusinessUnit;
  recipientUser?: InterBuProgressStepJsonldReadItemInterbuRecipientUser;
  updatedAt?: string;
  uploadedFiles?: InterBuProgressStepUploadedFileJsonldReadItemInterbu[];
  user: UserJsonldReadItemInterbu;
}

export type InterBuProgressStepJsonldReadItemInterbuContextOneOfHydra = typeof InterBuProgressStepJsonldReadItemInterbuContextOneOfHydra[keyof typeof InterBuProgressStepJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuProgressStepJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuProgressStepJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuProgressStepJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuProgressStepJsonldReadItemInterbuContext = string | InterBuProgressStepJsonldReadItemInterbuContextOneOf;

export type InterBuProgressStepCreateInterBuProgressStepInputProgressStep = typeof InterBuProgressStepCreateInterBuProgressStepInputProgressStep[keyof typeof InterBuProgressStepCreateInterBuProgressStepInputProgressStep];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuProgressStepCreateInterBuProgressStepInputProgressStep = {
  SENT_TO_BU: 'SENT_TO_BU',
  ASSIGNED_TO_USER: 'ASSIGNED_TO_USER',
  CONTACTED: 'CONTACTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ABANDONED: 'ABANDONED',
  REFUSED: 'REFUSED',
} as const;

export interface InterBuProgressStepCreateInterBuProgressStepInput {
  /** @nullable */
  comment?: string | null;
  'files[]'?: Blob[];
  interBuId: string;
  /** @nullable */
  motivation?: string | null;
  progressStep: InterBuProgressStepCreateInterBuProgressStepInputProgressStep;
  /** @nullable */
  recipientBuId?: string | null;
  /** @nullable */
  recipientUserId?: string | null;
}

/**
 * Flat row for interBU Excel export (one row per SharedData interBU exchange).
 */
export interface InterBuExcelExportRowJsonldReadCollectionInterbuExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentUrl?: string | null;
  /** @nullable */
  city?: string | null;
  /**
   * JSON-encoded list of comments: [{authorId, authorFirstname, authorLastname, message, createdAt}].
   * @nullable
   */
  commentsJson?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  deniedAt?: string | null;
  /**
   * Relative to the exporting user: sent, received, or sent_received.
   * @nullable
   */
  direction?: string | null;
  /** @nullable */
  fromClusterId?: string | null;
  /** @nullable */
  fromClusterName?: string | null;
  /** @nullable */
  fromManagerFirstname?: string | null;
  /** @nullable */
  fromManagerId?: string | null;
  /** @nullable */
  fromManagerLastname?: string | null;
  /** @nullable */
  fromUserId?: string | null;
  interBuId?: string;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  messageAnswer?: string | null;
  /** @nullable */
  messageEnd?: string | null;
  /** @nullable */
  peopleComments?: string | null;
  /** @nullable */
  peopleFirstname?: string | null;
  /** @nullable */
  peopleId?: string | null;
  /** @nullable */
  peopleLastname?: string | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  /** @nullable */
  priceUnitCode?: string | null;
  /** @nullable */
  priceUnitLabel?: string | null;
  /** @nullable */
  projectComments?: string | null;
  /** @nullable */
  projectMaturityCode?: string | null;
  /** @nullable */
  projectMaturityLabel?: string | null;
  /** @nullable */
  propertyTypeCode?: string | null;
  /** @nullable */
  propertyTypeLabel?: string | null;
  /**
   * Public reference of the InterBU, e.g. "IBU-00145".
   * @nullable
   */
  reference?: string | null;
  /** @nullable */
  revokedAt?: string | null;
  sharedDataId?: string;
  /** @nullable */
  statusCode?: string | null;
  /** @nullable */
  statusLabel?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  subjectAnswer?: string | null;
  /** @nullable */
  subjectEnd?: string | null;
  /** @nullable */
  subtypeCode?: string | null;
  /** @nullable */
  subtypeLabel?: string | null;
  /** @nullable */
  surfaceMax?: number | null;
  /** @nullable */
  surfaceMin?: number | null;
  /** @nullable */
  surfaceUnitCode?: string | null;
  /** @nullable */
  surfaceUnitLabel?: string | null;
  /** @nullable */
  targetClusterNames?: string | null;
  /** @nullable */
  terminatedAt?: string | null;
  /** @nullable */
  toClusterId?: string | null;
  /** @nullable */
  toClusterName?: string | null;
  /** @nullable */
  toManagerFirstname?: string | null;
  /** @nullable */
  toManagerId?: string | null;
  /** @nullable */
  toManagerLastname?: string | null;
  /** @nullable */
  typeCode?: string | null;
  /** @nullable */
  typeLabel?: string | null;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type InterBuClusterJsonldReadItemInterbuMetadata = {[key: string]: string};

export interface InterBuClusterJsonldReadItemInterbu {
  readonly '@context'?: InterBuClusterJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadItemInterbu;
  createdAt?: string;
  readonly id: string;
  metadata?: InterBuClusterJsonldReadItemInterbuMetadata;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export type InterBuClusterJsonldReadItemInterbuContextOneOfHydra = typeof InterBuClusterJsonldReadItemInterbuContextOneOfHydra[keyof typeof InterBuClusterJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuClusterJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuClusterJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuClusterJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuClusterJsonldReadItemInterbuContext = string | InterBuClusterJsonldReadItemInterbuContextOneOf;

export type InterBuClusterJsonldReadCollectionInterbuMetadata = {[key: string]: string};

export type InterBuClusterJsonldReadCollectionInterbuContextOneOfHydra = typeof InterBuClusterJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof InterBuClusterJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuClusterJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuClusterJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuClusterJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuClusterJsonldReadCollectionInterbuContext = string | InterBuClusterJsonldReadCollectionInterbuContextOneOf;

export interface InterBuClusterJsonldReadCollectionInterbu {
  readonly '@context'?: InterBuClusterJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadCollectionInterbu;
  createdAt?: string;
  readonly id: string;
  metadata?: InterBuClusterJsonldReadCollectionInterbuMetadata;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export type InterBuClusterJsonldMetadata = {[key: string]: string};

export interface InterBuClusterJsonld {
  readonly '@context'?: InterBuClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: string;
  createdAt?: string;
  readonly id: string;
  interBu?: string;
  metadata?: InterBuClusterJsonldMetadata;
  /** @nullable */
  order?: number | null;
  updatedAt?: string;
}

export type InterBuClusterJsonldContextOneOfHydra = typeof InterBuClusterJsonldContextOneOfHydra[keyof typeof InterBuClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: InterBuClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuClusterJsonldContext = string | InterBuClusterJsonldContextOneOf;

export type InterBuJsonldReadItemInterbuType = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuSurfaceUnit = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuSubtype = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuPropertyType = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuProjectMaturity = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuPriceUnit = RefLabelJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuPeople = PeopleJsonldReadItemInterbu | null;

export type InterBuJsonldReadItemInterbuFromManager = CollaboratorJsonldReadItemInterbu | null;

export interface InterBuJsonldReadItemInterbu {
  readonly '@context'?: InterBuJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  /** @nullable */
  city?: string | null;
  clusters?: InterBuClusterJsonldReadItemInterbu[];
  readonly comments?: readonly InterbuCommentJsonldReadItemInterbu[];
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  fromManager?: InterBuJsonldReadItemInterbuFromManager;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  messageEnd?: string | null;
  people?: InterBuJsonldReadItemInterbuPeople;
  /** @nullable */
  peopleComments?: string | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  priceUnit?: InterBuJsonldReadItemInterbuPriceUnit;
  /** @nullable */
  projectComments?: string | null;
  projectMaturity?: InterBuJsonldReadItemInterbuProjectMaturity;
  propertyType?: InterBuJsonldReadItemInterbuPropertyType;
  readonly shortReference?: string;
  status?: RefLabelJsonldReadItemInterbu;
  /** @nullable */
  subjectEnd?: string | null;
  subtype?: InterBuJsonldReadItemInterbuSubtype;
  /** @nullable */
  surfaceMax?: number | null;
  /** @nullable */
  surfaceMin?: number | null;
  surfaceUnit?: InterBuJsonldReadItemInterbuSurfaceUnit;
  type?: InterBuJsonldReadItemInterbuType;
  updatedAt?: string;
  /** @nullable */
  zipcode?: string | null;
}

export type InterBuJsonldReadItemInterbuContextOneOfHydra = typeof InterBuJsonldReadItemInterbuContextOneOfHydra[keyof typeof InterBuJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuJsonldReadItemInterbuContext = string | InterBuJsonldReadItemInterbuContextOneOf;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataType = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataSurfaceUnit = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataSubtype = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataPropertyType = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataProjectMaturity = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataPriceUnit = RefLabelJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataPeople = PeopleJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataFromManager = CollaboratorJsonldReadCollectionSharedDataReadItemSharedData | null;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuJsonldReadCollectionSharedDataReadItemSharedDataContext = string | InterBuJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface InterBuJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  /** @nullable */
  city?: string | null;
  readonly comments?: readonly InterbuCommentJsonldReadCollectionSharedDataReadItemSharedData[];
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  fromManager?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataFromManager;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  messageEnd?: string | null;
  people?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataPeople;
  /** @nullable */
  peopleComments?: string | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  priceUnit?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataPriceUnit;
  /** @nullable */
  projectComments?: string | null;
  projectMaturity?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataProjectMaturity;
  propertyType?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataPropertyType;
  readonly shortReference?: string;
  status?: RefLabelJsonldReadCollectionSharedDataReadItemSharedData;
  /** @nullable */
  subjectEnd?: string | null;
  subtype?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataSubtype;
  /** @nullable */
  surfaceMax?: number | null;
  /** @nullable */
  surfaceMin?: number | null;
  surfaceUnit?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataSurfaceUnit;
  type?: InterBuJsonldReadCollectionSharedDataReadItemSharedDataType;
  updatedAt?: string;
  /** @nullable */
  zipcode?: string | null;
}

export type InterBuJsonldReadCollectionSharedDataType = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataSurfaceUnit = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataSubtype = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataPropertyType = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataProjectMaturity = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataPriceUnit = RefLabelJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataPeople = PeopleJsonldReadCollectionSharedData | null;

export type InterBuJsonldReadCollectionSharedDataFromManager = CollaboratorJsonldReadCollectionSharedData | null;

export interface InterBuJsonldReadCollectionSharedData {
  readonly '@context'?: InterBuJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  /** @nullable */
  city?: string | null;
  readonly comments?: readonly InterbuCommentJsonldReadCollectionSharedData[];
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  fromManager?: InterBuJsonldReadCollectionSharedDataFromManager;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  messageEnd?: string | null;
  people?: InterBuJsonldReadCollectionSharedDataPeople;
  /** @nullable */
  peopleComments?: string | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  priceUnit?: InterBuJsonldReadCollectionSharedDataPriceUnit;
  /** @nullable */
  projectComments?: string | null;
  projectMaturity?: InterBuJsonldReadCollectionSharedDataProjectMaturity;
  propertyType?: InterBuJsonldReadCollectionSharedDataPropertyType;
  readonly shortReference?: string;
  status?: RefLabelJsonldReadCollectionSharedData;
  /** @nullable */
  subjectEnd?: string | null;
  subtype?: InterBuJsonldReadCollectionSharedDataSubtype;
  /** @nullable */
  surfaceMax?: number | null;
  /** @nullable */
  surfaceMin?: number | null;
  surfaceUnit?: InterBuJsonldReadCollectionSharedDataSurfaceUnit;
  type?: InterBuJsonldReadCollectionSharedDataType;
  updatedAt?: string;
  /** @nullable */
  zipcode?: string | null;
}

export type InterBuJsonldReadCollectionSharedDataContextOneOfHydra = typeof InterBuJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof InterBuJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: InterBuJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuJsonldReadCollectionSharedDataContext = string | InterBuJsonldReadCollectionSharedDataContextOneOf;

export type InterBuJsonldReadCollectionInterbuType = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuSurfaceUnit = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuSubtype = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuPropertyType = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuProjectMaturity = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuPriceUnit = RefLabelJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuPeople = PeopleJsonldReadCollectionInterbu | null;

export type InterBuJsonldReadCollectionInterbuFromManager = CollaboratorJsonldReadCollectionInterbu | null;

export interface InterBuJsonldReadCollectionInterbu {
  readonly '@context'?: InterBuJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  /** @nullable */
  city?: string | null;
  clusters?: InterBuClusterJsonldReadCollectionInterbu[];
  readonly comments?: readonly InterbuCommentJsonldReadCollectionInterbu[];
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  fromManager?: InterBuJsonldReadCollectionInterbuFromManager;
  readonly id: string;
  isShared?: boolean;
  /** @nullable */
  messageEnd?: string | null;
  people?: InterBuJsonldReadCollectionInterbuPeople;
  /** @nullable */
  peopleComments?: string | null;
  /** @nullable */
  priceMax?: number | null;
  /** @nullable */
  priceMin?: number | null;
  priceUnit?: InterBuJsonldReadCollectionInterbuPriceUnit;
  /** @nullable */
  projectComments?: string | null;
  projectMaturity?: InterBuJsonldReadCollectionInterbuProjectMaturity;
  propertyType?: InterBuJsonldReadCollectionInterbuPropertyType;
  sharedData?: SharedDataJsonldReadCollectionInterbu[];
  readonly shortReference?: string;
  status?: RefLabelJsonldReadCollectionInterbu;
  /** @nullable */
  subjectEnd?: string | null;
  subtype?: InterBuJsonldReadCollectionInterbuSubtype;
  /** @nullable */
  surfaceMax?: number | null;
  /** @nullable */
  surfaceMin?: number | null;
  surfaceUnit?: InterBuJsonldReadCollectionInterbuSurfaceUnit;
  type?: InterBuJsonldReadCollectionInterbuType;
  updatedAt?: string;
  /** @nullable */
  zipcode?: string | null;
}

export type InterBuJsonldReadCollectionInterbuContextOneOfHydra = typeof InterBuJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof InterBuJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterBuJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type InterBuJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: InterBuJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type InterBuJsonldReadCollectionInterbuContext = string | InterBuJsonldReadCollectionInterbuContextOneOf;

export interface InterBuPostInterBuInputJsonld {
  /** @nullable */
  address_1?: string | null;
  /** @nullable */
  address_2?: string | null;
  /** @nullable */
  address_3?: string | null;
  /** @nullable */
  city?: string | null;
  /** @minItems 1 */
  clusters?: string[];
  /** @nullable */
  country: string | null;
  from_cluster_id: string;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  people_comment?: string | null;
  people_id: string;
  /**
   * @minimum 0
   * @nullable
   */
  price_max?: number | null;
  /**
   * @minimum 0
   * @nullable
   */
  price_min?: number | null;
  /** @nullable */
  price_unit?: string | null;
  /** @nullable */
  project_comment?: string | null;
  /** @nullable */
  project_maturity: string | null;
  property_type: string;
  subject: string;
  subtype: string;
  /**
   * @nullable
   */
  surface_max?: number | null;
  /**
   * @nullable
   */
  surface_min?: number | null;
  /** @nullable */
  surface_unit?: string | null;
  type: string;
  /** @nullable */
  zipcode?: string | null;
}

export interface InterBuPostInterBuClustersInputJsonld {
  /** @minItems 1 */
  cluster_ids: string[];
}

export type I18nTextJsonldReadItemAgencyItemLocale = RefLabelJsonldReadItemAgencyItem | null;

export interface I18nTextJsonldReadItemAgencyItem {
  readonly '@context'?: I18nTextJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  hook?: string | null;
  readonly id: string;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  kind?: string | null;
  locale?: I18nTextJsonldReadItemAgencyItemLocale;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  shortMessage?: string | null;
  /** @nullable */
  subtitle?: string | null;
  /** @nullable */
  title?: string | null;
  updatedAt?: string;
}

export type I18nTextJsonldReadItemAgencyItemContextOneOfHydra = typeof I18nTextJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof I18nTextJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const I18nTextJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type I18nTextJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: I18nTextJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type I18nTextJsonldReadItemAgencyItemContext = string | I18nTextJsonldReadItemAgencyItemContextOneOf;

export type I18nTextJsonldContextOneOfHydra = typeof I18nTextJsonldContextOneOfHydra[keyof typeof I18nTextJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const I18nTextJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type I18nTextJsonldContextOneOf = {
  '@vocab': string;
  hydra: I18nTextJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type I18nTextJsonldContext = string | I18nTextJsonldContextOneOf;

export interface I18nTextJsonld {
  readonly '@context'?: I18nTextJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: RelAgencyI18nTextJsonld[];
  cluster?: RelClusterI18nTextJsonld[];
  createdAt?: string;
  /** @nullable */
  hook?: string | null;
  readonly id: string;
  /** @nullable */
  isPrivate?: boolean | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  locale?: string | null;
  marketSegment?: RelMarketSegmentI18nTextJsonld[];
  /** @nullable */
  message?: string | null;
  property?: RelPropertyI18nTextJsonld[];
  propertySearch?: RelPropertySearchI18nTextJsonld[];
  /** @nullable */
  shortMessage?: string | null;
  /** @nullable */
  subtitle?: string | null;
  /** @nullable */
  title?: string | null;
  updatedAt?: string;
}

export interface HolidayLocationJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: HolidayLocationJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  country?: string | null;
  readonly id: string;
}

export type HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type HolidayLocationJsonldReadItemClientWithoutPrivateDataContext = string | HolidayLocationJsonldReadItemClientWithoutPrivateDataContextOneOf;

export interface HobbyCategoryJsonldReadCollectionHobbyCategory {
  readonly '@id'?: string;
  readonly '@type'?: string;
  hobbies?: HobbyJsonldReadCollectionHobbyCategory[];
  readonly id: string;
  name: string;
}

export type HobbyCategoryJsonldContextOneOfHydra = typeof HobbyCategoryJsonldContextOneOfHydra[keyof typeof HobbyCategoryJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HobbyCategoryJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HobbyCategoryJsonldContextOneOf = {
  '@vocab': string;
  hydra: HobbyCategoryJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type HobbyCategoryJsonldContext = string | HobbyCategoryJsonldContextOneOf;

export interface HobbyCategoryJsonld {
  readonly '@context'?: HobbyCategoryJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  hobbies?: string[];
  readonly id: string;
  name: string;
}

export type HobbyCategoryTranslationsDTOTranslations = {[key: string]: {[key: string]: string}};

export interface HobbyCategoryTranslationsDTO {
  translations: HobbyCategoryTranslationsDTOTranslations;
}

export interface HobbyCategoryPostHobbyCategoryInputJsonld {
  translations?: MandatoryTranslationsDTOJsonld;
}

export type HobbyCategoryPatchHobbyCategoryInputTranslations = OptionalTranslationsDTO | null;

export interface HobbyCategoryPatchHobbyCategoryInput {
  translations?: HobbyCategoryPatchHobbyCategoryInputTranslations;
}

export interface HobbyJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: HobbyJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type HobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof HobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof HobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HobbyJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: HobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type HobbyJsonldReadItemClientWithoutPrivateDataContext = string | HobbyJsonldReadItemClientWithoutPrivateDataContextOneOf;

export interface HobbyJsonldReadCollectionHobbyCategory {
  readonly '@context'?: HobbyJsonldReadCollectionHobbyCategoryContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type HobbyJsonldReadCollectionHobbyCategoryContextOneOfHydra = typeof HobbyJsonldReadCollectionHobbyCategoryContextOneOfHydra[keyof typeof HobbyJsonldReadCollectionHobbyCategoryContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HobbyJsonldReadCollectionHobbyCategoryContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HobbyJsonldReadCollectionHobbyCategoryContextOneOf = {
  '@vocab': string;
  hydra: HobbyJsonldReadCollectionHobbyCategoryContextOneOfHydra;
  [key: string]: unknown;
 };

export type HobbyJsonldReadCollectionHobbyCategoryContext = string | HobbyJsonldReadCollectionHobbyCategoryContextOneOf;

export interface HobbyJsonld {
  readonly '@context'?: HobbyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  category?: string;
  clientHobbies?: ClientHobbyJsonld[];
  readonly id: string;
  name: string;
}

export type HobbyJsonldContextOneOfHydra = typeof HobbyJsonldContextOneOfHydra[keyof typeof HobbyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HobbyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HobbyJsonldContextOneOf = {
  '@vocab': string;
  hydra: HobbyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type HobbyJsonldContext = string | HobbyJsonldContextOneOf;

export type HobbyTranslationsDTOTranslations = {[key: string]: {[key: string]: string}};

export interface HobbyTranslationsDTO {
  translations: HobbyTranslationsDTOTranslations;
}

export interface HobbyPostHobbyInputJsonld {
  hobbyCategoryId: string;
  translations?: MandatoryTranslationsDTOJsonld;
}

export type HobbyPatchHobbyInputTranslations = OptionalTranslationsDTO | null;

export interface HobbyPatchHobbyInput {
  translations?: HobbyPatchHobbyInputTranslations;
}

export type HelpdeskJsonldWriteItemHelpdeskItemContextOneOfHydra = typeof HelpdeskJsonldWriteItemHelpdeskItemContextOneOfHydra[keyof typeof HelpdeskJsonldWriteItemHelpdeskItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HelpdeskJsonldWriteItemHelpdeskItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HelpdeskJsonldWriteItemHelpdeskItemContextOneOf = {
  '@vocab': string;
  hydra: HelpdeskJsonldWriteItemHelpdeskItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type HelpdeskJsonldWriteItemHelpdeskItemContext = string | HelpdeskJsonldWriteItemHelpdeskItemContextOneOf;

export interface HelpdeskJsonldWriteItemHelpdeskItem {
  readonly '@context'?: HelpdeskJsonldWriteItemHelpdeskItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  description?: string;
  emailSent?: boolean;
  metadata?: unknown;
  /** @nullable */
  priority?: string | null;
  reason?: string;
  status?: string;
  subject?: string;
  type?: string;
}

export interface HelpdeskJsonldReadItemHelpdeskItem {
  readonly '@context'?: HelpdeskJsonldReadItemHelpdeskItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  createdAt?: string;
  description?: string;
  emailSent?: boolean;
  readonly id: string;
  metadata?: unknown;
  /** @nullable */
  priority?: string | null;
  reason?: string;
  status?: string;
  subject?: string;
  type?: string;
  updatedAt?: string;
  user?: UserJsonldReadItemHelpdeskItem;
}

export type HelpdeskJsonldReadItemHelpdeskItemContextOneOfHydra = typeof HelpdeskJsonldReadItemHelpdeskItemContextOneOfHydra[keyof typeof HelpdeskJsonldReadItemHelpdeskItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HelpdeskJsonldReadItemHelpdeskItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HelpdeskJsonldReadItemHelpdeskItemContextOneOf = {
  '@vocab': string;
  hydra: HelpdeskJsonldReadItemHelpdeskItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type HelpdeskJsonldReadItemHelpdeskItemContext = string | HelpdeskJsonldReadItemHelpdeskItemContextOneOf;

export interface HelpdeskJsonldReadCollectionHelpdesk {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  createdAt?: string;
  description?: string;
  emailSent?: boolean;
  readonly id: string;
  metadata?: unknown;
  /** @nullable */
  priority?: string | null;
  reason?: string;
  status?: string;
  subject?: string;
  type?: string;
  updatedAt?: string;
  user?: UserJsonldReadCollectionHelpdesk;
}

export type HelpdeskJsonldContextOneOfHydra = typeof HelpdeskJsonldContextOneOfHydra[keyof typeof HelpdeskJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HelpdeskJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type HelpdeskJsonldContextOneOf = {
  '@vocab': string;
  hydra: HelpdeskJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type HelpdeskJsonldContext = string | HelpdeskJsonldContextOneOf;

export interface HelpdeskJsonld {
  readonly '@context'?: HelpdeskJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  attachmentKey?: string | null;
  /** @nullable */
  attachmentName?: string | null;
  /** @nullable */
  attachmentSize?: number | null;
  /** @nullable */
  attachmentUrl?: string | null;
  createdAt?: string;
  description?: string;
  emailSent?: boolean;
  readonly id: string;
  metadata?: unknown;
  /** @nullable */
  priority?: string | null;
  reason?: string;
  status?: string;
  subject?: string;
  type?: string;
  updatedAt?: string;
  user?: string;
}

export interface HelpdeskPostHelpdeskInputHelpdeskCreate {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  file?: Blob | null;
  /** @nullable */
  metadata?: string[] | null;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem { [key: string]: unknown }

export type ExternalPlatformJsonldReadItemClusterItemContextOneOfHydra = typeof ExternalPlatformJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ExternalPlatformJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalPlatformJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ExternalPlatformJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ExternalPlatformJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ExternalPlatformJsonldReadItemClusterItemContext = string | ExternalPlatformJsonldReadItemClusterItemContextOneOf;

export interface ExternalPlatformJsonldReadItemClusterItem {
  readonly '@context'?: ExternalPlatformJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export type ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ExternalPlatformJsonldReadCollectionClusterExcelExportContext = string | ExternalPlatformJsonldReadCollectionClusterExcelExportContextOneOf;

export interface ExternalPlatformJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: ExternalPlatformJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export interface ExternalPlatformJsonldReadCollectionCluster {
  readonly '@context'?: ExternalPlatformJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  code?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export type ExternalPlatformJsonldReadCollectionClusterContextOneOfHydra = typeof ExternalPlatformJsonldReadCollectionClusterContextOneOfHydra[keyof typeof ExternalPlatformJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalPlatformJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ExternalPlatformJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: ExternalPlatformJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type ExternalPlatformJsonldReadCollectionClusterContext = string | ExternalPlatformJsonldReadCollectionClusterContextOneOf;

export interface ExternalPlatformJsonld {
  readonly '@context'?: ExternalPlatformJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: RelClusterExternalPlatformJsonld[];
  code?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
}

export type ExternalPlatformJsonldContextOneOfHydra = typeof ExternalPlatformJsonldContextOneOfHydra[keyof typeof ExternalPlatformJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalPlatformJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ExternalPlatformJsonldContextOneOf = {
  '@vocab': string;
  hydra: ExternalPlatformJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ExternalPlatformJsonldContext = string | ExternalPlatformJsonldContextOneOf;

export interface EventJsonldReadCollectionEvent {
  readonly '@id'?: string;
  readonly '@type'?: string;
  endDate: string;
  readonly id: string;
  startDate: string;
  title: string;
}

export type EventJsonldContextOneOfHydra = typeof EventJsonldContextOneOfHydra[keyof typeof EventJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type EventJsonldContextOneOf = {
  '@vocab': string;
  hydra: EventJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type EventJsonldContext = string | EventJsonldContextOneOf;

export interface EventJsonld {
  readonly '@context'?: EventJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  clients?: string[];
  endDate: string;
  readonly id: string;
  startDate: string;
  title: string;
}

export interface EventPostEventInputJsonld {
  endDate: string;
  startDate: string;
  translations?: MandatoryTranslationsDTOJsonld;
}

export type EventPatchEventInputTranslations = OptionalTranslationsDTO | null;

export interface EventPatchEventInput {
  /** @nullable */
  endDate?: string | null;
  /** @nullable */
  startDate?: string | null;
  translations?: EventPatchEventInputTranslations;
}

export type EventEventWithTranslationsDTOTranslations = {[key: string]: {[key: string]: string}};

export interface EventEventWithTranslationsDTO {
  endDate: string;
  startDate: string;
  translations: EventEventWithTranslationsDTOTranslations;
}

export interface EntityResourceJsonldReadCollectionUserClustersEntityCanSetId {
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface EntityResourceJsonldReadCollectionUserClusters {
  readonly '@id'?: string;
  readonly '@type'?: string;
}

export interface EntityMediaDTO {
  isDefault?: boolean;
  mediaID?: string;
  order?: number;
}

export interface DirectoryCollaboratorMatchJsonldReadCollectionDirectoryCluster {
  readonly '@context'?: DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  fullname?: string | null;
  /** @nullable */
  function?: string | null;
  id?: string;
  /** @nullable */
  lastname?: string | null;
}

export type DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOfHydra = typeof DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOfHydra[keyof typeof DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOf = {
  '@vocab': string;
  hydra: DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContext = string | DirectoryCollaboratorMatchJsonldReadCollectionDirectoryClusterContextOneOf;

/**
 * Collaborator of an agency in the international directory (ADR 0012, D2): active, published in
the directory, with professional fields only — never birth date, nationality, address, dates of
entry or leaving.
 */
export interface DirectoryCollaboratorJsonldReadCollectionDirectoryCollaborator {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /**
   * E-mail of the default (professional) contact details.
   * @nullable
   */
  email?: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  fullname?: string | null;
  /**
   * Job title in this agency.
   * @nullable
   */
  function?: string | null;
  id?: string;
  /** @nullable */
  lastname?: string | null;
  /**
   * One phone of the default contact details: the mobile, or the landline when there is none.
   * @nullable
   */
  phone?: string | null;
  /**
   * URL of the default picture, without resizing parameters.
   * @nullable
   */
  photo?: string | null;
  /**
   * Role code in this agency (manager, cluster:role:collaborator…).
   * @nullable
   */
  role?: string | null;
}

/**
 * Agency of the international directory (ADR 0012, D2): only what the map and the tree need, for
every agency that passes the filters, in one call. The server decides which statuses the user
may see (D3) and counts only the collaborators published in the directory.
 */
export interface DirectoryClusterJsonldReadCollectionDirectoryCluster {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  expertiseArea?: string | null;
  id?: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  matchingCollaborators?: DirectoryCollaboratorMatchJsonldReadCollectionDirectoryCluster[];
  name?: string;
  nbCollaborators?: number;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  photo?: string | null;
  /** @nullable */
  status?: string | null;
  types?: string[];
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsDTOJsonldTimetables = TimetablesDTOJsonld | null;

export type ContactDetailsDTOJsonldMobileNoWhatsapp = string | null | boolean | null;

export type ContactDetailsDTOJsonldMobile2NoWhatsapp = string | null | boolean | null;

export interface ContactDetailsDTOJsonld {
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: string | null;
  /** @nullable */
  canton?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  emailValidity?: string | null;
  /** @nullable */
  fax?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  isDefault?: string | null;
  /** @nullable */
  latitude?: string | null;
  /** @nullable */
  longitude?: string | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: ContactDetailsDTOJsonldMobile2NoWhatsapp;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: ContactDetailsDTOJsonldMobileNoWhatsapp;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: string | null;
  /** @nullable */
  neighborhoodLongitude?: string | null;
  /** @nullable */
  order?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicLatitude?: string | null;
  /** @nullable */
  publicLongitude?: string | null;
  /** @nullable */
  radius?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: ContactDetailsDTOJsonldTimetables;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldUserReadItemCanton = RefLabelJsonldUserReadItem | null;

export type ContactDetailsJsonldUserReadItemContextOneOfHydra = typeof ContactDetailsJsonldUserReadItemContextOneOfHydra[keyof typeof ContactDetailsJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldUserReadItemContext = string | ContactDetailsJsonldUserReadItemContextOneOf;

export interface ContactDetailsJsonldUserReadItem {
  readonly '@context'?: ContactDetailsJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldUserReadItemCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldUserReadCollectionCanton = RefLabelJsonldUserReadCollection | null;

export type ContactDetailsJsonldUserReadCollectionContextOneOfHydra = typeof ContactDetailsJsonldUserReadCollectionContextOneOfHydra[keyof typeof ContactDetailsJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldUserReadCollectionContext = string | ContactDetailsJsonldUserReadCollectionContextOneOf;

export interface ContactDetailsJsonldUserReadCollection {
  readonly '@context'?: ContactDetailsJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldUserReadCollectionCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemSocietyItemCanton = RefLabelJsonldReadItemSocietyItem | null;

export interface ContactDetailsJsonldReadItemSocietyItem {
  readonly '@context'?: ContactDetailsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemSocietyItemCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = typeof ContactDetailsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemSocietyItemContext = string | ContactDetailsJsonldReadItemSocietyItemContextOneOf;

export type ContactDetailsJsonldReadItemPropertySearchContextOneOfHydra = typeof ContactDetailsJsonldReadItemPropertySearchContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemPropertySearchContext = string | ContactDetailsJsonldReadItemPropertySearchContextOneOf;

export interface ContactDetailsJsonldReadItemPropertySearch {
  readonly '@context'?: ContactDetailsJsonldReadItemPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ContactDetailsJsonldReadItemPropertyCanton = RefLabelJsonldReadItemProperty | null;

export type ContactDetailsJsonldReadItemPropertyContextOneOfHydra = typeof ContactDetailsJsonldReadItemPropertyContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemPropertyContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemPropertyContext = string | ContactDetailsJsonldReadItemPropertyContextOneOf;

export interface ContactDetailsJsonldReadItemProperty {
  readonly '@context'?: ContactDetailsJsonldReadItemPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemPropertyCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemProjectCanton = RefLabelJsonldReadItemProject | null;

export type ContactDetailsJsonldReadItemProjectContextOneOfHydra = typeof ContactDetailsJsonldReadItemProjectContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemProjectContext = string | ContactDetailsJsonldReadItemProjectContextOneOf;

export interface ContactDetailsJsonldReadItemProject {
  readonly '@context'?: ContactDetailsJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemProjectCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemPeopleCanton = RefLabelJsonldReadItemPeople | null;

export type ContactDetailsJsonldReadItemPeopleContext = string | ContactDetailsJsonldReadItemPeopleContextOneOf;

export interface ContactDetailsJsonldReadItemPeople {
  readonly '@context'?: ContactDetailsJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemPeopleCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemPeopleContextOneOfHydra = typeof ContactDetailsJsonldReadItemPeopleContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemCollaboratorItemCanton = RefLabelJsonldReadItemCollaboratorItem | null;

export type ContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemCollaboratorItemContext = string | ContactDetailsJsonldReadItemCollaboratorItemContextOneOf;

export interface ContactDetailsJsonldReadItemCollaboratorItem {
  readonly '@context'?: ContactDetailsJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemCollaboratorItemCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemClusterItemCanton = RefLabelJsonldReadItemClusterItem | null;

export type ContactDetailsJsonldReadItemClusterItemContextOneOfHydra = typeof ContactDetailsJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemClusterItemContext = string | ContactDetailsJsonldReadItemClusterItemContextOneOf;

export interface ContactDetailsJsonldReadItemClusterItem {
  readonly '@context'?: ContactDetailsJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemClusterItemCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemAgencyItemCanton = RefLabelJsonldReadItemAgencyItem | null;

export interface ContactDetailsJsonldReadItemAgencyItem {
  readonly '@context'?: ContactDetailsJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadItemAgencyItemCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = typeof ContactDetailsJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof ContactDetailsJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadItemAgencyItemContext = string | ContactDetailsJsonldReadItemAgencyItemContextOneOf;

export type ContactDetailsJsonldReadCollectionSocietyExcelExportCanton = RefLabelJsonldReadCollectionSocietyExcelExport | null;

export interface ContactDetailsJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionSocietyExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionSocietyExcelExportContext = string | ContactDetailsJsonldReadCollectionSocietyExcelExportContextOneOf;

export type ContactDetailsJsonldReadCollectionSocietyCanton = RefLabelJsonldReadCollectionSociety | null;

export interface ContactDetailsJsonldReadCollectionSociety {
  readonly '@context'?: ContactDetailsJsonldReadCollectionSocietyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionSocietyCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionSocietyContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionSocietyContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionSocietyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionSocietyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionSocietyContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionSocietyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionSocietyContext = string | ContactDetailsJsonldReadCollectionSocietyContextOneOf;

export interface ContactDetailsJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  readonly id: string;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  updatedAt?: string;
}

export type ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContext = string | ContactDetailsJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type ContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionSharedDataContext = string | ContactDetailsJsonldReadCollectionSharedDataContextOneOf;

export interface ContactDetailsJsonldReadCollectionSharedData {
  readonly '@context'?: ContactDetailsJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  readonly id: string;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  updatedAt?: string;
}

export type ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPropertySearchExcelExportContext = string | ContactDetailsJsonldReadCollectionPropertySearchExcelExportContextOneOf;

export interface ContactDetailsJsonldReadCollectionPropertySearchExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPropertySearchExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export interface ContactDetailsJsonldReadCollectionPropertySearch {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPropertySearchContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type ContactDetailsJsonldReadCollectionPropertySearchContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPropertySearchContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPropertySearchContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPropertySearchContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPropertySearchContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPropertySearchContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPropertySearchContext = string | ContactDetailsJsonldReadCollectionPropertySearchContextOneOf;

export type ContactDetailsJsonldReadCollectionPropertyExcelExportCanton = RefLabelJsonldReadCollectionPropertyExcelExport | null;

export type ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPropertyExcelExportContext = string | ContactDetailsJsonldReadCollectionPropertyExcelExportContextOneOf;

export interface ContactDetailsJsonldReadCollectionPropertyExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionPropertyExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionPropertyCanton = RefLabelJsonldReadCollectionProperty | null;

export interface ContactDetailsJsonldReadCollectionProperty {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPropertyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionPropertyCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionPropertyContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPropertyContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPropertyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPropertyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPropertyContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPropertyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPropertyContext = string | ContactDetailsJsonldReadCollectionPropertyContextOneOf;

export type ContactDetailsJsonldReadCollectionProjectExcelExportCanton = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionProjectExcelExportContext = string | ContactDetailsJsonldReadCollectionProjectExcelExportContextOneOf;

export interface ContactDetailsJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionProjectExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionProjectCanton = RefLabelJsonldReadCollectionProject | null;

export interface ContactDetailsJsonldReadCollectionProject {
  readonly '@context'?: ContactDetailsJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionProjectCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionProjectContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionProjectContext = string | ContactDetailsJsonldReadCollectionProjectContextOneOf;

export type ContactDetailsJsonldReadCollectionPeopleExcelExportCanton = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface ContactDetailsJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionPeopleExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPeopleExcelExportContext = string | ContactDetailsJsonldReadCollectionPeopleExcelExportContextOneOf;

export type ContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionPeopleContext = string | ContactDetailsJsonldReadCollectionPeopleContextOneOf;

export interface ContactDetailsJsonldReadCollectionPeople {
  readonly '@context'?: ContactDetailsJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  readonly id: string;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  updatedAt?: string;
}

export interface ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  readonly id: string;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  updatedAt?: string;
}

export type ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | ContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export type ContactDetailsJsonldReadCollectionCollaboratorExcelExportCanton = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export type ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionCollaboratorExcelExportContext = string | ContactDetailsJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export interface ContactDetailsJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionCollaboratorExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionCollaboratorCanton = RefLabelJsonldReadCollectionCollaborator | null;

export interface ContactDetailsJsonldReadCollectionCollaborator {
  readonly '@context'?: ContactDetailsJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionCollaboratorCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionCollaboratorContext = string | ContactDetailsJsonldReadCollectionCollaboratorContextOneOf;

export type ContactDetailsJsonldReadCollectionClusterExcelExportCanton = RefLabelJsonldReadCollectionClusterExcelExport | null;

export type ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionClusterExcelExportContext = string | ContactDetailsJsonldReadCollectionClusterExcelExportContextOneOf;

export interface ContactDetailsJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionClusterExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionClusterCanton = RefLabelJsonldReadCollectionCluster | null;

export interface ContactDetailsJsonldReadCollectionCluster {
  readonly '@context'?: ContactDetailsJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionClusterCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionClusterContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionClusterContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionClusterContext = string | ContactDetailsJsonldReadCollectionClusterContextOneOf;

export type ContactDetailsJsonldReadCollectionAgencyExcelExportCanton = RefLabelJsonldReadCollectionAgencyExcelExport | null;

export interface ContactDetailsJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: ContactDetailsJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionAgencyExcelExportCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionAgencyExcelExportContext = string | ContactDetailsJsonldReadCollectionAgencyExcelExportContextOneOf;

export type ContactDetailsJsonldReadCollectionAgencyCanton = RefLabelJsonldReadCollectionAgency | null;

export interface ContactDetailsJsonldReadCollectionAgency {
  readonly '@context'?: ContactDetailsJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  /** @nullable */
  altitude?: number | null;
  canton?: ContactDetailsJsonldReadCollectionAgencyCanton;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldReadCollectionAgencyContextOneOfHydra = typeof ContactDetailsJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof ContactDetailsJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldReadCollectionAgencyContext = string | ContactDetailsJsonldReadCollectionAgencyContextOneOf;

export interface ContactDetailsJsonld {
  readonly '@context'?: ContactDetailsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  address1?: string | null;
  /** @nullable */
  address2?: string | null;
  /** @nullable */
  address3?: string | null;
  agency?: RelAgencyContactDetailsJsonld[];
  agencyOwner?: RelAgencyOwnerContactDetailsJsonld[];
  /** @nullable */
  altitude?: number | null;
  /** @nullable */
  canton?: string | null;
  /** @nullable */
  city?: string | null;
  collaborator?: RelCollaboratorContactDetailsJsonld[];
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  emailFallback?: string | null;
  /** @nullable */
  emailLeads?: string | null;
  /** @nullable */
  emailRedir?: string | null;
  /** @nullable */
  emailValidity?: string | null;
  /** @nullable */
  fax?: string | null;
  readonly id: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  mobile?: string | null;
  /** @nullable */
  mobile2?: string | null;
  /** @nullable */
  mobile2Country?: string | null;
  /** @nullable */
  mobile2E164?: string | null;
  mobile2NoWhatsapp?: boolean;
  /** @nullable */
  mobile2Validity?: string | null;
  /** @nullable */
  mobileCountry?: string | null;
  /** @nullable */
  mobileE164?: string | null;
  mobileNoWhatsapp?: boolean;
  /** @nullable */
  mobileValidity?: string | null;
  /** @nullable */
  neighborhood?: string | null;
  /** @nullable */
  neighborhoodLatitude?: number | null;
  /** @nullable */
  neighborhoodLongitude?: number | null;
  people?: PeopleContactDetailsJsonld[];
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  phone2?: string | null;
  /** @nullable */
  phone2Country?: string | null;
  /** @nullable */
  phone2E164?: string | null;
  /** @nullable */
  phone2Validity?: string | null;
  /** @nullable */
  phoneCountry?: string | null;
  /** @nullable */
  phoneE164?: string | null;
  /** @nullable */
  phoneValidity?: string | null;
  /** @nullable */
  phoneWww?: string | null;
  propertyContactDetails?: PropertyContactDetailsJsonld[];
  /** @nullable */
  publicCity?: string | null;
  /** @nullable */
  publicCountry?: string | null;
  /** @nullable */
  publicLatitude?: number | null;
  /** @nullable */
  publicLongitude?: number | null;
  /** @nullable */
  publicNeighborhood?: string | null;
  /** @nullable */
  publicNeighborhoodLatitude?: number | null;
  /** @nullable */
  publicNeighborhoodLongitude?: number | null;
  /** @nullable */
  publicZipcode?: string | null;
  /** @nullable */
  radius?: number | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  socialFacebook?: string | null;
  /** @nullable */
  socialInstagram?: string | null;
  /** @nullable */
  socialLinkedin?: string | null;
  /** @nullable */
  socialTwitter?: string | null;
  /** @nullable */
  socialYoutube?: string | null;
  timetables?: unknown;
  updatedAt?: string;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  zipcode?: string | null;
}

export type ContactDetailsJsonldContextOneOfHydra = typeof ContactDetailsJsonldContextOneOfHydra[keyof typeof ContactDetailsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ContactDetailsJsonldContextOneOf = {
  '@vocab': string;
  hydra: ContactDetailsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ContactDetailsJsonldContext = string | ContactDetailsJsonldContextOneOf;

export interface CommentJsonldReadItemInterbu {
  readonly '@context'?: CommentJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  fromUser?: UserJsonldReadItemInterbu;
  readonly id: string;
  message?: string;
  updatedAt?: string;
}

export type CommentJsonldReadItemInterbuContextOneOfHydra = typeof CommentJsonldReadItemInterbuContextOneOfHydra[keyof typeof CommentJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CommentJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: CommentJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type CommentJsonldReadItemInterbuContext = string | CommentJsonldReadItemInterbuContextOneOf;

export type CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type CommentJsonldReadCollectionSharedDataReadItemSharedDataContext = string | CommentJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export interface CommentJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: CommentJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  fromUser?: UserJsonldReadCollectionSharedDataReadItemSharedData;
  readonly id: string;
  message?: string;
  updatedAt?: string;
}

export type CommentJsonldReadCollectionSharedDataContextOneOfHydra = typeof CommentJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof CommentJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CommentJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: CommentJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type CommentJsonldReadCollectionSharedDataContext = string | CommentJsonldReadCollectionSharedDataContextOneOf;

export interface CommentJsonldReadCollectionSharedData {
  readonly '@context'?: CommentJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  fromUser?: UserJsonldReadCollectionSharedData;
  readonly id: string;
  message?: string;
  updatedAt?: string;
}

export interface CommentJsonldReadCollectionInterbu {
  readonly '@context'?: CommentJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  fromUser?: UserJsonldReadCollectionInterbu;
  readonly id: string;
  message?: string;
  updatedAt?: string;
}

export type CommentJsonldReadCollectionInterbuContextOneOfHydra = typeof CommentJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof CommentJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CommentJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: CommentJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type CommentJsonldReadCollectionInterbuContext = string | CommentJsonldReadCollectionInterbuContextOneOf;

export interface CollaboratorUserDTOJsonld {
  collaborator?: string;
  isUserDefault?: boolean;
}

export interface CollaboratorUserDTO {
  collaborator?: string;
  isUserDefault?: boolean;
}

export interface CollaboratorTranslationJsonldReadItemCollaboratorItem {
  readonly '@context'?: CollaboratorTranslationJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOfHydra = typeof CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorTranslationJsonldReadItemCollaboratorItemContext = string | CollaboratorTranslationJsonldReadItemCollaboratorItemContextOneOf;

export type CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOfHydra = typeof CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorTranslationJsonldReadCollectionCollaboratorContext = string | CollaboratorTranslationJsonldReadCollectionCollaboratorContextOneOf;

export interface CollaboratorTranslationJsonldReadCollectionCollaborator {
  readonly '@context'?: CollaboratorTranslationJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
}

export type CollaboratorTranslationJsonldContextOneOfHydra = typeof CollaboratorTranslationJsonldContextOneOfHydra[keyof typeof CollaboratorTranslationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorTranslationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorTranslationJsonldContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorTranslationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorTranslationJsonldContext = string | CollaboratorTranslationJsonldContextOneOf;

export interface CollaboratorTranslationJsonld {
  readonly '@context'?: CollaboratorTranslationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  entity_id?: string | null;
  /** @nullable */
  entityId?: string | null;
  field?: string;
  readonly id?: number;
  readonly label?: string;
  locale?: string;
  /**
   * Get related object
   * @nullable
   */
  object?: string | null;
  /** @nullable */
  rel_entity_id?: string | null;
  /** @nullable */
  relEntityId?: string | null;
}

export interface CollaboratorPeopleDTOJsonld {
  collaborator?: string;
  id?: string;
  people?: string;
  role?: string;
}

export interface CollaboratorMediaJsonldUserReadItem {
  readonly '@context'?: CollaboratorMediaJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldUserReadItemContextOneOfHydra = typeof CollaboratorMediaJsonldUserReadItemContextOneOfHydra[keyof typeof CollaboratorMediaJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldUserReadItemContext = string | CollaboratorMediaJsonldUserReadItemContextOneOf;

export interface CollaboratorMediaJsonldReadItemSocietyItem {
  readonly '@context'?: CollaboratorMediaJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadItemSocietyItemContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemSocietyItemContext = string | CollaboratorMediaJsonldReadItemSocietyItemContextOneOf;

export type CollaboratorMediaJsonldReadItemProjectContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemProjectContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemProjectContext = string | CollaboratorMediaJsonldReadItemProjectContextOneOf;

export interface CollaboratorMediaJsonldReadItemProject {
  readonly '@context'?: CollaboratorMediaJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadItemPeopleContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemPeopleContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemPeopleContext = string | CollaboratorMediaJsonldReadItemPeopleContextOneOf;

export interface CollaboratorMediaJsonldReadItemPeople {
  readonly '@context'?: CollaboratorMediaJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadItemCollaboratorItemUsage = RefLabelJsonldReadItemCollaboratorItem | null;

export type CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemCollaboratorItemContext = string | CollaboratorMediaJsonldReadItemCollaboratorItemContextOneOf;

export interface CollaboratorMediaJsonldReadItemCollaboratorItem {
  readonly '@context'?: CollaboratorMediaJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: CollaboratorJsonldReadItemCollaboratorItem;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemCollaboratorItem;
  /** @nullable */
  order?: number | null;
  usage?: CollaboratorMediaJsonldReadItemCollaboratorItemUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export interface CollaboratorMediaJsonldReadItemClusterItem {
  readonly '@context'?: CollaboratorMediaJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadItemClusterItemContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemClusterItemContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemClusterItemContext = string | CollaboratorMediaJsonldReadItemClusterItemContextOneOf;

export type CollaboratorMediaJsonldReadItemAgencyItemContextOneOfHydra = typeof CollaboratorMediaJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadItemAgencyItemContext = string | CollaboratorMediaJsonldReadItemAgencyItemContextOneOf;

export interface CollaboratorMediaJsonldReadItemAgencyItem {
  readonly '@context'?: CollaboratorMediaJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionProjectExcelExportContext = string | CollaboratorMediaJsonldReadCollectionProjectExcelExportContextOneOf;

export interface CollaboratorMediaJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface CollaboratorMediaJsonldReadCollectionProject {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadCollectionProjectContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionProjectContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionProjectContext = string | CollaboratorMediaJsonldReadCollectionProjectContextOneOf;

export interface CollaboratorMediaJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionPeopleExcelExportContext = string | CollaboratorMediaJsonldReadCollectionPeopleExcelExportContextOneOf;

export type CollaboratorMediaJsonldReadCollectionPeopleContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionPeopleContext = string | CollaboratorMediaJsonldReadCollectionPeopleContextOneOf;

export interface CollaboratorMediaJsonldReadCollectionPeople {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type CollaboratorMediaJsonldReadCollectionCollaboratorUsage = RefLabelJsonldReadCollectionCollaborator | null;

export type CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOfHydra = typeof CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldReadCollectionCollaboratorContext = string | CollaboratorMediaJsonldReadCollectionCollaboratorContextOneOf;

export interface CollaboratorMediaJsonldReadCollectionCollaborator {
  readonly '@context'?: CollaboratorMediaJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: CollaboratorJsonldReadCollectionCollaborator;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionCollaborator;
  /** @nullable */
  order?: number | null;
  usage?: CollaboratorMediaJsonldReadCollectionCollaboratorUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type CollaboratorMediaJsonldContextOneOfHydra = typeof CollaboratorMediaJsonldContextOneOfHydra[keyof typeof CollaboratorMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorMediaJsonldContext = string | CollaboratorMediaJsonldContextOneOf;

export interface CollaboratorMediaJsonld {
  readonly '@context'?: CollaboratorMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  collaborator?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  /** @nullable */
  usage?: string | null;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type CollaboratorClusterDTOJsonldMetadatas = {[key: string]: string};

export type CollaboratorClusterDTOJsonldDateOfLeaving = string | null | string | null;

export type CollaboratorClusterDTOJsonldDateOfEntry = string | null | string | null;

export interface CollaboratorClusterDTOJsonld {
  cluster?: string;
  cluster_id?: string;
  collaborator?: string;
  /** @nullable */
  commentStatus?: string | null;
  dateOfEntry?: CollaboratorClusterDTOJsonldDateOfEntry;
  dateOfLeaving?: CollaboratorClusterDTOJsonldDateOfLeaving;
  /** @nullable */
  function?: string | null;
  id?: string;
  isDefault?: boolean;
  isPublished?: boolean;
  isPublishedInDirectory?: boolean;
  metadatas?: CollaboratorClusterDTOJsonldMetadatas;
  rank?: string;
  role?: string;
  /** @nullable */
  status?: string | null;
}

export interface CollaboratorAgencyDTOJsonld {
  agency?: string;
  collaborator?: string;
  id?: string;
  isDefault?: boolean;
  role?: string;
}

export type CollaboratorJsonldUserReadItemTitle = RefLabelJsonldUserReadItem | null;

export type CollaboratorJsonldUserReadItemStatus = RefLabelJsonldUserReadItem | null;

export type CollaboratorJsonldUserReadItemContextOneOfHydra = typeof CollaboratorJsonldUserReadItemContextOneOfHydra[keyof typeof CollaboratorJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldUserReadItemContext = string | CollaboratorJsonldUserReadItemContextOneOf;

export interface CollaboratorJsonldUserReadItem {
  readonly '@context'?: CollaboratorJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldUserReadItem[];
  /** @nullable */
  birthdate?: string | null;
  cluster?: RelCollaboratorClusterJsonldUserReadItem[];
  contactDetails?: RelCollaboratorContactDetailsJsonldUserReadItem[];
  createdAt?: string;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  /** @nullable */
  isUserDefault?: boolean | null;
  languages?: RefLabelJsonldUserReadItem[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldUserReadItem[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldUserReadItemStatus;
  title?: CollaboratorJsonldUserReadItemTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldUserReadCollectionTitle = RefLabelJsonldUserReadCollection | null;

export type CollaboratorJsonldUserReadCollectionContextOneOfHydra = typeof CollaboratorJsonldUserReadCollectionContextOneOfHydra[keyof typeof CollaboratorJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldUserReadCollectionContext = string | CollaboratorJsonldUserReadCollectionContextOneOf;

export interface CollaboratorJsonldUserReadCollection {
  readonly '@context'?: CollaboratorJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldUserReadCollection[];
  cluster?: RelCollaboratorClusterJsonldUserReadCollection[];
  contactDetails?: RelCollaboratorContactDetailsJsonldUserReadCollection[];
  createdAt?: string;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  /** @nullable */
  isUserDefault?: boolean | null;
  languages?: RefLabelJsonldUserReadCollection[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  title?: CollaboratorJsonldUserReadCollectionTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemSocietyItemTitle = RefLabelJsonldReadItemSocietyItem | null;

export interface CollaboratorJsonldReadItemSocietyItem {
  readonly '@context'?: CollaboratorJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemSocietyItem[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  lastname?: string;
  media?: CollaboratorMediaJsonldReadItemSocietyItem[];
  title?: CollaboratorJsonldReadItemSocietyItemTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemSocietyItemContextOneOfHydra = typeof CollaboratorJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemSocietyItemContext = string | CollaboratorJsonldReadItemSocietyItemContextOneOf;

export type CollaboratorJsonldReadItemProjectTitle = RefLabelJsonldReadItemProject | null;

export type CollaboratorJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type CollaboratorJsonldReadItemProjectContextOneOfHydra = typeof CollaboratorJsonldReadItemProjectContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemProjectContext = string | CollaboratorJsonldReadItemProjectContextOneOf;

export interface CollaboratorJsonldReadItemProject {
  readonly '@context'?: CollaboratorJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadItemProject[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemProject[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadItemProject[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadItemProject[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadItemProjectStatus;
  title?: CollaboratorJsonldReadItemProjectTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemPeopleTitle = RefLabelJsonldReadItemPeople | null;

export type CollaboratorJsonldReadItemPeopleStatus = RefLabelJsonldReadItemPeople | null;

export interface CollaboratorJsonldReadItemPeople {
  readonly '@context'?: CollaboratorJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadItemPeople[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemPeople[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadItemPeople[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadItemPeople[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadItemPeopleStatus;
  title?: CollaboratorJsonldReadItemPeopleTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemPeopleContextOneOfHydra = typeof CollaboratorJsonldReadItemPeopleContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemPeopleContext = string | CollaboratorJsonldReadItemPeopleContextOneOf;

export type CollaboratorJsonldReadItemInterbuContextOneOfHydra = typeof CollaboratorJsonldReadItemInterbuContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemInterbuContext = string | CollaboratorJsonldReadItemInterbuContextOneOf;

export interface CollaboratorJsonldReadItemInterbu {
  readonly '@context'?: CollaboratorJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemCollaboratorItemUsers = UserJsonldReadItemCollaboratorItem | null;

export type CollaboratorJsonldReadItemCollaboratorItemTitle = RefLabelJsonldReadItemCollaboratorItem | null;

export type CollaboratorJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export type CollaboratorJsonldReadItemCollaboratorItemNbProjectsByType = {[key: string]: number};

export interface CollaboratorJsonldReadItemCollaboratorItem {
  readonly '@context'?: CollaboratorJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadItemCollaboratorItem[];
  /** @nullable */
  birthdate?: string | null;
  cluster?: RelCollaboratorClusterJsonldReadItemCollaboratorItem[];
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemCollaboratorItem[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadItemCollaboratorItem[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonldReadItemCollaboratorItem[];
  media?: CollaboratorMediaJsonldReadItemCollaboratorItem[];
  /** @nullable */
  nationality?: string | null;
  nbAgencies?: number;
  nbClusters?: number;
  nbLegalRepresentatives?: number;
  nbPeople?: number;
  nbProjectsByType?: CollaboratorJsonldReadItemCollaboratorItemNbProjectsByType;
  people?: RelPeopleCollaboratorJsonldReadItemCollaboratorItem[];
  /** @nullable */
  presentation_html?: string | null;
  /** @nullable */
  presentation_text?: string | null;
  project?: ProjectCollaboratorJsonldReadItemCollaboratorItem[];
  status?: CollaboratorJsonldReadItemCollaboratorItemStatus;
  title?: CollaboratorJsonldReadItemCollaboratorItemTitle;
  translations?: CollaboratorTranslationJsonldReadItemCollaboratorItem[];
  updatedAt?: string;
  users?: CollaboratorJsonldReadItemCollaboratorItemUsers;
}

export type CollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = typeof CollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemCollaboratorItemContext = string | CollaboratorJsonldReadItemCollaboratorItemContextOneOf;

export type CollaboratorJsonldReadItemClusterItemTitle = RefLabelJsonldReadItemClusterItem | null;

export type CollaboratorJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export interface CollaboratorJsonldReadItemClusterItem {
  readonly '@context'?: CollaboratorJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemClusterItem[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  languages?: RefLabelJsonldReadItemClusterItem[];
  lastname?: string;
  media?: CollaboratorMediaJsonldReadItemClusterItem[];
  status?: CollaboratorJsonldReadItemClusterItemStatus;
  title?: CollaboratorJsonldReadItemClusterItemTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemClusterItemContextOneOfHydra = typeof CollaboratorJsonldReadItemClusterItemContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemClusterItemContext = string | CollaboratorJsonldReadItemClusterItemContextOneOf;

export type CollaboratorJsonldReadItemAgencyItemTitle = RefLabelJsonldReadItemAgencyItem | null;

export type CollaboratorJsonldReadItemAgencyItemStatus = RefLabelJsonldReadItemAgencyItem | null;

export interface CollaboratorJsonldReadItemAgencyItem {
  readonly '@context'?: CollaboratorJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadItemAgencyItem[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  lastname?: string;
  media?: CollaboratorMediaJsonldReadItemAgencyItem[];
  status?: CollaboratorJsonldReadItemAgencyItemStatus;
  title?: CollaboratorJsonldReadItemAgencyItemTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadItemAgencyItemContextOneOfHydra = typeof CollaboratorJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof CollaboratorJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadItemAgencyItemContext = string | CollaboratorJsonldReadItemAgencyItemContextOneOf;

export interface CollaboratorJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionSharedDataReadItemSharedData[];
  createdAt?: string;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  lastname?: string;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContext = string | CollaboratorJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type CollaboratorJsonldReadCollectionSharedDataContextOneOfHydra = typeof CollaboratorJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionSharedDataContext = string | CollaboratorJsonldReadCollectionSharedDataContextOneOf;

export interface CollaboratorJsonldReadCollectionSharedData {
  readonly '@context'?: CollaboratorJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionSharedData[];
  createdAt?: string;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  lastname?: string;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionProjectExcelExportTitle = RefLabelJsonldReadCollectionProjectExcelExport | null;

export type CollaboratorJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface CollaboratorJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: CollaboratorJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionProjectExcelExport[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionProjectExcelExport[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadCollectionProjectExcelExport[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadCollectionProjectExcelExportStatus;
  title?: CollaboratorJsonldReadCollectionProjectExcelExportTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof CollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionProjectExcelExportContext = string | CollaboratorJsonldReadCollectionProjectExcelExportContextOneOf;

export type CollaboratorJsonldReadCollectionProjectTitle = RefLabelJsonldReadCollectionProject | null;

export type CollaboratorJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export interface CollaboratorJsonldReadCollectionProject {
  readonly '@context'?: CollaboratorJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionProject[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  lastname?: string;
  media?: CollaboratorMediaJsonldReadCollectionProject[];
  status?: CollaboratorJsonldReadCollectionProjectStatus;
  title?: CollaboratorJsonldReadCollectionProjectTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionProjectContextOneOfHydra = typeof CollaboratorJsonldReadCollectionProjectContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionProjectContext = string | CollaboratorJsonldReadCollectionProjectContextOneOf;

export type CollaboratorJsonldReadCollectionPeopleExcelExportTitle = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export type CollaboratorJsonldReadCollectionPeopleExcelExportStatus = RefLabelJsonldReadCollectionPeopleExcelExport | null;

export interface CollaboratorJsonldReadCollectionPeopleExcelExport {
  readonly '@context'?: CollaboratorJsonldReadCollectionPeopleExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionPeopleExcelExport[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadCollectionPeopleExcelExport[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadCollectionPeopleExcelExportStatus;
  title?: CollaboratorJsonldReadCollectionPeopleExcelExportTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra = typeof CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionPeopleExcelExportContext = string | CollaboratorJsonldReadCollectionPeopleExcelExportContextOneOf;

export type CollaboratorJsonldReadCollectionPeopleTitle = RefLabelJsonldReadCollectionPeople | null;

export type CollaboratorJsonldReadCollectionPeopleStatus = RefLabelJsonldReadCollectionPeople | null;

export interface CollaboratorJsonldReadCollectionPeople {
  readonly '@context'?: CollaboratorJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadCollectionPeople[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionPeople[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionPeople[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadCollectionPeople[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadCollectionPeopleStatus;
  title?: CollaboratorJsonldReadCollectionPeopleTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionPeopleContextOneOfHydra = typeof CollaboratorJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionPeopleContext = string | CollaboratorJsonldReadCollectionPeopleContextOneOf;

export type CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesTitle = RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesStatus = RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses | null;

export type CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  /** @nullable */
  birthdate?: string | null;
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses[];
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesStatus;
  title?: CollaboratorJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionInterbuContextOneOfHydra = typeof CollaboratorJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionInterbuContext = string | CollaboratorJsonldReadCollectionInterbuContextOneOf;

export interface CollaboratorJsonldReadCollectionInterbu {
  readonly '@context'?: CollaboratorJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionCollaboratorExcelExportTitle = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export type CollaboratorJsonldReadCollectionCollaboratorExcelExportStatus = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export interface CollaboratorJsonldReadCollectionCollaboratorExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonldReadCollectionCollaboratorExcelExport[];
  /** @nullable */
  birthdate?: string | null;
  cluster?: RelCollaboratorClusterJsonldReadCollectionCollaboratorExcelExport[];
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionCollaboratorExcelExport[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionCollaboratorExcelExport[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  /** @nullable */
  nationality?: string | null;
  status?: CollaboratorJsonldReadCollectionCollaboratorExcelExportStatus;
  title?: CollaboratorJsonldReadCollectionCollaboratorExcelExportTitle;
  updatedAt?: string;
}

export type CollaboratorJsonldReadCollectionCollaboratorUsers = UserJsonldReadCollectionCollaborator | null;

export type CollaboratorJsonldReadCollectionCollaboratorTitle = RefLabelJsonldReadCollectionCollaborator | null;

export type CollaboratorJsonldReadCollectionCollaboratorStatus = RefLabelJsonldReadCollectionCollaborator | null;

export type CollaboratorJsonldReadCollectionCollaboratorNbProjectsByType = {[key: string]: number};

export interface CollaboratorJsonldReadCollectionCollaborator {
  readonly '@context'?: CollaboratorJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  birthdate?: string | null;
  cluster?: RelCollaboratorClusterJsonldReadCollectionCollaborator[];
  contactDetails?: RelCollaboratorContactDetailsJsonldReadCollectionCollaborator[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  languages?: RefLabelJsonldReadCollectionCollaborator[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  media?: CollaboratorMediaJsonldReadCollectionCollaborator[];
  /** @nullable */
  nationality?: string | null;
  nbAgencies?: number;
  nbClusters?: number;
  nbLegalRepresentatives?: number;
  nbPeople?: number;
  nbProjectsByType?: CollaboratorJsonldReadCollectionCollaboratorNbProjectsByType;
  /** @nullable */
  presentation_html?: string | null;
  /** @nullable */
  presentation_text?: string | null;
  status?: CollaboratorJsonldReadCollectionCollaboratorStatus;
  title?: CollaboratorJsonldReadCollectionCollaboratorTitle;
  translations?: CollaboratorTranslationJsonldReadCollectionCollaborator[];
  updatedAt?: string;
  users?: CollaboratorJsonldReadCollectionCollaboratorUsers;
}

export type CollaboratorJsonldReadCollectionCollaboratorContextOneOfHydra = typeof CollaboratorJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof CollaboratorJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldReadCollectionCollaboratorContext = string | CollaboratorJsonldReadCollectionCollaboratorContextOneOf;

export type CollaboratorJsonldNbProjectsByType = {[key: string]: number};

export type CollaboratorJsonldContextOneOfHydra = typeof CollaboratorJsonldContextOneOfHydra[keyof typeof CollaboratorJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaboratorJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CollaboratorJsonldContextOneOf = {
  '@vocab': string;
  hydra: CollaboratorJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type CollaboratorJsonldContext = string | CollaboratorJsonldContextOneOf;

export interface CollaboratorJsonld {
  readonly '@context'?: CollaboratorJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelCollaboratorAgencyJsonld[];
  /** @nullable */
  birthdate?: string | null;
  cluster?: RelCollaboratorClusterJsonld[];
  contactDetails?: RelCollaboratorContactDetailsJsonld[];
  createdAt?: string;
  /** @nullable */
  dateOfEntry?: string | null;
  /** @nullable */
  dateOfLeaving?: string | null;
  /** @nullable */
  readonly defaultCluster?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  introduction?: string | null;
  /** @nullable */
  isIndependent?: boolean | null;
  /** @nullable */
  isUserDefault?: boolean | null;
  languages?: string[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  legalRepresentative?: RelAgencyOwnerLegalRepresentativeJsonld[];
  media?: CollaboratorMediaJsonld[];
  /** @nullable */
  nationality?: string | null;
  nbAgencies?: number;
  nbClusters?: number;
  nbLegalRepresentatives?: number;
  nbPeople?: number;
  nbProjectsByType?: CollaboratorJsonldNbProjectsByType;
  /** @nullable */
  readonly normalizedFirstname?: string | null;
  /** @nullable */
  readonly normalizedFullname?: string | null;
  /** @nullable */
  readonly normalizedLastname?: string | null;
  people?: RelPeopleCollaboratorJsonld[];
  /** @nullable */
  presentation_html?: string | null;
  /** @nullable */
  presentation_text?: string | null;
  /** @nullable */
  presentationHtml?: string | null;
  /** @nullable */
  presentationText?: string | null;
  project?: ProjectCollaboratorJsonld[];
  /** @nullable */
  status?: string | null;
  /** @nullable */
  title?: string | null;
  translations?: CollaboratorTranslationJsonld[];
  updatedAt?: string;
  /** @nullable */
  users?: string | null;
}

export type CollaboratorPostCollaboratorInputJsonldIsIndependent = string | null | boolean | null;

export type CollaboratorPostCollaboratorInputJsonldDateOfLeaving = string | null | string | null;

export type CollaboratorPostCollaboratorInputJsonldDateOfEntry = string | null | string | null;

export type CollaboratorPostCollaboratorInputJsonldCluster = unknown[] | null | unknown;

export type CollaboratorPostCollaboratorInputJsonldBirthdate = string | null | string | null;

export interface CollaboratorPostCollaboratorInputJsonld {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: CollaboratorAgencyDTOJsonld[] | null;
  birthdate?: CollaboratorPostCollaboratorInputJsonldBirthdate;
  cluster?: CollaboratorPostCollaboratorInputJsonldCluster;
  /** @nullable */
  contactDetails?: ContactDetailsDTOJsonld[] | null;
  dateOfEntry?: CollaboratorPostCollaboratorInputJsonldDateOfEntry;
  dateOfLeaving?: CollaboratorPostCollaboratorInputJsonldDateOfLeaving;
  /** @nullable */
  fid_cluster?: string | null;
  firstname?: string;
  /** @nullable */
  fullname?: string | null;
  /** @nullable */
  introduction?: string | null;
  isIndependent?: CollaboratorPostCollaboratorInputJsonldIsIndependent;
  languages?: string[];
  lastname?: string;
  /** @nullable */
  legal?: string | null;
  /** @nullable */
  legalRepresentative?: LegalRepresentativeDTOJsonld[] | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  people?: CollaboratorPeopleDTOJsonld[] | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface CollaboratorPatchEntityMediaInput {
  datas?: EntityMediaDTO[];
}

export type CollaboratorPatchCollaboratorInputIsIndependent = string | null | boolean | null;

export type CollaboratorPatchCollaboratorInputDateOfLeaving = string | null | string | null;

export type CollaboratorPatchCollaboratorInputDateOfEntry = string | null | string | null;

export type CollaboratorPatchCollaboratorInputCluster = unknown[] | null | unknown;

export type CollaboratorPatchCollaboratorInputBirthdate = string | null | string | null;

export interface CollaboratorPatchCollaboratorInput {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: PatchCollaboratorAgencyDTO[] | null;
  birthdate?: CollaboratorPatchCollaboratorInputBirthdate;
  cluster?: CollaboratorPatchCollaboratorInputCluster;
  /** @nullable */
  contactDetails?: PatchContactDetailsDTO[] | null;
  dateOfEntry?: CollaboratorPatchCollaboratorInputDateOfEntry;
  dateOfLeaving?: CollaboratorPatchCollaboratorInputDateOfLeaving;
  /** @nullable */
  fid_cluster?: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  fullname?: string | null;
  /** @nullable */
  introduction?: string | null;
  isIndependent?: CollaboratorPatchCollaboratorInputIsIndependent;
  languages?: string[];
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  legal?: string | null;
  /** @nullable */
  legalRepresentative?: PatchLegalRepresentativeDTO[] | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  people?: PatchCollaboratorPeopleDTO[] | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  translations?: TranslationsExtInputDTO[] | null;
}

export interface ClusterTranslationJsonldReadItemClusterItem {
  readonly '@context'?: ClusterTranslationJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  entity_id?: string | null;
  readonly field?: string;
  readonly label?: string;
  readonly locale?: string;
  /** @nullable */
  rel_entity_id?: string | null;
}

export type ClusterTranslationJsonldReadItemClusterItemContextOneOfHydra = typeof ClusterTranslationJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ClusterTranslationJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterTranslationJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterTranslationJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterTranslationJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterTranslationJsonldReadItemClusterItemContext = string | ClusterTranslationJsonldReadItemClusterItemContextOneOf;

export type ClusterTranslationJsonldContextOneOfHydra = typeof ClusterTranslationJsonldContextOneOfHydra[keyof typeof ClusterTranslationJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterTranslationJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterTranslationJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClusterTranslationJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterTranslationJsonldContext = string | ClusterTranslationJsonldContextOneOf;

export interface ClusterTranslationJsonld {
  readonly '@context'?: ClusterTranslationJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  entity_id?: string | null;
  /** @nullable */
  entityId?: string | null;
  field?: string;
  readonly id?: number;
  readonly label?: string;
  locale?: string;
  /**
   * Get related object
   * @nullable
   */
  object?: string | null;
  /** @nullable */
  rel_entity_id?: string | null;
  /** @nullable */
  relEntityId?: string | null;
}

export interface ClusterSocietyDTOJsonld {
  agencyOwner?: string;
  cluster?: string;
  id?: string;
}

export type ClusterMediaJsonldReadItemSocietyItemContextOneOfHydra = typeof ClusterMediaJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof ClusterMediaJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadItemSocietyItemContext = string | ClusterMediaJsonldReadItemSocietyItemContextOneOf;

export interface ClusterMediaJsonldReadItemSocietyItem {
  readonly '@context'?: ClusterMediaJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ClusterMediaJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ClusterMediaJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ClusterMediaJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadItemCollaboratorItemContext = string | ClusterMediaJsonldReadItemCollaboratorItemContextOneOf;

export interface ClusterMediaJsonldReadItemCollaboratorItem {
  readonly '@context'?: ClusterMediaJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ClusterMediaJsonldReadItemClusterItemUsage = RefLabelJsonldReadItemClusterItem | null;

export type ClusterMediaJsonldReadItemClusterItemContextOneOfHydra = typeof ClusterMediaJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ClusterMediaJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadItemClusterItemContext = string | ClusterMediaJsonldReadItemClusterItemContextOneOf;

export interface ClusterMediaJsonldReadItemClusterItem {
  readonly '@context'?: ClusterMediaJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadItemClusterItem;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemClusterItem;
  /** @nullable */
  order?: number | null;
  usage?: ClusterMediaJsonldReadItemClusterItemUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export interface ClusterMediaJsonldReadItemAgencyItem {
  readonly '@context'?: ClusterMediaJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type ClusterMediaJsonldReadItemAgencyItemContextOneOfHydra = typeof ClusterMediaJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof ClusterMediaJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadItemAgencyItemContext = string | ClusterMediaJsonldReadItemAgencyItemContextOneOf;

export type ClusterMediaJsonldReadCollectionClusterExcelExportUsage = RefLabelJsonldReadCollectionClusterExcelExport | null;

export interface ClusterMediaJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: ClusterMediaJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadCollectionClusterExcelExport;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionClusterExcelExport;
  /** @nullable */
  order?: number | null;
  usage?: ClusterMediaJsonldReadCollectionClusterExcelExportUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadCollectionClusterExcelExportContext = string | ClusterMediaJsonldReadCollectionClusterExcelExportContextOneOf;

export type ClusterMediaJsonldReadCollectionClusterUsage = RefLabelJsonldReadCollectionCluster | null;

export type ClusterMediaJsonldReadCollectionClusterContextOneOfHydra = typeof ClusterMediaJsonldReadCollectionClusterContextOneOfHydra[keyof typeof ClusterMediaJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldReadCollectionClusterContext = string | ClusterMediaJsonldReadCollectionClusterContextOneOf;

export interface ClusterMediaJsonldReadCollectionCluster {
  readonly '@context'?: ClusterMediaJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: ClusterJsonldReadCollectionCluster;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionCluster;
  /** @nullable */
  order?: number | null;
  usage?: ClusterMediaJsonldReadCollectionClusterUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type ClusterMediaJsonldContextOneOfHydra = typeof ClusterMediaJsonldContextOneOfHydra[keyof typeof ClusterMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClusterMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterMediaJsonldContext = string | ClusterMediaJsonldContextOneOf;

export interface ClusterMediaJsonld {
  readonly '@context'?: ClusterMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  cluster?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  /** @nullable */
  usage?: string | null;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type ClusterJsonldUserReadItemStatus = RefLabelJsonldUserReadItem | null;

export type ClusterJsonldUserReadItemContextOneOfHydra = typeof ClusterJsonldUserReadItemContextOneOfHydra[keyof typeof ClusterJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldUserReadItemContext = string | ClusterJsonldUserReadItemContextOneOf;

export interface ClusterJsonldUserReadItem {
  readonly '@context'?: ClusterJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldUserReadItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldUserReadItemStatus;
  type?: RefLabelJsonldUserReadItem[];
  updatedAt?: string;
}

export type ClusterJsonldUserReadCollectionStatus = RefLabelJsonldUserReadCollection | null;

export interface ClusterJsonldUserReadCollection {
  readonly '@context'?: ClusterJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldUserReadCollection[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldUserReadCollectionStatus;
  type?: RefLabelJsonldUserReadCollection[];
  updatedAt?: string;
}

export type ClusterJsonldUserReadCollectionContextOneOfHydra = typeof ClusterJsonldUserReadCollectionContextOneOfHydra[keyof typeof ClusterJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldUserReadCollectionContext = string | ClusterJsonldUserReadCollectionContextOneOf;

export type ClusterJsonldReadItemSocietyItemStatus = RefLabelJsonldReadItemSocietyItem | null;

export type ClusterJsonldReadItemSocietyItemContextOneOfHydra = typeof ClusterJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof ClusterJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemSocietyItemContext = string | ClusterJsonldReadItemSocietyItemContextOneOf;

export interface ClusterJsonldReadItemSocietyItem {
  readonly '@context'?: ClusterJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencyClusterJsonldReadItemSocietyItem[];
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadItemSocietyItem[];
  coordsDisplayMode?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemSocietyItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadItemSocietyItem[];
  name?: string;
  status?: ClusterJsonldReadItemSocietyItemStatus;
  type?: RefLabelJsonldReadItemSocietyItem[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemProjectStatus = RefLabelJsonldReadItemProject | null;

export type ClusterJsonldReadItemProjectContextOneOfHydra = typeof ClusterJsonldReadItemProjectContextOneOfHydra[keyof typeof ClusterJsonldReadItemProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemProjectContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemProjectContext = string | ClusterJsonldReadItemProjectContextOneOf;

export interface ClusterJsonldReadItemProject {
  readonly '@context'?: ClusterJsonldReadItemProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadItemProject[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemProject[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldReadItemProjectStatus;
  type?: RefLabelJsonldReadItemProject[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemPeopleStatus = RefLabelJsonldReadItemPeople | null;

export interface ClusterJsonldReadItemPeople {
  readonly '@context'?: ClusterJsonldReadItemPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  coordsDisplayMode?: string;
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldReadItemPeopleStatus;
  type?: RefLabelJsonldReadItemPeople[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemPeopleContextOneOfHydra = typeof ClusterJsonldReadItemPeopleContextOneOfHydra[keyof typeof ClusterJsonldReadItemPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemPeopleContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemPeopleContext = string | ClusterJsonldReadItemPeopleContextOneOf;

export interface ClusterJsonldReadItemInterbu {
  readonly '@context'?: ClusterJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  interBus?: InterBuClusterJsonldReadItemInterbu[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemInterbuContextOneOfHydra = typeof ClusterJsonldReadItemInterbuContextOneOfHydra[keyof typeof ClusterJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemInterbuContext = string | ClusterJsonldReadItemInterbuContextOneOf;

export type ClusterJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export interface ClusterJsonldReadItemCollaboratorItem {
  readonly '@context'?: ClusterJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadItemCollaboratorItem[];
  coordsDisplayMode?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemCollaboratorItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadItemCollaboratorItem[];
  name?: string;
  status?: ClusterJsonldReadItemCollaboratorItemStatus;
  type?: RefLabelJsonldReadItemCollaboratorItem[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemCollaboratorItemContextOneOfHydra = typeof ClusterJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof ClusterJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemCollaboratorItemContext = string | ClusterJsonldReadItemCollaboratorItemContextOneOf;

export type ClusterJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export type ClusterJsonldReadItemClusterItemNbProjectsByType = {[key: string]: number};

export interface ClusterJsonldReadItemClusterItem {
  readonly '@context'?: ClusterJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencyClusterJsonldReadItemClusterItem[];
  agencyOwner?: RelAgencyOwnerClusterJsonldReadItemClusterItem[];
  collaborator?: RelCollaboratorClusterJsonldReadItemClusterItem[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadItemClusterItem[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemClusterItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadItemClusterItem[];
  name?: string;
  nbAgencies?: number;
  nbAgencyOwners?: number;
  nbCollaborators?: number;
  nbPeople?: number;
  nbProjectsByType?: ClusterJsonldReadItemClusterItemNbProjectsByType;
  people?: RelClusterPeopleJsonldReadItemClusterItem[];
  /** @nullable */
  presentation_html?: string | null;
  /** @nullable */
  presentation_text?: string | null;
  project?: ProjectClusterJsonldReadItemClusterItem[];
  status?: ClusterJsonldReadItemClusterItemStatus;
  translations?: ClusterTranslationJsonldReadItemClusterItem[];
  type?: RefLabelJsonldReadItemClusterItem[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemClusterItemContextOneOfHydra = typeof ClusterJsonldReadItemClusterItemContextOneOfHydra[keyof typeof ClusterJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemClusterItemContext = string | ClusterJsonldReadItemClusterItemContextOneOf;

export type ClusterJsonldReadItemAgencyItemStatus = RefLabelJsonldReadItemAgencyItem | null;

export interface ClusterJsonldReadItemAgencyItem {
  readonly '@context'?: ClusterJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadItemAgencyItem[];
  coordsDisplayMode?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadItemAgencyItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadItemAgencyItem[];
  name?: string;
  status?: ClusterJsonldReadItemAgencyItemStatus;
  type?: RefLabelJsonldReadItemAgencyItem[];
  updatedAt?: string;
}

export type ClusterJsonldReadItemAgencyItemContextOneOfHydra = typeof ClusterJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof ClusterJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadItemAgencyItemContext = string | ClusterJsonldReadItemAgencyItemContextOneOf;

export interface ClusterJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: ClusterJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof ClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionSocietyExcelExportContext = string | ClusterJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface ClusterJsonldReadCollectionSharedDataReadItemSharedData {
  readonly '@context'?: ClusterJsonldReadCollectionSharedDataReadItemSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = typeof ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionSharedDataReadItemSharedDataContext = string | ClusterJsonldReadCollectionSharedDataReadItemSharedDataContextOneOf;

export type ClusterJsonldReadCollectionSharedDataContextOneOfHydra = typeof ClusterJsonldReadCollectionSharedDataContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionSharedDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionSharedDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionSharedDataContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionSharedDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionSharedDataContext = string | ClusterJsonldReadCollectionSharedDataContextOneOf;

export interface ClusterJsonldReadCollectionSharedData {
  readonly '@context'?: ClusterJsonldReadCollectionSharedDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionProjectExcelExportStatus = RefLabelJsonldReadCollectionProjectExcelExport | null;

export interface ClusterJsonldReadCollectionProjectExcelExport {
  readonly '@context'?: ClusterJsonldReadCollectionProjectExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadCollectionProjectExcelExport[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionProjectExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldReadCollectionProjectExcelExportStatus;
  type?: RefLabelJsonldReadCollectionProjectExcelExport[];
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra = typeof ClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionProjectExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionProjectExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionProjectExcelExportContext = string | ClusterJsonldReadCollectionProjectExcelExportContextOneOf;

export type ClusterJsonldReadCollectionProjectStatus = RefLabelJsonldReadCollectionProject | null;

export type ClusterJsonldReadCollectionProjectContextOneOfHydra = typeof ClusterJsonldReadCollectionProjectContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionProjectContext = string | ClusterJsonldReadCollectionProjectContextOneOf;

export interface ClusterJsonldReadCollectionProject {
  readonly '@context'?: ClusterJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadCollectionProject[];
  coordsDisplayMode?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionProject[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  name?: string;
  status?: ClusterJsonldReadCollectionProjectStatus;
  type?: RefLabelJsonldReadCollectionProject[];
  updatedAt?: string;
}

export interface ClusterJsonldReadCollectionPeople {
  readonly '@context'?: ClusterJsonldReadCollectionPeopleContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionPeopleContextOneOfHydra = typeof ClusterJsonldReadCollectionPeopleContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionPeopleContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionPeopleContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionPeopleContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionPeopleContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionPeopleContext = string | ClusterJsonldReadCollectionPeopleContextOneOf;

export type ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = typeof ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext = string | ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContextOneOf;

export interface ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpouses {
  readonly '@context'?: ClusterJsonldReadCollectionLightPeopleWithCollaboratorsPeopleWithProjectsPeopleWithCollaboratorsSpousesContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionInterbuContextOneOfHydra = typeof ClusterJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionInterbuContext = string | ClusterJsonldReadCollectionInterbuContextOneOf;

export interface ClusterJsonldReadCollectionInterbu {
  readonly '@context'?: ClusterJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  interBus?: InterBuClusterJsonldReadCollectionInterbu[];
  updatedAt?: string;
}

export interface ClusterJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: ClusterJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionCollaboratorExcelExportContext = string | ClusterJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export type ClusterJsonldReadCollectionCollaboratorStatus = RefLabelJsonldReadCollectionCollaborator | null;

export type ClusterJsonldReadCollectionCollaboratorContextOneOfHydra = typeof ClusterJsonldReadCollectionCollaboratorContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionCollaboratorContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionCollaboratorContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionCollaboratorContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionCollaboratorContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionCollaboratorContext = string | ClusterJsonldReadCollectionCollaboratorContextOneOf;

export interface ClusterJsonldReadCollectionCollaborator {
  readonly '@context'?: ClusterJsonldReadCollectionCollaboratorContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionCollaborator[];
  readonly id: string;
  name?: string;
  status?: ClusterJsonldReadCollectionCollaboratorStatus;
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionClusterExcelExportStatus = RefLabelJsonldReadCollectionClusterExcelExport | null;

export interface ClusterJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: ClusterJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencyClusterJsonldReadCollectionClusterExcelExport[];
  agencyOwner?: RelAgencyOwnerClusterJsonldReadCollectionClusterExcelExport[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadCollectionClusterExcelExport[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionClusterExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadCollectionClusterExcelExport[];
  name?: string;
  status?: ClusterJsonldReadCollectionClusterExcelExportStatus;
  type?: RefLabelJsonldReadCollectionClusterExcelExport[];
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof ClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionClusterExcelExportContext = string | ClusterJsonldReadCollectionClusterExcelExportContextOneOf;

export type ClusterJsonldReadCollectionClusterStatus = RefLabelJsonldReadCollectionCluster | null;

export type ClusterJsonldReadCollectionClusterNbProjectsByType = {[key: string]: number};

export interface ClusterJsonldReadCollectionCluster {
  readonly '@context'?: ClusterJsonldReadCollectionClusterContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonldReadCollectionCluster[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /**
   * Distance in km from the point given by ?near[lat]&near[lng] (ADR 0004, D3); null otherwise.
   * @nullable
   */
  distance?: number | null;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonldReadCollectionCluster[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonldReadCollectionCluster[];
  name?: string;
  nbAgencies?: number;
  nbAgencyOwners?: number;
  nbCollaborators?: number;
  nbPeople?: number;
  nbProjectsByType?: ClusterJsonldReadCollectionClusterNbProjectsByType;
  status?: ClusterJsonldReadCollectionClusterStatus;
  type?: RefLabelJsonldReadCollectionCluster[];
  updatedAt?: string;
}

export type ClusterJsonldReadCollectionClusterContextOneOfHydra = typeof ClusterJsonldReadCollectionClusterContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionClusterContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionClusterContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionClusterContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionClusterContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionClusterContext = string | ClusterJsonldReadCollectionClusterContextOneOf;

export type ClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra = typeof ClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra[keyof typeof ClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldReadCollectionAgencyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldReadCollectionAgencyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldReadCollectionAgencyExcelExportContext = string | ClusterJsonldReadCollectionAgencyExcelExportContextOneOf;

export interface ClusterJsonldReadCollectionAgencyExcelExport {
  readonly '@context'?: ClusterJsonldReadCollectionAgencyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type ClusterJsonldNbProjectsByType = {[key: string]: number};

export interface ClusterJsonld {
  readonly '@context'?: ClusterJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  agency?: RelAgencyClusterJsonld[];
  agencyOwner?: RelAgencyOwnerClusterJsonld[];
  /** @nullable */
  clusterParent?: string | null;
  collaborator?: RelCollaboratorClusterJsonld[];
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionOwner?: number | null;
  /** @nullable */
  commissionOwnerRate?: number | null;
  /** @nullable */
  commissionTenant?: number | null;
  /** @nullable */
  commissionTenantRate?: number | null;
  contactDetails?: RelClusterContactDetailsJsonld[];
  coordsDisplayMode?: string;
  createdAt?: string;
  /**
   * Distance in km from the point given by ?near[lat]&near[lng] (ADR 0004, D3); null otherwise.
   * @nullable
   */
  distance?: number | null;
  /** @nullable */
  expertiseArea?: string | null;
  externalPlatform?: RelClusterExternalPlatformJsonld[];
  i18nText?: RelClusterI18nTextJsonld[];
  readonly id: string;
  interBus?: InterBuClusterJsonld[];
  /** @nullable */
  internalSource?: string | null;
  isL12nOutsourced?: boolean;
  media?: ClusterMediaJsonld[];
  name?: string;
  nbAgencies?: number;
  nbAgencyOwners?: number;
  nbCollaborators?: number;
  nbPeople?: number;
  nbProjectsByType?: ClusterJsonldNbProjectsByType;
  people?: RelClusterPeopleJsonld[];
  /** @nullable */
  presentation_html?: string | null;
  /** @nullable */
  presentation_text?: string | null;
  /** @nullable */
  presentationHtml?: string | null;
  /** @nullable */
  presentationText?: string | null;
  project?: ProjectClusterJsonld[];
  sharedData?: string[];
  /** @nullable */
  status?: string | null;
  translations?: ClusterTranslationJsonld[];
  type?: string[];
  updatedAt?: string;
}

export type ClusterJsonldContextOneOfHydra = typeof ClusterJsonldContextOneOfHydra[keyof typeof ClusterJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClusterJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClusterJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClusterJsonldContext = string | ClusterJsonldContextOneOf;

export interface ClusterPostClusterInputJsonld {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: AgencyClusterDTOJsonld[] | null;
  /** @nullable */
  agencyOwner?: ClusterSocietyDTOJsonld[] | null;
  /** @nullable */
  clusterParent?: string | null;
  /** @nullable */
  collaborator?: CollaboratorClusterDTOJsonld[] | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  contactDetails?: ContactDetailsDTOJsonld[] | null;
  /** @nullable */
  coordsDisplayMode?: string | null;
  /** @nullable */
  expertiseArea?: string | null;
  /** @nullable */
  isL12nOutsourced?: string | null;
  name?: string;
  /** @nullable */
  people?: PeopleClusterDTOJsonld[] | null;
  /** @nullable */
  project?: ProjectClusterDTOJsonld[] | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  type?: string[] | null;
}

export interface ClusterPatchEntityMediaInput {
  datas?: EntityMediaDTO[];
}

export interface ClusterPatchClusterInput {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  agency?: PatchAgencyClusterDTO[] | null;
  /** @nullable */
  agencyOwner?: PatchClusterSocietyDTO[] | null;
  /** @nullable */
  clusterParent?: string | null;
  /** @nullable */
  collaborator?: PatchCollaboratorClusterDTO[] | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  contactDetails?: PatchContactDetailsDTO[] | null;
  /** @nullable */
  coordsDisplayMode?: string | null;
  /** @nullable */
  expertiseArea?: string | null;
  /** @nullable */
  isL12nOutsourced?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  people?: PatchPeopleClusterDTO[] | null;
  /** @nullable */
  project?: PatchProjectClusterDTO[] | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  translations?: TranslationsExtInputDTO[] | null;
  /** @nullable */
  type?: string[] | null;
}

export interface ClientHobbyJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: ClientHobbyJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  hobby?: HobbyJsonldReadItemClientWithoutPrivateData;
}

export type ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientHobbyJsonldReadItemClientWithoutPrivateDataContext = string | ClientHobbyJsonldReadItemClientWithoutPrivateDataContextOneOf;

export interface ClientHobbyJsonld {
  readonly '@context'?: ClientHobbyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  client?: string;
  /** @nullable */
  comment?: string | null;
  hobby?: string;
}

export type ClientHobbyJsonldContextOneOfHydra = typeof ClientHobbyJsonldContextOneOfHydra[keyof typeof ClientHobbyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientHobbyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientHobbyJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClientHobbyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientHobbyJsonldContext = string | ClientHobbyJsonldContextOneOf;

export type ClientAccessRequestJsonldReadCollectionClientAccessRequestStatus = typeof ClientAccessRequestJsonldReadCollectionClientAccessRequestStatus[keyof typeof ClientAccessRequestJsonldReadCollectionClientAccessRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestJsonldReadCollectionClientAccessRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED',
} as const;

export type ClientAccessRequestJsonldReadCollectionClientAccessRequestMotivation = typeof ClientAccessRequestJsonldReadCollectionClientAccessRequestMotivation[keyof typeof ClientAccessRequestJsonldReadCollectionClientAccessRequestMotivation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestJsonldReadCollectionClientAccessRequestMotivation = {
  JOINT_PROJECT: 'JOINT_PROJECT',
  NEW_PROSPECTS: 'NEW_PROSPECTS',
} as const;

export type ClientAccessRequestJsonldReadCollectionClientAccessRequestBusinessUnit = BusinessUnitJsonldReadCollectionClientAccessRequest | null;

export interface ClientAccessRequestJsonldReadCollectionClientAccessRequest {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  answerDate?: string | null;
  businessUnit?: ClientAccessRequestJsonldReadCollectionClientAccessRequestBusinessUnit;
  client: ClientJsonldReadCollectionClientAccessRequest;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  readonly id: string;
  motivation?: ClientAccessRequestJsonldReadCollectionClientAccessRequestMotivation;
  status?: ClientAccessRequestJsonldReadCollectionClientAccessRequestStatus;
  user?: UserJsonldReadCollectionClientAccessRequest;
}

export type ClientAccessRequestJsonldStatus = typeof ClientAccessRequestJsonldStatus[keyof typeof ClientAccessRequestJsonldStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestJsonldStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED',
} as const;

export type ClientAccessRequestJsonldMotivation = typeof ClientAccessRequestJsonldMotivation[keyof typeof ClientAccessRequestJsonldMotivation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestJsonldMotivation = {
  JOINT_PROJECT: 'JOINT_PROJECT',
  NEW_PROSPECTS: 'NEW_PROSPECTS',
} as const;

export type ClientAccessRequestJsonldContextOneOfHydra = typeof ClientAccessRequestJsonldContextOneOfHydra[keyof typeof ClientAccessRequestJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientAccessRequestJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClientAccessRequestJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientAccessRequestJsonldContext = string | ClientAccessRequestJsonldContextOneOf;

export interface ClientAccessRequestJsonld {
  readonly '@context'?: ClientAccessRequestJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  answerDate?: string | null;
  /** @nullable */
  businessUnit?: string | null;
  client: string;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  readonly id: string;
  motivation?: ClientAccessRequestJsonldMotivation;
  status?: ClientAccessRequestJsonldStatus;
  updatedAt?: string;
  user?: string;
}

export type ClientAccessRequestCreateClientAccessRequestInputJsonldMotivation = typeof ClientAccessRequestCreateClientAccessRequestInputJsonldMotivation[keyof typeof ClientAccessRequestCreateClientAccessRequestInputJsonldMotivation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestCreateClientAccessRequestInputJsonldMotivation = {
  JOINT_PROJECT: 'JOINT_PROJECT',
  NEW_PROSPECTS: 'NEW_PROSPECTS',
} as const;

export interface ClientAccessRequestCreateClientAccessRequestInputJsonld {
  clientId: string;
  /** @nullable */
  comment?: string | null;
  motivation: ClientAccessRequestCreateClientAccessRequestInputJsonldMotivation;
}

export type ClientAccessRequestWriteItemClientAccessRequestStatus = typeof ClientAccessRequestWriteItemClientAccessRequestStatus[keyof typeof ClientAccessRequestWriteItemClientAccessRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAccessRequestWriteItemClientAccessRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED',
} as const;

export interface ClientAccessRequestWriteItemClientAccessRequest {
  status?: ClientAccessRequestWriteItemClientAccessRequestStatus;
}

export type ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadItemTpropertyWithoutPrivateDataContext = string | ClientJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export interface ClientJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: ClientJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  /** @nullable */
  lastName?: string | null;
}

export type ClientJsonldReadItemInterbuLanguagesItem = typeof ClientJsonldReadItemInterbuLanguagesItem[keyof typeof ClientJsonldReadItemInterbuLanguagesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemInterbuLanguagesItem = {
  af_ZA: 'af_ZA',
  am_ET: 'am_ET',
  ar_AA: 'ar_AA',
  as_IN: 'as_IN',
  az_AZ: 'az_AZ',
  be_BY: 'be_BY',
  bg_BG: 'bg_BG',
  bn_BD: 'bn_BD',
  bo_IN: 'bo_IN',
  bs_BA: 'bs_BA',
  ca_ES: 'ca_ES',
  cs_CZ: 'cs_CZ',
  da_DK: 'da_DK',
  de_DE: 'de_DE',
  el_GR: 'el_GR',
  en_GB: 'en_GB',
  es_ES: 'es_ES',
  et_EE: 'et_EE',
  fi_FI: 'fi_FI',
  fr_FR: 'fr_FR',
  ga_IE: 'ga_IE',
  he_IL: 'he_IL',
  hi_IN: 'hi_IN',
  hr_BA: 'hr_BA',
  hu_HU: 'hu_HU',
  hy_AM: 'hy_AM',
  id_ID: 'id_ID',
  ig_NG: 'ig_NG',
  ii_CN: 'ii_CN',
  is_IS: 'is_IS',
  it_IT: 'it_IT',
  iu_CA: 'iu_CA',
  ja_JP: 'ja_JP',
  jv_ID: 'jv_ID',
  ka_GE: 'ka_GE',
  ki_KE: 'ki_KE',
  kk_KZ: 'kk_KZ',
  km_KH: 'km_KH',
  kn_IN: 'kn_IN',
  ko_KR: 'ko_KR',
  ks_IN: 'ks_IN',
  ku_TR: 'ku_TR',
  kw_GB: 'kw_GB',
  lb_LU: 'lb_LU',
  lg_UG: 'lg_UG',
  ln_AO: 'ln_AO',
  lo_LA: 'lo_LA',
  lt_LT: 'lt_LT',
  lu_CD: 'lu_CD',
  lv_LV: 'lv_LV',
  mg_MG: 'mg_MG',
  en_MH: 'en_MH',
  mi_NZ: 'mi_NZ',
  mk_MK: 'mk_MK',
  ml_IN: 'ml_IN',
  mn_MN: 'mn_MN',
  mr_IN: 'mr_IN',
  ms_BN: 'ms_BN',
  mt_MT: 'mt_MT',
  my_MM: 'my_MM',
  en_NR: 'en_NR',
  nb_NO: 'nb_NO',
  ne_IN: 'ne_IN',
  nl_NL: 'nl_NL',
  nn_NO: 'nn_NO',
  no_NO: 'no_NO',
  nr_ZA: 'nr_ZA',
  om_ET: 'om_ET',
  pl_PL: 'pl_PL',
  ps_PK: 'ps_PK',
  pt_PT: 'pt_PT',
  qu_PE: 'qu_PE',
  rm_CH: 'rm_CH',
  ro_RO: 'ro_RO',
  ru_RU: 'ru_RU',
  rw_RW: 'rw_RW',
  sa_IN: 'sa_IN',
  sd_PK: 'sd_PK',
  se_SE: 'se_SE',
  sg_CF: 'sg_CF',
  sk_SK: 'sk_SK',
  sl_SL: 'sl_SL',
  sn_ZW: 'sn_ZW',
  so_SO: 'so_SO',
  sq_AL: 'sq_AL',
  sr_BA: 'sr_BA',
  ss_SZ: 'ss_SZ',
  st_LS: 'st_LS',
  sv_SE: 'sv_SE',
  te_IN: 'te_IN',
  tg_TJ: 'tg_TJ',
  th_TH: 'th_TH',
  ti_ER: 'ti_ER',
  tk_TM: 'tk_TM',
  tn_BW: 'tn_BW',
  to_TO: 'to_TO',
  tr_TR: 'tr_TR',
  ts_ZA: 'ts_ZA',
  tt_RU: 'tt_RU',
  uk_UA: 'uk_UA',
  ur_PK: 'ur_PK',
  uz_UZ: 'uz_UZ',
  ve_ZA: 've_ZA',
  vi_VN: 'vi_VN',
  wo_SN: 'wo_SN',
  xh_ZA: 'xh_ZA',
  'yi-001': 'yi-001',
  yo_NG: 'yo_NG',
  zh_CN: 'zh_CN',
  zu_ZA: 'zu_ZA',
} as const;

export type ClientJsonldReadItemInterbuCivility = typeof ClientJsonldReadItemInterbuCivility[keyof typeof ClientJsonldReadItemInterbuCivility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemInterbuCivility = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export interface ClientJsonldReadItemInterbu {
  readonly '@context'?: ClientJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  civility?: ClientJsonldReadItemInterbuCivility;
  createdAt?: string;
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  languages?: ClientJsonldReadItemInterbuLanguagesItem[];
  /** @nullable */
  lastName?: string | null;
  updatedAt?: string;
}

export type ClientJsonldReadItemInterbuContextOneOfHydra = typeof ClientJsonldReadItemInterbuContextOneOfHydra[keyof typeof ClientJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadItemInterbuContext = string | ClientJsonldReadItemInterbuContextOneOf;

export type ClientJsonldReadItemClientWithoutPrivateDataVisibility = typeof ClientJsonldReadItemClientWithoutPrivateDataVisibility[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataVisibility = {
  NOT_CONFIDENTIAL: 'NOT_CONFIDENTIAL',
  CONFIDENTIAL: 'CONFIDENTIAL',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataUser = UserJsonldReadItemClientWithoutPrivateData | null;

export type ClientJsonldReadItemClientWithoutPrivateDataReferenceCurrency = typeof ClientJsonldReadItemClientWithoutPrivateDataReferenceCurrency[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataReferenceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataReferenceCurrency = {
  EUR: 'EUR',
  USD: 'USD',
  CAD: 'CAD',
  HUF: 'HUF',
  MUR: 'MUR',
  MAD: 'MAD',
  RUB: 'RUB',
  CHF: 'CHF',
  GBP: 'GBP',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataProjectStatus = typeof ClientJsonldReadItemClientWithoutPrivateDataProjectStatus[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataProjectStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataProfileType = typeof ClientJsonldReadItemClientWithoutPrivateDataProfileType[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataProfileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataProfileType = {
  PRIVATE_INDIVIDUAL: 'PRIVATE_INDIVIDUAL',
  INVESTOR: 'INVESTOR',
  INSTITUTIONAL_INVESTOR: 'INSTITUTIONAL_INVESTOR',
  JOINT_OWNERSHIP: 'JOINT_OWNERSHIP',
  PROPERTY_TRADER: 'PROPERTY_TRADER',
  NOTARY: 'NOTARY',
  INTERMEDIATE: 'INTERMEDIATE',
  COUNTERPART: 'COUNTERPART',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataNationality = typeof ClientJsonldReadItemClientWithoutPrivateDataNationality[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataNationality];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataNationality = {
  ad: 'ad',
  ae: 'ae',
  af: 'af',
  ag: 'ag',
  ai: 'ai',
  al: 'al',
  am: 'am',
  ao: 'ao',
  ar: 'ar',
  as: 'as',
  at: 'at',
  au: 'au',
  aw: 'aw',
  az: 'az',
  ba: 'ba',
  bb: 'bb',
  bd: 'bd',
  be: 'be',
  bf: 'bf',
  bg: 'bg',
  bh: 'bh',
  bi: 'bi',
  bj: 'bj',
  bm: 'bm',
  bn: 'bn',
  bo: 'bo',
  br: 'br',
  bs: 'bs',
  bt: 'bt',
  bw: 'bw',
  by: 'by',
  bz: 'bz',
  ca: 'ca',
  cd: 'cd',
  cf: 'cf',
  cg: 'cg',
  ch: 'ch',
  ci: 'ci',
  ck: 'ck',
  cl: 'cl',
  cm: 'cm',
  cn: 'cn',
  co: 'co',
  cr: 'cr',
  cu: 'cu',
  cv: 'cv',
  cy: 'cy',
  cz: 'cz',
  de: 'de',
  dj: 'dj',
  dk: 'dk',
  dm: 'dm',
  do: 'do',
  dz: 'dz',
  ec: 'ec',
  ee: 'ee',
  eg: 'eg',
  er: 'er',
  es: 'es',
  et: 'et',
  fi: 'fi',
  fj: 'fj',
  fm: 'fm',
  fr: 'fr',
  ga: 'ga',
  gb: 'gb',
  gd: 'gd',
  ge: 'ge',
  gh: 'gh',
  gm: 'gm',
  gn: 'gn',
  gq: 'gq',
  gr: 'gr',
  gt: 'gt',
  gw: 'gw',
  gy: 'gy',
  hk: 'hk',
  hn: 'hn',
  hr: 'hr',
  ht: 'ht',
  hu: 'hu',
  id: 'id',
  ie: 'ie',
  il: 'il',
  in: 'in',
  iq: 'iq',
  ir: 'ir',
  is: 'is',
  it: 'it',
  jm: 'jm',
  jo: 'jo',
  jp: 'jp',
  ke: 'ke',
  kg: 'kg',
  kh: 'kh',
  ki: 'ki',
  km: 'km',
  kn: 'kn',
  kp: 'kp',
  kr: 'kr',
  kw: 'kw',
  ky: 'ky',
  kz: 'kz',
  la: 'la',
  lb: 'lb',
  lc: 'lc',
  li: 'li',
  lk: 'lk',
  lr: 'lr',
  ls: 'ls',
  lt: 'lt',
  lu: 'lu',
  lv: 'lv',
  ly: 'ly',
  ma: 'ma',
  mc: 'mc',
  md: 'md',
  me: 'me',
  mg: 'mg',
  mh: 'mh',
  mk: 'mk',
  ml: 'ml',
  mm: 'mm',
  mn: 'mn',
  mr: 'mr',
  mt: 'mt',
  mu: 'mu',
  mv: 'mv',
  mw: 'mw',
  mx: 'mx',
  my: 'my',
  mz: 'mz',
  na: 'na',
  ne: 'ne',
  ng: 'ng',
  ni: 'ni',
  nl: 'nl',
  no: 'no',
  np: 'np',
  nr: 'nr',
  nu: 'nu',
  nz: 'nz',
  om: 'om',
  pa: 'pa',
  pe: 'pe',
  pg: 'pg',
  ph: 'ph',
  pk: 'pk',
  pl: 'pl',
  pr: 'pr',
  ps: 'ps',
  pt: 'pt',
  pw: 'pw',
  py: 'py',
  qa: 'qa',
  ro: 'ro',
  rs: 'rs',
  ru: 'ru',
  rw: 'rw',
  sa: 'sa',
  sb: 'sb',
  sc: 'sc',
  sd: 'sd',
  se: 'se',
  sg: 'sg',
  si: 'si',
  sk: 'sk',
  sl: 'sl',
  sm: 'sm',
  sn: 'sn',
  so: 'so',
  sr: 'sr',
  ss: 'ss',
  st: 'st',
  sv: 'sv',
  sy: 'sy',
  sz: 'sz',
  td: 'td',
  tg: 'tg',
  th: 'th',
  tj: 'tj',
  tk: 'tk',
  tl: 'tl',
  tm: 'tm',
  tn: 'tn',
  to: 'to',
  tr: 'tr',
  tt: 'tt',
  tv: 'tv',
  tw: 'tw',
  tz: 'tz',
  ua: 'ua',
  ug: 'ug',
  us: 'us',
  uy: 'uy',
  uz: 'uz',
  va: 'va',
  vc: 'vc',
  ve: 've',
  vn: 'vn',
  vu: 'vu',
  ws: 'ws',
  ye: 'ye',
  za: 'za',
  zm: 'zm',
  zw: 'zw',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataLanguagesItem = typeof ClientJsonldReadItemClientWithoutPrivateDataLanguagesItem[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataLanguagesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataLanguagesItem = {
  af_ZA: 'af_ZA',
  am_ET: 'am_ET',
  ar_AA: 'ar_AA',
  as_IN: 'as_IN',
  az_AZ: 'az_AZ',
  be_BY: 'be_BY',
  bg_BG: 'bg_BG',
  bn_BD: 'bn_BD',
  bo_IN: 'bo_IN',
  bs_BA: 'bs_BA',
  ca_ES: 'ca_ES',
  cs_CZ: 'cs_CZ',
  da_DK: 'da_DK',
  de_DE: 'de_DE',
  el_GR: 'el_GR',
  en_GB: 'en_GB',
  es_ES: 'es_ES',
  et_EE: 'et_EE',
  fi_FI: 'fi_FI',
  fr_FR: 'fr_FR',
  ga_IE: 'ga_IE',
  he_IL: 'he_IL',
  hi_IN: 'hi_IN',
  hr_BA: 'hr_BA',
  hu_HU: 'hu_HU',
  hy_AM: 'hy_AM',
  id_ID: 'id_ID',
  ig_NG: 'ig_NG',
  ii_CN: 'ii_CN',
  is_IS: 'is_IS',
  it_IT: 'it_IT',
  iu_CA: 'iu_CA',
  ja_JP: 'ja_JP',
  jv_ID: 'jv_ID',
  ka_GE: 'ka_GE',
  ki_KE: 'ki_KE',
  kk_KZ: 'kk_KZ',
  km_KH: 'km_KH',
  kn_IN: 'kn_IN',
  ko_KR: 'ko_KR',
  ks_IN: 'ks_IN',
  ku_TR: 'ku_TR',
  kw_GB: 'kw_GB',
  lb_LU: 'lb_LU',
  lg_UG: 'lg_UG',
  ln_AO: 'ln_AO',
  lo_LA: 'lo_LA',
  lt_LT: 'lt_LT',
  lu_CD: 'lu_CD',
  lv_LV: 'lv_LV',
  mg_MG: 'mg_MG',
  en_MH: 'en_MH',
  mi_NZ: 'mi_NZ',
  mk_MK: 'mk_MK',
  ml_IN: 'ml_IN',
  mn_MN: 'mn_MN',
  mr_IN: 'mr_IN',
  ms_BN: 'ms_BN',
  mt_MT: 'mt_MT',
  my_MM: 'my_MM',
  en_NR: 'en_NR',
  nb_NO: 'nb_NO',
  ne_IN: 'ne_IN',
  nl_NL: 'nl_NL',
  nn_NO: 'nn_NO',
  no_NO: 'no_NO',
  nr_ZA: 'nr_ZA',
  om_ET: 'om_ET',
  pl_PL: 'pl_PL',
  ps_PK: 'ps_PK',
  pt_PT: 'pt_PT',
  qu_PE: 'qu_PE',
  rm_CH: 'rm_CH',
  ro_RO: 'ro_RO',
  ru_RU: 'ru_RU',
  rw_RW: 'rw_RW',
  sa_IN: 'sa_IN',
  sd_PK: 'sd_PK',
  se_SE: 'se_SE',
  sg_CF: 'sg_CF',
  sk_SK: 'sk_SK',
  sl_SL: 'sl_SL',
  sn_ZW: 'sn_ZW',
  so_SO: 'so_SO',
  sq_AL: 'sq_AL',
  sr_BA: 'sr_BA',
  ss_SZ: 'ss_SZ',
  st_LS: 'st_LS',
  sv_SE: 'sv_SE',
  te_IN: 'te_IN',
  tg_TJ: 'tg_TJ',
  th_TH: 'th_TH',
  ti_ER: 'ti_ER',
  tk_TM: 'tk_TM',
  tn_BW: 'tn_BW',
  to_TO: 'to_TO',
  tr_TR: 'tr_TR',
  ts_ZA: 'ts_ZA',
  tt_RU: 'tt_RU',
  uk_UA: 'uk_UA',
  ur_PK: 'ur_PK',
  uz_UZ: 'uz_UZ',
  ve_ZA: 've_ZA',
  vi_VN: 'vi_VN',
  wo_SN: 'wo_SN',
  xh_ZA: 'xh_ZA',
  'yi-001': 'yi-001',
  yo_NG: 'yo_NG',
  zh_CN: 'zh_CN',
  zu_ZA: 'zu_ZA',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataFamilySituation = typeof ClientJsonldReadItemClientWithoutPrivateDataFamilySituation[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataFamilySituation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataFamilySituation = {
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  WIDOWED: 'WIDOWED',
  DIVORCED: 'DIVORCED',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataContactOrigin = typeof ClientJsonldReadItemClientWithoutPrivateDataContactOrigin[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataContactOrigin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataContactOrigin = {
  WEB: 'WEB',
  VISIT: 'VISIT',
  PHONE: 'PHONE',
  MAGAZINE: 'MAGAZINE',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataCivility = typeof ClientJsonldReadItemClientWithoutPrivateDataCivility[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataCivility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataCivility = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataBusinessUnit = BusinessUnitJsonldReadItemClientWithoutPrivateData | null;

export interface ClientJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: ClientJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  activity?: string | null;
  /** @nullable */
  birthPlace?: string | null;
  businessUnit?: ClientJsonldReadItemClientWithoutPrivateDataBusinessUnit;
  circles?: CircleJsonldReadItemClientWithoutPrivateData[];
  civility?: ClientJsonldReadItemClientWithoutPrivateDataCivility;
  contactOrigin?: ClientJsonldReadItemClientWithoutPrivateDataContactOrigin;
  familySituation?: ClientJsonldReadItemClientWithoutPrivateDataFamilySituation;
  /** @nullable */
  favoriteContactType?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  hasChild?: boolean | null;
  hobbies?: ClientHobbyJsonldReadItemClientWithoutPrivateData[];
  holidayLocation?: HolidayLocationJsonldReadItemClientWithoutPrivateData[];
  readonly id: string;
  /** @nullable */
  isGlobalNewsletterSubscriber?: boolean | null;
  /** @nullable */
  isMagazinSubscriber?: boolean | null;
  /** @nullable */
  isMonitored?: boolean | null;
  /** @nullable */
  isThemedNewsletterSubscriber?: boolean | null;
  languages?: ClientJsonldReadItemClientWithoutPrivateDataLanguagesItem[];
  /** @nullable */
  lastName?: string | null;
  nationality?: ClientJsonldReadItemClientWithoutPrivateDataNationality;
  profileType?: ClientJsonldReadItemClientWithoutPrivateDataProfileType;
  readonly projectStatus?: ClientJsonldReadItemClientWithoutPrivateDataProjectStatus;
  /** @nullable */
  rating?: number | null;
  referenceCurrency?: ClientJsonldReadItemClientWithoutPrivateDataReferenceCurrency;
  subscriptions?: TsubscriptionJsonldReadItemClientWithoutPrivateData[];
  user?: ClientJsonldReadItemClientWithoutPrivateDataUser;
  visibility: ClientJsonldReadItemClientWithoutPrivateDataVisibility;
}

export type ClientJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof ClientJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof ClientJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadItemClientWithoutPrivateDataContext = string | ClientJsonldReadItemClientWithoutPrivateDataContextOneOf;

export type ClientJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = typeof ClientJsonldReadCollectionTpropertyExcelExportContextOneOfHydra[keyof typeof ClientJsonldReadCollectionTpropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadCollectionTpropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadCollectionTpropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadCollectionTpropertyExcelExportContext = string | ClientJsonldReadCollectionTpropertyExcelExportContextOneOf;

export interface ClientJsonldReadCollectionTpropertyExcelExport {
  readonly '@context'?: ClientJsonldReadCollectionTpropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  emails?: string[];
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  /** @nullable */
  lastName?: string | null;
  phoneNumbers?: string[];
  updatedAt?: string;
}

export type ClientJsonldReadCollectionInterbuCivility = typeof ClientJsonldReadCollectionInterbuCivility[keyof typeof ClientJsonldReadCollectionInterbuCivility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionInterbuCivility = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export type ClientJsonldReadCollectionInterbuContextOneOfHydra = typeof ClientJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof ClientJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadCollectionInterbuContext = string | ClientJsonldReadCollectionInterbuContextOneOf;

export interface ClientJsonldReadCollectionInterbu {
  readonly '@context'?: ClientJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  civility?: ClientJsonldReadCollectionInterbuCivility;
  createdAt?: string;
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  /** @nullable */
  lastName?: string | null;
  updatedAt?: string;
}

export type ClientJsonldReadCollectionClientAccessRequestProjectStatus = typeof ClientJsonldReadCollectionClientAccessRequestProjectStatus[keyof typeof ClientJsonldReadCollectionClientAccessRequestProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientAccessRequestProjectStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export type ClientJsonldReadCollectionClientAccessRequestProfileType = typeof ClientJsonldReadCollectionClientAccessRequestProfileType[keyof typeof ClientJsonldReadCollectionClientAccessRequestProfileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientAccessRequestProfileType = {
  PRIVATE_INDIVIDUAL: 'PRIVATE_INDIVIDUAL',
  INVESTOR: 'INVESTOR',
  INSTITUTIONAL_INVESTOR: 'INSTITUTIONAL_INVESTOR',
  JOINT_OWNERSHIP: 'JOINT_OWNERSHIP',
  PROPERTY_TRADER: 'PROPERTY_TRADER',
  NOTARY: 'NOTARY',
  INTERMEDIATE: 'INTERMEDIATE',
  COUNTERPART: 'COUNTERPART',
} as const;

export type ClientJsonldReadCollectionClientAccessRequestCivility = typeof ClientJsonldReadCollectionClientAccessRequestCivility[keyof typeof ClientJsonldReadCollectionClientAccessRequestCivility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientAccessRequestCivility = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export interface ClientJsonldReadCollectionClientAccessRequest {
  readonly '@context'?: ClientJsonldReadCollectionClientAccessRequestContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  civility?: ClientJsonldReadCollectionClientAccessRequestCivility;
  createdAt?: string;
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  /** @nullable */
  lastName?: string | null;
  profileType?: ClientJsonldReadCollectionClientAccessRequestProfileType;
  readonly projectStatus?: ClientJsonldReadCollectionClientAccessRequestProjectStatus;
}

export type ClientJsonldReadCollectionClientAccessRequestContextOneOfHydra = typeof ClientJsonldReadCollectionClientAccessRequestContextOneOfHydra[keyof typeof ClientJsonldReadCollectionClientAccessRequestContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientAccessRequestContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientJsonldReadCollectionClientAccessRequestContextOneOf = {
  '@vocab': string;
  hydra: ClientJsonldReadCollectionClientAccessRequestContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientJsonldReadCollectionClientAccessRequestContext = string | ClientJsonldReadCollectionClientAccessRequestContextOneOf;

export type ClientJsonldReadCollectionClientVisibility = typeof ClientJsonldReadCollectionClientVisibility[keyof typeof ClientJsonldReadCollectionClientVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientVisibility = {
  NOT_CONFIDENTIAL: 'NOT_CONFIDENTIAL',
  CONFIDENTIAL: 'CONFIDENTIAL',
} as const;

export type ClientJsonldReadCollectionClientUser = UserJsonldReadCollectionClient | null;

export type ClientJsonldReadCollectionClientProjectStatus = typeof ClientJsonldReadCollectionClientProjectStatus[keyof typeof ClientJsonldReadCollectionClientProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientProjectStatus = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  ABANDONED: 'ABANDONED',
} as const;

export type ClientJsonldReadCollectionClientProfileType = typeof ClientJsonldReadCollectionClientProfileType[keyof typeof ClientJsonldReadCollectionClientProfileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientProfileType = {
  PRIVATE_INDIVIDUAL: 'PRIVATE_INDIVIDUAL',
  INVESTOR: 'INVESTOR',
  INSTITUTIONAL_INVESTOR: 'INSTITUTIONAL_INVESTOR',
  JOINT_OWNERSHIP: 'JOINT_OWNERSHIP',
  PROPERTY_TRADER: 'PROPERTY_TRADER',
  NOTARY: 'NOTARY',
  INTERMEDIATE: 'INTERMEDIATE',
  COUNTERPART: 'COUNTERPART',
} as const;

export type ClientJsonldReadCollectionClientCivility = typeof ClientJsonldReadCollectionClientCivility[keyof typeof ClientJsonldReadCollectionClientCivility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientJsonldReadCollectionClientCivility = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export type ClientJsonldReadCollectionClientBusinessUnit = BusinessUnitJsonldReadCollectionClient | null;

export interface ClientJsonldReadCollectionClient {
  readonly '@id'?: string;
  readonly '@type'?: string;
  businessUnit?: ClientJsonldReadCollectionClientBusinessUnit;
  civility?: ClientJsonldReadCollectionClientCivility;
  createdAt?: string;
  /** @nullable */
  firstName?: string | null;
  readonly id: string;
  /** @nullable */
  lastName?: string | null;
  profileType?: ClientJsonldReadCollectionClientProfileType;
  readonly projectStatus?: ClientJsonldReadCollectionClientProjectStatus;
  updatedAt?: string;
  user?: ClientJsonldReadCollectionClientUser;
  visibility: ClientJsonldReadCollectionClientVisibility;
}

export interface ClientLogsOutputJsonld {
  readonly '@context'?: ClientLogsOutputJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  logs?: LogJsonld[];
}

export type ClientLogsOutputJsonldContextOneOfHydra = typeof ClientLogsOutputJsonldContextOneOfHydra[keyof typeof ClientLogsOutputJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientLogsOutputJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type ClientLogsOutputJsonldContextOneOf = {
  '@vocab': string;
  hydra: ClientLogsOutputJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type ClientLogsOutputJsonldContext = string | ClientLogsOutputJsonldContextOneOf;

export interface CircleJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: CircleJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type CircleJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof CircleJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof CircleJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CircleJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CircleJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: CircleJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type CircleJsonldReadItemClientWithoutPrivateDataContext = string | CircleJsonldReadItemClientWithoutPrivateDataContextOneOf;

export type CircleJsonldReadCollectionCircleCountriesItem = typeof CircleJsonldReadCollectionCircleCountriesItem[keyof typeof CircleJsonldReadCollectionCircleCountriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CircleJsonldReadCollectionCircleCountriesItem = {
  af: 'af',
  ax: 'ax',
  al: 'al',
  dz: 'dz',
  as: 'as',
  ad: 'ad',
  ao: 'ao',
  ai: 'ai',
  aq: 'aq',
  ag: 'ag',
  ar: 'ar',
  am: 'am',
  aw: 'aw',
  au: 'au',
  at: 'at',
  az: 'az',
  bs: 'bs',
  bh: 'bh',
  bd: 'bd',
  bb: 'bb',
  by: 'by',
  be: 'be',
  bz: 'bz',
  bj: 'bj',
  bm: 'bm',
  bt: 'bt',
  bo: 'bo',
  ba: 'ba',
  bw: 'bw',
  bv: 'bv',
  br: 'br',
  io: 'io',
  vg: 'vg',
  bn: 'bn',
  bg: 'bg',
  bf: 'bf',
  bi: 'bi',
  kh: 'kh',
  cm: 'cm',
  ca: 'ca',
  cv: 'cv',
  bq: 'bq',
  ky: 'ky',
  cf: 'cf',
  td: 'td',
  cl: 'cl',
  cn: 'cn',
  cx: 'cx',
  cc: 'cc',
  co: 'co',
  km: 'km',
  ck: 'ck',
  cr: 'cr',
  ci: 'ci',
  hr: 'hr',
  cu: 'cu',
  cw: 'cw',
  cy: 'cy',
  cz: 'cz',
  cd: 'cd',
  dk: 'dk',
  dj: 'dj',
  dm: 'dm',
  do: 'do',
  ec: 'ec',
  eg: 'eg',
  sv: 'sv',
  gq: 'gq',
  er: 'er',
  ee: 'ee',
  sz: 'sz',
  et: 'et',
  fk: 'fk',
  fo: 'fo',
  fj: 'fj',
  fi: 'fi',
  fr: 'fr',
  gf: 'gf',
  pf: 'pf',
  tf: 'tf',
  ga: 'ga',
  gm: 'gm',
  ge: 'ge',
  de: 'de',
  gh: 'gh',
  gi: 'gi',
  gr: 'gr',
  gl: 'gl',
  gd: 'gd',
  gp: 'gp',
  gu: 'gu',
  gt: 'gt',
  gg: 'gg',
  gn: 'gn',
  gw: 'gw',
  gy: 'gy',
  ht: 'ht',
  hm: 'hm',
  hn: 'hn',
  hk: 'hk',
  hu: 'hu',
  is: 'is',
  in: 'in',
  id: 'id',
  ir: 'ir',
  iq: 'iq',
  ie: 'ie',
  im: 'im',
  il: 'il',
  it: 'it',
  jm: 'jm',
  jp: 'jp',
  je: 'je',
  jo: 'jo',
  kz: 'kz',
  ke: 'ke',
  ki: 'ki',
  xk: 'xk',
  kw: 'kw',
  kg: 'kg',
  la: 'la',
  lv: 'lv',
  lb: 'lb',
  ls: 'ls',
  lr: 'lr',
  ly: 'ly',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mo: 'mo',
  mg: 'mg',
  mw: 'mw',
  my: 'my',
  mv: 'mv',
  ml: 'ml',
  mt: 'mt',
  mh: 'mh',
  mq: 'mq',
  mr: 'mr',
  mu: 'mu',
  yt: 'yt',
  mx: 'mx',
  fm: 'fm',
  md: 'md',
  mc: 'mc',
  mn: 'mn',
  me: 'me',
  ms: 'ms',
  ma: 'ma',
  mz: 'mz',
  mm: 'mm',
  na: 'na',
  nr: 'nr',
  np: 'np',
  nl: 'nl',
  nc: 'nc',
  nz: 'nz',
  ni: 'ni',
  ne: 'ne',
  ng: 'ng',
  nu: 'nu',
  nf: 'nf',
  kp: 'kp',
  mk: 'mk',
  mp: 'mp',
  no: 'no',
  om: 'om',
  pk: 'pk',
  pw: 'pw',
  ps: 'ps',
  pa: 'pa',
  pg: 'pg',
  py: 'py',
  pe: 'pe',
  ph: 'ph',
  pn: 'pn',
  pl: 'pl',
  pt: 'pt',
  pr: 'pr',
  qa: 'qa',
  cg: 'cg',
  re: 're',
  ro: 'ro',
  ru: 'ru',
  rw: 'rw',
  bl: 'bl',
  sh: 'sh',
  kn: 'kn',
  lc: 'lc',
  mf: 'mf',
  pm: 'pm',
  vc: 'vc',
  ws: 'ws',
  sm: 'sm',
  st: 'st',
  sa: 'sa',
  sn: 'sn',
  rs: 'rs',
  sc: 'sc',
  sl: 'sl',
  sg: 'sg',
  sx: 'sx',
  sk: 'sk',
  si: 'si',
  sb: 'sb',
  so: 'so',
  za: 'za',
  gs: 'gs',
  kr: 'kr',
  ss: 'ss',
  es: 'es',
  lk: 'lk',
  sd: 'sd',
  sr: 'sr',
  sj: 'sj',
  se: 'se',
  ch: 'ch',
  sy: 'sy',
  tw: 'tw',
  tj: 'tj',
  tz: 'tz',
  th: 'th',
  tl: 'tl',
  tg: 'tg',
  tk: 'tk',
  to: 'to',
  tt: 'tt',
  tn: 'tn',
  tr: 'tr',
  tm: 'tm',
  tc: 'tc',
  tv: 'tv',
  ug: 'ug',
  ua: 'ua',
  ae: 'ae',
  gb: 'gb',
  us: 'us',
  um: 'um',
  vi: 'vi',
  uy: 'uy',
  uz: 'uz',
  vu: 'vu',
  va: 'va',
  ve: 've',
  vn: 'vn',
  wf: 'wf',
  eh: 'eh',
  ye: 'ye',
  zm: 'zm',
  zw: 'zw',
} as const;

export interface CircleJsonldReadCollectionCircle {
  readonly '@id'?: string;
  readonly '@type'?: string;
  countries: CircleJsonldReadCollectionCircleCountriesItem[];
  readonly id: string;
  name: string;
}

export type CircleJsonldCountriesItem = typeof CircleJsonldCountriesItem[keyof typeof CircleJsonldCountriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CircleJsonldCountriesItem = {
  af: 'af',
  ax: 'ax',
  al: 'al',
  dz: 'dz',
  as: 'as',
  ad: 'ad',
  ao: 'ao',
  ai: 'ai',
  aq: 'aq',
  ag: 'ag',
  ar: 'ar',
  am: 'am',
  aw: 'aw',
  au: 'au',
  at: 'at',
  az: 'az',
  bs: 'bs',
  bh: 'bh',
  bd: 'bd',
  bb: 'bb',
  by: 'by',
  be: 'be',
  bz: 'bz',
  bj: 'bj',
  bm: 'bm',
  bt: 'bt',
  bo: 'bo',
  ba: 'ba',
  bw: 'bw',
  bv: 'bv',
  br: 'br',
  io: 'io',
  vg: 'vg',
  bn: 'bn',
  bg: 'bg',
  bf: 'bf',
  bi: 'bi',
  kh: 'kh',
  cm: 'cm',
  ca: 'ca',
  cv: 'cv',
  bq: 'bq',
  ky: 'ky',
  cf: 'cf',
  td: 'td',
  cl: 'cl',
  cn: 'cn',
  cx: 'cx',
  cc: 'cc',
  co: 'co',
  km: 'km',
  ck: 'ck',
  cr: 'cr',
  ci: 'ci',
  hr: 'hr',
  cu: 'cu',
  cw: 'cw',
  cy: 'cy',
  cz: 'cz',
  cd: 'cd',
  dk: 'dk',
  dj: 'dj',
  dm: 'dm',
  do: 'do',
  ec: 'ec',
  eg: 'eg',
  sv: 'sv',
  gq: 'gq',
  er: 'er',
  ee: 'ee',
  sz: 'sz',
  et: 'et',
  fk: 'fk',
  fo: 'fo',
  fj: 'fj',
  fi: 'fi',
  fr: 'fr',
  gf: 'gf',
  pf: 'pf',
  tf: 'tf',
  ga: 'ga',
  gm: 'gm',
  ge: 'ge',
  de: 'de',
  gh: 'gh',
  gi: 'gi',
  gr: 'gr',
  gl: 'gl',
  gd: 'gd',
  gp: 'gp',
  gu: 'gu',
  gt: 'gt',
  gg: 'gg',
  gn: 'gn',
  gw: 'gw',
  gy: 'gy',
  ht: 'ht',
  hm: 'hm',
  hn: 'hn',
  hk: 'hk',
  hu: 'hu',
  is: 'is',
  in: 'in',
  id: 'id',
  ir: 'ir',
  iq: 'iq',
  ie: 'ie',
  im: 'im',
  il: 'il',
  it: 'it',
  jm: 'jm',
  jp: 'jp',
  je: 'je',
  jo: 'jo',
  kz: 'kz',
  ke: 'ke',
  ki: 'ki',
  xk: 'xk',
  kw: 'kw',
  kg: 'kg',
  la: 'la',
  lv: 'lv',
  lb: 'lb',
  ls: 'ls',
  lr: 'lr',
  ly: 'ly',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mo: 'mo',
  mg: 'mg',
  mw: 'mw',
  my: 'my',
  mv: 'mv',
  ml: 'ml',
  mt: 'mt',
  mh: 'mh',
  mq: 'mq',
  mr: 'mr',
  mu: 'mu',
  yt: 'yt',
  mx: 'mx',
  fm: 'fm',
  md: 'md',
  mc: 'mc',
  mn: 'mn',
  me: 'me',
  ms: 'ms',
  ma: 'ma',
  mz: 'mz',
  mm: 'mm',
  na: 'na',
  nr: 'nr',
  np: 'np',
  nl: 'nl',
  nc: 'nc',
  nz: 'nz',
  ni: 'ni',
  ne: 'ne',
  ng: 'ng',
  nu: 'nu',
  nf: 'nf',
  kp: 'kp',
  mk: 'mk',
  mp: 'mp',
  no: 'no',
  om: 'om',
  pk: 'pk',
  pw: 'pw',
  ps: 'ps',
  pa: 'pa',
  pg: 'pg',
  py: 'py',
  pe: 'pe',
  ph: 'ph',
  pn: 'pn',
  pl: 'pl',
  pt: 'pt',
  pr: 'pr',
  qa: 'qa',
  cg: 'cg',
  re: 're',
  ro: 'ro',
  ru: 'ru',
  rw: 'rw',
  bl: 'bl',
  sh: 'sh',
  kn: 'kn',
  lc: 'lc',
  mf: 'mf',
  pm: 'pm',
  vc: 'vc',
  ws: 'ws',
  sm: 'sm',
  st: 'st',
  sa: 'sa',
  sn: 'sn',
  rs: 'rs',
  sc: 'sc',
  sl: 'sl',
  sg: 'sg',
  sx: 'sx',
  sk: 'sk',
  si: 'si',
  sb: 'sb',
  so: 'so',
  za: 'za',
  gs: 'gs',
  kr: 'kr',
  ss: 'ss',
  es: 'es',
  lk: 'lk',
  sd: 'sd',
  sr: 'sr',
  sj: 'sj',
  se: 'se',
  ch: 'ch',
  sy: 'sy',
  tw: 'tw',
  tj: 'tj',
  tz: 'tz',
  th: 'th',
  tl: 'tl',
  tg: 'tg',
  tk: 'tk',
  to: 'to',
  tt: 'tt',
  tn: 'tn',
  tr: 'tr',
  tm: 'tm',
  tc: 'tc',
  tv: 'tv',
  ug: 'ug',
  ua: 'ua',
  ae: 'ae',
  gb: 'gb',
  us: 'us',
  um: 'um',
  vi: 'vi',
  uy: 'uy',
  uz: 'uz',
  vu: 'vu',
  va: 'va',
  ve: 've',
  vn: 'vn',
  wf: 'wf',
  eh: 'eh',
  ye: 'ye',
  zm: 'zm',
  zw: 'zw',
} as const;

export interface CircleJsonld {
  readonly '@context'?: CircleJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  clients?: string[];
  countries: CircleJsonldCountriesItem[];
  readonly id: string;
  name: string;
}

export type CircleJsonldContextOneOfHydra = typeof CircleJsonldContextOneOfHydra[keyof typeof CircleJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CircleJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type CircleJsonldContextOneOf = {
  '@vocab': string;
  hydra: CircleJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type CircleJsonldContext = string | CircleJsonldContextOneOf;

export interface CirclePostCircleInputJsonld {
  countries: string[];
  translations?: MandatoryTranslationsDTOJsonld;
}

export type CirclePatchCircleInputTranslations = OptionalTranslationsDTO | null;

export interface CirclePatchCircleInput {
  /** @nullable */
  countries?: string[] | null;
  translations?: CirclePatchCircleInputTranslations;
}

export type CircleCircleWithTranslationsDTOTranslations = {[key: string]: {[key: string]: string}};

export type CircleCircleWithTranslationsDTOCountriesItem = typeof CircleCircleWithTranslationsDTOCountriesItem[keyof typeof CircleCircleWithTranslationsDTOCountriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CircleCircleWithTranslationsDTOCountriesItem = {
  af: 'af',
  ax: 'ax',
  al: 'al',
  dz: 'dz',
  as: 'as',
  ad: 'ad',
  ao: 'ao',
  ai: 'ai',
  aq: 'aq',
  ag: 'ag',
  ar: 'ar',
  am: 'am',
  aw: 'aw',
  au: 'au',
  at: 'at',
  az: 'az',
  bs: 'bs',
  bh: 'bh',
  bd: 'bd',
  bb: 'bb',
  by: 'by',
  be: 'be',
  bz: 'bz',
  bj: 'bj',
  bm: 'bm',
  bt: 'bt',
  bo: 'bo',
  ba: 'ba',
  bw: 'bw',
  bv: 'bv',
  br: 'br',
  io: 'io',
  vg: 'vg',
  bn: 'bn',
  bg: 'bg',
  bf: 'bf',
  bi: 'bi',
  kh: 'kh',
  cm: 'cm',
  ca: 'ca',
  cv: 'cv',
  bq: 'bq',
  ky: 'ky',
  cf: 'cf',
  td: 'td',
  cl: 'cl',
  cn: 'cn',
  cx: 'cx',
  cc: 'cc',
  co: 'co',
  km: 'km',
  ck: 'ck',
  cr: 'cr',
  ci: 'ci',
  hr: 'hr',
  cu: 'cu',
  cw: 'cw',
  cy: 'cy',
  cz: 'cz',
  cd: 'cd',
  dk: 'dk',
  dj: 'dj',
  dm: 'dm',
  do: 'do',
  ec: 'ec',
  eg: 'eg',
  sv: 'sv',
  gq: 'gq',
  er: 'er',
  ee: 'ee',
  sz: 'sz',
  et: 'et',
  fk: 'fk',
  fo: 'fo',
  fj: 'fj',
  fi: 'fi',
  fr: 'fr',
  gf: 'gf',
  pf: 'pf',
  tf: 'tf',
  ga: 'ga',
  gm: 'gm',
  ge: 'ge',
  de: 'de',
  gh: 'gh',
  gi: 'gi',
  gr: 'gr',
  gl: 'gl',
  gd: 'gd',
  gp: 'gp',
  gu: 'gu',
  gt: 'gt',
  gg: 'gg',
  gn: 'gn',
  gw: 'gw',
  gy: 'gy',
  ht: 'ht',
  hm: 'hm',
  hn: 'hn',
  hk: 'hk',
  hu: 'hu',
  is: 'is',
  in: 'in',
  id: 'id',
  ir: 'ir',
  iq: 'iq',
  ie: 'ie',
  im: 'im',
  il: 'il',
  it: 'it',
  jm: 'jm',
  jp: 'jp',
  je: 'je',
  jo: 'jo',
  kz: 'kz',
  ke: 'ke',
  ki: 'ki',
  xk: 'xk',
  kw: 'kw',
  kg: 'kg',
  la: 'la',
  lv: 'lv',
  lb: 'lb',
  ls: 'ls',
  lr: 'lr',
  ly: 'ly',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mo: 'mo',
  mg: 'mg',
  mw: 'mw',
  my: 'my',
  mv: 'mv',
  ml: 'ml',
  mt: 'mt',
  mh: 'mh',
  mq: 'mq',
  mr: 'mr',
  mu: 'mu',
  yt: 'yt',
  mx: 'mx',
  fm: 'fm',
  md: 'md',
  mc: 'mc',
  mn: 'mn',
  me: 'me',
  ms: 'ms',
  ma: 'ma',
  mz: 'mz',
  mm: 'mm',
  na: 'na',
  nr: 'nr',
  np: 'np',
  nl: 'nl',
  nc: 'nc',
  nz: 'nz',
  ni: 'ni',
  ne: 'ne',
  ng: 'ng',
  nu: 'nu',
  nf: 'nf',
  kp: 'kp',
  mk: 'mk',
  mp: 'mp',
  no: 'no',
  om: 'om',
  pk: 'pk',
  pw: 'pw',
  ps: 'ps',
  pa: 'pa',
  pg: 'pg',
  py: 'py',
  pe: 'pe',
  ph: 'ph',
  pn: 'pn',
  pl: 'pl',
  pt: 'pt',
  pr: 'pr',
  qa: 'qa',
  cg: 'cg',
  re: 're',
  ro: 'ro',
  ru: 'ru',
  rw: 'rw',
  bl: 'bl',
  sh: 'sh',
  kn: 'kn',
  lc: 'lc',
  mf: 'mf',
  pm: 'pm',
  vc: 'vc',
  ws: 'ws',
  sm: 'sm',
  st: 'st',
  sa: 'sa',
  sn: 'sn',
  rs: 'rs',
  sc: 'sc',
  sl: 'sl',
  sg: 'sg',
  sx: 'sx',
  sk: 'sk',
  si: 'si',
  sb: 'sb',
  so: 'so',
  za: 'za',
  gs: 'gs',
  kr: 'kr',
  ss: 'ss',
  es: 'es',
  lk: 'lk',
  sd: 'sd',
  sr: 'sr',
  sj: 'sj',
  se: 'se',
  ch: 'ch',
  sy: 'sy',
  tw: 'tw',
  tj: 'tj',
  tz: 'tz',
  th: 'th',
  tl: 'tl',
  tg: 'tg',
  tk: 'tk',
  to: 'to',
  tt: 'tt',
  tn: 'tn',
  tr: 'tr',
  tm: 'tm',
  tc: 'tc',
  tv: 'tv',
  ug: 'ug',
  ua: 'ua',
  ae: 'ae',
  gb: 'gb',
  us: 'us',
  um: 'um',
  vi: 'vi',
  uy: 'uy',
  uz: 'uz',
  vu: 'vu',
  va: 'va',
  ve: 've',
  vn: 'vn',
  wf: 'wf',
  eh: 'eh',
  ye: 'ye',
  zm: 'zm',
  zw: 'zw',
} as const;

export interface CircleCircleWithTranslationsDTO {
  countries: CircleCircleWithTranslationsDTOCountriesItem[];
  translations: CircleCircleWithTranslationsDTOTranslations;
}

export type BusinessUnitJsonldUserReadItemContextOneOfHydra = typeof BusinessUnitJsonldUserReadItemContextOneOfHydra[keyof typeof BusinessUnitJsonldUserReadItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldUserReadItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldUserReadItemContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldUserReadItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldUserReadItemContext = string | BusinessUnitJsonldUserReadItemContextOneOf;

export interface BusinessUnitJsonldUserReadItem {
  readonly '@context'?: BusinessUnitJsonldUserReadItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export type BusinessUnitJsonldUserReadCollectionContextOneOfHydra = typeof BusinessUnitJsonldUserReadCollectionContextOneOfHydra[keyof typeof BusinessUnitJsonldUserReadCollectionContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldUserReadCollectionContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldUserReadCollectionContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldUserReadCollectionContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldUserReadCollectionContext = string | BusinessUnitJsonldUserReadCollectionContextOneOf;

export interface BusinessUnitJsonldUserReadCollection {
  readonly '@context'?: BusinessUnitJsonldUserReadCollectionContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export interface BusinessUnitJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
}

export type BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContext = string | BusinessUnitJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export interface BusinessUnitJsonldReadItemInterbu {
  readonly '@context'?: BusinessUnitJsonldReadItemInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export type BusinessUnitJsonldReadItemInterbuContextOneOfHydra = typeof BusinessUnitJsonldReadItemInterbuContextOneOfHydra[keyof typeof BusinessUnitJsonldReadItemInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadItemInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadItemInterbuContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadItemInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadItemInterbuContext = string | BusinessUnitJsonldReadItemInterbuContextOneOf;

export interface BusinessUnitJsonldReadItemClientWithoutPrivateData {
  readonly '@context'?: BusinessUnitJsonldReadItemClientWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = typeof BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOfHydra[keyof typeof BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadItemClientWithoutPrivateDataContext = string | BusinessUnitJsonldReadItemClientWithoutPrivateDataContextOneOf;

export type BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContext = string | BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf;

export interface BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateData {
  readonly '@context'?: BusinessUnitJsonldReadCollectionTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
}

export type BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadCollectionTpropertyExcelExportContext = string | BusinessUnitJsonldReadCollectionTpropertyExcelExportContextOneOf;

export interface BusinessUnitJsonldReadCollectionTpropertyExcelExport {
  readonly '@context'?: BusinessUnitJsonldReadCollectionTpropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export interface BusinessUnitJsonldReadCollectionProject {
  readonly '@context'?: BusinessUnitJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export type BusinessUnitJsonldReadCollectionProjectContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionProjectContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadCollectionProjectContext = string | BusinessUnitJsonldReadCollectionProjectContextOneOf;

export interface BusinessUnitJsonldReadCollectionNames {
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
  name: string;
}

export type BusinessUnitJsonldReadCollectionInterbuContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionInterbuContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionInterbuContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionInterbuContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionInterbuContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionInterbuContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadCollectionInterbuContext = string | BusinessUnitJsonldReadCollectionInterbuContextOneOf;

export interface BusinessUnitJsonldReadCollectionInterbu {
  readonly '@context'?: BusinessUnitJsonldReadCollectionInterbuContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export type BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOfHydra;
  [key: string]: unknown;
 };

export type BusinessUnitJsonldReadCollectionClientAccessRequestContext = string | BusinessUnitJsonldReadCollectionClientAccessRequestContextOneOf;

export interface BusinessUnitJsonldReadCollectionClientAccessRequest {
  readonly '@context'?: BusinessUnitJsonldReadCollectionClientAccessRequestContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
}

export type BusinessUnitJsonldReadCollectionClientContext = string | BusinessUnitJsonldReadCollectionClientContextOneOf;

export interface BusinessUnitJsonldReadCollectionClient {
  readonly '@context'?: BusinessUnitJsonldReadCollectionClientContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name: string;
  updatedAt?: string;
}

export type BusinessUnitJsonldReadCollectionClientContextOneOfHydra = typeof BusinessUnitJsonldReadCollectionClientContextOneOfHydra[keyof typeof BusinessUnitJsonldReadCollectionClientContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitJsonldReadCollectionClientContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type BusinessUnitJsonldReadCollectionClientContextOneOf = {
  '@vocab': string;
  hydra: BusinessUnitJsonldReadCollectionClientContextOneOfHydra;
  [key: string]: unknown;
 };

export interface BrevoNewsletterJsonld {
  readonly '@id'?: string;
  readonly '@type'?: string;
  id?: number;
  imageLink?: string;
  name?: string;
  sentDate?: string;
  shareLink?: string;
  subject?: string;
  type?: string;
}

export interface AgencySocietyDTOJsonld {
  agency?: string;
  agencyOwner?: string;
  id?: string;
}

export interface AgencyOwnerLegalsJsonldReadItemSocietyItem {
  readonly '@context'?: AgencyOwnerLegalsJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOfHydra = typeof AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyOwnerLegalsJsonldReadItemSocietyItemContext = string | AgencyOwnerLegalsJsonldReadItemSocietyItemContextOneOf;

export interface AgencyOwnerLegalsJsonld {
  readonly '@context'?: AgencyOwnerLegalsJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agencyOwner?: RelAgencyOwnerLegalJsonld[];
  /** @nullable */
  amount?: number | null;
  amountCurrency?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  /** @nullable */
  type?: string | null;
  updatedAt?: string;
  /** @nullable */
  value?: string | null;
}

export type AgencyOwnerLegalsJsonldContextOneOfHydra = typeof AgencyOwnerLegalsJsonldContextOneOfHydra[keyof typeof AgencyOwnerLegalsJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyOwnerLegalsJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyOwnerLegalsJsonldContextOneOf = {
  '@vocab': string;
  hydra: AgencyOwnerLegalsJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyOwnerLegalsJsonldContext = string | AgencyOwnerLegalsJsonldContextOneOf;

export type AgencyMediaJsonldReadItemSocietyItemContextOneOfHydra = typeof AgencyMediaJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof AgencyMediaJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldReadItemSocietyItemContext = string | AgencyMediaJsonldReadItemSocietyItemContextOneOf;

export interface AgencyMediaJsonldReadItemSocietyItem {
  readonly '@context'?: AgencyMediaJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type AgencyMediaJsonldReadItemCollaboratorItemContextOneOfHydra = typeof AgencyMediaJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof AgencyMediaJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldReadItemCollaboratorItemContext = string | AgencyMediaJsonldReadItemCollaboratorItemContextOneOf;

export interface AgencyMediaJsonldReadItemCollaboratorItem {
  readonly '@context'?: AgencyMediaJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export interface AgencyMediaJsonldReadItemClusterItem {
  readonly '@context'?: AgencyMediaJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  readonly id: string;
}

export type AgencyMediaJsonldReadItemClusterItemContextOneOfHydra = typeof AgencyMediaJsonldReadItemClusterItemContextOneOfHydra[keyof typeof AgencyMediaJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldReadItemClusterItemContext = string | AgencyMediaJsonldReadItemClusterItemContextOneOf;

export type AgencyMediaJsonldReadItemAgencyItemUsage = RefLabelJsonldReadItemAgencyItem | null;

export interface AgencyMediaJsonldReadItemAgencyItem {
  readonly '@context'?: AgencyMediaJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: AgencyJsonldReadItemAgencyItem;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadItemAgencyItem;
  /** @nullable */
  order?: number | null;
  usage?: AgencyMediaJsonldReadItemAgencyItemUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type AgencyMediaJsonldReadItemAgencyItemContextOneOfHydra = typeof AgencyMediaJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof AgencyMediaJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldReadItemAgencyItemContext = string | AgencyMediaJsonldReadItemAgencyItemContextOneOf;

export type AgencyMediaJsonldReadCollectionAgencyUsage = RefLabelJsonldReadCollectionAgency | null;

export interface AgencyMediaJsonldReadCollectionAgency {
  readonly '@context'?: AgencyMediaJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: AgencyJsonldReadCollectionAgency;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: MediaJsonldReadCollectionAgency;
  /** @nullable */
  order?: number | null;
  usage?: AgencyMediaJsonldReadCollectionAgencyUsage;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export type AgencyMediaJsonldReadCollectionAgencyContextOneOfHydra = typeof AgencyMediaJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof AgencyMediaJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldReadCollectionAgencyContext = string | AgencyMediaJsonldReadCollectionAgencyContextOneOf;

export type AgencyMediaJsonldContextOneOfHydra = typeof AgencyMediaJsonldContextOneOfHydra[keyof typeof AgencyMediaJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyMediaJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyMediaJsonldContextOneOf = {
  '@vocab': string;
  hydra: AgencyMediaJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyMediaJsonldContext = string | AgencyMediaJsonldContextOneOf;

export interface AgencyMediaJsonld {
  readonly '@context'?: AgencyMediaJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  agency?: string;
  readonly id: string;
  /** @nullable */
  isDefault?: boolean | null;
  media?: string;
  /** @nullable */
  order?: number | null;
  /** @nullable */
  usage?: string | null;
  /**
   * The media usage code
   * @nullable
   */
  usageCode?: string | null;
}

export interface AgencyClusterDTOJsonld {
  agency?: string;
  cluster?: string;
  id?: string;
  isDefault?: boolean;
}

export type AgencyJsonldReadItemSocietyItemStatus = RefLabelJsonldReadItemSocietyItem | null;

export type AgencyJsonldReadItemSocietyItemContextOneOfHydra = typeof AgencyJsonldReadItemSocietyItemContextOneOfHydra[keyof typeof AgencyJsonldReadItemSocietyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadItemSocietyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadItemSocietyItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadItemSocietyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadItemSocietyItemContext = string | AgencyJsonldReadItemSocietyItemContextOneOf;

export interface AgencyJsonldReadItemSocietyItem {
  readonly '@context'?: AgencyJsonldReadItemSocietyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  cluster?: RelAgencyClusterJsonldReadItemSocietyItem[];
  collaborator?: RelCollaboratorAgencyJsonldReadItemSocietyItem[];
  contactDetails?: RelAgencyContactDetailsJsonldReadItemSocietyItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonldReadItemSocietyItem[];
  name?: string;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadItemSocietyItemStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadItemCollaboratorItemStatus = RefLabelJsonldReadItemCollaboratorItem | null;

export interface AgencyJsonldReadItemCollaboratorItem {
  readonly '@context'?: AgencyJsonldReadItemCollaboratorItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonldReadItemCollaboratorItem[];
  agencyOwner?: RelAgencySocietyJsonldReadItemCollaboratorItem[];
  cluster?: RelAgencyClusterJsonldReadItemCollaboratorItem[];
  contactDetails?: RelAgencyContactDetailsJsonldReadItemCollaboratorItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonldReadItemCollaboratorItem[];
  name?: string;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadItemCollaboratorItemStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadItemCollaboratorItemContextOneOfHydra = typeof AgencyJsonldReadItemCollaboratorItemContextOneOfHydra[keyof typeof AgencyJsonldReadItemCollaboratorItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadItemCollaboratorItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadItemCollaboratorItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadItemCollaboratorItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadItemCollaboratorItemContext = string | AgencyJsonldReadItemCollaboratorItemContextOneOf;

export type AgencyJsonldReadItemClusterItemStatus = RefLabelJsonldReadItemClusterItem | null;

export interface AgencyJsonldReadItemClusterItem {
  readonly '@context'?: AgencyJsonldReadItemClusterItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  collaborator?: RelCollaboratorAgencyJsonldReadItemClusterItem[];
  contactDetails?: RelAgencyContactDetailsJsonldReadItemClusterItem[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonldReadItemClusterItem[];
  name?: string;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadItemClusterItemStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadItemClusterItemContextOneOfHydra = typeof AgencyJsonldReadItemClusterItemContextOneOfHydra[keyof typeof AgencyJsonldReadItemClusterItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadItemClusterItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadItemClusterItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadItemClusterItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadItemClusterItemContext = string | AgencyJsonldReadItemClusterItemContextOneOf;

export type AgencyJsonldReadItemAgencyItemStatus = RefLabelJsonldReadItemAgencyItem | null;

export type AgencyJsonldReadItemAgencyItemContextOneOfHydra = typeof AgencyJsonldReadItemAgencyItemContextOneOfHydra[keyof typeof AgencyJsonldReadItemAgencyItemContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadItemAgencyItemContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadItemAgencyItemContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadItemAgencyItemContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadItemAgencyItemContext = string | AgencyJsonldReadItemAgencyItemContextOneOf;

export interface AgencyJsonldReadItemAgencyItem {
  readonly '@context'?: AgencyJsonldReadItemAgencyItemContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonldReadItemAgencyItem[];
  agencyOwner?: RelAgencySocietyJsonldReadItemAgencyItem[];
  cluster?: RelAgencyClusterJsonldReadItemAgencyItem[];
  collaborator?: RelCollaboratorAgencyJsonldReadItemAgencyItem[];
  contactDetails?: RelAgencyContactDetailsJsonldReadItemAgencyItem[];
  createdAt?: string;
  i18nText?: RelAgencyI18nTextJsonldReadItemAgencyItem[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonldReadItemAgencyItem[];
  name?: string;
  nbAgencyOwner?: number;
  nbCluster?: number;
  nbCollaborator?: number;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadItemAgencyItemStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = typeof AgencyJsonldReadCollectionSocietyExcelExportContextOneOfHydra[keyof typeof AgencyJsonldReadCollectionSocietyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadCollectionSocietyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadCollectionSocietyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadCollectionSocietyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadCollectionSocietyExcelExportContext = string | AgencyJsonldReadCollectionSocietyExcelExportContextOneOf;

export interface AgencyJsonldReadCollectionSocietyExcelExport {
  readonly '@context'?: AgencyJsonldReadCollectionSocietyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type AgencyJsonldReadCollectionCollaboratorExcelExportStatus = RefLabelJsonldReadCollectionCollaboratorExcelExport | null;

export interface AgencyJsonldReadCollectionCollaboratorExcelExport {
  readonly '@context'?: AgencyJsonldReadCollectionCollaboratorExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonldReadCollectionCollaboratorExcelExport[];
  agencyOwner?: RelAgencySocietyJsonldReadCollectionCollaboratorExcelExport[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  name?: string;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadCollectionCollaboratorExcelExportStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = typeof AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra[keyof typeof AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadCollectionCollaboratorExcelExportContext = string | AgencyJsonldReadCollectionCollaboratorExcelExportContextOneOf;

export type AgencyJsonldReadCollectionClusterExcelExportContextOneOfHydra = typeof AgencyJsonldReadCollectionClusterExcelExportContextOneOfHydra[keyof typeof AgencyJsonldReadCollectionClusterExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadCollectionClusterExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadCollectionClusterExcelExportContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadCollectionClusterExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadCollectionClusterExcelExportContext = string | AgencyJsonldReadCollectionClusterExcelExportContextOneOf;

export interface AgencyJsonldReadCollectionClusterExcelExport {
  readonly '@context'?: AgencyJsonldReadCollectionClusterExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  createdAt?: string;
  readonly id: string;
  name?: string;
  updatedAt?: string;
}

export type AgencyJsonldReadCollectionAgencyExcelExportStatus = RefLabelJsonldReadCollectionAgencyExcelExport | null;

export interface AgencyJsonldReadCollectionAgencyExcelExport {
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonldReadCollectionAgencyExcelExport[];
  agencyOwner?: RelAgencySocietyJsonldReadCollectionAgencyExcelExport[];
  cluster?: RelAgencyClusterJsonldReadCollectionAgencyExcelExport[];
  contactDetails?: RelAgencyContactDetailsJsonldReadCollectionAgencyExcelExport[];
  createdAt?: string;
  i18nText?: RelAgencyI18nTextJsonldReadCollectionAgencyExcelExport[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  name?: string;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadCollectionAgencyExcelExportStatus;
  updatedAt?: string;
}

export type AgencyJsonldReadCollectionAgencyStatus = RefLabelJsonldReadCollectionAgency | null;

export type AgencyJsonldReadCollectionAgencyContextOneOfHydra = typeof AgencyJsonldReadCollectionAgencyContextOneOfHydra[keyof typeof AgencyJsonldReadCollectionAgencyContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldReadCollectionAgencyContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldReadCollectionAgencyContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldReadCollectionAgencyContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldReadCollectionAgencyContext = string | AgencyJsonldReadCollectionAgencyContextOneOf;

export interface AgencyJsonldReadCollectionAgency {
  readonly '@context'?: AgencyJsonldReadCollectionAgencyContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonldReadCollectionAgency[];
  contactDetails?: RelAgencyContactDetailsJsonldReadCollectionAgency[];
  createdAt?: string;
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonldReadCollectionAgency[];
  name?: string;
  nbAgencyOwner?: number;
  nbCluster?: number;
  nbCollaborator?: number;
  /** @nullable */
  officialName?: string | null;
  status?: AgencyJsonldReadCollectionAgencyStatus;
  updatedAt?: string;
}

export type AgencyJsonldContextOneOfHydra = typeof AgencyJsonldContextOneOfHydra[keyof typeof AgencyJsonldContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyJsonldContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AgencyJsonldContextOneOf = {
  '@vocab': string;
  hydra: AgencyJsonldContextOneOfHydra;
  [key: string]: unknown;
 };

export type AgencyJsonldContext = string | AgencyJsonldContextOneOf;

export interface AgencyJsonld {
  readonly '@context'?: AgencyJsonldContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  accessLevel?: number | null;
  accessLevelForced?: boolean;
  /** @nullable */
  accessLevelMin?: number | null;
  activities?: RelAgencyActivityJsonld[];
  agencyOwner?: RelAgencySocietyJsonld[];
  cluster?: RelAgencyClusterJsonld[];
  collaborator?: RelCollaboratorAgencyJsonld[];
  contactDetails?: RelAgencyContactDetailsJsonld[];
  createdAt?: string;
  i18nText?: RelAgencyI18nTextJsonld[];
  readonly id: string;
  /** @nullable */
  internalSource?: string | null;
  /** @nullable */
  legal?: string | null;
  media?: AgencyMediaJsonld[];
  name?: string;
  nbAgencyOwner?: number;
  nbCluster?: number;
  nbCollaborator?: number;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
}

export interface AgencyPostAgencyInputJsonld {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  activities?: string[] | null;
  /** @nullable */
  agencyOwner?: AgencySocietyDTOJsonld[] | null;
  /** @nullable */
  cluster?: AgencyClusterDTOJsonld[] | null;
  /** @nullable */
  collaborator?: CollaboratorAgencyDTOJsonld[] | null;
  /** @nullable */
  contactDetails?: ContactDetailsDTOJsonld[] | null;
  /** @nullable */
  legal?: string | null;
  name: string;
  /** @nullable */
  officialName?: string | null;
  status?: string;
}

export interface AgencyPatchEntityMediaInput {
  datas?: EntityMediaDTO[];
}

export interface AgencyPatchAgencyInput {
  /** @nullable */
  accessLevel?: string | null;
  /** @nullable */
  accessLevelForced?: string | null;
  /** @nullable */
  activities?: string[] | null;
  /** @nullable */
  agencyOwner?: PatchAgencySocietyDTO[] | null;
  /** @nullable */
  cluster?: PatchAgencyClusterDTO[] | null;
  /** @nullable */
  collaborator?: PatchCollaboratorAgencyDTO[] | null;
  /** @nullable */
  contactDetails?: PatchContactDetailsDTO[] | null;
  /** @nullable */
  legal?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  officialName?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface AddressJsonldReadItemTpropertyWithoutPrivateData {
  readonly '@context'?: AddressJsonldReadItemTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  city?: string | null;
  createdAt?: string;
  readonly id: string;
}

export type AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = typeof AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type AddressJsonldReadItemTpropertyWithoutPrivateDataContext = string | AddressJsonldReadItemTpropertyWithoutPrivateDataContextOneOf;

export type AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = typeof AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra[keyof typeof AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf = {
  '@vocab': string;
  hydra: AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOfHydra;
  [key: string]: unknown;
 };

export type AddressJsonldReadCollectionTpropertyWithoutPrivateDataContext = string | AddressJsonldReadCollectionTpropertyWithoutPrivateDataContextOneOf;

export interface AddressJsonldReadCollectionTpropertyWithoutPrivateData {
  readonly '@context'?: AddressJsonldReadCollectionTpropertyWithoutPrivateDataContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  city?: string | null;
  createdAt?: string;
  readonly id: string;
}

export interface AddressJsonldReadCollectionTpropertyExcelExport {
  readonly '@context'?: AddressJsonldReadCollectionTpropertyExcelExportContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  addressLine1?: string | null;
  /** @nullable */
  addressLine2?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}

export type AddressJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = typeof AddressJsonldReadCollectionTpropertyExcelExportContextOneOfHydra[keyof typeof AddressJsonldReadCollectionTpropertyExcelExportContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressJsonldReadCollectionTpropertyExcelExportContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AddressJsonldReadCollectionTpropertyExcelExportContextOneOf = {
  '@vocab': string;
  hydra: AddressJsonldReadCollectionTpropertyExcelExportContextOneOfHydra;
  [key: string]: unknown;
 };

export type AddressJsonldReadCollectionTpropertyExcelExportContext = string | AddressJsonldReadCollectionTpropertyExcelExportContextOneOf;

export type AddressJsonldReadCollectionProjectContextOneOfHydra = typeof AddressJsonldReadCollectionProjectContextOneOfHydra[keyof typeof AddressJsonldReadCollectionProjectContextOneOfHydra];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressJsonldReadCollectionProjectContextOneOfHydra = {
  'http://wwww3org/ns/hydra/core#': 'http://www.w3.org/ns/hydra/core#',
} as const;

export type AddressJsonldReadCollectionProjectContextOneOf = {
  '@vocab': string;
  hydra: AddressJsonldReadCollectionProjectContextOneOfHydra;
  [key: string]: unknown;
 };

export type AddressJsonldReadCollectionProjectContext = string | AddressJsonldReadCollectionProjectContextOneOf;

export interface AddressJsonldReadCollectionProject {
  readonly '@context'?: AddressJsonldReadCollectionProjectContext;
  readonly '@id'?: string;
  readonly '@type'?: string;
  /** @nullable */
  city?: string | null;
  createdAt?: string;
  readonly id: string;
  updatedAt?: string;
}




type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Download a media file using a token
 */
export const downloadMedia = (
    key: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<Blob>(
      {url: `/api/medias/download/${key}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getDownloadMediaQueryKey = (key: string,) => {
    return [`/api/medias/download/${key}`] as const;
    }

    
export const getDownloadMediaQueryOptions = <TData = Awaited<ReturnType<typeof downloadMedia>>, TError = DownloadMedia400 | DownloadMedia401>(key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadMedia>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadMediaQueryKey(key);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadMedia>>> = ({ signal }) => downloadMedia(key, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(key), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadMediaQueryResult = NonNullable<Awaited<ReturnType<typeof downloadMedia>>>
export type DownloadMediaQueryError = DownloadMedia400 | DownloadMedia401

/**
 * @summary Download a media file using a token
 */
export const useDownloadMedia = <TData = Awaited<ReturnType<typeof downloadMedia>>, TError = DownloadMedia400 | DownloadMedia401>(
 key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadMedia>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDownloadMediaQueryOptions(key,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Agency resources.
 * @summary Retrieves the collection of Agency resources.
 */
export const getAgencies = (
    params?: GetAgenciesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetAgencies200>(
      {url: `/api/agencies`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAgenciesQueryKey = (params?: GetAgenciesParams,) => {
    return [`/api/agencies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAgenciesQueryOptions = <TData = Awaited<ReturnType<typeof getAgencies>>, TError = void>(params?: GetAgenciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencies>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgenciesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencies>>> = ({ signal }) => getAgencies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgenciesQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencies>>>
export type GetAgenciesQueryError = void

/**
 * @summary Retrieves the collection of Agency resources.
 */
export const useGetAgencies = <TData = Awaited<ReturnType<typeof getAgencies>>, TError = void>(
 params?: GetAgenciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencies>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAgenciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Agency resource.
 * @summary Creates a Agency resource.
 */
export const postAgency = (
    agencyPostAgencyInputJsonld: AgencyPostAgencyInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/agencies`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: agencyPostAgencyInputJsonld
    },
      options);
    }
  


export const getPostAgencyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgency>>, TError,{data: AgencyPostAgencyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postAgency>>, TError,{data: AgencyPostAgencyInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAgency>>, {data: AgencyPostAgencyInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postAgency(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof postAgency>>>
    export type PostAgencyMutationBody = AgencyPostAgencyInputJsonld
    export type PostAgencyMutationError = void

    /**
 * @summary Creates a Agency resource.
 */
export const usePostAgency = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgency>>, TError,{data: AgencyPostAgencyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAgency>>,
        TError,
        {data: AgencyPostAgencyInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostAgencyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of Agency resources.
 * @summary Retrieves the collection of Agency resources.
 */
export const getAgenciesExcelExportData = (
    params?: GetAgenciesExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetAgenciesExcelExportData200>(
      {url: `/api/agencies/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAgenciesExcelExportDataQueryKey = (params?: GetAgenciesExcelExportDataParams,) => {
    return [`/api/agencies/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAgenciesExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getAgenciesExcelExportData>>, TError = void>(params?: GetAgenciesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgenciesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgenciesExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgenciesExcelExportData>>> = ({ signal }) => getAgenciesExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgenciesExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgenciesExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAgenciesExcelExportData>>>
export type GetAgenciesExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Agency resources.
 */
export const useGetAgenciesExcelExportData = <TData = Awaited<ReturnType<typeof getAgenciesExcelExportData>>, TError = void>(
 params?: GetAgenciesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgenciesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAgenciesExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the Agency resource.
 * @summary Removes the Agency resource.
 */
export const deleteAgency = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/agencies/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAgencyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgency>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgency>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgency>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAgency(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgency>>>
    
    export type DeleteAgencyMutationError = void

    /**
 * @summary Removes the Agency resource.
 */
export const useDeleteAgency = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgency>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgency>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAgencyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Agency resource.
 * @summary Updates the Agency resource.
 */
export const patchAgency = (
    id: string,
    agencyPatchAgencyInput: AgencyPatchAgencyInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/agencies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: agencyPatchAgencyInput
    },
      options);
    }
  


export const getPatchAgencyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAgency>>, TError,{id: string;data: AgencyPatchAgencyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAgency>>, TError,{id: string;data: AgencyPatchAgencyInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAgency>>, {id: string;data: AgencyPatchAgencyInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAgency(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof patchAgency>>>
    export type PatchAgencyMutationBody = AgencyPatchAgencyInput
    export type PatchAgencyMutationError = void

    /**
 * @summary Updates the Agency resource.
 */
export const usePatchAgency = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAgency>>, TError,{id: string;data: AgencyPatchAgencyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchAgency>>,
        TError,
        {id: string;data: AgencyPatchAgencyInput},
        TContext
      > => {

      const mutationOptions = getPatchAgencyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Agency resource.
 * @summary Creates a Agency resource.
 */
export const postAgencyMedia = (
    id: string,
    postAgencyMediaBody?: PostAgencyMediaBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(postAgencyMediaBody)
      return customMutator<unknown>(
      {url: `/api/agencies/${id}/medias`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostAgencyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgencyMedia>>, TError,{id: string;data: PostAgencyMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postAgencyMedia>>, TError,{id: string;data: PostAgencyMediaBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAgencyMedia>>, {id: string;data: PostAgencyMediaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postAgencyMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAgencyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postAgencyMedia>>>
    export type PostAgencyMediaMutationBody = PostAgencyMediaBody
    export type PostAgencyMediaMutationError = void

    /**
 * @summary Creates a Agency resource.
 */
export const usePostAgencyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgencyMedia>>, TError,{id: string;data: PostAgencyMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAgencyMedia>>,
        TError,
        {id: string;data: PostAgencyMediaBody},
        TContext
      > => {

      const mutationOptions = getPostAgencyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Agency resource.
 * @summary Updates the Agency resource.
 */
export const patchAgencyMedia = (
    id: string,
    agencyPatchEntityMediaInput: AgencyPatchEntityMediaInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/agencies/${id}/medias`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: agencyPatchEntityMediaInput
    },
      options);
    }
  


export const getPatchAgencyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAgencyMedia>>, TError,{id: string;data: AgencyPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAgencyMedia>>, TError,{id: string;data: AgencyPatchEntityMediaInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAgencyMedia>>, {id: string;data: AgencyPatchEntityMediaInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAgencyMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAgencyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof patchAgencyMedia>>>
    export type PatchAgencyMediaMutationBody = AgencyPatchEntityMediaInput
    export type PatchAgencyMediaMutationError = void

    /**
 * @summary Updates the Agency resource.
 */
export const usePatchAgencyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAgencyMedia>>, TError,{id: string;data: AgencyPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchAgencyMedia>>,
        TError,
        {id: string;data: AgencyPatchEntityMediaInput},
        TContext
      > => {

      const mutationOptions = getPatchAgencyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Agency resource.
 * @summary Removes the Agency resource.
 */
export const deleteAgencyMedia = (
    id: string,
    mediaId: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/agencies/${id}/medias/${mediaId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAgencyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyMedia>>, TError,{id: string;mediaId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgencyMedia>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteAgencyMedia(id,mediaId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgencyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgencyMedia>>>
    
    export type DeleteAgencyMediaMutationError = void

    /**
 * @summary Removes the Agency resource.
 */
export const useDeleteAgencyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgencyMedia>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAgencyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Agency resource.
 * @summary Retrieves a Agency resource.
 */
export const getAgency = (
    id: string,
    params?: GetAgencyParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<AgencyJsonldReadItemAgencyItem>(
      {url: `/api/agency/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAgencyQueryKey = (id: string,
    params?: GetAgencyParams,) => {
    return [`/api/agency/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAgencyQueryOptions = <TData = Awaited<ReturnType<typeof getAgency>>, TError = void>(id: string,
    params?: GetAgencyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgency>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgency>>> = ({ signal }) => getAgency(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgency>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyQueryResult = NonNullable<Awaited<ReturnType<typeof getAgency>>>
export type GetAgencyQueryError = void

/**
 * @summary Retrieves a Agency resource.
 */
export const useGetAgency = <TData = Awaited<ReturnType<typeof getAgency>>, TError = void>(
 id: string,
    params?: GetAgencyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgency>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAgencyQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of BrevoNewsletter resources.
 * @summary Retrieves the collection of BrevoNewsletter resources.
 */
export const getBrevoNewslettersTop3 = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetBrevoNewslettersTop3200>(
      {url: `/api/brevo/newsletters/top3`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBrevoNewslettersTop3QueryKey = () => {
    return [`/api/brevo/newsletters/top3`] as const;
    }

    
export const getGetBrevoNewslettersTop3QueryOptions = <TData = Awaited<ReturnType<typeof getBrevoNewslettersTop3>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrevoNewslettersTop3>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrevoNewslettersTop3QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrevoNewslettersTop3>>> = ({ signal }) => getBrevoNewslettersTop3(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrevoNewslettersTop3>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrevoNewslettersTop3QueryResult = NonNullable<Awaited<ReturnType<typeof getBrevoNewslettersTop3>>>
export type GetBrevoNewslettersTop3QueryError = void

/**
 * @summary Retrieves the collection of BrevoNewsletter resources.
 */
export const useGetBrevoNewslettersTop3 = <TData = Awaited<ReturnType<typeof getBrevoNewslettersTop3>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrevoNewslettersTop3>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBrevoNewslettersTop3QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of BusinessUnit resources.
 * @summary Retrieves the collection of BusinessUnit resources.
 */
export const getBusinessUnitNames = (
    params?: GetBusinessUnitNamesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetBusinessUnitNames200>(
      {url: `/api/business-units/names`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBusinessUnitNamesQueryKey = (params?: GetBusinessUnitNamesParams,) => {
    return [`/api/business-units/names`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessUnitNamesQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessUnitNames>>, TError = void>(params?: GetBusinessUnitNamesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitNames>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessUnitNamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessUnitNames>>> = ({ signal }) => getBusinessUnitNames(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitNames>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBusinessUnitNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessUnitNames>>>
export type GetBusinessUnitNamesQueryError = void

/**
 * @summary Retrieves the collection of BusinessUnit resources.
 */
export const useGetBusinessUnitNames = <TData = Awaited<ReturnType<typeof getBusinessUnitNames>>, TError = void>(
 params?: GetBusinessUnitNamesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitNames>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBusinessUnitNamesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Circle resources.
 * @summary Retrieves the collection of Circle resources.
 */
export const getCircles = (
    params?: GetCirclesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetCircles200>(
      {url: `/api/circles`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCirclesQueryKey = (params?: GetCirclesParams,) => {
    return [`/api/circles`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCirclesQueryOptions = <TData = Awaited<ReturnType<typeof getCircles>>, TError = void>(params?: GetCirclesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCircles>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCirclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCircles>>> = ({ signal }) => getCircles(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCircles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCirclesQueryResult = NonNullable<Awaited<ReturnType<typeof getCircles>>>
export type GetCirclesQueryError = void

/**
 * @summary Retrieves the collection of Circle resources.
 */
export const useGetCircles = <TData = Awaited<ReturnType<typeof getCircles>>, TError = void>(
 params?: GetCirclesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCircles>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCirclesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Circle resource.
 * @summary Creates a Circle resource.
 */
export const postCircle = (
    circlePostCircleInputJsonld: CirclePostCircleInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/circles`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: circlePostCircleInputJsonld
    },
      options);
    }
  


export const getPostCircleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCircle>>, TError,{data: CirclePostCircleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postCircle>>, TError,{data: CirclePostCircleInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCircle>>, {data: CirclePostCircleInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postCircle(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCircleMutationResult = NonNullable<Awaited<ReturnType<typeof postCircle>>>
    export type PostCircleMutationBody = CirclePostCircleInputJsonld
    export type PostCircleMutationError = void

    /**
 * @summary Creates a Circle resource.
 */
export const usePostCircle = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCircle>>, TError,{data: CirclePostCircleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCircle>>,
        TError,
        {data: CirclePostCircleInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostCircleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Circle resource.
 * @summary Removes the Circle resource.
 */
export const deleteCircle = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/circles/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCircleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCircle>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCircle>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCircle>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCircle(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCircleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCircle>>>
    
    export type DeleteCircleMutationError = void

    /**
 * @summary Removes the Circle resource.
 */
export const useDeleteCircle = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCircle>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCircle>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCircleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Circle resource.
 * @summary Updates the Circle resource.
 */
export const patchCircle = (
    id: string,
    circlePatchCircleInput: CirclePatchCircleInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/circles/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: circlePatchCircleInput
    },
      options);
    }
  


export const getPatchCircleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCircle>>, TError,{id: string;data: CirclePatchCircleInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCircle>>, TError,{id: string;data: CirclePatchCircleInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCircle>>, {id: string;data: CirclePatchCircleInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCircle(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCircleMutationResult = NonNullable<Awaited<ReturnType<typeof patchCircle>>>
    export type PatchCircleMutationBody = CirclePatchCircleInput
    export type PatchCircleMutationError = void

    /**
 * @summary Updates the Circle resource.
 */
export const usePatchCircle = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCircle>>, TError,{id: string;data: CirclePatchCircleInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchCircle>>,
        TError,
        {id: string;data: CirclePatchCircleInput},
        TContext
      > => {

      const mutationOptions = getPatchCircleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Circle resource.
 * @summary Retrieves a Circle resource.
 */
export const getCircleWithTranslations = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<CircleCircleWithTranslationsDTO>(
      {url: `/api/circles/${id}/translations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCircleWithTranslationsQueryKey = (id: string,) => {
    return [`/api/circles/${id}/translations`] as const;
    }

    
export const getGetCircleWithTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getCircleWithTranslations>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCircleWithTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCircleWithTranslationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCircleWithTranslations>>> = ({ signal }) => getCircleWithTranslations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCircleWithTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCircleWithTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCircleWithTranslations>>>
export type GetCircleWithTranslationsQueryError = void

/**
 * @summary Retrieves a Circle resource.
 */
export const useGetCircleWithTranslations = <TData = Awaited<ReturnType<typeof getCircleWithTranslations>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCircleWithTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCircleWithTranslationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Client resources.
 * @summary Retrieves the collection of Client resources.
 */
export const getClients = (
    params?: GetClientsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClients200>(
      {url: `/api/clients`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClientsQueryKey = (params?: GetClientsParams,) => {
    return [`/api/clients`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClientsQueryOptions = <TData = Awaited<ReturnType<typeof getClients>>, TError = void>(params?: GetClientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClients>>> = ({ signal }) => getClients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getClients>>>
export type GetClientsQueryError = void

/**
 * @summary Retrieves the collection of Client resources.
 */
export const useGetClients = <TData = Awaited<ReturnType<typeof getClients>>, TError = void>(
 params?: GetClientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Client resource.
 * @summary Retrieves a Client resource.
 */
export const getClient = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ClientJsonldReadItemClientWithoutPrivateData>(
      {url: `/api/clients/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetClientQueryKey = (id: string,) => {
    return [`/api/clients/${id}`] as const;
    }

    
export const getGetClientQueryOptions = <TData = Awaited<ReturnType<typeof getClient>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClient>>> = ({ signal }) => getClient(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientQueryResult = NonNullable<Awaited<ReturnType<typeof getClient>>>
export type GetClientQueryError = void

/**
 * @summary Retrieves a Client resource.
 */
export const useGetClient = <TData = Awaited<ReturnType<typeof getClient>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Client resource.
 * @summary Retrieves a Client resource.
 */
export const getClientLogs = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ClientLogsOutputJsonld>(
      {url: `/api/clients/${id}/logs`, method: 'GET', signal
    },
      options);
    }
  

export const getGetClientLogsQueryKey = (id: string,) => {
    return [`/api/clients/${id}/logs`] as const;
    }

    
export const getGetClientLogsQueryOptions = <TData = Awaited<ReturnType<typeof getClientLogs>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientLogs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientLogsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientLogs>>> = ({ signal }) => getClientLogs(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientLogs>>>
export type GetClientLogsQueryError = void

/**
 * @summary Retrieves a Client resource.
 */
export const useGetClientLogs = <TData = Awaited<ReturnType<typeof getClientLogs>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientLogs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientLogsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a ClientAccessRequest resource.
 * @summary Creates a ClientAccessRequest resource.
 */
export const postClientAccessRequest = (
    clientAccessRequestCreateClientAccessRequestInputJsonld: ClientAccessRequestCreateClientAccessRequestInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<ClientAccessRequestJsonld>(
      {url: `/api/client-access-requests`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: clientAccessRequestCreateClientAccessRequestInputJsonld
    },
      options);
    }
  


export const getPostClientAccessRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClientAccessRequest>>, TError,{data: ClientAccessRequestCreateClientAccessRequestInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postClientAccessRequest>>, TError,{data: ClientAccessRequestCreateClientAccessRequestInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClientAccessRequest>>, {data: ClientAccessRequestCreateClientAccessRequestInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postClientAccessRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostClientAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postClientAccessRequest>>>
    export type PostClientAccessRequestMutationBody = ClientAccessRequestCreateClientAccessRequestInputJsonld
    export type PostClientAccessRequestMutationError = void

    /**
 * @summary Creates a ClientAccessRequest resource.
 */
export const usePostClientAccessRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClientAccessRequest>>, TError,{data: ClientAccessRequestCreateClientAccessRequestInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postClientAccessRequest>>,
        TError,
        {data: ClientAccessRequestCreateClientAccessRequestInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostClientAccessRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of ClientAccessRequest resources.
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const getAnsweredClientAccessRequest = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetAnsweredClientAccessRequest200>(
      {url: `/api/client-access-requests/answered`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAnsweredClientAccessRequestQueryKey = () => {
    return [`/api/client-access-requests/answered`] as const;
    }

    
export const getGetAnsweredClientAccessRequestQueryOptions = <TData = Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnsweredClientAccessRequestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>> = ({ signal }) => getAnsweredClientAccessRequest(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnsweredClientAccessRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>>
export type GetAnsweredClientAccessRequestQueryError = void

/**
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const useGetAnsweredClientAccessRequest = <TData = Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnsweredClientAccessRequest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAnsweredClientAccessRequestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of ClientAccessRequest resources.
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const getPendingClientAccessRequest = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPendingClientAccessRequest200>(
      {url: `/api/client-access-requests/pending`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPendingClientAccessRequestQueryKey = () => {
    return [`/api/client-access-requests/pending`] as const;
    }

    
export const getGetPendingClientAccessRequestQueryOptions = <TData = Awaited<ReturnType<typeof getPendingClientAccessRequest>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingClientAccessRequest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingClientAccessRequestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingClientAccessRequest>>> = ({ signal }) => getPendingClientAccessRequest(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingClientAccessRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPendingClientAccessRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingClientAccessRequest>>>
export type GetPendingClientAccessRequestQueryError = void

/**
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const useGetPendingClientAccessRequest = <TData = Awaited<ReturnType<typeof getPendingClientAccessRequest>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingClientAccessRequest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPendingClientAccessRequestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates the ClientAccessRequest resource.
 * @summary Updates the ClientAccessRequest resource.
 */
export const patchClientAccessRequest = (
    id: string,
    clientAccessRequestWriteItemClientAccessRequest: ClientAccessRequestWriteItemClientAccessRequest,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<ClientAccessRequestJsonld>(
      {url: `/api/client-access-requests/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: clientAccessRequestWriteItemClientAccessRequest
    },
      options);
    }
  


export const getPatchClientAccessRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientAccessRequest>>, TError,{id: string;data: ClientAccessRequestWriteItemClientAccessRequest}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClientAccessRequest>>, TError,{id: string;data: ClientAccessRequestWriteItemClientAccessRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClientAccessRequest>>, {id: string;data: ClientAccessRequestWriteItemClientAccessRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchClientAccessRequest(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchClientAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof patchClientAccessRequest>>>
    export type PatchClientAccessRequestMutationBody = ClientAccessRequestWriteItemClientAccessRequest
    export type PatchClientAccessRequestMutationError = void

    /**
 * @summary Updates the ClientAccessRequest resource.
 */
export const usePatchClientAccessRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientAccessRequest>>, TError,{id: string;data: ClientAccessRequestWriteItemClientAccessRequest}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchClientAccessRequest>>,
        TError,
        {id: string;data: ClientAccessRequestWriteItemClientAccessRequest},
        TContext
      > => {

      const mutationOptions = getPatchClientAccessRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of ClientAccessRequest resources.
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const apiClientsClientAccessRequestsGetSubresource = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ApiClientsClientAccessRequestsGetSubresource200>(
      {url: `/api/clients/${id}/pending-access-request`, method: 'GET', signal
    },
      options);
    }
  

export const getApiClientsClientAccessRequestsGetSubresourceQueryKey = (id: string,) => {
    return [`/api/clients/${id}/pending-access-request`] as const;
    }

    
export const getApiClientsClientAccessRequestsGetSubresourceQueryOptions = <TData = Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiClientsClientAccessRequestsGetSubresourceQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>> = ({ signal }) => apiClientsClientAccessRequestsGetSubresource(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiClientsClientAccessRequestsGetSubresourceQueryResult = NonNullable<Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>>
export type ApiClientsClientAccessRequestsGetSubresourceQueryError = void

/**
 * @summary Retrieves the collection of ClientAccessRequest resources.
 */
export const useApiClientsClientAccessRequestsGetSubresource = <TData = Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiClientsClientAccessRequestsGetSubresource>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getApiClientsClientAccessRequestsGetSubresourceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Cluster resource.
 * @summary Retrieves a Cluster resource.
 */
export const getCluster = (
    id: string,
    params?: GetClusterParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ClusterJsonldReadItemClusterItem>(
      {url: `/api/cluster/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClusterQueryKey = (id: string,
    params?: GetClusterParams,) => {
    return [`/api/cluster/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClusterQueryOptions = <TData = Awaited<ReturnType<typeof getCluster>>, TError = void>(id: string,
    params?: GetClusterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClusterQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCluster>>> = ({ signal }) => getCluster(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClusterQueryResult = NonNullable<Awaited<ReturnType<typeof getCluster>>>
export type GetClusterQueryError = void

/**
 * @summary Retrieves a Cluster resource.
 */
export const useGetCluster = <TData = Awaited<ReturnType<typeof getCluster>>, TError = void>(
 id: string,
    params?: GetClusterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClusterQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Cluster resources.
 * @summary Retrieves the collection of Cluster resources.
 */
export const getClusters = (
    params?: GetClustersParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClusters200>(
      {url: `/api/clusters`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClustersQueryKey = (params?: GetClustersParams,) => {
    return [`/api/clusters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClustersQueryOptions = <TData = Awaited<ReturnType<typeof getClusters>>, TError = void>(params?: GetClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClustersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClusters>>> = ({ signal }) => getClusters(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getClusters>>>
export type GetClustersQueryError = void

/**
 * @summary Retrieves the collection of Cluster resources.
 */
export const useGetClusters = <TData = Awaited<ReturnType<typeof getClusters>>, TError = void>(
 params?: GetClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClustersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Cluster resource.
 * @summary Creates a Cluster resource.
 */
export const postCluster = (
    clusterPostClusterInputJsonld: ClusterPostClusterInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/clusters`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: clusterPostClusterInputJsonld
    },
      options);
    }
  


export const getPostClusterMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCluster>>, TError,{data: ClusterPostClusterInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postCluster>>, TError,{data: ClusterPostClusterInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCluster>>, {data: ClusterPostClusterInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postCluster(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostClusterMutationResult = NonNullable<Awaited<ReturnType<typeof postCluster>>>
    export type PostClusterMutationBody = ClusterPostClusterInputJsonld
    export type PostClusterMutationError = void

    /**
 * @summary Creates a Cluster resource.
 */
export const usePostCluster = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCluster>>, TError,{data: ClusterPostClusterInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCluster>>,
        TError,
        {data: ClusterPostClusterInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostClusterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of Cluster resources.
 * @summary Retrieves the collection of Cluster resources.
 */
export const getClustersExcelExportData = (
    params?: GetClustersExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClustersExcelExportData200>(
      {url: `/api/clusters/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClustersExcelExportDataQueryKey = (params?: GetClustersExcelExportDataParams,) => {
    return [`/api/clusters/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClustersExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getClustersExcelExportData>>, TError = void>(params?: GetClustersExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClustersExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClustersExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClustersExcelExportData>>> = ({ signal }) => getClustersExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClustersExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClustersExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getClustersExcelExportData>>>
export type GetClustersExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Cluster resources.
 */
export const useGetClustersExcelExportData = <TData = Awaited<ReturnType<typeof getClustersExcelExportData>>, TError = void>(
 params?: GetClustersExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClustersExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClustersExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the Cluster resource.
 * @summary Removes the Cluster resource.
 */
export const deleteCluster = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/clusters/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteClusterMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCluster>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCluster(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClusterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCluster>>>
    
    export type DeleteClusterMutationError = void

    /**
 * @summary Removes the Cluster resource.
 */
export const useDeleteCluster = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCluster>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteClusterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Cluster resource.
 * @summary Updates the Cluster resource.
 */
export const patchCluster = (
    id: string,
    clusterPatchClusterInput: ClusterPatchClusterInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/clusters/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: clusterPatchClusterInput
    },
      options);
    }
  


export const getPatchClusterMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCluster>>, TError,{id: string;data: ClusterPatchClusterInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCluster>>, TError,{id: string;data: ClusterPatchClusterInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCluster>>, {id: string;data: ClusterPatchClusterInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCluster(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchClusterMutationResult = NonNullable<Awaited<ReturnType<typeof patchCluster>>>
    export type PatchClusterMutationBody = ClusterPatchClusterInput
    export type PatchClusterMutationError = void

    /**
 * @summary Updates the Cluster resource.
 */
export const usePatchCluster = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCluster>>, TError,{id: string;data: ClusterPatchClusterInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchCluster>>,
        TError,
        {id: string;data: ClusterPatchClusterInput},
        TContext
      > => {

      const mutationOptions = getPatchClusterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Cluster resource.
 * @summary Creates a Cluster resource.
 */
export const postClusterMedia = (
    id: string,
    postClusterMediaBody?: PostClusterMediaBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(postClusterMediaBody)
      return customMutator<unknown>(
      {url: `/api/clusters/${id}/medias`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostClusterMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClusterMedia>>, TError,{id: string;data: PostClusterMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postClusterMedia>>, TError,{id: string;data: PostClusterMediaBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postClusterMedia>>, {id: string;data: PostClusterMediaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postClusterMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostClusterMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postClusterMedia>>>
    export type PostClusterMediaMutationBody = PostClusterMediaBody
    export type PostClusterMediaMutationError = void

    /**
 * @summary Creates a Cluster resource.
 */
export const usePostClusterMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postClusterMedia>>, TError,{id: string;data: PostClusterMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postClusterMedia>>,
        TError,
        {id: string;data: PostClusterMediaBody},
        TContext
      > => {

      const mutationOptions = getPostClusterMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Cluster resource.
 * @summary Updates the Cluster resource.
 */
export const patchClusterMedia = (
    id: string,
    clusterPatchEntityMediaInput: ClusterPatchEntityMediaInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/clusters/${id}/medias`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: clusterPatchEntityMediaInput
    },
      options);
    }
  


export const getPatchClusterMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClusterMedia>>, TError,{id: string;data: ClusterPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClusterMedia>>, TError,{id: string;data: ClusterPatchEntityMediaInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClusterMedia>>, {id: string;data: ClusterPatchEntityMediaInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchClusterMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchClusterMediaMutationResult = NonNullable<Awaited<ReturnType<typeof patchClusterMedia>>>
    export type PatchClusterMediaMutationBody = ClusterPatchEntityMediaInput
    export type PatchClusterMediaMutationError = void

    /**
 * @summary Updates the Cluster resource.
 */
export const usePatchClusterMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClusterMedia>>, TError,{id: string;data: ClusterPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchClusterMedia>>,
        TError,
        {id: string;data: ClusterPatchEntityMediaInput},
        TContext
      > => {

      const mutationOptions = getPatchClusterMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Cluster resource.
 * @summary Removes the Cluster resource.
 */
export const deleteClusterMedia = (
    id: string,
    mediaId: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/clusters/${id}/medias/${mediaId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteClusterMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClusterMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClusterMedia>>, TError,{id: string;mediaId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClusterMedia>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteClusterMedia(id,mediaId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClusterMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClusterMedia>>>
    
    export type DeleteClusterMediaMutationError = void

    /**
 * @summary Removes the Cluster resource.
 */
export const useDeleteClusterMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClusterMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteClusterMedia>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {

      const mutationOptions = getDeleteClusterMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Collaborator resource.
 * @summary Retrieves a Collaborator resource.
 */
export const getCollaborator = (
    id: string,
    params?: GetCollaboratorParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<CollaboratorJsonldReadItemCollaboratorItem>(
      {url: `/api/collaborator/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCollaboratorQueryKey = (id: string,
    params?: GetCollaboratorParams,) => {
    return [`/api/collaborator/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCollaboratorQueryOptions = <TData = Awaited<ReturnType<typeof getCollaborator>>, TError = void>(id: string,
    params?: GetCollaboratorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaborator>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollaboratorQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollaborator>>> = ({ signal }) => getCollaborator(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollaborator>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCollaboratorQueryResult = NonNullable<Awaited<ReturnType<typeof getCollaborator>>>
export type GetCollaboratorQueryError = void

/**
 * @summary Retrieves a Collaborator resource.
 */
export const useGetCollaborator = <TData = Awaited<ReturnType<typeof getCollaborator>>, TError = void>(
 id: string,
    params?: GetCollaboratorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaborator>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCollaboratorQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Collaborator resources.
 * @summary Retrieves the collection of Collaborator resources.
 */
export const getCollaborators = (
    params?: GetCollaboratorsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetCollaborators200>(
      {url: `/api/collaborators`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCollaboratorsQueryKey = (params?: GetCollaboratorsParams,) => {
    return [`/api/collaborators`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCollaboratorsQueryOptions = <TData = Awaited<ReturnType<typeof getCollaborators>>, TError = void>(params?: GetCollaboratorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaborators>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollaboratorsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollaborators>>> = ({ signal }) => getCollaborators(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollaborators>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCollaboratorsQueryResult = NonNullable<Awaited<ReturnType<typeof getCollaborators>>>
export type GetCollaboratorsQueryError = void

/**
 * @summary Retrieves the collection of Collaborator resources.
 */
export const useGetCollaborators = <TData = Awaited<ReturnType<typeof getCollaborators>>, TError = void>(
 params?: GetCollaboratorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaborators>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCollaboratorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Collaborator resource.
 * @summary Creates a Collaborator resource.
 */
export const postCollaborator = (
    collaboratorPostCollaboratorInputJsonld: CollaboratorPostCollaboratorInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/collaborators`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: collaboratorPostCollaboratorInputJsonld
    },
      options);
    }
  


export const getPostCollaboratorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCollaborator>>, TError,{data: CollaboratorPostCollaboratorInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postCollaborator>>, TError,{data: CollaboratorPostCollaboratorInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCollaborator>>, {data: CollaboratorPostCollaboratorInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postCollaborator(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof postCollaborator>>>
    export type PostCollaboratorMutationBody = CollaboratorPostCollaboratorInputJsonld
    export type PostCollaboratorMutationError = void

    /**
 * @summary Creates a Collaborator resource.
 */
export const usePostCollaborator = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCollaborator>>, TError,{data: CollaboratorPostCollaboratorInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCollaborator>>,
        TError,
        {data: CollaboratorPostCollaboratorInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostCollaboratorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of Collaborator resources.
 * @summary Retrieves the collection of Collaborator resources.
 */
export const getCollaboratorsExcelExportData = (
    params?: GetCollaboratorsExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetCollaboratorsExcelExportData200>(
      {url: `/api/collaborators/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCollaboratorsExcelExportDataQueryKey = (params?: GetCollaboratorsExcelExportDataParams,) => {
    return [`/api/collaborators/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCollaboratorsExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>, TError = void>(params?: GetCollaboratorsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollaboratorsExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>> = ({ signal }) => getCollaboratorsExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCollaboratorsExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>>
export type GetCollaboratorsExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Collaborator resources.
 */
export const useGetCollaboratorsExcelExportData = <TData = Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>, TError = void>(
 params?: GetCollaboratorsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCollaboratorsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCollaboratorsExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the Collaborator resource.
 * @summary Removes the Collaborator resource.
 */
export const deleteCollaborator = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/collaborators/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCollaboratorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollaborator>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCollaborator>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCollaborator>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCollaborator(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCollaborator>>>
    
    export type DeleteCollaboratorMutationError = void

    /**
 * @summary Removes the Collaborator resource.
 */
export const useDeleteCollaborator = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollaborator>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCollaborator>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCollaboratorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Collaborator resource.
 * @summary Updates the Collaborator resource.
 */
export const patchCollaborator = (
    id: string,
    collaboratorPatchCollaboratorInput: CollaboratorPatchCollaboratorInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/collaborators/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: collaboratorPatchCollaboratorInput
    },
      options);
    }
  


export const getPatchCollaboratorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCollaborator>>, TError,{id: string;data: CollaboratorPatchCollaboratorInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCollaborator>>, TError,{id: string;data: CollaboratorPatchCollaboratorInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCollaborator>>, {id: string;data: CollaboratorPatchCollaboratorInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCollaborator(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof patchCollaborator>>>
    export type PatchCollaboratorMutationBody = CollaboratorPatchCollaboratorInput
    export type PatchCollaboratorMutationError = void

    /**
 * @summary Updates the Collaborator resource.
 */
export const usePatchCollaborator = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCollaborator>>, TError,{id: string;data: CollaboratorPatchCollaboratorInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchCollaborator>>,
        TError,
        {id: string;data: CollaboratorPatchCollaboratorInput},
        TContext
      > => {

      const mutationOptions = getPatchCollaboratorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Collaborator resource.
 * @summary Creates a Collaborator resource.
 */
export const postCollaboratorMedia = (
    id: string,
    postCollaboratorMediaBody?: PostCollaboratorMediaBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(postCollaboratorMediaBody)
      return customMutator<unknown>(
      {url: `/api/collaborators/${id}/medias`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostCollaboratorMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCollaboratorMedia>>, TError,{id: string;data: PostCollaboratorMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postCollaboratorMedia>>, TError,{id: string;data: PostCollaboratorMediaBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCollaboratorMedia>>, {id: string;data: PostCollaboratorMediaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postCollaboratorMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCollaboratorMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postCollaboratorMedia>>>
    export type PostCollaboratorMediaMutationBody = PostCollaboratorMediaBody
    export type PostCollaboratorMediaMutationError = void

    /**
 * @summary Creates a Collaborator resource.
 */
export const usePostCollaboratorMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCollaboratorMedia>>, TError,{id: string;data: PostCollaboratorMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCollaboratorMedia>>,
        TError,
        {id: string;data: PostCollaboratorMediaBody},
        TContext
      > => {

      const mutationOptions = getPostCollaboratorMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Collaborator resource.
 * @summary Updates the Collaborator resource.
 */
export const patchCollaboratorMedia = (
    id: string,
    collaboratorPatchEntityMediaInput: CollaboratorPatchEntityMediaInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/collaborators/${id}/medias`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: collaboratorPatchEntityMediaInput
    },
      options);
    }
  


export const getPatchCollaboratorMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCollaboratorMedia>>, TError,{id: string;data: CollaboratorPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCollaboratorMedia>>, TError,{id: string;data: CollaboratorPatchEntityMediaInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCollaboratorMedia>>, {id: string;data: CollaboratorPatchEntityMediaInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCollaboratorMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCollaboratorMediaMutationResult = NonNullable<Awaited<ReturnType<typeof patchCollaboratorMedia>>>
    export type PatchCollaboratorMediaMutationBody = CollaboratorPatchEntityMediaInput
    export type PatchCollaboratorMediaMutationError = void

    /**
 * @summary Updates the Collaborator resource.
 */
export const usePatchCollaboratorMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCollaboratorMedia>>, TError,{id: string;data: CollaboratorPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchCollaboratorMedia>>,
        TError,
        {id: string;data: CollaboratorPatchEntityMediaInput},
        TContext
      > => {

      const mutationOptions = getPatchCollaboratorMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Collaborator resource.
 * @summary Removes the Collaborator resource.
 */
export const deleteCollaboratorMedia = (
    id: string,
    mediaId: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/collaborators/${id}/medias/${mediaId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCollaboratorMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollaboratorMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCollaboratorMedia>>, TError,{id: string;mediaId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCollaboratorMedia>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteCollaboratorMedia(id,mediaId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCollaboratorMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCollaboratorMedia>>>
    
    export type DeleteCollaboratorMediaMutationError = void

    /**
 * @summary Removes the Collaborator resource.
 */
export const useDeleteCollaboratorMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollaboratorMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCollaboratorMedia>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCollaboratorMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of DirectoryCluster resources.
 * @summary Retrieves the collection of DirectoryCluster resources.
 */
export const getDirectoryClusters = (
    params?: GetDirectoryClustersParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetDirectoryClusters200>(
      {url: `/api/directory/clusters`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDirectoryClustersQueryKey = (params?: GetDirectoryClustersParams,) => {
    return [`/api/directory/clusters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDirectoryClustersQueryOptions = <TData = Awaited<ReturnType<typeof getDirectoryClusters>>, TError = void>(params?: GetDirectoryClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectoryClustersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectoryClusters>>> = ({ signal }) => getDirectoryClusters(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDirectoryClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectoryClusters>>>
export type GetDirectoryClustersQueryError = void

/**
 * @summary Retrieves the collection of DirectoryCluster resources.
 */
export const useGetDirectoryClusters = <TData = Awaited<ReturnType<typeof getDirectoryClusters>>, TError = void>(
 params?: GetDirectoryClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDirectoryClustersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of DirectoryCollaborator resources.
 * @summary Retrieves the collection of DirectoryCollaborator resources.
 */
export const getDirectoryClusterCollaborators = (
    clusterId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetDirectoryClusterCollaborators200>(
      {url: `/api/directory/clusters/${clusterId}/collaborators`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDirectoryClusterCollaboratorsQueryKey = (clusterId: string,) => {
    return [`/api/directory/clusters/${clusterId}/collaborators`] as const;
    }

    
export const getGetDirectoryClusterCollaboratorsQueryOptions = <TData = Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>, TError = void>(clusterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectoryClusterCollaboratorsQueryKey(clusterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>> = ({ signal }) => getDirectoryClusterCollaborators(clusterId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clusterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDirectoryClusterCollaboratorsQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>>
export type GetDirectoryClusterCollaboratorsQueryError = void

/**
 * @summary Retrieves the collection of DirectoryCollaborator resources.
 */
export const useGetDirectoryClusterCollaborators = <TData = Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>, TError = void>(
 clusterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDirectoryClusterCollaborators>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDirectoryClusterCollaboratorsQueryOptions(clusterId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of EntityResource resources.
 * @summary Retrieves the collection of EntityResource resources.
 */
export const getUserClustersNoId = (
    params?: GetUserClustersNoIdParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetUserClustersNoId200>(
      {url: `/api/entities/user-clusters`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserClustersNoIdQueryKey = (params?: GetUserClustersNoIdParams,) => {
    return [`/api/entities/user-clusters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserClustersNoIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserClustersNoId>>, TError = void>(params?: GetUserClustersNoIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserClustersNoId>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserClustersNoIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserClustersNoId>>> = ({ signal }) => getUserClustersNoId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserClustersNoId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserClustersNoIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserClustersNoId>>>
export type GetUserClustersNoIdQueryError = void

/**
 * @summary Retrieves the collection of EntityResource resources.
 */
export const useGetUserClustersNoId = <TData = Awaited<ReturnType<typeof getUserClustersNoId>>, TError = void>(
 params?: GetUserClustersNoIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserClustersNoId>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserClustersNoIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of EntityResource resources.
 * @summary Retrieves the collection of EntityResource resources.
 */
export const getUserClusters = (
    id: string,
    params?: GetUserClustersParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetUserClusters200>(
      {url: `/api/entities/user-clusters/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserClustersQueryKey = (id: string,
    params?: GetUserClustersParams,) => {
    return [`/api/entities/user-clusters/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserClustersQueryOptions = <TData = Awaited<ReturnType<typeof getUserClusters>>, TError = void>(id: string,
    params?: GetUserClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserClustersQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserClusters>>> = ({ signal }) => getUserClusters(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getUserClusters>>>
export type GetUserClustersQueryError = void

/**
 * @summary Retrieves the collection of EntityResource resources.
 */
export const useGetUserClusters = <TData = Awaited<ReturnType<typeof getUserClusters>>, TError = void>(
 id: string,
    params?: GetUserClustersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserClusters>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserClustersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Event resources.
 * @summary Retrieves the collection of Event resources.
 */
export const getEvents = (
    params?: GetEventsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetEvents200>(
      {url: `/api/events`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [`/api/events`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = void>(params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = void

/**
 * @summary Retrieves the collection of Event resources.
 */
export const useGetEvents = <TData = Awaited<ReturnType<typeof getEvents>>, TError = void>(
 params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Event resource.
 * @summary Creates a Event resource.
 */
export const postEvent = (
    eventPostEventInputJsonld: EventPostEventInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/events`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: eventPostEventInputJsonld
    },
      options);
    }
  


export const getPostEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: EventPostEventInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: EventPostEventInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEvent>>, {data: EventPostEventInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postEvent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventMutationResult = NonNullable<Awaited<ReturnType<typeof postEvent>>>
    export type PostEventMutationBody = EventPostEventInputJsonld
    export type PostEventMutationError = void

    /**
 * @summary Creates a Event resource.
 */
export const usePostEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: EventPostEventInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postEvent>>,
        TError,
        {data: EventPostEventInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Event resource.
 * @summary Removes the Event resource.
 */
export const deleteEvent = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/events/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEvent(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>
    
    export type DeleteEventMutationError = void

    /**
 * @summary Removes the Event resource.
 */
export const useDeleteEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Event resource.
 * @summary Updates the Event resource.
 */
export const patchEvent = (
    id: string,
    eventPatchEventInput: EventPatchEventInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/events/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: eventPatchEventInput
    },
      options);
    }
  


export const getPatchEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEvent>>, TError,{id: string;data: EventPatchEventInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEvent>>, TError,{id: string;data: EventPatchEventInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEvent>>, {id: string;data: EventPatchEventInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEvent(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventMutationResult = NonNullable<Awaited<ReturnType<typeof patchEvent>>>
    export type PatchEventMutationBody = EventPatchEventInput
    export type PatchEventMutationError = void

    /**
 * @summary Updates the Event resource.
 */
export const usePatchEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEvent>>, TError,{id: string;data: EventPatchEventInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchEvent>>,
        TError,
        {id: string;data: EventPatchEventInput},
        TContext
      > => {

      const mutationOptions = getPatchEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Event resource.
 * @summary Retrieves a Event resource.
 */
export const getEventWithTranslations = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<EventEventWithTranslationsDTO>(
      {url: `/api/events/${id}/translations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEventWithTranslationsQueryKey = (id: string,) => {
    return [`/api/events/${id}/translations`] as const;
    }

    
export const getGetEventWithTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getEventWithTranslations>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventWithTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventWithTranslationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventWithTranslations>>> = ({ signal }) => getEventWithTranslations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventWithTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventWithTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventWithTranslations>>>
export type GetEventWithTranslationsQueryError = void

/**
 * @summary Retrieves a Event resource.
 */
export const useGetEventWithTranslations = <TData = Awaited<ReturnType<typeof getEventWithTranslations>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventWithTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEventWithTranslationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Helpdesk resources.
 * @summary Retrieves the collection of Helpdesk resources.
 */
export const getHelpdesks = (
    params?: GetHelpdesksParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetHelpdesks200>(
      {url: `/api/helpdesks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHelpdesksQueryKey = (params?: GetHelpdesksParams,) => {
    return [`/api/helpdesks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHelpdesksQueryOptions = <TData = Awaited<ReturnType<typeof getHelpdesks>>, TError = void>(params?: GetHelpdesksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHelpdesks>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHelpdesksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHelpdesks>>> = ({ signal }) => getHelpdesks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHelpdesks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHelpdesksQueryResult = NonNullable<Awaited<ReturnType<typeof getHelpdesks>>>
export type GetHelpdesksQueryError = void

/**
 * @summary Retrieves the collection of Helpdesk resources.
 */
export const useGetHelpdesks = <TData = Awaited<ReturnType<typeof getHelpdesks>>, TError = void>(
 params?: GetHelpdesksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHelpdesks>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHelpdesksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Helpdesk resource.
 * @summary Creates a Helpdesk resource.
 */
export const postHelpdesk = (
    helpdeskPostHelpdeskInputHelpdeskCreate: HelpdeskPostHelpdeskInputHelpdeskCreate,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(helpdeskPostHelpdeskInputHelpdeskCreate)
      return customMutator<HelpdeskJsonldWriteItemHelpdeskItem>(
      {url: `/api/helpdesks`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostHelpdeskMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelpdesk>>, TError,{data: HelpdeskPostHelpdeskInputHelpdeskCreate}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postHelpdesk>>, TError,{data: HelpdeskPostHelpdeskInputHelpdeskCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHelpdesk>>, {data: HelpdeskPostHelpdeskInputHelpdeskCreate}> = (props) => {
          const {data} = props ?? {};

          return  postHelpdesk(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHelpdeskMutationResult = NonNullable<Awaited<ReturnType<typeof postHelpdesk>>>
    export type PostHelpdeskMutationBody = HelpdeskPostHelpdeskInputHelpdeskCreate
    export type PostHelpdeskMutationError = void

    /**
 * @summary Creates a Helpdesk resource.
 */
export const usePostHelpdesk = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelpdesk>>, TError,{data: HelpdeskPostHelpdeskInputHelpdeskCreate}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postHelpdesk>>,
        TError,
        {data: HelpdeskPostHelpdeskInputHelpdeskCreate},
        TContext
      > => {

      const mutationOptions = getPostHelpdeskMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Helpdesk resource.
 * @summary Retrieves a Helpdesk resource.
 */
export const getHelpdeskById = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<HelpdeskJsonldReadItemHelpdeskItem>(
      {url: `/api/helpdesks/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHelpdeskByIdQueryKey = (id: string,) => {
    return [`/api/helpdesks/${id}`] as const;
    }

    
export const getGetHelpdeskByIdQueryOptions = <TData = Awaited<ReturnType<typeof getHelpdeskById>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHelpdeskById>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHelpdeskByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHelpdeskById>>> = ({ signal }) => getHelpdeskById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHelpdeskById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHelpdeskByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHelpdeskById>>>
export type GetHelpdeskByIdQueryError = void

/**
 * @summary Retrieves a Helpdesk resource.
 */
export const useGetHelpdeskById = <TData = Awaited<ReturnType<typeof getHelpdeskById>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHelpdeskById>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHelpdeskByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Replaces the Helpdesk resource.
 * @summary Replaces the Helpdesk resource.
 */
export const putHelpdesk = (
    id: string,
    helpdeskPatchHelpdeskInputWriteItemHelpdeskItem: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(helpdeskPatchHelpdeskInputWriteItemHelpdeskItem)
      return customMutator<unknown>(
      {url: `/api/helpdesks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutHelpdeskMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHelpdesk>>, TError,{id: string;data: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putHelpdesk>>, TError,{id: string;data: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHelpdesk>>, {id: string;data: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem}> = (props) => {
          const {id,data} = props ?? {};

          return  putHelpdesk(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutHelpdeskMutationResult = NonNullable<Awaited<ReturnType<typeof putHelpdesk>>>
    export type PutHelpdeskMutationBody = HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem
    export type PutHelpdeskMutationError = void

    /**
 * @summary Replaces the Helpdesk resource.
 */
export const usePutHelpdesk = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHelpdesk>>, TError,{id: string;data: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof putHelpdesk>>,
        TError,
        {id: string;data: HelpdeskPatchHelpdeskInputWriteItemHelpdeskItem},
        TContext
      > => {

      const mutationOptions = getPutHelpdeskMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Helpdesk resource.
 * @summary Removes the Helpdesk resource.
 */
export const deleteHelpdesk = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/helpdesks/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteHelpdeskMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHelpdesk>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHelpdesk>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHelpdesk>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHelpdesk(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHelpdeskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHelpdesk>>>
    
    export type DeleteHelpdeskMutationError = void

    /**
 * @summary Removes the Helpdesk resource.
 */
export const useDeleteHelpdesk = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHelpdesk>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteHelpdesk>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteHelpdeskMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Hobby resource.
 * @summary Creates a Hobby resource.
 */
export const postHobby = (
    hobbyPostHobbyInputJsonld: HobbyPostHobbyInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/hobbies`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: hobbyPostHobbyInputJsonld
    },
      options);
    }
  


export const getPostHobbyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHobby>>, TError,{data: HobbyPostHobbyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postHobby>>, TError,{data: HobbyPostHobbyInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHobby>>, {data: HobbyPostHobbyInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postHobby(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHobbyMutationResult = NonNullable<Awaited<ReturnType<typeof postHobby>>>
    export type PostHobbyMutationBody = HobbyPostHobbyInputJsonld
    export type PostHobbyMutationError = void

    /**
 * @summary Creates a Hobby resource.
 */
export const usePostHobby = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHobby>>, TError,{data: HobbyPostHobbyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postHobby>>,
        TError,
        {data: HobbyPostHobbyInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostHobbyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Hobby resource.
 * @summary Removes the Hobby resource.
 */
export const deleteHobby = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/hobbies/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteHobbyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHobby>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHobby>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHobby>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHobby(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHobbyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHobby>>>
    
    export type DeleteHobbyMutationError = void

    /**
 * @summary Removes the Hobby resource.
 */
export const useDeleteHobby = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHobby>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteHobby>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteHobbyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Hobby resource.
 * @summary Updates the Hobby resource.
 */
export const patchHobby = (
    id: string,
    hobbyPatchHobbyInput: HobbyPatchHobbyInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/hobbies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: hobbyPatchHobbyInput
    },
      options);
    }
  


export const getPatchHobbyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHobby>>, TError,{id: string;data: HobbyPatchHobbyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchHobby>>, TError,{id: string;data: HobbyPatchHobbyInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchHobby>>, {id: string;data: HobbyPatchHobbyInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchHobby(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchHobbyMutationResult = NonNullable<Awaited<ReturnType<typeof patchHobby>>>
    export type PatchHobbyMutationBody = HobbyPatchHobbyInput
    export type PatchHobbyMutationError = void

    /**
 * @summary Updates the Hobby resource.
 */
export const usePatchHobby = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHobby>>, TError,{id: string;data: HobbyPatchHobbyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchHobby>>,
        TError,
        {id: string;data: HobbyPatchHobbyInput},
        TContext
      > => {

      const mutationOptions = getPatchHobbyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Hobby resource.
 * @summary Retrieves a Hobby resource.
 */
export const getHobbyTranslations = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<HobbyTranslationsDTO>(
      {url: `/api/hobbies/${id}/translations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHobbyTranslationsQueryKey = (id: string,) => {
    return [`/api/hobbies/${id}/translations`] as const;
    }

    
export const getGetHobbyTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getHobbyTranslations>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHobbyTranslationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHobbyTranslations>>> = ({ signal }) => getHobbyTranslations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHobbyTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHobbyTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getHobbyTranslations>>>
export type GetHobbyTranslationsQueryError = void

/**
 * @summary Retrieves a Hobby resource.
 */
export const useGetHobbyTranslations = <TData = Awaited<ReturnType<typeof getHobbyTranslations>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHobbyTranslationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of HobbyCategory resources.
 * @summary Retrieves the collection of HobbyCategory resources.
 */
export const getHobbyCategories = (
    params?: GetHobbyCategoriesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetHobbyCategories200>(
      {url: `/api/hobby-categories`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHobbyCategoriesQueryKey = (params?: GetHobbyCategoriesParams,) => {
    return [`/api/hobby-categories`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHobbyCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getHobbyCategories>>, TError = void>(params?: GetHobbyCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategories>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHobbyCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHobbyCategories>>> = ({ signal }) => getHobbyCategories(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHobbyCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getHobbyCategories>>>
export type GetHobbyCategoriesQueryError = void

/**
 * @summary Retrieves the collection of HobbyCategory resources.
 */
export const useGetHobbyCategories = <TData = Awaited<ReturnType<typeof getHobbyCategories>>, TError = void>(
 params?: GetHobbyCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategories>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHobbyCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a HobbyCategory resource.
 * @summary Creates a HobbyCategory resource.
 */
export const postHobbyCategory = (
    hobbyCategoryPostHobbyCategoryInputJsonld: HobbyCategoryPostHobbyCategoryInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/hobby-categories`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: hobbyCategoryPostHobbyCategoryInputJsonld
    },
      options);
    }
  


export const getPostHobbyCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHobbyCategory>>, TError,{data: HobbyCategoryPostHobbyCategoryInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postHobbyCategory>>, TError,{data: HobbyCategoryPostHobbyCategoryInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHobbyCategory>>, {data: HobbyCategoryPostHobbyCategoryInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postHobbyCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHobbyCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postHobbyCategory>>>
    export type PostHobbyCategoryMutationBody = HobbyCategoryPostHobbyCategoryInputJsonld
    export type PostHobbyCategoryMutationError = void

    /**
 * @summary Creates a HobbyCategory resource.
 */
export const usePostHobbyCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHobbyCategory>>, TError,{data: HobbyCategoryPostHobbyCategoryInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postHobbyCategory>>,
        TError,
        {data: HobbyCategoryPostHobbyCategoryInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostHobbyCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the HobbyCategory resource.
 * @summary Removes the HobbyCategory resource.
 */
export const deleteHobbyCategory = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/hobby-categories/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteHobbyCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHobbyCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHobbyCategory>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHobbyCategory>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHobbyCategory(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHobbyCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHobbyCategory>>>
    
    export type DeleteHobbyCategoryMutationError = void

    /**
 * @summary Removes the HobbyCategory resource.
 */
export const useDeleteHobbyCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHobbyCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteHobbyCategory>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteHobbyCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the HobbyCategory resource.
 * @summary Updates the HobbyCategory resource.
 */
export const patchHobbyCategory = (
    id: string,
    hobbyCategoryPatchHobbyCategoryInput: HobbyCategoryPatchHobbyCategoryInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/hobby-categories/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: hobbyCategoryPatchHobbyCategoryInput
    },
      options);
    }
  


export const getPatchHobbyCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHobbyCategory>>, TError,{id: string;data: HobbyCategoryPatchHobbyCategoryInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchHobbyCategory>>, TError,{id: string;data: HobbyCategoryPatchHobbyCategoryInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchHobbyCategory>>, {id: string;data: HobbyCategoryPatchHobbyCategoryInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchHobbyCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchHobbyCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof patchHobbyCategory>>>
    export type PatchHobbyCategoryMutationBody = HobbyCategoryPatchHobbyCategoryInput
    export type PatchHobbyCategoryMutationError = void

    /**
 * @summary Updates the HobbyCategory resource.
 */
export const usePatchHobbyCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHobbyCategory>>, TError,{id: string;data: HobbyCategoryPatchHobbyCategoryInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchHobbyCategory>>,
        TError,
        {id: string;data: HobbyCategoryPatchHobbyCategoryInput},
        TContext
      > => {

      const mutationOptions = getPatchHobbyCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a HobbyCategory resource.
 * @summary Retrieves a HobbyCategory resource.
 */
export const getHobbyCategoryTranslations = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<HobbyCategoryTranslationsDTO>(
      {url: `/api/hobby-categories/${id}/translations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHobbyCategoryTranslationsQueryKey = (id: string,) => {
    return [`/api/hobby-categories/${id}/translations`] as const;
    }

    
export const getGetHobbyCategoryTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getHobbyCategoryTranslations>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategoryTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHobbyCategoryTranslationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHobbyCategoryTranslations>>> = ({ signal }) => getHobbyCategoryTranslations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategoryTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHobbyCategoryTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getHobbyCategoryTranslations>>>
export type GetHobbyCategoryTranslationsQueryError = void

/**
 * @summary Retrieves a HobbyCategory resource.
 */
export const useGetHobbyCategoryTranslations = <TData = Awaited<ReturnType<typeof getHobbyCategoryTranslations>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHobbyCategoryTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHobbyCategoryTranslationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of InterBu resources.
 * @summary Retrieves the collection of InterBu resources.
 */
export const getInterBus = (
    params?: GetInterBusParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetInterBus200>(
      {url: `/api/inter-bus`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetInterBusQueryKey = (params?: GetInterBusParams,) => {
    return [`/api/inter-bus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInterBusQueryOptions = <TData = Awaited<ReturnType<typeof getInterBus>>, TError = void>(params?: GetInterBusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterBusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterBus>>> = ({ signal }) => getInterBus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterBus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterBusQueryResult = NonNullable<Awaited<ReturnType<typeof getInterBus>>>
export type GetInterBusQueryError = void

/**
 * @summary Retrieves the collection of InterBu resources.
 */
export const useGetInterBus = <TData = Awaited<ReturnType<typeof getInterBus>>, TError = void>(
 params?: GetInterBusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInterBusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a InterBu resource.
 * @summary Creates a InterBu resource.
 */
export const postInterbu = (
    interBuPostInterBuInputJsonld: InterBuPostInterBuInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<InterBuPostInterBuResponse | unknown>(
      {url: `/api/inter-bus`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: interBuPostInterBuInputJsonld
    },
      options);
    }
  


export const getPostInterbuMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbu>>, TError,{data: InterBuPostInterBuInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postInterbu>>, TError,{data: InterBuPostInterBuInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterbu>>, {data: InterBuPostInterBuInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postInterbu(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInterbuMutationResult = NonNullable<Awaited<ReturnType<typeof postInterbu>>>
    export type PostInterbuMutationBody = InterBuPostInterBuInputJsonld
    export type PostInterbuMutationError = void

    /**
 * @summary Creates a InterBu resource.
 */
export const usePostInterbu = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbu>>, TError,{data: InterBuPostInterBuInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInterbu>>,
        TError,
        {data: InterBuPostInterBuInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostInterbuMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a InterBu resource.
 * @summary Retrieves a InterBu resource.
 */
export const getInterBuItem = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<InterBuJsonldReadItemInterbu>(
      {url: `/api/inter-bus/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetInterBuItemQueryKey = (id: string,) => {
    return [`/api/inter-bus/${id}`] as const;
    }

    
export const getGetInterBuItemQueryOptions = <TData = Awaited<ReturnType<typeof getInterBuItem>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuItem>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterBuItemQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterBuItem>>> = ({ signal }) => getInterBuItem(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterBuItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterBuItemQueryResult = NonNullable<Awaited<ReturnType<typeof getInterBuItem>>>
export type GetInterBuItemQueryError = void

/**
 * @summary Retrieves a InterBu resource.
 */
export const useGetInterBuItem = <TData = Awaited<ReturnType<typeof getInterBuItem>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuItem>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInterBuItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates the InterBu resource.
 * @summary Updates the InterBu resource.
 */
export const patchInterbu = (
    id: string,
    patchInterbuBody?: PatchInterbuBodyOne | PatchInterbuBodyTwo,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/inter-bus/${id}`, method: 'PATCH',
      data: patchInterbuBody
    },
      options);
    }
  


export const getPatchInterbuMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInterbu>>, TError,{id: string;data: PatchInterbuBodyOne | PatchInterbuBodyTwo}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchInterbu>>, TError,{id: string;data: PatchInterbuBodyOne | PatchInterbuBodyTwo}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInterbu>>, {id: string;data: PatchInterbuBodyOne | PatchInterbuBodyTwo}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInterbu(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInterbuMutationResult = NonNullable<Awaited<ReturnType<typeof patchInterbu>>>
    export type PatchInterbuMutationBody = PatchInterbuBodyOne | PatchInterbuBodyTwo
    export type PatchInterbuMutationError = void

    /**
 * @summary Updates the InterBu resource.
 */
export const usePatchInterbu = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInterbu>>, TError,{id: string;data: PatchInterbuBodyOne | PatchInterbuBodyTwo}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchInterbu>>,
        TError,
        {id: string;data: PatchInterbuBodyOne | PatchInterbuBodyTwo},
        TContext
      > => {

      const mutationOptions = getPatchInterbuMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a InterBu resource.
 * @summary Creates a InterBu resource.
 */
export const postInterbuFile = (
    id: string,
    postInterbuFileBody?: PostInterbuFileBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(postInterbuFileBody)
      return customMutator<unknown>(
      {url: `/api/inter-bus/${id}/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostInterbuFileMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbuFile>>, TError,{id: string;data: PostInterbuFileBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postInterbuFile>>, TError,{id: string;data: PostInterbuFileBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterbuFile>>, {id: string;data: PostInterbuFileBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postInterbuFile(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInterbuFileMutationResult = NonNullable<Awaited<ReturnType<typeof postInterbuFile>>>
    export type PostInterbuFileMutationBody = PostInterbuFileBody
    export type PostInterbuFileMutationError = void

    /**
 * @summary Creates a InterBu resource.
 */
export const usePostInterbuFile = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbuFile>>, TError,{id: string;data: PostInterbuFileBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInterbuFile>>,
        TError,
        {id: string;data: PostInterbuFileBody},
        TContext
      > => {

      const mutationOptions = getPostInterbuFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the InterBu resource.
 * @summary Removes the InterBu resource.
 */
export const deleteInterbuFile = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/inter-bus/${id}/file`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteInterbuFileMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterbuFile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInterbuFile>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInterbuFile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInterbuFile(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInterbuFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInterbuFile>>>
    
    export type DeleteInterbuFileMutationError = void

    /**
 * @summary Removes the InterBu resource.
 */
export const useDeleteInterbuFile = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterbuFile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteInterbuFile>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInterbuFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a InterBu resource.
 * @summary Creates a InterBu resource.
 */
export const postInterbuClusters = (
    id: string,
    interBuPostInterBuClustersInputJsonld: InterBuPostInterBuClustersInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/shared-datas/interbu/${id}/clusters`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: interBuPostInterBuClustersInputJsonld
    },
      options);
    }
  


export const getPostInterbuClustersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbuClusters>>, TError,{id: string;data: InterBuPostInterBuClustersInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postInterbuClusters>>, TError,{id: string;data: InterBuPostInterBuClustersInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterbuClusters>>, {id: string;data: InterBuPostInterBuClustersInputJsonld}> = (props) => {
          const {id,data} = props ?? {};

          return  postInterbuClusters(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInterbuClustersMutationResult = NonNullable<Awaited<ReturnType<typeof postInterbuClusters>>>
    export type PostInterbuClustersMutationBody = InterBuPostInterBuClustersInputJsonld
    export type PostInterbuClustersMutationError = void

    /**
 * @summary Creates a InterBu resource.
 */
export const usePostInterbuClusters = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterbuClusters>>, TError,{id: string;data: InterBuPostInterBuClustersInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInterbuClusters>>,
        TError,
        {id: string;data: InterBuPostInterBuClustersInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostInterbuClustersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of InterBuExcelExportRow resources.
 * @summary Retrieves the collection of InterBuExcelExportRow resources.
 */
export const getInterBuExcelExportData = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetInterBuExcelExportData200>(
      {url: `/api/shared-datas/interbu/excel-export`, method: 'GET', signal
    },
      options);
    }
  

export const getGetInterBuExcelExportDataQueryKey = () => {
    return [`/api/shared-datas/interbu/excel-export`] as const;
    }

    
export const getGetInterBuExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getInterBuExcelExportData>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterBuExcelExportDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterBuExcelExportData>>> = ({ signal }) => getInterBuExcelExportData(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterBuExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterBuExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getInterBuExcelExportData>>>
export type GetInterBuExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of InterBuExcelExportRow resources.
 */
export const useGetInterBuExcelExportData = <TData = Awaited<ReturnType<typeof getInterBuExcelExportData>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInterBuExcelExportDataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a InterBuProgressStep resource.
 * @summary Creates a InterBuProgressStep resource.
 */
export const postInterBuProgressStep = (
    interBuProgressStepCreateInterBuProgressStepInput: InterBuProgressStepCreateInterBuProgressStepInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(interBuProgressStepCreateInterBuProgressStepInput)
      return customMutator<unknown>(
      {url: `/api/inter-bu-progress-steps`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostInterBuProgressStepMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterBuProgressStep>>, TError,{data: InterBuProgressStepCreateInterBuProgressStepInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postInterBuProgressStep>>, TError,{data: InterBuProgressStepCreateInterBuProgressStepInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterBuProgressStep>>, {data: InterBuProgressStepCreateInterBuProgressStepInput}> = (props) => {
          const {data} = props ?? {};

          return  postInterBuProgressStep(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInterBuProgressStepMutationResult = NonNullable<Awaited<ReturnType<typeof postInterBuProgressStep>>>
    export type PostInterBuProgressStepMutationBody = InterBuProgressStepCreateInterBuProgressStepInput
    export type PostInterBuProgressStepMutationError = void

    /**
 * @summary Creates a InterBuProgressStep resource.
 */
export const usePostInterBuProgressStep = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterBuProgressStep>>, TError,{data: InterBuProgressStepCreateInterBuProgressStepInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInterBuProgressStep>>,
        TError,
        {data: InterBuProgressStepCreateInterBuProgressStepInput},
        TContext
      > => {

      const mutationOptions = getPostInterBuProgressStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a InterBuStats resource.
 * @summary Retrieves a InterBuStats resource.
 */
export const getInterBuStats = (
    params: GetInterBuStatsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<InterBuStatsJsonldReadItemInterbuStats>(
      {url: `/api/shared-datas/interbu/stats`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetInterBuStatsQueryKey = (params: GetInterBuStatsParams,) => {
    return [`/api/shared-datas/interbu/stats`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInterBuStatsQueryOptions = <TData = Awaited<ReturnType<typeof getInterBuStats>>, TError = void>(params: GetInterBuStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuStats>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterBuStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterBuStats>>> = ({ signal }) => getInterBuStats(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterBuStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterBuStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterBuStats>>>
export type GetInterBuStatsQueryError = void

/**
 * @summary Retrieves a InterBuStats resource.
 */
export const useGetInterBuStats = <TData = Awaited<ReturnType<typeof getInterBuStats>>, TError = void>(
 params: GetInterBuStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBuStats>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInterBuStatsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of ItemAction resources.
 * @summary Retrieves the collection of ItemAction resources.
 */
export const getItemActions = (
    params?: GetItemActionsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetItemActions200>(
      {url: `/api/item-actions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetItemActionsQueryKey = (params?: GetItemActionsParams,) => {
    return [`/api/item-actions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetItemActionsQueryOptions = <TData = Awaited<ReturnType<typeof getItemActions>>, TError = void>(params?: GetItemActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemActions>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemActionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemActions>>> = ({ signal }) => getItemActions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItemActions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItemActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getItemActions>>>
export type GetItemActionsQueryError = void

/**
 * @summary Retrieves the collection of ItemAction resources.
 */
export const useGetItemActions = <TData = Awaited<ReturnType<typeof getItemActions>>, TError = void>(
 params?: GetItemActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemActions>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetItemActionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a ItemAction resource.
 * @summary Creates a ItemAction resource.
 */
export const postItemActions = (
    itemActionPostItemActionsInputJsonld: ItemActionPostItemActionsInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/item-actions`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: itemActionPostItemActionsInputJsonld
    },
      options);
    }
  


export const getPostItemActionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postItemActions>>, TError,{data: ItemActionPostItemActionsInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postItemActions>>, TError,{data: ItemActionPostItemActionsInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postItemActions>>, {data: ItemActionPostItemActionsInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postItemActions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostItemActionsMutationResult = NonNullable<Awaited<ReturnType<typeof postItemActions>>>
    export type PostItemActionsMutationBody = ItemActionPostItemActionsInputJsonld
    export type PostItemActionsMutationError = void

    /**
 * @summary Creates a ItemAction resource.
 */
export const usePostItemActions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postItemActions>>, TError,{data: ItemActionPostItemActionsInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postItemActions>>,
        TError,
        {data: ItemActionPostItemActionsInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostItemActionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the ItemAction resource.
 * @summary Updates the ItemAction resource.
 */
export const patchItemActions = (
    itemActionPostItemActionsInput: ItemActionPostItemActionsInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/item-actions`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: itemActionPostItemActionsInput
    },
      options);
    }
  


export const getPatchItemActionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchItemActions>>, TError,{data: ItemActionPostItemActionsInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchItemActions>>, TError,{data: ItemActionPostItemActionsInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchItemActions>>, {data: ItemActionPostItemActionsInput}> = (props) => {
          const {data} = props ?? {};

          return  patchItemActions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchItemActionsMutationResult = NonNullable<Awaited<ReturnType<typeof patchItemActions>>>
    export type PatchItemActionsMutationBody = ItemActionPostItemActionsInput
    export type PatchItemActionsMutationError = void

    /**
 * @summary Updates the ItemAction resource.
 */
export const usePatchItemActions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchItemActions>>, TError,{data: ItemActionPostItemActionsInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchItemActions>>,
        TError,
        {data: ItemActionPostItemActionsInput},
        TContext
      > => {

      const mutationOptions = getPatchItemActionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a user token.
 * @summary Creates a user token.
 */
export const loginCheckPost = (
    loginCheckPostBody: LoginCheckPostBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<LoginCheckPost200>(
      {url: `/api_login_check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginCheckPostBody
    },
      options);
    }
  


export const getLoginCheckPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: LoginCheckPostBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: LoginCheckPostBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginCheckPost>>, {data: LoginCheckPostBody}> = (props) => {
          const {data} = props ?? {};

          return  loginCheckPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginCheckPostMutationResult = NonNullable<Awaited<ReturnType<typeof loginCheckPost>>>
    export type LoginCheckPostMutationBody = LoginCheckPostBody
    export type LoginCheckPostMutationError = unknown

    /**
 * @summary Creates a user token.
 */
export const useLoginCheckPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: LoginCheckPostBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof loginCheckPost>>,
        TError,
        {data: LoginCheckPostBody},
        TContext
      > => {

      const mutationOptions = getLoginCheckPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of MBV4 Synchro resources.
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const getBarnesStatusDeleted = (
    params?: GetBarnesStatusDeletedParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetBarnesStatusDeleted200>(
      {url: `/api/mbv4/barnes-status-deleted`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBarnesStatusDeletedQueryKey = (params?: GetBarnesStatusDeletedParams,) => {
    return [`/api/mbv4/barnes-status-deleted`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBarnesStatusDeletedQueryOptions = <TData = Awaited<ReturnType<typeof getBarnesStatusDeleted>>, TError = void>(params?: GetBarnesStatusDeletedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusDeleted>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBarnesStatusDeletedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBarnesStatusDeleted>>> = ({ signal }) => getBarnesStatusDeleted(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusDeleted>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBarnesStatusDeletedQueryResult = NonNullable<Awaited<ReturnType<typeof getBarnesStatusDeleted>>>
export type GetBarnesStatusDeletedQueryError = void

/**
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const useGetBarnesStatusDeleted = <TData = Awaited<ReturnType<typeof getBarnesStatusDeleted>>, TError = void>(
 params?: GetBarnesStatusDeletedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusDeleted>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBarnesStatusDeletedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of MBV4 Synchro resources.
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const getBarnesStatusUpdated = (
    params?: GetBarnesStatusUpdatedParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetBarnesStatusUpdated200>(
      {url: `/api/mbv4/barnes-status-updated`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBarnesStatusUpdatedQueryKey = (params?: GetBarnesStatusUpdatedParams,) => {
    return [`/api/mbv4/barnes-status-updated`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBarnesStatusUpdatedQueryOptions = <TData = Awaited<ReturnType<typeof getBarnesStatusUpdated>>, TError = void>(params?: GetBarnesStatusUpdatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusUpdated>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBarnesStatusUpdatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBarnesStatusUpdated>>> = ({ signal }) => getBarnesStatusUpdated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusUpdated>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBarnesStatusUpdatedQueryResult = NonNullable<Awaited<ReturnType<typeof getBarnesStatusUpdated>>>
export type GetBarnesStatusUpdatedQueryError = void

/**
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const useGetBarnesStatusUpdated = <TData = Awaited<ReturnType<typeof getBarnesStatusUpdated>>, TError = void>(
 params?: GetBarnesStatusUpdatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBarnesStatusUpdated>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBarnesStatusUpdatedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a MBV4 Synchro resource.
 * @summary Creates a MBV4 Synchro resource.
 */
export const postLaunchImport = (
    mBV4SynchroPostMbv4ImportInputJsonld: MBV4SynchroPostMbv4ImportInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<MBV4SynchroJsonld>(
      {url: `/api/mbv4/import-launcher`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: mBV4SynchroPostMbv4ImportInputJsonld
    },
      options);
    }
  


export const getPostLaunchImportMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLaunchImport>>, TError,{data: MBV4SynchroPostMbv4ImportInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postLaunchImport>>, TError,{data: MBV4SynchroPostMbv4ImportInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLaunchImport>>, {data: MBV4SynchroPostMbv4ImportInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postLaunchImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLaunchImportMutationResult = NonNullable<Awaited<ReturnType<typeof postLaunchImport>>>
    export type PostLaunchImportMutationBody = MBV4SynchroPostMbv4ImportInputJsonld
    export type PostLaunchImportMutationError = void

    /**
 * @summary Creates a MBV4 Synchro resource.
 */
export const usePostLaunchImport = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLaunchImport>>, TError,{data: MBV4SynchroPostMbv4ImportInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postLaunchImport>>,
        TError,
        {data: MBV4SynchroPostMbv4ImportInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostLaunchImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a MBV4 Synchro resource.
 * @summary Creates a MBV4 Synchro resource.
 */
export const postLaunchSynchro = (
    mBV4SynchroPostMbv4SynchroInputJsonld: MBV4SynchroPostMbv4SynchroInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<MBV4SynchroJsonld>(
      {url: `/api/mbv4/synchro-launcher`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: mBV4SynchroPostMbv4SynchroInputJsonld
    },
      options);
    }
  


export const getPostLaunchSynchroMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLaunchSynchro>>, TError,{data: MBV4SynchroPostMbv4SynchroInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postLaunchSynchro>>, TError,{data: MBV4SynchroPostMbv4SynchroInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLaunchSynchro>>, {data: MBV4SynchroPostMbv4SynchroInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postLaunchSynchro(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLaunchSynchroMutationResult = NonNullable<Awaited<ReturnType<typeof postLaunchSynchro>>>
    export type PostLaunchSynchroMutationBody = MBV4SynchroPostMbv4SynchroInputJsonld
    export type PostLaunchSynchroMutationError = void

    /**
 * @summary Creates a MBV4 Synchro resource.
 */
export const usePostLaunchSynchro = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLaunchSynchro>>, TError,{data: MBV4SynchroPostMbv4SynchroInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postLaunchSynchro>>,
        TError,
        {data: MBV4SynchroPostMbv4SynchroInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostLaunchSynchroMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a MBV4 Synchro resource.
 * @summary Creates a MBV4 Synchro resource.
 */
export const postLoadSynchroLog = (
    mBV4SynchroSynchroLogDTOJsonld: MBV4SynchroSynchroLogDTOJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/mbv4/synchro-log`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: mBV4SynchroSynchroLogDTOJsonld
    },
      options);
    }
  


export const getPostLoadSynchroLogMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLoadSynchroLog>>, TError,{data: MBV4SynchroSynchroLogDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postLoadSynchroLog>>, TError,{data: MBV4SynchroSynchroLogDTOJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLoadSynchroLog>>, {data: MBV4SynchroSynchroLogDTOJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postLoadSynchroLog(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLoadSynchroLogMutationResult = NonNullable<Awaited<ReturnType<typeof postLoadSynchroLog>>>
    export type PostLoadSynchroLogMutationBody = MBV4SynchroSynchroLogDTOJsonld
    export type PostLoadSynchroLogMutationError = void

    /**
 * @summary Creates a MBV4 Synchro resource.
 */
export const usePostLoadSynchroLog = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLoadSynchroLog>>, TError,{data: MBV4SynchroSynchroLogDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postLoadSynchroLog>>,
        TError,
        {data: MBV4SynchroSynchroLogDTOJsonld},
        TContext
      > => {

      const mutationOptions = getPostLoadSynchroLogMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of MBV4 Synchro resources.
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const getSynchroStatus = (
    params?: GetSynchroStatusParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetSynchroStatus200>(
      {url: `/api/mbv4/synchro-status`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSynchroStatusQueryKey = (params?: GetSynchroStatusParams,) => {
    return [`/api/mbv4/synchro-status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSynchroStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSynchroStatus>>, TError = void>(params?: GetSynchroStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSynchroStatus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSynchroStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSynchroStatus>>> = ({ signal }) => getSynchroStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSynchroStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSynchroStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSynchroStatus>>>
export type GetSynchroStatusQueryError = void

/**
 * @summary Retrieves the collection of MBV4 Synchro resources.
 */
export const useGetSynchroStatus = <TData = Awaited<ReturnType<typeof getSynchroStatus>>, TError = void>(
 params?: GetSynchroStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSynchroStatus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSynchroStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of MarketSegment resources.
 * @summary Retrieves the collection of MarketSegment resources.
 */
export const getMarketSegments = (
    params?: GetMarketSegmentsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetMarketSegments200>(
      {url: `/api/market-segments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMarketSegmentsQueryKey = (params?: GetMarketSegmentsParams,) => {
    return [`/api/market-segments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMarketSegmentsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketSegments>>, TError = void>(params?: GetMarketSegmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketSegments>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketSegmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketSegments>>> = ({ signal }) => getMarketSegments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketSegments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketSegmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketSegments>>>
export type GetMarketSegmentsQueryError = void

/**
 * @summary Retrieves the collection of MarketSegment resources.
 */
export const useGetMarketSegments = <TData = Awaited<ReturnType<typeof getMarketSegments>>, TError = void>(
 params?: GetMarketSegmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketSegments>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMarketSegmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a MarketSegment resource.
 * @summary Creates a MarketSegment resource.
 */
export const postMarketSegment = (
    marketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<MarketSegmentJsonldWriteItemMarketSegmentItem>(
      {url: `/api/market-segments`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: marketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem
    },
      options);
    }
  


export const getPostMarketSegmentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketSegment>>, TError,{data: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketSegment>>, TError,{data: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketSegment>>, {data: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem}> = (props) => {
          const {data} = props ?? {};

          return  postMarketSegment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketSegment>>>
    export type PostMarketSegmentMutationBody = MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem
    export type PostMarketSegmentMutationError = void

    /**
 * @summary Creates a MarketSegment resource.
 */
export const usePostMarketSegment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketSegment>>, TError,{data: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMarketSegment>>,
        TError,
        {data: MarketSegmentPostMarketSegmentInputJsonldWriteItemMarketSegmentItem},
        TContext
      > => {

      const mutationOptions = getPostMarketSegmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a MarketSegment resource.
 * @summary Creates a MarketSegment resource.
 */
export const postApplyMarketSegment = (
    marketSegmentPostApplyMarketSegmentInputJsonld: MarketSegmentPostApplyMarketSegmentInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/market-segments/apply`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: marketSegmentPostApplyMarketSegmentInputJsonld
    },
      options);
    }
  


export const getPostApplyMarketSegmentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplyMarketSegment>>, TError,{data: MarketSegmentPostApplyMarketSegmentInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplyMarketSegment>>, TError,{data: MarketSegmentPostApplyMarketSegmentInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplyMarketSegment>>, {data: MarketSegmentPostApplyMarketSegmentInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postApplyMarketSegment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplyMarketSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof postApplyMarketSegment>>>
    export type PostApplyMarketSegmentMutationBody = MarketSegmentPostApplyMarketSegmentInputJsonld
    export type PostApplyMarketSegmentMutationError = void

    /**
 * @summary Creates a MarketSegment resource.
 */
export const usePostApplyMarketSegment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplyMarketSegment>>, TError,{data: MarketSegmentPostApplyMarketSegmentInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postApplyMarketSegment>>,
        TError,
        {data: MarketSegmentPostApplyMarketSegmentInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostApplyMarketSegmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a MarketSegment resource.
 * @summary Retrieves a MarketSegment resource.
 */
export const getMarketSegmentById = (
    id: string,
    params?: GetMarketSegmentByIdParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<MarketSegmentJsonldReadItemMarketSegmentItem>(
      {url: `/api/market-segments/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMarketSegmentByIdQueryKey = (id: string,
    params?: GetMarketSegmentByIdParams,) => {
    return [`/api/market-segments/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMarketSegmentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getMarketSegmentById>>, TError = void>(id: string,
    params?: GetMarketSegmentByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketSegmentById>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketSegmentByIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketSegmentById>>> = ({ signal }) => getMarketSegmentById(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketSegmentById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketSegmentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketSegmentById>>>
export type GetMarketSegmentByIdQueryError = void

/**
 * @summary Retrieves a MarketSegment resource.
 */
export const useGetMarketSegmentById = <TData = Awaited<ReturnType<typeof getMarketSegmentById>>, TError = void>(
 id: string,
    params?: GetMarketSegmentByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketSegmentById>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMarketSegmentByIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the MarketSegment resource.
 * @summary Removes the MarketSegment resource.
 */
export const deleteMarketSegment = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/market-segments/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMarketSegmentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketSegment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketSegment>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketSegment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMarketSegment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketSegment>>>
    
    export type DeleteMarketSegmentMutationError = void

    /**
 * @summary Removes the MarketSegment resource.
 */
export const useDeleteMarketSegment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketSegment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketSegment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMarketSegmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the MarketSegment resource.
 * @summary Updates the MarketSegment resource.
 */
export const patchMarketSegment = (
    id: string,
    marketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/market-segments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: marketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem
    },
      options);
    }
  


export const getPatchMarketSegmentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMarketSegment>>, TError,{id: string;data: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMarketSegment>>, TError,{id: string;data: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMarketSegment>>, {id: string;data: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem}> = (props) => {
          const {id,data} = props ?? {};

          return  patchMarketSegment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMarketSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof patchMarketSegment>>>
    export type PatchMarketSegmentMutationBody = MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem
    export type PatchMarketSegmentMutationError = void

    /**
 * @summary Updates the MarketSegment resource.
 */
export const usePatchMarketSegment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMarketSegment>>, TError,{id: string;data: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchMarketSegment>>,
        TError,
        {id: string;data: MarketSegmentPatchMarketSegmentInputWriteItemMarketSegmentItem},
        TContext
      > => {

      const mutationOptions = getPatchMarketSegmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Media resource.
 * @summary Retrieves a Media resource.
 */
export const getFile = (
    folderName: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<MediaJsonld>(
      {url: `/api/medias/file/${folderName}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFileQueryKey = (folderName: string,) => {
    return [`/api/medias/file/${folderName}`] as const;
    }

    
export const getGetFileQueryOptions = <TData = Awaited<ReturnType<typeof getFile>>, TError = void>(folderName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileQueryKey(folderName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFile>>> = ({ signal }) => getFile(folderName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(folderName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFile>>>
export type GetFileQueryError = void

/**
 * @summary Retrieves a Media resource.
 */
export const useGetFile = <TData = Awaited<ReturnType<typeof getFile>>, TError = void>(
 folderName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFileQueryOptions(folderName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Media resources.
 * @summary Retrieves the collection of Media resources.
 */
export const listFile = (
    folderName: string,
    params?: ListFileParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ListFile200>(
      {url: `/api/medias/files/${folderName}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getListFileQueryKey = (folderName: string,
    params?: ListFileParams,) => {
    return [`/api/medias/files/${folderName}`, ...(params ? [params]: [])] as const;
    }

    
export const getListFileQueryOptions = <TData = Awaited<ReturnType<typeof listFile>>, TError = void>(folderName: string,
    params?: ListFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFileQueryKey(folderName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFile>>> = ({ signal }) => listFile(folderName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(folderName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFileQueryResult = NonNullable<Awaited<ReturnType<typeof listFile>>>
export type ListFileQueryError = void

/**
 * @summary Retrieves the collection of Media resources.
 */
export const useListFile = <TData = Awaited<ReturnType<typeof listFile>>, TError = void>(
 folderName: string,
    params?: ListFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListFileQueryOptions(folderName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Media resources.
 * @summary Retrieves the collection of Media resources.
 */
export const listFolder = (
    folderName: string,
    params?: ListFolderParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ListFolder200>(
      {url: `/api/medias/folders/${folderName}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getListFolderQueryKey = (folderName: string,
    params?: ListFolderParams,) => {
    return [`/api/medias/folders/${folderName}`, ...(params ? [params]: [])] as const;
    }

    
export const getListFolderQueryOptions = <TData = Awaited<ReturnType<typeof listFolder>>, TError = void>(folderName: string,
    params?: ListFolderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFolder>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFolderQueryKey(folderName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolder>>> = ({ signal }) => listFolder(folderName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(folderName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFolder>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFolderQueryResult = NonNullable<Awaited<ReturnType<typeof listFolder>>>
export type ListFolderQueryError = void

/**
 * @summary Retrieves the collection of Media resources.
 */
export const useListFolder = <TData = Awaited<ReturnType<typeof listFolder>>, TError = void>(
 folderName: string,
    params?: ListFolderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFolder>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListFolderQueryOptions(folderName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of MediaFolder resources.
 * @summary Retrieves the collection of MediaFolder resources.
 */
export const apiMediaFoldersGetCollection = (
    params?: ApiMediaFoldersGetCollectionParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ApiMediaFoldersGetCollection200>(
      {url: `/api/media-folders`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getApiMediaFoldersGetCollectionQueryKey = (params?: ApiMediaFoldersGetCollectionParams,) => {
    return [`/api/media-folders`, ...(params ? [params]: [])] as const;
    }

    
export const getApiMediaFoldersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>, TError = void>(params?: ApiMediaFoldersGetCollectionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMediaFoldersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>> = ({ signal }) => apiMediaFoldersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiMediaFoldersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>>
export type ApiMediaFoldersGetCollectionQueryError = void

/**
 * @summary Retrieves the collection of MediaFolder resources.
 */
export const useApiMediaFoldersGetCollection = <TData = Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>, TError = void>(
 params?: ApiMediaFoldersGetCollectionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiMediaFoldersGetCollection>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getApiMediaFoldersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of People resources.
 * @summary Retrieves the collection of People resources.
 */
export const getPeoples = (
    params?: GetPeoplesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPeoples200>(
      {url: `/api/people`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPeoplesQueryKey = (params?: GetPeoplesParams,) => {
    return [`/api/people`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPeoplesQueryOptions = <TData = Awaited<ReturnType<typeof getPeoples>>, TError = void>(params?: GetPeoplesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeoples>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeoplesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeoples>>> = ({ signal }) => getPeoples(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPeoples>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPeoplesQueryResult = NonNullable<Awaited<ReturnType<typeof getPeoples>>>
export type GetPeoplesQueryError = void

/**
 * @summary Retrieves the collection of People resources.
 */
export const useGetPeoples = <TData = Awaited<ReturnType<typeof getPeoples>>, TError = void>(
 params?: GetPeoplesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeoples>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPeoplesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a People resource.
 * @summary Creates a People resource.
 */
export const postPeople = (
    peoplePostPeopleInputJsonld: PeoplePostPeopleInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<PeoplePostPeopleResponse | unknown>(
      {url: `/api/people`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: peoplePostPeopleInputJsonld
    },
      options);
    }
  


export const getPostPeopleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPeople>>, TError,{data: PeoplePostPeopleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postPeople>>, TError,{data: PeoplePostPeopleInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPeople>>, {data: PeoplePostPeopleInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postPeople(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof postPeople>>>
    export type PostPeopleMutationBody = PeoplePostPeopleInputJsonld
    export type PostPeopleMutationError = void

    /**
 * @summary Creates a People resource.
 */
export const usePostPeople = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPeople>>, TError,{data: PeoplePostPeopleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postPeople>>,
        TError,
        {data: PeoplePostPeopleInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostPeopleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of People resources.
 * @summary Retrieves the collection of People resources.
 */
export const getPeoplesExcelExportData = (
    params?: GetPeoplesExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPeoplesExcelExportData200>(
      {url: `/api/people/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPeoplesExcelExportDataQueryKey = (params?: GetPeoplesExcelExportDataParams,) => {
    return [`/api/people/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPeoplesExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getPeoplesExcelExportData>>, TError = void>(params?: GetPeoplesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeoplesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeoplesExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeoplesExcelExportData>>> = ({ signal }) => getPeoplesExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPeoplesExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPeoplesExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPeoplesExcelExportData>>>
export type GetPeoplesExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of People resources.
 */
export const useGetPeoplesExcelExportData = <TData = Awaited<ReturnType<typeof getPeoplesExcelExportData>>, TError = void>(
 params?: GetPeoplesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeoplesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPeoplesExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a People resource.
 * @summary Creates a People resource.
 */
export const postPeopleReassign = (
    peoplePostReassignPeopleInputJsonld: PeoplePostReassignPeopleInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/people/reassign`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: peoplePostReassignPeopleInputJsonld
    },
      options);
    }
  


export const getPostPeopleReassignMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPeopleReassign>>, TError,{data: PeoplePostReassignPeopleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postPeopleReassign>>, TError,{data: PeoplePostReassignPeopleInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPeopleReassign>>, {data: PeoplePostReassignPeopleInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postPeopleReassign(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPeopleReassignMutationResult = NonNullable<Awaited<ReturnType<typeof postPeopleReassign>>>
    export type PostPeopleReassignMutationBody = PeoplePostReassignPeopleInputJsonld
    export type PostPeopleReassignMutationError = void

    /**
 * @summary Creates a People resource.
 */
export const usePostPeopleReassign = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPeopleReassign>>, TError,{data: PeoplePostReassignPeopleInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postPeopleReassign>>,
        TError,
        {data: PeoplePostReassignPeopleInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostPeopleReassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of People resources.
 * @summary Retrieves the collection of People resources.
 */
export const getSimilarPeople = (
    id: string,
    params?: GetSimilarPeopleParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetSimilarPeople200>(
      {url: `/api/people/similar/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSimilarPeopleQueryKey = (id: string,
    params?: GetSimilarPeopleParams,) => {
    return [`/api/people/similar/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSimilarPeopleQueryOptions = <TData = Awaited<ReturnType<typeof getSimilarPeople>>, TError = void>(id: string,
    params?: GetSimilarPeopleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimilarPeople>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimilarPeopleQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimilarPeople>>> = ({ signal }) => getSimilarPeople(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimilarPeople>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSimilarPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getSimilarPeople>>>
export type GetSimilarPeopleQueryError = void

/**
 * @summary Retrieves the collection of People resources.
 */
export const useGetSimilarPeople = <TData = Awaited<ReturnType<typeof getSimilarPeople>>, TError = void>(
 id: string,
    params?: GetSimilarPeopleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimilarPeople>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSimilarPeopleQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a People resource.
 * @summary Retrieves a People resource.
 */
export const getPeople = (
    id: string,
    params?: GetPeopleParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<PeopleJsonldReadItemPeople>(
      {url: `/api/people/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPeopleQueryKey = (id: string,
    params?: GetPeopleParams,) => {
    return [`/api/people/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPeopleQueryOptions = <TData = Awaited<ReturnType<typeof getPeople>>, TError = void>(id: string,
    params?: GetPeopleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeopleQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeople>>> = ({ signal }) => getPeople(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getPeople>>>
export type GetPeopleQueryError = void

/**
 * @summary Retrieves a People resource.
 */
export const useGetPeople = <TData = Awaited<ReturnType<typeof getPeople>>, TError = void>(
 id: string,
    params?: GetPeopleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPeopleQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates the People resource.
 * @summary Updates the People resource.
 */
export const patchPeople = (
    id: string,
    peoplePatchPeopleInput: PeoplePatchPeopleInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/people/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: peoplePatchPeopleInput
    },
      options);
    }
  


export const getPatchPeopleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPeople>>, TError,{id: string;data: PeoplePatchPeopleInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPeople>>, TError,{id: string;data: PeoplePatchPeopleInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPeople>>, {id: string;data: PeoplePatchPeopleInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPeople(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof patchPeople>>>
    export type PatchPeopleMutationBody = PeoplePatchPeopleInput
    export type PatchPeopleMutationError = void

    /**
 * @summary Updates the People resource.
 */
export const usePatchPeople = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPeople>>, TError,{id: string;data: PeoplePatchPeopleInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchPeople>>,
        TError,
        {id: string;data: PeoplePatchPeopleInput},
        TContext
      > => {

      const mutationOptions = getPatchPeopleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Project resource.
 * @summary Retrieves a Project resource.
 */
export const getProject = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<ProjectJsonldReadItemProject>(
      {url: `/api/project/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProjectQueryKey = (id: string,) => {
    return [`/api/project/${id}`] as const;
    }

    
export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = void

/**
 * @summary Retrieves a Project resource.
 */
export const useGetProject = <TData = Awaited<ReturnType<typeof getProject>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Project resources.
 * @summary Retrieves the collection of Project resources.
 */
export const getProjects = (
    params?: GetProjectsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetProjects200>(
      {url: `/api/projects`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProjectsQueryKey = (params?: GetProjectsParams,) => {
    return [`/api/projects`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getProjects>>, TError = void>(params?: GetProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>
export type GetProjectsQueryError = void

/**
 * @summary Retrieves the collection of Project resources.
 */
export const useGetProjects = <TData = Awaited<ReturnType<typeof getProjects>>, TError = void>(
 params?: GetProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Project resources.
 * @summary Retrieves the collection of Project resources.
 */
export const getProjectsExcelExportData = (
    params?: GetProjectsExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetProjectsExcelExportData200>(
      {url: `/api/projects/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProjectsExcelExportDataQueryKey = (params?: GetProjectsExcelExportDataParams,) => {
    return [`/api/projects/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectsExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getProjectsExcelExportData>>, TError = void>(params?: GetProjectsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectsExcelExportData>>> = ({ signal }) => getProjectsExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectsExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectsExcelExportData>>>
export type GetProjectsExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Project resources.
 */
export const useGetProjectsExcelExportData = <TData = Awaited<ReturnType<typeof getProjectsExcelExportData>>, TError = void>(
 params?: GetProjectsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectsExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Property resources.
 * @summary Retrieves the collection of Property resources.
 */
export const getProperties = (
    params?: GetPropertiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetProperties200>(
      {url: `/api/properties`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesQueryKey = (params?: GetPropertiesParams,) => {
    return [`/api/properties`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getProperties>>, TError = void>(params?: GetPropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperties>>> = ({ signal }) => getProperties(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProperties>>>
export type GetPropertiesQueryError = void

/**
 * @summary Retrieves the collection of Property resources.
 */
export const useGetProperties = <TData = Awaited<ReturnType<typeof getProperties>>, TError = void>(
 params?: GetPropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Property resources.
 * @summary Retrieves the collection of Property resources.
 */
export const getPropertiesExcelExportData = (
    params?: GetPropertiesExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPropertiesExcelExportData200>(
      {url: `/api/properties/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesExcelExportDataQueryKey = (params?: GetPropertiesExcelExportDataParams,) => {
    return [`/api/properties/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesExcelExportData>>, TError = void>(params?: GetPropertiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesExcelExportData>>> = ({ signal }) => getPropertiesExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesExcelExportData>>>
export type GetPropertiesExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Property resources.
 */
export const useGetPropertiesExcelExportData = <TData = Awaited<ReturnType<typeof getPropertiesExcelExportData>>, TError = void>(
 params?: GetPropertiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Property resource.
 * @summary Retrieves a Property resource.
 */
export const getProperty = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<PropertyJsonldReadItemProperty>(
      {url: `/api/property/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPropertyQueryKey = (id: string,) => {
    return [`/api/property/${id}`] as const;
    }

    
export const getGetPropertyQueryOptions = <TData = Awaited<ReturnType<typeof getProperty>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperty>>> = ({ signal }) => getProperty(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getProperty>>>
export type GetPropertyQueryError = void

/**
 * @summary Retrieves a Property resource.
 */
export const useGetProperty = <TData = Awaited<ReturnType<typeof getProperty>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertyQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a PropertyOffer resource.
 * @summary Retrieves a PropertyOffer resource.
 */
export const getPropertyOffer = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<PropertyOfferJsonldReadItemPropertyOffer>(
      {url: `/api/property-offer/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPropertyOfferQueryKey = (id: string,) => {
    return [`/api/property-offer/${id}`] as const;
    }

    
export const getGetPropertyOfferQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyOffer>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertyOffer>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyOfferQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyOffer>>> = ({ signal }) => getPropertyOffer(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyOffer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertyOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyOffer>>>
export type GetPropertyOfferQueryError = void

/**
 * @summary Retrieves a PropertyOffer resource.
 */
export const useGetPropertyOffer = <TData = Awaited<ReturnType<typeof getPropertyOffer>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertyOffer>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertyOfferQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of PropertyOffer resources.
 * @summary Retrieves the collection of PropertyOffer resources.
 */
export const getPropertiesOffer = (
    params?: GetPropertiesOfferParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPropertiesOffer200>(
      {url: `/api/property-offers`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesOfferQueryKey = (params?: GetPropertiesOfferParams,) => {
    return [`/api/property-offers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesOfferQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesOffer>>, TError = void>(params?: GetPropertiesOfferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOffer>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesOfferQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesOffer>>> = ({ signal }) => getPropertiesOffer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOffer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesOffer>>>
export type GetPropertiesOfferQueryError = void

/**
 * @summary Retrieves the collection of PropertyOffer resources.
 */
export const useGetPropertiesOffer = <TData = Awaited<ReturnType<typeof getPropertiesOffer>>, TError = void>(
 params?: GetPropertiesOfferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOffer>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesOfferQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of PropertyOffer resources.
 * @summary Retrieves the collection of PropertyOffer resources.
 */
export const getPropertiesOfferOfferExcelExportData = (
    params?: GetPropertiesOfferOfferExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPropertiesOfferOfferExcelExportData200>(
      {url: `/api/property-offers/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesOfferOfferExcelExportDataQueryKey = (params?: GetPropertiesOfferOfferExcelExportDataParams,) => {
    return [`/api/property-offers/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesOfferOfferExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>, TError = void>(params?: GetPropertiesOfferOfferExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesOfferOfferExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>> = ({ signal }) => getPropertiesOfferOfferExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesOfferOfferExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>>
export type GetPropertiesOfferOfferExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of PropertyOffer resources.
 */
export const useGetPropertiesOfferOfferExcelExportData = <TData = Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>, TError = void>(
 params?: GetPropertiesOfferOfferExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesOfferOfferExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesOfferOfferExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a PropertySearch resource.
 * @summary Retrieves a PropertySearch resource.
 */
export const getPropertySearch = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<PropertySearchJsonldReadItemPropertySearch>(
      {url: `/api/property-search/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPropertySearchQueryKey = (id: string,) => {
    return [`/api/property-search/${id}`] as const;
    }

    
export const getGetPropertySearchQueryOptions = <TData = Awaited<ReturnType<typeof getPropertySearch>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertySearch>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertySearchQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertySearch>>> = ({ signal }) => getPropertySearch(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertySearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertySearchQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertySearch>>>
export type GetPropertySearchQueryError = void

/**
 * @summary Retrieves a PropertySearch resource.
 */
export const useGetPropertySearch = <TData = Awaited<ReturnType<typeof getPropertySearch>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertySearch>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertySearchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of PropertySearch resources.
 * @summary Retrieves the collection of PropertySearch resources.
 */
export const getPropertiesSearch = (
    params?: GetPropertiesSearchParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPropertiesSearch200>(
      {url: `/api/property-searches`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesSearchQueryKey = (params?: GetPropertiesSearchParams,) => {
    return [`/api/property-searches`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesSearchQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesSearch>>, TError = void>(params?: GetPropertiesSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearch>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesSearch>>> = ({ signal }) => getPropertiesSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesSearch>>>
export type GetPropertiesSearchQueryError = void

/**
 * @summary Retrieves the collection of PropertySearch resources.
 */
export const useGetPropertiesSearch = <TData = Awaited<ReturnType<typeof getPropertiesSearch>>, TError = void>(
 params?: GetPropertiesSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearch>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of PropertySearch resources.
 * @summary Retrieves the collection of PropertySearch resources.
 */
export const getPropertiesSearchExcelExportData = (
    params?: GetPropertiesSearchExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetPropertiesSearchExcelExportData200>(
      {url: `/api/property-searches/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPropertiesSearchExcelExportDataQueryKey = (params?: GetPropertiesSearchExcelExportDataParams,) => {
    return [`/api/property-searches/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPropertiesSearchExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>, TError = void>(params?: GetPropertiesSearchExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesSearchExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>> = ({ signal }) => getPropertiesSearchExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPropertiesSearchExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>>
export type GetPropertiesSearchExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of PropertySearch resources.
 */
export const useGetPropertiesSearchExcelExportData = <TData = Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>, TError = void>(
 params?: GetPropertiesSearchExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSearchExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPropertiesSearchExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a RefLabel resource.
 * @summary Retrieves a RefLabel resource.
 */
export const getRefLabel = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<RefLabelJsonldReadItemRefLabelItem>(
      {url: `/api/ref-label/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRefLabelQueryKey = (id: string,) => {
    return [`/api/ref-label/${id}`] as const;
    }

    
export const getGetRefLabelQueryOptions = <TData = Awaited<ReturnType<typeof getRefLabel>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabel>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefLabelQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefLabel>>> = ({ signal }) => getRefLabel(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefLabel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefLabelQueryResult = NonNullable<Awaited<ReturnType<typeof getRefLabel>>>
export type GetRefLabelQueryError = void

/**
 * @summary Retrieves a RefLabel resource.
 */
export const useGetRefLabel = <TData = Awaited<ReturnType<typeof getRefLabel>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabel>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRefLabelQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of RefLabel resources.
 * @summary Retrieves the collection of RefLabel resources.
 */
export const getRefLabels = (
    params?: GetRefLabelsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetRefLabels200>(
      {url: `/api/ref-labels`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRefLabelsQueryKey = (params?: GetRefLabelsParams,) => {
    return [`/api/ref-labels`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRefLabelsQueryOptions = <TData = Awaited<ReturnType<typeof getRefLabels>>, TError = void>(params?: GetRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefLabelsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefLabels>>> = ({ signal }) => getRefLabels(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefLabels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof getRefLabels>>>
export type GetRefLabelsQueryError = void

/**
 * @summary Retrieves the collection of RefLabel resources.
 */
export const useGetRefLabels = <TData = Awaited<ReturnType<typeof getRefLabels>>, TError = void>(
 params?: GetRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRefLabelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a RefLabel resource.
 * @summary Creates a RefLabel resource.
 */
export const postRefLabel = (
    refLabelPostRefLabelInputJsonld: RefLabelPostRefLabelInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/ref-labels`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: refLabelPostRefLabelInputJsonld
    },
      options);
    }
  


export const getPostRefLabelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRefLabel>>, TError,{data: RefLabelPostRefLabelInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postRefLabel>>, TError,{data: RefLabelPostRefLabelInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRefLabel>>, {data: RefLabelPostRefLabelInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postRefLabel(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRefLabelMutationResult = NonNullable<Awaited<ReturnType<typeof postRefLabel>>>
    export type PostRefLabelMutationBody = RefLabelPostRefLabelInputJsonld
    export type PostRefLabelMutationError = void

    /**
 * @summary Creates a RefLabel resource.
 */
export const usePostRefLabel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRefLabel>>, TError,{data: RefLabelPostRefLabelInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRefLabel>>,
        TError,
        {data: RefLabelPostRefLabelInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostRefLabelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of RefLabel resources.
 * @summary Retrieves the collection of RefLabel resources.
 */
export const getCountriesRefLabels = (
    params?: GetCountriesRefLabelsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetCountriesRefLabels200>(
      {url: `/api/ref-labels/countries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCountriesRefLabelsQueryKey = (params?: GetCountriesRefLabelsParams,) => {
    return [`/api/ref-labels/countries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCountriesRefLabelsQueryOptions = <TData = Awaited<ReturnType<typeof getCountriesRefLabels>>, TError = void>(params?: GetCountriesRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCountriesRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountriesRefLabelsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountriesRefLabels>>> = ({ signal }) => getCountriesRefLabels(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountriesRefLabels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCountriesRefLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof getCountriesRefLabels>>>
export type GetCountriesRefLabelsQueryError = void

/**
 * @summary Retrieves the collection of RefLabel resources.
 */
export const useGetCountriesRefLabels = <TData = Awaited<ReturnType<typeof getCountriesRefLabels>>, TError = void>(
 params?: GetCountriesRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCountriesRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCountriesRefLabelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of RefLabel resources.
 * @summary Retrieves the collection of RefLabel resources.
 */
export const getRefLabelsExcelExportData = (
    params?: GetRefLabelsExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetRefLabelsExcelExportData200>(
      {url: `/api/ref-labels/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRefLabelsExcelExportDataQueryKey = (params?: GetRefLabelsExcelExportDataParams,) => {
    return [`/api/ref-labels/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRefLabelsExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getRefLabelsExcelExportData>>, TError = void>(params?: GetRefLabelsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefLabelsExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefLabelsExcelExportData>>> = ({ signal }) => getRefLabelsExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefLabelsExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefLabelsExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getRefLabelsExcelExportData>>>
export type GetRefLabelsExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of RefLabel resources.
 */
export const useGetRefLabelsExcelExportData = <TData = Awaited<ReturnType<typeof getRefLabelsExcelExportData>>, TError = void>(
 params?: GetRefLabelsExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelsExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRefLabelsExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of RefLabel resources.
 * @summary Retrieves the collection of RefLabel resources.
 */
export const getLocalesRefLabels = (
    params?: GetLocalesRefLabelsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetLocalesRefLabels200>(
      {url: `/api/ref-labels/locales`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLocalesRefLabelsQueryKey = (params?: GetLocalesRefLabelsParams,) => {
    return [`/api/ref-labels/locales`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLocalesRefLabelsQueryOptions = <TData = Awaited<ReturnType<typeof getLocalesRefLabels>>, TError = void>(params?: GetLocalesRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocalesRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocalesRefLabelsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocalesRefLabels>>> = ({ signal }) => getLocalesRefLabels(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocalesRefLabels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocalesRefLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocalesRefLabels>>>
export type GetLocalesRefLabelsQueryError = void

/**
 * @summary Retrieves the collection of RefLabel resources.
 */
export const useGetLocalesRefLabels = <TData = Awaited<ReturnType<typeof getLocalesRefLabels>>, TError = void>(
 params?: GetLocalesRefLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocalesRefLabels>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLocalesRefLabelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the RefLabel resource.
 * @summary Removes the RefLabel resource.
 */
export const deleteRefLabel = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/ref-labels/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRefLabelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabel>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRefLabel>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRefLabel(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRefLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRefLabel>>>
    
    export type DeleteRefLabelMutationError = void

    /**
 * @summary Removes the RefLabel resource.
 */
export const useDeleteRefLabel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRefLabel>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRefLabelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the RefLabel resource.
 * @summary Updates the RefLabel resource.
 */
export const patchRefLabel = (
    id: string,
    refLabelPatchRefLabelInput: RefLabelPatchRefLabelInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/ref-labels/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: refLabelPatchRefLabelInput
    },
      options);
    }
  


export const getPatchRefLabelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRefLabel>>, TError,{id: string;data: RefLabelPatchRefLabelInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchRefLabel>>, TError,{id: string;data: RefLabelPatchRefLabelInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchRefLabel>>, {id: string;data: RefLabelPatchRefLabelInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchRefLabel(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchRefLabelMutationResult = NonNullable<Awaited<ReturnType<typeof patchRefLabel>>>
    export type PatchRefLabelMutationBody = RefLabelPatchRefLabelInput
    export type PatchRefLabelMutationError = void

    /**
 * @summary Updates the RefLabel resource.
 */
export const usePatchRefLabel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRefLabel>>, TError,{id: string;data: RefLabelPatchRefLabelInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchRefLabel>>,
        TError,
        {id: string;data: RefLabelPatchRefLabelInput},
        TContext
      > => {

      const mutationOptions = getPatchRefLabelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a RefLabelGroup resource.
 * @summary Retrieves a RefLabelGroup resource.
 */
export const getRefLabelGroup = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<RefLabelGroupJsonldReadItemRefLabelGroupItem>(
      {url: `/api/ref-label-group/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRefLabelGroupQueryKey = (id: string,) => {
    return [`/api/ref-label-group/${id}`] as const;
    }

    
export const getGetRefLabelGroupQueryOptions = <TData = Awaited<ReturnType<typeof getRefLabelGroup>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroup>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefLabelGroupQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefLabelGroup>>> = ({ signal }) => getRefLabelGroup(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefLabelGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getRefLabelGroup>>>
export type GetRefLabelGroupQueryError = void

/**
 * @summary Retrieves a RefLabelGroup resource.
 */
export const useGetRefLabelGroup = <TData = Awaited<ReturnType<typeof getRefLabelGroup>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroup>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRefLabelGroupQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of RefLabelGroup resources.
 * @summary Retrieves the collection of RefLabelGroup resources.
 */
export const getRefLabelGroups = (
    params?: GetRefLabelGroupsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetRefLabelGroups200>(
      {url: `/api/ref-label-groups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRefLabelGroupsQueryKey = (params?: GetRefLabelGroupsParams,) => {
    return [`/api/ref-label-groups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRefLabelGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getRefLabelGroups>>, TError = void>(params?: GetRefLabelGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroups>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefLabelGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefLabelGroups>>> = ({ signal }) => getRefLabelGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefLabelGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getRefLabelGroups>>>
export type GetRefLabelGroupsQueryError = void

/**
 * @summary Retrieves the collection of RefLabelGroup resources.
 */
export const useGetRefLabelGroups = <TData = Awaited<ReturnType<typeof getRefLabelGroups>>, TError = void>(
 params?: GetRefLabelGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefLabelGroups>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRefLabelGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a RefLabelGroup resource.
 * @summary Creates a RefLabelGroup resource.
 */
export const postRefLabelGroup = (
    refLabelGroupPostRefLabelGroupInputJsonld: RefLabelGroupPostRefLabelGroupInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/ref-label-groups`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: refLabelGroupPostRefLabelGroupInputJsonld
    },
      options);
    }
  


export const getPostRefLabelGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRefLabelGroup>>, TError,{data: RefLabelGroupPostRefLabelGroupInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postRefLabelGroup>>, TError,{data: RefLabelGroupPostRefLabelGroupInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRefLabelGroup>>, {data: RefLabelGroupPostRefLabelGroupInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postRefLabelGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRefLabelGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postRefLabelGroup>>>
    export type PostRefLabelGroupMutationBody = RefLabelGroupPostRefLabelGroupInputJsonld
    export type PostRefLabelGroupMutationError = void

    /**
 * @summary Creates a RefLabelGroup resource.
 */
export const usePostRefLabelGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRefLabelGroup>>, TError,{data: RefLabelGroupPostRefLabelGroupInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRefLabelGroup>>,
        TError,
        {data: RefLabelGroupPostRefLabelGroupInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostRefLabelGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the RefLabelGroup resource.
 * @summary Removes the RefLabelGroup resource.
 */
export const deleteRefLabelGroup = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/ref-label-groups/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRefLabelGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelGroup>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelGroup>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRefLabelGroup>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRefLabelGroup(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRefLabelGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRefLabelGroup>>>
    
    export type DeleteRefLabelGroupMutationError = void

    /**
 * @summary Removes the RefLabelGroup resource.
 */
export const useDeleteRefLabelGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelGroup>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRefLabelGroup>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRefLabelGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the RefLabelGroup resource.
 * @summary Updates the RefLabelGroup resource.
 */
export const patchRefLabelGroup = (
    id: string,
    refLabelGroupPatchRefLabelGroupInput: RefLabelGroupPatchRefLabelGroupInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/ref-label-groups/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: refLabelGroupPatchRefLabelGroupInput
    },
      options);
    }
  


export const getPatchRefLabelGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRefLabelGroup>>, TError,{id: string;data: RefLabelGroupPatchRefLabelGroupInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchRefLabelGroup>>, TError,{id: string;data: RefLabelGroupPatchRefLabelGroupInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchRefLabelGroup>>, {id: string;data: RefLabelGroupPatchRefLabelGroupInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchRefLabelGroup(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchRefLabelGroupMutationResult = NonNullable<Awaited<ReturnType<typeof patchRefLabelGroup>>>
    export type PatchRefLabelGroupMutationBody = RefLabelGroupPatchRefLabelGroupInput
    export type PatchRefLabelGroupMutationError = void

    /**
 * @summary Updates the RefLabelGroup resource.
 */
export const usePatchRefLabelGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRefLabelGroup>>, TError,{id: string;data: RefLabelGroupPatchRefLabelGroupInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchRefLabelGroup>>,
        TError,
        {id: string;data: RefLabelGroupPatchRefLabelGroupInput},
        TContext
      > => {

      const mutationOptions = getPatchRefLabelGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the RefLabelGroupRelation resource.
 * @summary Removes the RefLabelGroupRelation resource.
 */
export const deleteRefLabelRelation = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/ref-label-group-relations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRefLabelRelationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelRelation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelRelation>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRefLabelRelation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRefLabelRelation(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRefLabelRelationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRefLabelRelation>>>
    
    export type DeleteRefLabelRelationMutationError = void

    /**
 * @summary Removes the RefLabelGroupRelation resource.
 */
export const useDeleteRefLabelRelation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRefLabelRelation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRefLabelRelation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRefLabelRelationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a ResetPasswordRequest resource.
 * @summary Creates a ResetPasswordRequest resource.
 */
export const postResetPassword = (
    resetPasswordRequestPostCheckResetPasswordRequestDTOJsonld: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<ResetPasswordRequestJsonld>(
      {url: `/api/reset/password`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: resetPasswordRequestPostCheckResetPasswordRequestDTOJsonld
    },
      options);
    }
  


export const getPostResetPasswordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResetPassword>>, TError,{data: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postResetPassword>>, TError,{data: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResetPassword>>, {data: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postResetPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postResetPassword>>>
    export type PostResetPasswordMutationBody = ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld
    export type PostResetPasswordMutationError = void

    /**
 * @summary Creates a ResetPasswordRequest resource.
 */
export const usePostResetPassword = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResetPassword>>, TError,{data: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResetPassword>>,
        TError,
        {data: ResetPasswordRequestPostCheckResetPasswordRequestDTOJsonld},
        TContext
      > => {

      const mutationOptions = getPostResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a ResetPasswordRequest resource.
 * @summary Creates a ResetPasswordRequest resource.
 */
export const postResetRequest = (
    resetPasswordRequestPostResetPasswordRequestDTOJsonld: ResetPasswordRequestPostResetPasswordRequestDTOJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<ResetPasswordRequestJsonld>(
      {url: `/api/reset/request`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: resetPasswordRequestPostResetPasswordRequestDTOJsonld
    },
      options);
    }
  


export const getPostResetRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResetRequest>>, TError,{data: ResetPasswordRequestPostResetPasswordRequestDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postResetRequest>>, TError,{data: ResetPasswordRequestPostResetPasswordRequestDTOJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResetRequest>>, {data: ResetPasswordRequestPostResetPasswordRequestDTOJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postResetRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResetRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postResetRequest>>>
    export type PostResetRequestMutationBody = ResetPasswordRequestPostResetPasswordRequestDTOJsonld
    export type PostResetRequestMutationError = void

    /**
 * @summary Creates a ResetPasswordRequest resource.
 */
export const usePostResetRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResetRequest>>, TError,{data: ResetPasswordRequestPostResetPasswordRequestDTOJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResetRequest>>,
        TError,
        {data: ResetPasswordRequestPostResetPasswordRequestDTOJsonld},
        TContext
      > => {

      const mutationOptions = getPostResetRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Settings resource.
 * @summary Retrieves a Settings resource.
 */
export const getSettings = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<SettingsJsonld>(
      {url: `/api/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSettingsQueryKey = () => {
    return [`/api/settings`] as const;
    }

    
export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = void

/**
 * @summary Retrieves a Settings resource.
 */
export const useGetSettings = <TData = Awaited<ReturnType<typeof getSettings>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Setting resource.
 * @summary Creates a Setting resource.
 */
export const postSettings = (
    settingPostSettingInputJsonld: SettingPostSettingInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<SettingJsonld>(
      {url: `/api/settings`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: settingPostSettingInputJsonld
    },
      options);
    }
  


export const getPostSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettings>>, TError,{data: SettingPostSettingInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postSettings>>, TError,{data: SettingPostSettingInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSettings>>, {data: SettingPostSettingInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postSettings>>>
    export type PostSettingsMutationBody = SettingPostSettingInputJsonld
    export type PostSettingsMutationError = void

    /**
 * @summary Creates a Setting resource.
 */
export const usePostSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettings>>, TError,{data: SettingPostSettingInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSettings>>,
        TError,
        {data: SettingPostSettingInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Setting resource.
 * @summary Updates the Setting resource.
 */
export const patchSettings = (
    settingPostSettingInput: SettingPostSettingInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<SettingJsonld>(
      {url: `/api/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: settingPostSettingInput
    },
      options);
    }
  


export const getPatchSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSettings>>, TError,{data: SettingPostSettingInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSettings>>, TError,{data: SettingPostSettingInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSettings>>, {data: SettingPostSettingInput}> = (props) => {
          const {data} = props ?? {};

          return  patchSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchSettings>>>
    export type PatchSettingsMutationBody = SettingPostSettingInput
    export type PatchSettingsMutationError = void

    /**
 * @summary Updates the Setting resource.
 */
export const usePatchSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSettings>>, TError,{data: SettingPostSettingInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchSettings>>,
        TError,
        {data: SettingPostSettingInput},
        TContext
      > => {

      const mutationOptions = getPatchSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Setting resource.
 * @summary Creates a Setting resource.
 */
export const postSettingsPassword = (
    settingPostSettingPasswordInputJsonld: SettingPostSettingPasswordInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/settings/password`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: settingPostSettingPasswordInputJsonld
    },
      options);
    }
  


export const getPostSettingsPasswordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsPassword>>, TError,{data: SettingPostSettingPasswordInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postSettingsPassword>>, TError,{data: SettingPostSettingPasswordInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSettingsPassword>>, {data: SettingPostSettingPasswordInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postSettingsPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSettingsPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postSettingsPassword>>>
    export type PostSettingsPasswordMutationBody = SettingPostSettingPasswordInputJsonld
    export type PostSettingsPasswordMutationError = void

    /**
 * @summary Creates a Setting resource.
 */
export const usePostSettingsPassword = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsPassword>>, TError,{data: SettingPostSettingPasswordInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSettingsPassword>>,
        TError,
        {data: SettingPostSettingPasswordInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostSettingsPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Setting resource.
 * @summary Retrieves a Setting resource.
 */
export const getSetting = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<SettingJsonldReadItemSetting>(
      {url: `/api/settings/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSettingQueryKey = (id: string,) => {
    return [`/api/settings/${id}`] as const;
    }

    
export const getGetSettingQueryOptions = <TData = Awaited<ReturnType<typeof getSetting>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetting>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetting>>> = ({ signal }) => getSetting(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getSetting>>>
export type GetSettingQueryError = void

/**
 * @summary Retrieves a Setting resource.
 */
export const useGetSetting = <TData = Awaited<ReturnType<typeof getSetting>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetting>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSettingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of SharedData resources.
 * @summary Retrieves the collection of SharedData resources.
 */
export const getUserSharedDatas = (
    params?: GetUserSharedDatasParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetUserSharedDatas200>(
      {url: `/api/shared-datas`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserSharedDatasQueryKey = (params?: GetUserSharedDatasParams,) => {
    return [`/api/shared-datas`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserSharedDatasQueryOptions = <TData = Awaited<ReturnType<typeof getUserSharedDatas>>, TError = void>(params?: GetUserSharedDatasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSharedDatas>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSharedDatasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSharedDatas>>> = ({ signal }) => getUserSharedDatas(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSharedDatas>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSharedDatasQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSharedDatas>>>
export type GetUserSharedDatasQueryError = void

/**
 * @summary Retrieves the collection of SharedData resources.
 */
export const useGetUserSharedDatas = <TData = Awaited<ReturnType<typeof getUserSharedDatas>>, TError = void>(
 params?: GetUserSharedDatasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSharedDatas>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSharedDatasQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a SharedData resource.
 * @summary Creates a SharedData resource.
 */
export const createUserSharedData = (
    sharedDataPostSharedDataInputJsonldWriteItemSharedData: SharedDataPostSharedDataInputJsonldWriteItemSharedData,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/shared-datas`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: sharedDataPostSharedDataInputJsonldWriteItemSharedData
    },
      options);
    }
  


export const getCreateUserSharedDataMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserSharedData>>, TError,{data: SharedDataPostSharedDataInputJsonldWriteItemSharedData}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserSharedData>>, TError,{data: SharedDataPostSharedDataInputJsonldWriteItemSharedData}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserSharedData>>, {data: SharedDataPostSharedDataInputJsonldWriteItemSharedData}> = (props) => {
          const {data} = props ?? {};

          return  createUserSharedData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserSharedDataMutationResult = NonNullable<Awaited<ReturnType<typeof createUserSharedData>>>
    export type CreateUserSharedDataMutationBody = SharedDataPostSharedDataInputJsonldWriteItemSharedData
    export type CreateUserSharedDataMutationError = void

    /**
 * @summary Creates a SharedData resource.
 */
export const useCreateUserSharedData = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserSharedData>>, TError,{data: SharedDataPostSharedDataInputJsonldWriteItemSharedData}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof createUserSharedData>>,
        TError,
        {data: SharedDataPostSharedDataInputJsonldWriteItemSharedData},
        TContext
      > => {

      const mutationOptions = getCreateUserSharedDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the SharedData resource.
 * @summary Updates the SharedData resource.
 */
export const updateUserSharedData = (
    sharedDataPatchSharedDataInputWriteItemSharedData: SharedDataPatchSharedDataInputWriteItemSharedData,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/shared-datas`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: sharedDataPatchSharedDataInputWriteItemSharedData
    },
      options);
    }
  


export const getUpdateUserSharedDataMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserSharedData>>, TError,{data: SharedDataPatchSharedDataInputWriteItemSharedData}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserSharedData>>, TError,{data: SharedDataPatchSharedDataInputWriteItemSharedData}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserSharedData>>, {data: SharedDataPatchSharedDataInputWriteItemSharedData}> = (props) => {
          const {data} = props ?? {};

          return  updateUserSharedData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserSharedDataMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserSharedData>>>
    export type UpdateUserSharedDataMutationBody = SharedDataPatchSharedDataInputWriteItemSharedData
    export type UpdateUserSharedDataMutationError = void

    /**
 * @summary Updates the SharedData resource.
 */
export const useUpdateUserSharedData = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserSharedData>>, TError,{data: SharedDataPatchSharedDataInputWriteItemSharedData}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserSharedData>>,
        TError,
        {data: SharedDataPatchSharedDataInputWriteItemSharedData},
        TContext
      > => {

      const mutationOptions = getUpdateUserSharedDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the SharedData resource.
 * @summary Updates the SharedData resource.
 */
export const cancelInterBuSharedData = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/shared-datas/interbu/${id}`, method: 'PATCH'
    },
      options);
    }
  


export const getCancelInterBuSharedDataMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInterBuSharedData>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelInterBuSharedData>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelInterBuSharedData>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelInterBuSharedData(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelInterBuSharedDataMutationResult = NonNullable<Awaited<ReturnType<typeof cancelInterBuSharedData>>>
    
    export type CancelInterBuSharedDataMutationError = void

    /**
 * @summary Updates the SharedData resource.
 */
export const useCancelInterBuSharedData = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInterBuSharedData>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelInterBuSharedData>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelInterBuSharedDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a SharedData resource.
 * @summary Creates a SharedData resource.
 */
export const postSharedDataReassign = (
    sharedDataPostReassignSharedDataInputJsonld: SharedDataPostReassignSharedDataInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/shared-datas/reassign`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: sharedDataPostReassignSharedDataInputJsonld
    },
      options);
    }
  


export const getPostSharedDataReassignMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSharedDataReassign>>, TError,{data: SharedDataPostReassignSharedDataInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postSharedDataReassign>>, TError,{data: SharedDataPostReassignSharedDataInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSharedDataReassign>>, {data: SharedDataPostReassignSharedDataInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postSharedDataReassign(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSharedDataReassignMutationResult = NonNullable<Awaited<ReturnType<typeof postSharedDataReassign>>>
    export type PostSharedDataReassignMutationBody = SharedDataPostReassignSharedDataInputJsonld
    export type PostSharedDataReassignMutationError = void

    /**
 * @summary Creates a SharedData resource.
 */
export const usePostSharedDataReassign = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSharedDataReassign>>, TError,{data: SharedDataPostReassignSharedDataInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSharedDataReassign>>,
        TError,
        {data: SharedDataPostReassignSharedDataInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostSharedDataReassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a SharedData resource.
 * @summary Retrieves a SharedData resource.
 */
export const getUserSharedData = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<SharedDataJsonldReadCollectionSharedDataReadItemSharedData>(
      {url: `/api/shared-datas/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserSharedDataQueryKey = (id: string,) => {
    return [`/api/shared-datas/${id}`] as const;
    }

    
export const getGetUserSharedDataQueryOptions = <TData = Awaited<ReturnType<typeof getUserSharedData>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSharedData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSharedDataQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSharedData>>> = ({ signal }) => getUserSharedData(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSharedData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSharedDataQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSharedData>>>
export type GetUserSharedDataQueryError = void

/**
 * @summary Retrieves a SharedData resource.
 */
export const useGetUserSharedData = <TData = Awaited<ReturnType<typeof getUserSharedData>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSharedData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSharedDataQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Society resources.
 * @summary Retrieves the collection of Society resources.
 */
export const getSocieties = (
    params?: GetSocietiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetSocieties200>(
      {url: `/api/societies`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSocietiesQueryKey = (params?: GetSocietiesParams,) => {
    return [`/api/societies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSocietiesQueryOptions = <TData = Awaited<ReturnType<typeof getSocieties>>, TError = void>(params?: GetSocietiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocieties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocietiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocieties>>> = ({ signal }) => getSocieties(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocieties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocietiesQueryResult = NonNullable<Awaited<ReturnType<typeof getSocieties>>>
export type GetSocietiesQueryError = void

/**
 * @summary Retrieves the collection of Society resources.
 */
export const useGetSocieties = <TData = Awaited<ReturnType<typeof getSocieties>>, TError = void>(
 params?: GetSocietiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocieties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSocietiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Society resource.
 * @summary Creates a Society resource.
 */
export const postSociety = (
    societyPostSocietyInputJsonld: SocietyPostSocietyInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/societies`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: societyPostSocietyInputJsonld
    },
      options);
    }
  


export const getPostSocietyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSociety>>, TError,{data: SocietyPostSocietyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postSociety>>, TError,{data: SocietyPostSocietyInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSociety>>, {data: SocietyPostSocietyInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postSociety(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSocietyMutationResult = NonNullable<Awaited<ReturnType<typeof postSociety>>>
    export type PostSocietyMutationBody = SocietyPostSocietyInputJsonld
    export type PostSocietyMutationError = void

    /**
 * @summary Creates a Society resource.
 */
export const usePostSociety = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSociety>>, TError,{data: SocietyPostSocietyInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSociety>>,
        TError,
        {data: SocietyPostSocietyInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostSocietyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of Society resources.
 * @summary Retrieves the collection of Society resources.
 */
export const getSocietiesExcelExportData = (
    params?: GetSocietiesExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetSocietiesExcelExportData200>(
      {url: `/api/societies/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSocietiesExcelExportDataQueryKey = (params?: GetSocietiesExcelExportDataParams,) => {
    return [`/api/societies/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSocietiesExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getSocietiesExcelExportData>>, TError = void>(params?: GetSocietiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocietiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocietiesExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocietiesExcelExportData>>> = ({ signal }) => getSocietiesExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocietiesExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocietiesExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getSocietiesExcelExportData>>>
export type GetSocietiesExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Society resources.
 */
export const useGetSocietiesExcelExportData = <TData = Awaited<ReturnType<typeof getSocietiesExcelExportData>>, TError = void>(
 params?: GetSocietiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocietiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSocietiesExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Society resource.
 * @summary Retrieves a Society resource.
 */
export const getSociety = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<SocietyJsonldReadItemSocietyItem>(
      {url: `/api/societies/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSocietyQueryKey = (id: string,) => {
    return [`/api/societies/${id}`] as const;
    }

    
export const getGetSocietyQueryOptions = <TData = Awaited<ReturnType<typeof getSociety>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSociety>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocietyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSociety>>> = ({ signal }) => getSociety(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSociety>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocietyQueryResult = NonNullable<Awaited<ReturnType<typeof getSociety>>>
export type GetSocietyQueryError = void

/**
 * @summary Retrieves a Society resource.
 */
export const useGetSociety = <TData = Awaited<ReturnType<typeof getSociety>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSociety>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSocietyQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the Society resource.
 * @summary Removes the Society resource.
 */
export const deleteSociety = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/societies/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSocietyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSociety>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSociety>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSociety>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSociety(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocietyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSociety>>>
    
    export type DeleteSocietyMutationError = void

    /**
 * @summary Removes the Society resource.
 */
export const useDeleteSociety = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSociety>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteSociety>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSocietyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Society resource.
 * @summary Updates the Society resource.
 */
export const patchSociety = (
    id: string,
    societyPatchSocietyInput: SocietyPatchSocietyInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/societies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: societyPatchSocietyInput
    },
      options);
    }
  


export const getPatchSocietyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSociety>>, TError,{id: string;data: SocietyPatchSocietyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSociety>>, TError,{id: string;data: SocietyPatchSocietyInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSociety>>, {id: string;data: SocietyPatchSocietyInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSociety(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSocietyMutationResult = NonNullable<Awaited<ReturnType<typeof patchSociety>>>
    export type PatchSocietyMutationBody = SocietyPatchSocietyInput
    export type PatchSocietyMutationError = void

    /**
 * @summary Updates the Society resource.
 */
export const usePatchSociety = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSociety>>, TError,{id: string;data: SocietyPatchSocietyInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchSociety>>,
        TError,
        {id: string;data: SocietyPatchSocietyInput},
        TContext
      > => {

      const mutationOptions = getPatchSocietyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a Society resource.
 * @summary Creates a Society resource.
 */
export const postSocietyMedia = (
    id: string,
    postSocietyMediaBody?: PostSocietyMediaBody,
 options?: SecondParameter<typeof customMutator>,) => {
      
      const formData = customFormDataFn(postSocietyMediaBody)
      return customMutator<unknown>(
      {url: `/api/societies/${id}/medias`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostSocietyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSocietyMedia>>, TError,{id: string;data: PostSocietyMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postSocietyMedia>>, TError,{id: string;data: PostSocietyMediaBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSocietyMedia>>, {id: string;data: PostSocietyMediaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postSocietyMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSocietyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postSocietyMedia>>>
    export type PostSocietyMediaMutationBody = PostSocietyMediaBody
    export type PostSocietyMediaMutationError = void

    /**
 * @summary Creates a Society resource.
 */
export const usePostSocietyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSocietyMedia>>, TError,{id: string;data: PostSocietyMediaBody}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSocietyMedia>>,
        TError,
        {id: string;data: PostSocietyMediaBody},
        TContext
      > => {

      const mutationOptions = getPostSocietyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Society resource.
 * @summary Updates the Society resource.
 */
export const patchSocietyMedia = (
    id: string,
    societyPatchEntityMediaInput: SocietyPatchEntityMediaInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/societies/${id}/medias`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: societyPatchEntityMediaInput
    },
      options);
    }
  


export const getPatchSocietyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSocietyMedia>>, TError,{id: string;data: SocietyPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSocietyMedia>>, TError,{id: string;data: SocietyPatchEntityMediaInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSocietyMedia>>, {id: string;data: SocietyPatchEntityMediaInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSocietyMedia(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSocietyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof patchSocietyMedia>>>
    export type PatchSocietyMediaMutationBody = SocietyPatchEntityMediaInput
    export type PatchSocietyMediaMutationError = void

    /**
 * @summary Updates the Society resource.
 */
export const usePatchSocietyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSocietyMedia>>, TError,{id: string;data: SocietyPatchEntityMediaInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchSocietyMedia>>,
        TError,
        {id: string;data: SocietyPatchEntityMediaInput},
        TContext
      > => {

      const mutationOptions = getPatchSocietyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Society resource.
 * @summary Removes the Society resource.
 */
export const deleteSocietyMedia = (
    id: string,
    mediaId: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/societies/${id}/medias/${mediaId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSocietyMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocietyMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocietyMedia>>, TError,{id: string;mediaId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocietyMedia>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteSocietyMedia(id,mediaId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocietyMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocietyMedia>>>
    
    export type DeleteSocietyMediaMutationError = void

    /**
 * @summary Removes the Society resource.
 */
export const useDeleteSocietyMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocietyMedia>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocietyMedia>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {

      const mutationOptions = getDeleteSocietyMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of TInterBu resources.
 * @summary Retrieves the collection of TInterBu resources.
 */
export const getClientInterBUs = (
    id: string,
    params?: GetClientInterBUsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClientInterBUs200>(
      {url: `/api/clients/${id}/inter-bus`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClientInterBUsQueryKey = (id: string,
    params?: GetClientInterBUsParams,) => {
    return [`/api/clients/${id}/inter-bus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClientInterBUsQueryOptions = <TData = Awaited<ReturnType<typeof getClientInterBUs>>, TError = void>(id: string,
    params?: GetClientInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientInterBUsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientInterBUs>>> = ({ signal }) => getClientInterBUs(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientInterBUs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientInterBUsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientInterBUs>>>
export type GetClientInterBUsQueryError = void

/**
 * @summary Retrieves the collection of TInterBu resources.
 */
export const useGetClientInterBUs = <TData = Awaited<ReturnType<typeof getClientInterBUs>>, TError = void>(
 id: string,
    params?: GetClientInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientInterBUsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TInterBu resources.
 * @summary Retrieves the collection of TInterBu resources.
 */
export const getBuAdminInterBUs = (
    params?: GetBuAdminInterBUsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetBuAdminInterBUs200>(
      {url: `/api/inter-bus/bu-admin-inter-bu`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBuAdminInterBUsQueryKey = (params?: GetBuAdminInterBUsParams,) => {
    return [`/api/inter-bus/bu-admin-inter-bu`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuAdminInterBUsQueryOptions = <TData = Awaited<ReturnType<typeof getBuAdminInterBUs>>, TError = void>(params?: GetBuAdminInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuAdminInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuAdminInterBUsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuAdminInterBUs>>> = ({ signal }) => getBuAdminInterBUs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuAdminInterBUs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBuAdminInterBUsQueryResult = NonNullable<Awaited<ReturnType<typeof getBuAdminInterBUs>>>
export type GetBuAdminInterBUsQueryError = void

/**
 * @summary Retrieves the collection of TInterBu resources.
 */
export const useGetBuAdminInterBUs = <TData = Awaited<ReturnType<typeof getBuAdminInterBUs>>, TError = void>(
 params?: GetBuAdminInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBuAdminInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBuAdminInterBUsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TInterBu resources.
 * @summary Retrieves the collection of TInterBu resources.
 */
export const getAssignedInterBUs = (
    params?: GetAssignedInterBUsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetAssignedInterBUs200>(
      {url: `/api/inter-bus/user-assigned-inter-bu`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAssignedInterBUsQueryKey = (params?: GetAssignedInterBUsParams,) => {
    return [`/api/inter-bus/user-assigned-inter-bu`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAssignedInterBUsQueryOptions = <TData = Awaited<ReturnType<typeof getAssignedInterBUs>>, TError = void>(params?: GetAssignedInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssignedInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssignedInterBUsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignedInterBUs>>> = ({ signal }) => getAssignedInterBUs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssignedInterBUs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssignedInterBUsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssignedInterBUs>>>
export type GetAssignedInterBUsQueryError = void

/**
 * @summary Retrieves the collection of TInterBu resources.
 */
export const useGetAssignedInterBUs = <TData = Awaited<ReturnType<typeof getAssignedInterBUs>>, TError = void>(
 params?: GetAssignedInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssignedInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAssignedInterBUsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TInterBu resources.
 * @summary Retrieves the collection of TInterBu resources.
 */
export const getSentInterBUs = (
    params?: GetSentInterBUsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetSentInterBUs200>(
      {url: `/api/inter-bus/user-sent-inter-bu`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSentInterBUsQueryKey = (params?: GetSentInterBUsParams,) => {
    return [`/api/inter-bus/user-sent-inter-bu`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSentInterBUsQueryOptions = <TData = Awaited<ReturnType<typeof getSentInterBUs>>, TError = void>(params?: GetSentInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSentInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSentInterBUsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSentInterBUs>>> = ({ signal }) => getSentInterBUs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSentInterBUs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSentInterBUsQueryResult = NonNullable<Awaited<ReturnType<typeof getSentInterBUs>>>
export type GetSentInterBUsQueryError = void

/**
 * @summary Retrieves the collection of TInterBu resources.
 */
export const useGetSentInterBUs = <TData = Awaited<ReturnType<typeof getSentInterBUs>>, TError = void>(
 params?: GetSentInterBUsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSentInterBUs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSentInterBUsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a TInterBu resource.
 * @summary Creates a TInterBu resource.
 */
export const postInterBu = (
    tInterBuCreateInterBUsInputJsonld: TInterBuCreateInterBUsInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/t-inter-bus`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: tInterBuCreateInterBUsInputJsonld
    },
      options);
    }
  


export const getPostInterBuMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterBu>>, TError,{data: TInterBuCreateInterBUsInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postInterBu>>, TError,{data: TInterBuCreateInterBUsInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterBu>>, {data: TInterBuCreateInterBUsInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postInterBu(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInterBuMutationResult = NonNullable<Awaited<ReturnType<typeof postInterBu>>>
    export type PostInterBuMutationBody = TInterBuCreateInterBUsInputJsonld
    export type PostInterBuMutationError = void

    /**
 * @summary Creates a TInterBu resource.
 */
export const usePostInterBu = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInterBu>>, TError,{data: TInterBuCreateInterBUsInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInterBu>>,
        TError,
        {data: TInterBuCreateInterBUsInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostInterBuMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a TInterBu resource.
 * @summary Retrieves a TInterBu resource.
 */
export const getInterBu = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<TInterBuJsonldReadItemInterbu>(
      {url: `/api/t-inter-bus/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetInterBuQueryKey = (id: string,) => {
    return [`/api/t-inter-bus/${id}`] as const;
    }

    
export const getGetInterBuQueryOptions = <TData = Awaited<ReturnType<typeof getInterBu>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBu>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterBuQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterBu>>> = ({ signal }) => getInterBu(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterBu>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterBuQueryResult = NonNullable<Awaited<ReturnType<typeof getInterBu>>>
export type GetInterBuQueryError = void

/**
 * @summary Retrieves a TInterBu resource.
 */
export const useGetInterBu = <TData = Awaited<ReturnType<typeof getInterBu>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterBu>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInterBuQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Stop impersonating and restore admin JWT.
 */
export const postExitImpersonation = (
    
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<Token>(
      {url: `/api/impersonate/exit`, method: 'POST'
    },
      options);
    }
  


export const getPostExitImpersonationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExitImpersonation>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postExitImpersonation>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExitImpersonation>>, void> = () => {
          

          return  postExitImpersonation(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostExitImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof postExitImpersonation>>>
    
    export type PostExitImpersonationMutationError = void

    /**
 * @summary Stop impersonating and restore admin JWT.
 */
export const usePostExitImpersonation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExitImpersonation>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postExitImpersonation>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostExitImpersonationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Use email and password to get JWT access token and refresh token.
 */
export const postCredentials = (
    credentials?: Credentials,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<Token>(
      {url: `/api/login_check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: credentials
    },
      options);
    }
  


export const getPostCredentialsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCredentials>>, TError,{data: Credentials}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postCredentials>>, TError,{data: Credentials}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCredentials>>, {data: Credentials}> = (props) => {
          const {data} = props ?? {};

          return  postCredentials(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof postCredentials>>>
    export type PostCredentialsMutationBody = Credentials
    export type PostCredentialsMutationError = unknown

    /**
 * @summary Use email and password to get JWT access token and refresh token.
 */
export const usePostCredentials = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCredentials>>, TError,{data: Credentials}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCredentials>>,
        TError,
        {data: Credentials},
        TContext
      > => {

      const mutationOptions = getPostCredentialsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Invalidate refresh token.
 */
export const getInvalidateRefreshToken = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<InvalidateRefreshTokenResponse>(
      {url: `/api/token/invalidate`, method: 'GET', signal
    },
      options);
    }
  

export const getGetInvalidateRefreshTokenQueryKey = () => {
    return [`/api/token/invalidate`] as const;
    }

    
export const getGetInvalidateRefreshTokenQueryOptions = <TData = Awaited<ReturnType<typeof getInvalidateRefreshToken>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvalidateRefreshToken>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvalidateRefreshTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvalidateRefreshToken>>> = ({ signal }) => getInvalidateRefreshToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvalidateRefreshToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvalidateRefreshTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getInvalidateRefreshToken>>>
export type GetInvalidateRefreshTokenQueryError = unknown

/**
 * @summary Invalidate refresh token.
 */
export const useGetInvalidateRefreshToken = <TData = Awaited<ReturnType<typeof getInvalidateRefreshToken>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvalidateRefreshToken>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvalidateRefreshTokenQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Use refresh token to get new access token.
 */
export const getNewAccessToken = (
    
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<Token>(
      {url: `/api/token/refresh`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNewAccessTokenQueryKey = () => {
    return [`/api/token/refresh`] as const;
    }

    
export const getGetNewAccessTokenQueryOptions = <TData = Awaited<ReturnType<typeof getNewAccessToken>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewAccessToken>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewAccessTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewAccessToken>>> = ({ signal }) => getNewAccessToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewAccessToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNewAccessTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getNewAccessToken>>>
export type GetNewAccessTokenQueryError = unknown

/**
 * @summary Use refresh token to get new access token.
 */
export const useGetNewAccessToken = <TData = Awaited<ReturnType<typeof getNewAccessToken>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewAccessToken>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNewAccessTokenQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Start impersonating a user (admin only). Returns JWT for target user with impersonatorId claim.
 */
export const postImpersonateUser = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<Token>(
      {url: `/api/users/${id}/impersonate`, method: 'POST'
    },
      options);
    }
  


export const getPostImpersonateUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postImpersonateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postImpersonateUser>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postImpersonateUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postImpersonateUser(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostImpersonateUserMutationResult = NonNullable<Awaited<ReturnType<typeof postImpersonateUser>>>
    
    export type PostImpersonateUserMutationError = void

    /**
 * @summary Start impersonating a user (admin only). Returns JWT for target user with impersonatorId claim.
 */
export const usePostImpersonateUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postImpersonateUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postImpersonateUser>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostImpersonateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves the collection of Tproject resources.
 * @summary Retrieves the collection of Tproject resources.
 */
export const getClientProjects = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClientProjects200>(
      {url: `/api/clients/${id}/projects`, method: 'GET', signal
    },
      options);
    }
  

export const getGetClientProjectsQueryKey = (id: string,) => {
    return [`/api/clients/${id}/projects`] as const;
    }

    
export const getGetClientProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getClientProjects>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProjects>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientProjectsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientProjects>>> = ({ signal }) => getClientProjects(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientProjects>>>
export type GetClientProjectsQueryError = void

/**
 * @summary Retrieves the collection of Tproject resources.
 */
export const useGetClientProjects = <TData = Awaited<ReturnType<typeof getClientProjects>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProjects>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientProjectsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Tproperty resources.
 * @summary Retrieves the collection of Tproperty resources.
 */
export const getClientProperties = (
    id: string,
    params?: GetClientPropertiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetClientProperties200>(
      {url: `/api/clients/${id}/properties`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetClientPropertiesQueryKey = (id: string,
    params?: GetClientPropertiesParams,) => {
    return [`/api/clients/${id}/properties`, ...(params ? [params]: [])] as const;
    }

    
export const getGetClientPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getClientProperties>>, TError = void>(id: string,
    params?: GetClientPropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientPropertiesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientProperties>>> = ({ signal }) => getClientProperties(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientProperties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getClientProperties>>>
export type GetClientPropertiesQueryError = void

/**
 * @summary Retrieves the collection of Tproperty resources.
 */
export const useGetClientProperties = <TData = Awaited<ReturnType<typeof getClientProperties>>, TError = void>(
 id: string,
    params?: GetClientPropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClientPropertiesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Tproperty resources.
 * @summary Retrieves the collection of Tproperty resources.
 */
export const getTproperties = (
    params?: GetTpropertiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetTproperties200>(
      {url: `/api/tproperties`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTpropertiesQueryKey = (params?: GetTpropertiesParams,) => {
    return [`/api/tproperties`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTpropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getTproperties>>, TError = void>(params?: GetTpropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTproperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTpropertiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTproperties>>> = ({ signal }) => getTproperties(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTproperties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTpropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getTproperties>>>
export type GetTpropertiesQueryError = void

/**
 * @summary Retrieves the collection of Tproperty resources.
 */
export const useGetTproperties = <TData = Awaited<ReturnType<typeof getTproperties>>, TError = void>(
 params?: GetTpropertiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTproperties>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTpropertiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Tproperty resources.
 * @summary Retrieves the collection of Tproperty resources.
 */
export const getTpropertiesExcelExportData = (
    params?: GetTpropertiesExcelExportDataParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetTpropertiesExcelExportData200>(
      {url: `/api/tproperties/excel-export`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTpropertiesExcelExportDataQueryKey = (params?: GetTpropertiesExcelExportDataParams,) => {
    return [`/api/tproperties/excel-export`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTpropertiesExcelExportDataQueryOptions = <TData = Awaited<ReturnType<typeof getTpropertiesExcelExportData>>, TError = void>(params?: GetTpropertiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTpropertiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTpropertiesExcelExportDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTpropertiesExcelExportData>>> = ({ signal }) => getTpropertiesExcelExportData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTpropertiesExcelExportData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTpropertiesExcelExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof getTpropertiesExcelExportData>>>
export type GetTpropertiesExcelExportDataQueryError = void

/**
 * @summary Retrieves the collection of Tproperty resources.
 */
export const useGetTpropertiesExcelExportData = <TData = Awaited<ReturnType<typeof getTpropertiesExcelExportData>>, TError = void>(
 params?: GetTpropertiesExcelExportDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTpropertiesExcelExportData>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTpropertiesExcelExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a Tproperty resource.
 * @summary Retrieves a Tproperty resource.
 */
export const getTproperty = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<TpropertyJsonldReadItemTpropertyWithoutPrivateData>(
      {url: `/api/tproperties/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTpropertyQueryKey = (id: string,) => {
    return [`/api/tproperties/${id}`] as const;
    }

    
export const getGetTpropertyQueryOptions = <TData = Awaited<ReturnType<typeof getTproperty>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTproperty>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTpropertyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTproperty>>> = ({ signal }) => getTproperty(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTproperty>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTpropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getTproperty>>>
export type GetTpropertyQueryError = void

/**
 * @summary Retrieves a Tproperty resource.
 */
export const useGetTproperty = <TData = Awaited<ReturnType<typeof getTproperty>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTproperty>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTpropertyQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates the Tproperty resource.
 * @summary Updates the Tproperty resource.
 */
export const patchTproperty = (
    id: string,
    tpropertyWriteItemTproperty: TpropertyWriteItemTproperty,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<TpropertyJsonldReadItemTpropertyWithoutPrivateData>(
      {url: `/api/tproperties/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: tpropertyWriteItemTproperty
    },
      options);
    }
  


export const getPatchTpropertyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTproperty>>, TError,{id: string;data: TpropertyWriteItemTproperty}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTproperty>>, TError,{id: string;data: TpropertyWriteItemTproperty}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTproperty>>, {id: string;data: TpropertyWriteItemTproperty}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTproperty(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTpropertyMutationResult = NonNullable<Awaited<ReturnType<typeof patchTproperty>>>
    export type PatchTpropertyMutationBody = TpropertyWriteItemTproperty
    export type PatchTpropertyMutationError = void

    /**
 * @summary Updates the Tproperty resource.
 */
export const usePatchTproperty = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTproperty>>, TError,{id: string;data: TpropertyWriteItemTproperty}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchTproperty>>,
        TError,
        {id: string;data: TpropertyWriteItemTproperty},
        TContext
      > => {

      const mutationOptions = getPatchTpropertyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Tproperty resource.
 * @summary Retrieves a Tproperty resource.
 */
export const getTpropertyLogs = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<TpropertyLogsOutputJsonld>(
      {url: `/api/tproperties/${id}/logs`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTpropertyLogsQueryKey = (id: string,) => {
    return [`/api/tproperties/${id}/logs`] as const;
    }

    
export const getGetTpropertyLogsQueryOptions = <TData = Awaited<ReturnType<typeof getTpropertyLogs>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTpropertyLogs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTpropertyLogsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTpropertyLogs>>> = ({ signal }) => getTpropertyLogs(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTpropertyLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTpropertyLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getTpropertyLogs>>>
export type GetTpropertyLogsQueryError = void

/**
 * @summary Retrieves a Tproperty resource.
 */
export const useGetTpropertyLogs = <TData = Awaited<ReturnType<typeof getTpropertyLogs>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTpropertyLogs>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTpropertyLogsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyAvailability resources.
 * @summary Retrieves the collection of TpropertyAvailability resources.
 */
export const gettPropertyAvailabilities = (
    params?: GettPropertyAvailabilitiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyAvailabilities200>(
      {url: `/api/tproperty-availabilities`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyAvailabilitiesQueryKey = (params?: GettPropertyAvailabilitiesParams,) => {
    return [`/api/tproperty-availabilities`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyAvailabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyAvailabilities>>, TError = void>(params?: GettPropertyAvailabilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyAvailabilities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyAvailabilitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyAvailabilities>>> = ({ signal }) => gettPropertyAvailabilities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyAvailabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyAvailabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyAvailabilities>>>
export type GettPropertyAvailabilitiesQueryError = void

/**
 * @summary Retrieves the collection of TpropertyAvailability resources.
 */
export const useGettPropertyAvailabilities = <TData = Awaited<ReturnType<typeof gettPropertyAvailabilities>>, TError = void>(
 params?: GettPropertyAvailabilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyAvailabilities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyAvailabilitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyFacility resources.
 * @summary Retrieves the collection of TpropertyFacility resources.
 */
export const gettPropertyFacilities = (
    params?: GettPropertyFacilitiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyFacilities200>(
      {url: `/api/tproperty-facilities`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyFacilitiesQueryKey = (params?: GettPropertyFacilitiesParams,) => {
    return [`/api/tproperty-facilities`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyFacilitiesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyFacilities>>, TError = void>(params?: GettPropertyFacilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyFacilities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyFacilitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyFacilities>>> = ({ signal }) => gettPropertyFacilities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyFacilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyFacilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyFacilities>>>
export type GettPropertyFacilitiesQueryError = void

/**
 * @summary Retrieves the collection of TpropertyFacility resources.
 */
export const useGettPropertyFacilities = <TData = Awaited<ReturnType<typeof gettPropertyFacilities>>, TError = void>(
 params?: GettPropertyFacilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyFacilities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyFacilitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyMandateType resources.
 * @summary Retrieves the collection of TpropertyMandateType resources.
 */
export const gettPropertyMandateTypes = (
    params?: GettPropertyMandateTypesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyMandateTypes200>(
      {url: `/api/tproperty-mandate-types`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyMandateTypesQueryKey = (params?: GettPropertyMandateTypesParams,) => {
    return [`/api/tproperty-mandate-types`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyMandateTypesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyMandateTypes>>, TError = void>(params?: GettPropertyMandateTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyMandateTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyMandateTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyMandateTypes>>> = ({ signal }) => gettPropertyMandateTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyMandateTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyMandateTypesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyMandateTypes>>>
export type GettPropertyMandateTypesQueryError = void

/**
 * @summary Retrieves the collection of TpropertyMandateType resources.
 */
export const useGettPropertyMandateTypes = <TData = Awaited<ReturnType<typeof gettPropertyMandateTypes>>, TError = void>(
 params?: GettPropertyMandateTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyMandateTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyMandateTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertySituation resources.
 * @summary Retrieves the collection of TpropertySituation resources.
 */
export const gettPropertySituations = (
    params?: GettPropertySituationsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertySituations200>(
      {url: `/api/tproperty-situations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertySituationsQueryKey = (params?: GettPropertySituationsParams,) => {
    return [`/api/tproperty-situations`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertySituationsQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertySituations>>, TError = void>(params?: GettPropertySituationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySituations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertySituationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertySituations>>> = ({ signal }) => gettPropertySituations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertySituations>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertySituationsQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertySituations>>>
export type GettPropertySituationsQueryError = void

/**
 * @summary Retrieves the collection of TpropertySituation resources.
 */
export const useGettPropertySituations = <TData = Awaited<ReturnType<typeof gettPropertySituations>>, TError = void>(
 params?: GettPropertySituationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySituations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertySituationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertySpecificity resources.
 * @summary Retrieves the collection of TpropertySpecificity resources.
 */
export const gettPropertySpecificities = (
    params?: GettPropertySpecificitiesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertySpecificities200>(
      {url: `/api/tproperty-specificities`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertySpecificitiesQueryKey = (params?: GettPropertySpecificitiesParams,) => {
    return [`/api/tproperty-specificities`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertySpecificitiesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertySpecificities>>, TError = void>(params?: GettPropertySpecificitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySpecificities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertySpecificitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertySpecificities>>> = ({ signal }) => gettPropertySpecificities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertySpecificities>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertySpecificitiesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertySpecificities>>>
export type GettPropertySpecificitiesQueryError = void

/**
 * @summary Retrieves the collection of TpropertySpecificity resources.
 */
export const useGettPropertySpecificities = <TData = Awaited<ReturnType<typeof gettPropertySpecificities>>, TError = void>(
 params?: GettPropertySpecificitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySpecificities>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertySpecificitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyState resources.
 * @summary Retrieves the collection of TpropertyState resources.
 */
export const gettPropertyStates = (
    params?: GettPropertyStatesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyStates200>(
      {url: `/api/tproperty-states`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyStatesQueryKey = (params?: GettPropertyStatesParams,) => {
    return [`/api/tproperty-states`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyStatesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyStates>>, TError = void>(params?: GettPropertyStatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyStates>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyStatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyStates>>> = ({ signal }) => gettPropertyStates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyStates>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyStatesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyStates>>>
export type GettPropertyStatesQueryError = void

/**
 * @summary Retrieves the collection of TpropertyState resources.
 */
export const useGettPropertyStates = <TData = Awaited<ReturnType<typeof gettPropertyStates>>, TError = void>(
 params?: GettPropertyStatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyStates>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyStatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertySubType resources.
 * @summary Retrieves the collection of TpropertySubType resources.
 */
export const gettPropertySubTypes = (
    params?: GettPropertySubTypesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertySubTypes200>(
      {url: `/api/tproperty-sub-types`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertySubTypesQueryKey = (params?: GettPropertySubTypesParams,) => {
    return [`/api/tproperty-sub-types`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertySubTypesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertySubTypes>>, TError = void>(params?: GettPropertySubTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySubTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertySubTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertySubTypes>>> = ({ signal }) => gettPropertySubTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertySubTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertySubTypesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertySubTypes>>>
export type GettPropertySubTypesQueryError = void

/**
 * @summary Retrieves the collection of TpropertySubType resources.
 */
export const useGettPropertySubTypes = <TData = Awaited<ReturnType<typeof gettPropertySubTypes>>, TError = void>(
 params?: GettPropertySubTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertySubTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertySubTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyView resources.
 * @summary Retrieves the collection of TpropertyView resources.
 */
export const gettPropertyViews = (
    params?: GettPropertyViewsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyViews200>(
      {url: `/api/tproperty-views`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyViewsQueryKey = (params?: GettPropertyViewsParams,) => {
    return [`/api/tproperty-views`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyViewsQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyViews>>, TError = void>(params?: GettPropertyViewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViews>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyViewsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyViews>>> = ({ signal }) => gettPropertyViews(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViews>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyViewsQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyViews>>>
export type GettPropertyViewsQueryError = void

/**
 * @summary Retrieves the collection of TpropertyView resources.
 */
export const useGettPropertyViews = <TData = Awaited<ReturnType<typeof gettPropertyViews>>, TError = void>(
 params?: GettPropertyViewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViews>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyViewsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of TpropertyViewType resources.
 * @summary Retrieves the collection of TpropertyViewType resources.
 */
export const gettPropertyViewTypes = (
    params?: GettPropertyViewTypesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GettPropertyViewTypes200>(
      {url: `/api/tproperty-view-types`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGettPropertyViewTypesQueryKey = (params?: GettPropertyViewTypesParams,) => {
    return [`/api/tproperty-view-types`, ...(params ? [params]: [])] as const;
    }

    
export const getGettPropertyViewTypesQueryOptions = <TData = Awaited<ReturnType<typeof gettPropertyViewTypes>>, TError = void>(params?: GettPropertyViewTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViewTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGettPropertyViewTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gettPropertyViewTypes>>> = ({ signal }) => gettPropertyViewTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViewTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GettPropertyViewTypesQueryResult = NonNullable<Awaited<ReturnType<typeof gettPropertyViewTypes>>>
export type GettPropertyViewTypesQueryError = void

/**
 * @summary Retrieves the collection of TpropertyViewType resources.
 */
export const useGettPropertyViewTypes = <TData = Awaited<ReturnType<typeof gettPropertyViewTypes>>, TError = void>(
 params?: GettPropertyViewTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof gettPropertyViewTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGettPropertyViewTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of Tsubscription resources.
 * @summary Retrieves the collection of Tsubscription resources.
 */
export const getTsubscriptions = (
    params?: GetTsubscriptionsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetTsubscriptions200>(
      {url: `/api/tsubscriptions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTsubscriptionsQueryKey = (params?: GetTsubscriptionsParams,) => {
    return [`/api/tsubscriptions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTsubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getTsubscriptions>>, TError = void>(params?: GetTsubscriptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptions>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTsubscriptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTsubscriptions>>> = ({ signal }) => getTsubscriptions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTsubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTsubscriptions>>>
export type GetTsubscriptionsQueryError = void

/**
 * @summary Retrieves the collection of Tsubscription resources.
 */
export const useGetTsubscriptions = <TData = Awaited<ReturnType<typeof getTsubscriptions>>, TError = void>(
 params?: GetTsubscriptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptions>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTsubscriptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a Tsubscription resource.
 * @summary Creates a Tsubscription resource.
 */
export const postTsubscription = (
    tsubscriptionPostSubscriptionInputJsonld: TsubscriptionPostSubscriptionInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/tsubscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: tsubscriptionPostSubscriptionInputJsonld
    },
      options);
    }
  


export const getPostTsubscriptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTsubscription>>, TError,{data: TsubscriptionPostSubscriptionInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postTsubscription>>, TError,{data: TsubscriptionPostSubscriptionInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTsubscription>>, {data: TsubscriptionPostSubscriptionInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postTsubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTsubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postTsubscription>>>
    export type PostTsubscriptionMutationBody = TsubscriptionPostSubscriptionInputJsonld
    export type PostTsubscriptionMutationError = void

    /**
 * @summary Creates a Tsubscription resource.
 */
export const usePostTsubscription = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTsubscription>>, TError,{data: TsubscriptionPostSubscriptionInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTsubscription>>,
        TError,
        {data: TsubscriptionPostSubscriptionInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostTsubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes the Tsubscription resource.
 * @summary Removes the Tsubscription resource.
 */
export const deleteTsubscription = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/tsubscriptions/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTsubscriptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTsubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTsubscription>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTsubscription>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTsubscription(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTsubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTsubscription>>>
    
    export type DeleteTsubscriptionMutationError = void

    /**
 * @summary Removes the Tsubscription resource.
 */
export const useDeleteTsubscription = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTsubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTsubscription>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTsubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the Tsubscription resource.
 * @summary Updates the Tsubscription resource.
 */
export const patchTsubscription = (
    id: string,
    tsubscriptionPatchSubscriptionInput: TsubscriptionPatchSubscriptionInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/tsubscriptions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: tsubscriptionPatchSubscriptionInput
    },
      options);
    }
  


export const getPatchTsubscriptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTsubscription>>, TError,{id: string;data: TsubscriptionPatchSubscriptionInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTsubscription>>, TError,{id: string;data: TsubscriptionPatchSubscriptionInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTsubscription>>, {id: string;data: TsubscriptionPatchSubscriptionInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTsubscription(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTsubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof patchTsubscription>>>
    export type PatchTsubscriptionMutationBody = TsubscriptionPatchSubscriptionInput
    export type PatchTsubscriptionMutationError = void

    /**
 * @summary Updates the Tsubscription resource.
 */
export const usePatchTsubscription = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTsubscription>>, TError,{id: string;data: TsubscriptionPatchSubscriptionInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchTsubscription>>,
        TError,
        {id: string;data: TsubscriptionPatchSubscriptionInput},
        TContext
      > => {

      const mutationOptions = getPatchTsubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a Tsubscription resource.
 * @summary Retrieves a Tsubscription resource.
 */
export const getTsubscriptionTranslations = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<TsubscriptionTranslationsDTO>(
      {url: `/api/tsubscriptions/${id}/translations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTsubscriptionTranslationsQueryKey = (id: string,) => {
    return [`/api/tsubscriptions/${id}/translations`] as const;
    }

    
export const getGetTsubscriptionTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getTsubscriptionTranslations>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptionTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTsubscriptionTranslationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTsubscriptionTranslations>>> = ({ signal }) => getTsubscriptionTranslations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptionTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTsubscriptionTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTsubscriptionTranslations>>>
export type GetTsubscriptionTranslationsQueryError = void

/**
 * @summary Retrieves a Tsubscription resource.
 */
export const useGetTsubscriptionTranslations = <TData = Awaited<ReturnType<typeof getTsubscriptionTranslations>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTsubscriptionTranslations>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTsubscriptionTranslationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves the collection of User resources.
 * @summary Retrieves the collection of User resources.
 */
export const getUsers = (
    params?: GetUsersParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<GetUsers200>(
      {url: `/api/users`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [`/api/users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = void>(params?: GetUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = void

/**
 * @summary Retrieves the collection of User resources.
 */
export const useGetUsers = <TData = Awaited<ReturnType<typeof getUsers>>, TError = void>(
 params?: GetUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a User resource.
 * @summary Creates a User resource.
 */
export const postUser = (
    userCreateUserInputJsonld: UserCreateUserInputJsonld,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/users/`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: userCreateUserInputJsonld
    },
      options);
    }
  


export const getPostUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: UserCreateUserInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: UserCreateUserInputJsonld}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUser>>, {data: UserCreateUserInputJsonld}> = (props) => {
          const {data} = props ?? {};

          return  postUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserMutationResult = NonNullable<Awaited<ReturnType<typeof postUser>>>
    export type PostUserMutationBody = UserCreateUserInputJsonld
    export type PostUserMutationError = void

    /**
 * @summary Creates a User resource.
 */
export const usePostUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: UserCreateUserInputJsonld}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUser>>,
        TError,
        {data: UserCreateUserInputJsonld},
        TContext
      > => {

      const mutationOptions = getPostUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves a User resource.
 * @summary Retrieves a User resource.
 */
export const getUser = (
    id: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {
      
      
      return customMutator<UserJsonldUserReadItem>(
      {url: `/api/users/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserQueryKey = (id: string,) => {
    return [`/api/users/${id}`] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = void

/**
 * @summary Retrieves a User resource.
 */
export const useGetUser = <TData = Awaited<ReturnType<typeof getUser>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Removes the User resource.
 * @summary Removes the User resource.
 */
export const deleteUser = (
    id: string,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<void>(
      {url: `/api/users/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = void

    /**
 * @summary Removes the User resource.
 */
export const useDeleteUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates the User resource.
 * @summary Updates the User resource.
 */
export const patchUser = (
    id: string,
    userPatchUserInput: UserPatchUserInput,
 options?: SecondParameter<typeof customMutator>,) => {
      
      
      return customMutator<unknown>(
      {url: `/api/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: userPatchUserInput
    },
      options);
    }
  


export const getPatchUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{id: string;data: UserPatchUserInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{id: string;data: UserPatchUserInput}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUser>>, {id: string;data: UserPatchUserInput}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUser(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserMutationResult = NonNullable<Awaited<ReturnType<typeof patchUser>>>
    export type PatchUserMutationBody = UserPatchUserInput
    export type PatchUserMutationError = void

    /**
 * @summary Updates the User resource.
 */
export const usePatchUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{id: string;data: UserPatchUserInput}, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationResult<
        Awaited<ReturnType<typeof patchUser>>,
        TError,
        {id: string;data: UserPatchUserInput},
        TContext
      > => {

      const mutationOptions = getPatchUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
